import { Group, useOrganismStatus, route, group } from '@amazeelabs/react-framework-bridge';
export * from '@amazeelabs/react-framework-bridge';
import clsx from 'clsx';
import React, { useContext, useState, useEffect, createContext, useRef, Fragment } from 'react';
import { useIntl } from '@amazeelabs/react-framework-bridge/react-intl';
import { ArrowNarrowUpIcon, ArrowRightIcon, MinusIcon, PlusIcon, ArrowNarrowRightIcon, ArrowDownIcon, CheckIcon, XIcon, ArrowLeftIcon, MenuAlt1Icon, PencilIcon, ChevronLeftIcon, ChevronRightIcon, MailIcon } from '@heroicons/react/outline';
import { buildHtml } from '@amazeelabs/react-framework-bridge/storybook';
import { forEach, uniq, map, toLower, lowerCase, startsWith, has, sum, debounce, isEmpty, toUpper } from 'lodash';
import { Transition, Disclosure, Listbox, Combobox, Popover, Dialog } from '@headlessui/react';
import { useField, useFormikContext, Formik, Form, Field } from '@amazeelabs/react-framework-bridge/formik';
import * as formik from '@amazeelabs/react-framework-bridge/formik';
export { formik };
import { pushToDatalayer } from '@luks/meta/src';
import DatePicker from 'react-datepicker';
import Lottie from 'lottie-react';
import gsap, { Power3 } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import GoogleMapReact from 'google-map-react';
import 'swiper/css';
import { Navigation, Autoplay, Pagination, A11y, Controller } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { DownloadIcon, CalendarIcon, LocationMarkerIcon, SearchIcon, HomeIcon as HomeIcon$1, ArrowUpIcon } from '@heroicons/react/solid';
import ReactPlayer from 'react-player';
import BodyClassName from 'react-body-classname';
import 'swiper/css/pagination';
import FsLightbox from 'fslightbox-react';
import { Helmet } from 'react-helmet';
export * from '@amazeelabs/react-framework-bridge/gatsby';

const ThemeContext = /*#__PURE__*/React.createContext({
  currentTheme: 'luzern'
});
function ThemeProvider({
  theme,
  children,
  groupTheme
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: groupTheme ? `theme-${groupTheme}` : `theme-${theme}`
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: {
      currentTheme: theme,
      groupTheme
    }
  }, children));
}
function useTheme(input) {
  const currentTheme = useContext(ThemeContext).currentTheme;
  if (currentTheme === 'zskr') {
    return input.zskr || input.luzern;
  }
  return input[currentTheme];
}
function useGroupTheme(input) {
  const groupTheme = useContext(ThemeContext).groupTheme;
  return groupTheme ? input[groupTheme] : null;
}
function useActiveTheme() {
  return useContext(ThemeContext).currentTheme;
}

function InternetExplorerChecker() {
  const [isIE, setIsIE] = useState(false);
  useEffect(() => {
    // @ts-ignore
    setIsIE(!!document?.documentMode);
  }, [setIsIE]);
  const intl = useIntl();
  const Logo = useTheme({
    luzern: /*#__PURE__*/React.createElement("img", {
      src: '/luks-logo_complete.svg',
      alt: 'Luzerner Kantonsspital'
    }),
    nidwalden: /*#__PURE__*/React.createElement("img", {
      className: 'w-full',
      src: '/nidwalden-logo_complete.svg',
      alt: 'Spital Nidwalden'
    })
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, isIE ? /*#__PURE__*/React.createElement("div", {
    className: 'fixed top-0 left-0 z-[9999] h-full w-full bg-white'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-page absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'mb-12 flex justify-center'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'max-w-xs'
  }, Logo)), /*#__PURE__*/React.createElement("div", {
    className: 'prose text-center lg:prose-xl'
  }, /*#__PURE__*/React.createElement("h1", null, intl.formatMessage({
    id: "Y/1PjG",
    defaultMessage: [{
      "type": 0,
      "value": "Bitte verwenden Sie einen anderen Browser."
    }]
  })), /*#__PURE__*/React.createElement("p", null, intl.formatMessage({
    id: "AGDas5",
    defaultMessage: [{
      "type": 0,
      "value": "Der Microsoft Internet Explorer unterstützt gewisse moderne Technologien nicht mehr, welche für luks.ch verwendet werden. Wenn Sie luks.ch trotzdem mit dem Internet Explorer verwenden, kann es zu Anzeigeproblemen kommen und es können nicht mehr alle Funktionen der verwendet werden. Wir empfehlen deshalb, für die Verwendung von luks.ch einen neuen Browser zu verwenden (bspw. Google Chrome, Mozilla Firefox, Apple Safari oder Microsoft Edge)."
    }]
  })))))) : null);
}

function Content(props) {
  const groupTheme = useGroupTheme({
    kinderspital: 'kinderspital'
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InternetExplorerChecker, null), /*#__PURE__*/React.createElement("main", {
    className: 'flex-1'
  }, props.header, /*#__PURE__*/React.createElement("div", {
    className: clsx('body min-h-[400px]', groupTheme === 'kinderspital' && 'relative')
  }, groupTheme === 'kinderspital' && /*#__PURE__*/React.createElement("div", {
    className: "color-swatches container-content absolute top-0 left-1/2 -z-10 mx-auto h-full w-full -translate-x-1/2 overflow-hidden"
  }, /*#__PURE__*/React.createElement("img", {
    className: "absolute top-0 left-0 -z-10 hidden xxl:block",
    src: '/kinderspital-paint-splatters-left.svg',
    alt: 'Kindespital paint splatters left'
  }), /*#__PURE__*/React.createElement("img", {
    className: "absolute top-80 right-0 -z-10 hidden xxl:block",
    src: '/kinderspital-paint-splatters-right.svg',
    alt: 'Kindespital paint splatters right'
  })), props.body)));
}

function Plain(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.body);
}

const CookieConsentContext = /*#__PURE__*/createContext({
  videoConsent: false,
  setVideoConsent: () => {},
  requestCookieConsent: () => {}
});
const CookieConsentProvider = props => {
  const [videoConsent, setVideoConsent] = useState(typeof props.force !== 'undefined' ? props.force : true);
  const [bannerLoaded, setBannerLoaded] = useState(false);
  const cookieGroupId = 'C0004';

  // Add click handlers to cookie banner
  useEffect(() => {
    let bannerInterval = undefined;
    if (!videoConsent && !bannerLoaded) {
      // We don't know when the cookie banner is loaded, so we're going to have to check.
      bannerInterval = window.setInterval(() => {
        if (document.getElementById('onetrust-accept-btn-handler')) {
          setBannerLoaded(true);
          window.clearInterval(bannerInterval);
        }
      }, 100);
    }
    if (!bannerLoaded) return;
    const bannerAcceptBtn = document.getElementById('onetrust-accept-btn-handler');
    const pcAllowAllBtn = document.getElementById('accept-recommended-btn-handler');
    const pcSaveBtn = document.getElementsByClassName('save-preference-btn-handler onetrust-close-btn-handler')[0];
    const consentGiven = () => setVideoConsent(true);
    if (bannerAcceptBtn) {
      bannerAcceptBtn.addEventListener('click', consentGiven);
    }
    if (pcAllowAllBtn) {
      pcAllowAllBtn.addEventListener('click', consentGiven);
    }
    if (pcSaveBtn) {
      pcSaveBtn.addEventListener('click', consentGiven);
    }

    // Remove event listener on cleanup
    return () => {
      if (bannerInterval) {
        clearInterval(bannerInterval);
      }
      if (bannerAcceptBtn) {
        bannerAcceptBtn.removeEventListener('click', consentGiven);
      }
      if (pcAllowAllBtn) {
        pcAllowAllBtn.removeEventListener('click', consentGiven);
      }
      if (pcSaveBtn) {
        pcSaveBtn.removeEventListener('click', consentGiven);
      }
    };
  });

  // Check whether we have the correct consent group activated
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (typeof props.force !== 'undefined') {
      setVideoConsent(props.force);
      return;
    }
    const getCookie = name => {
      const value = '; ' + document.cookie;
      const parts = value.split('; ' + name + '=');
      if (parts.length == 2) {
        return true;
      }
    };
    const activeConsentGroups =
    // @ts-ignore
    typeof OptanonActiveGroups !== 'undefined' ?
    // @ts-ignore
    OptanonActiveGroups.split(',').filter(item => item !== '') || null : [];
    // @ts-ignore
    const optanon = typeof window === 'object' && window.Optanon;
    const isOptanonAlertNoticeAllowed = optanon && typeof optanon.GetDomainData === 'function' && optanon.GetDomainData().ShowAlertNotice;
    if (!isOptanonAlertNoticeAllowed) {
      setVideoConsent(true);
      return;
    }
    const hasYouTubeConsent = typeof document !== 'undefined' && getCookie('OptanonAlertBoxClosed') && activeConsentGroups.includes(cookieGroupId);
    setVideoConsent(hasYouTubeConsent);
  });
  const requestCookieConsent = () => {
    // @ts-ignore
    if (typeof Optanon !== 'undefined') {
      // @ts-ignore
      Optanon.ToggleInfoDisplay();
    } else {
      setVideoConsent(true);
    }
  };
  return /*#__PURE__*/React.createElement(CookieConsentContext.Provider, {
    value: {
      videoConsent,
      setVideoConsent,
      requestCookieConsent
    }
  }, props.children);
};
const useCookieConsent = () => useContext(CookieConsentContext);

const JumpToTopButton = () => {
  const showButton = useScrollToTopButton();
  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    setTimeout(() => {
      document.querySelectorAll('#header-logo')[0].focus();
    }, 1500);
  };
  const groupTheme = useGroupTheme({
    kinderspital: {
      text: 'text-orange-400'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      text: 'text-blue-500'
    },
    nidwalden: {
      text: 'text-brown-900'
    }
  });
  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('fixed bottom-5 z-40 flex items-center rounded-full shadow-lg delay-1000 duration-300', {
      'right-7 md:right-10': showButton,
      'invisible -right-10 opacity-0': !showButton
    })
  }, /*#__PURE__*/React.createElement("button", {
    onClick: handleClick,
    className: clsx('group rounded-full bg-white p-2.5 text-xl outline-none duration-300 focus:border-transparent focus:outline-none md:p-4', theme.text),
    "aria-label": 'Scroll to top',
    "aria-hidden": "true",
    tabIndex: -1
  }, /*#__PURE__*/React.createElement(ArrowNarrowUpIcon, {
    className: 'h-6 w-6 opacity-50 transition-all group-hover:opacity-100 group-focus:opacity-100'
  })));
};
function useScrollToTopButton() {
  const [show, setShow] = useState(false);
  const limit = 290;
  useEffect(() => {
    function handleUpdate() {
      if (show && window.scrollY < limit) {
        setShow(false);
      }
      if (!show && window.scrollY >= limit) {
        setShow(true);
      }
    }
    handleUpdate();
    window.addEventListener('scroll', handleUpdate);
    return () => window.removeEventListener('scroll', handleUpdate);
  }, [show, setShow]);
  return show;
}

function StandardFrame(props) {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement(CookieConsentProvider, null, /*#__PURE__*/React.createElement(InternetExplorerChecker, null), /*#__PURE__*/React.createElement("div", {
    className: "snap-y snap-proximity scroll-pt-36"
  }, /*#__PURE__*/React.createElement("a", {
    tabIndex: 1,
    href: "#main-content",
    className: clsx(useTheme({
      luzern: 'skip-link-luks',
      nidwalden: 'skip-link-nidwalden'
    }))
  }, intl.formatMessage({
    id: "N+M7Zk",
    defaultMessage: [{
      "type": 0,
      "value": "Direkt zum Inhalt"
    }]
  })), /*#__PURE__*/React.createElement("a", {
    tabIndex: 1,
    href: "#footer",
    className: clsx(useTheme({
      luzern: 'skip-link-luks',
      nidwalden: 'skip-link-nidwalden'
    }))
  }, intl.formatMessage({
    id: "XGC31+",
    defaultMessage: [{
      "type": 0,
      "value": "Direkt zum Fussbereich"
    }]
  })), props.header, props.emergencyMessage, /*#__PURE__*/React.createElement("div", {
    id: "main-content"
  }, props.children), /*#__PURE__*/React.createElement("div", {
    id: "footer"
  }, props.footer), /*#__PURE__*/React.createElement(JumpToTopButton, null)));
}

function TimelineElement({
  anchorLabel,
  elementTitle,
  body
}) {
  const anchorLinkNoSpaces = anchorLabel.toString().replace(/\s/g, '-').replace('.', '').replace(',', '');
  const bgTheme = useTheme({
    luzern: `bg-blue-750`,
    nidwalden: `bg-brown-700`
  });
  const arrowTheme = useTheme({
    luzern: `text-blue-750`,
    nidwalden: `text-brown-700`
  });
  const timelineTheme = useTheme({
    luzern: `border-blue-750`,
    nidwalden: `border-brown-900`
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "mb-16 block max-w-[834px] last:mb-2 lg:mb-28"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pl-6 lg:pl-20"
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('relative z-0 mb-[30px] inline-block w-auto snap-start scroll-mt-32 py-[2px] px-[10px] text-[18px] font-bold leading-[28px] text-white lg:mb-[50px]', bgTheme),
    id: anchorLinkNoSpaces
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('absolute left-[-42px] -top-0.5 z-10 h-[34px] w-[34px] rounded-full border-2 bg-white py-[7px] px-[6px] lg:top-0 lg:top-0 lg:left-[-98px]', timelineTheme)
  }, /*#__PURE__*/React.createElement(ArrowRightIcon, {
    className: clsx('h-4 w-4 ', arrowTheme)
  })), anchorLabel), /*#__PURE__*/React.createElement("h3", {
    className: "mb-[30px] text-[20px] font-bold leading-[32px] lg:mb-[50px] lg:text-[30px] lg:leading-[40px]"
  }, elementTitle)), body.items.length ? /*#__PURE__*/React.createElement("section", {
    className: "group-even/element:lg:pl-[56px] pl-2 lg:pl-[56px]"
  }, /*#__PURE__*/React.createElement(Group, {
    definition: TimelineElementsGroup,
    input: body
  })) : null);
}

function CookieGate({
  children,
  enable
}) {
  const intl = useIntl();
  const groupTheme = useGroupTheme({
    kinderspital: {
      background: 'bg-orange-400/90'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      background: 'bg-blue-900/90'
    },
    nidwalden: {
      background: 'bg-brown-900/90'
    }
  });

  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  const {
    videoConsent,
    requestCookieConsent
  } = useCookieConsent();
  const showGate = enable && !videoConsent;
  return /*#__PURE__*/React.createElement("figure", {
    className: "my-5 w-full sm:my-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "aspect-w-16 aspect-h-9"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: requestCookieConsent,
    className: clsx('absolute left-0 top-0 z-10 h-full w-full cursor-pointer', theme.background, {
      block: showGate,
      hidden: !showGate
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex h-full w-full flex-col items-center justify-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex h-full w-full flex-col items-center justify-center p-5 text-white"
  }, /*#__PURE__*/React.createElement("p", {
    className: 'mb-3 text-center sm:mb-16 sm:mt-4'
  }, intl.formatMessage({
    id: "L8ETqi",
    defaultMessage: [{
      "type": 0,
      "value": "Bitte aktivieren Sie die Cookies, um Videos abzuspielen."
    }]
  }), ' '), /*#__PURE__*/React.createElement("div", {
    className: 'button-secondary pointer-events-none'
  }, intl.formatMessage({
    id: "JUu2H0",
    defaultMessage: [{
      "type": 0,
      "value": "Cookie-Einstellungen"
    }]
  }), ' ')))), children));
}

function getYoutubeId(url) {
  if (/youtube/.test(url)) {
    let ID = '';
    const parsed = url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    if (parsed[2] !== undefined) {
      const split = parsed[2].split(/[^0-9a-z_-]/i);
      ID = split[0];
    } else {
      ID = url;
    }
    return ID;
  }
}
let videoURLID$1 = '';
function Video({
  url
}) {
  const id = getYoutubeId(url);
  if (url) {
    const regex =
    // From https://stackoverflow.com/a/13286930/580371
    /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
    videoURLID$1 = regex.exec(url)?.[3] || '';
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, videoURLID$1 ? /*#__PURE__*/React.createElement(CookieGate, {
    enable: !!videoURLID$1
  }, /*#__PURE__*/React.createElement("iframe", {
    src: 'https://player.vimeo.com/video/' + videoURLID$1 + '?dnt=1',
    className: "h-full w-full",
    width: "100%",
    height: "100%",
    frameBorder: "0",
    allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture;",
    scrolling: "no"
  })) : /*#__PURE__*/React.createElement(CookieGate, {
    enable: !!id
  }, /*#__PURE__*/React.createElement("iframe", {
    className: 'h-full w-full',
    src: id ? `https://www.youtube-nocookie.com/embed/${id}` : url,
    frameBorder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true
  })));
}

function hasSourceProperty(input) {
  return input && typeof input.src === 'string';
}
function EnhancedHtml({
  Content
}) {
  // Clean up loaded scripts on unmount.
  const loadedScriptsRef = useRef([]);
  useEffect(() => {
    return () => {
      loadedScriptsRef.current.forEach(script => script.remove());
      loadedScriptsRef.current = [];
    };
  }, []);
  return /*#__PURE__*/React.createElement(Content, {
    classNames: {
      'iframe.podigee-iframe': 'h-[420px] md:h-[340px]'
    },
    components: {
      iframe: ({
        node,
        ...props
      }) => {
        if (hasSourceProperty(node.properties) && node.properties.src.match(/youtube/)) {
          return /*#__PURE__*/React.createElement(Video, {
            url: node.properties.src
          });
        }
        return /*#__PURE__*/React.createElement("iframe", props);
      },
      script: ({
        node
      }) => {
        // Editors can add scripts to the HTML. They expect scripts to be
        // executed.
        // When a script is pre-rendered on the server, there is no issue. But
        // scripts rendered by React are not executed at all.
        // To make the behavior consistent:
        // - Prevent scripts from being rendered on the server side
        // - Run scripts manually on the client side
        if (typeof document !== 'undefined') {
          const script = document.createElement('script');
          script.onerror = () => console.error('Script failed to load');
          if (node.properties && 'src' in node.properties && typeof node.properties.src === 'string') {
            script.src = node.properties.src;
          } else if (node.children?.[0]?.type === 'text' && 'value' in node.children[0]) {
            script.textContent = node.children[0].value;
          }
          if (script.src || script.textContent) {
            document.body.appendChild(script);
            loadedScriptsRef.current.push(script);
          }
        }

        // Do not render the script.
        return null;
      }
    }
  });
}

function Table({
  heading,
  rows,
  id,
  noContainer = false,
  noLastBorder = false
}) {
  const groupTheme = useGroupTheme({
    kinderspital: {
      default: 'bg-orange-200'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      default: 'bg-blue-100'
    },
    nidwalden: {
      default: 'bg-brown-100'
    }
  });

  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  if (!rows.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(noContainer ? '' : 'container-page mb-10 md:mb-14')
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-text'
  }, heading ? /*#__PURE__*/React.createElement("div", {
    className: "prose"
  }, /*#__PURE__*/React.createElement("h2", {
    id: id,
    className: 'mt-12 mb-8 md:mb-8'
  }, heading)) : null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center sm:justify-center"
  }, /*#__PURE__*/React.createElement("table", {
    className: clsx(noContainer ? 'mb-0 mt-0' : '')
  }, /*#__PURE__*/React.createElement("tbody", null, rows.map(({
    title,
    content
  }, index) => /*#__PURE__*/React.createElement("tr", {
    key: index,
    className: clsx('flex flex-col sm:table-row', !noLastBorder ? 'border-b border-grey-200' : '', index % 2 !== 0 ? theme.default : '', noLastBorder && index !== rows.length - 1 ? 'border-b border-grey-200' : '')
  }, /*#__PURE__*/React.createElement("td", {
    className: 'align-top font-bold p-4 sm:pl-0 sm:w-4/12'
  }, title), /*#__PURE__*/React.createElement("td", {
    className: 'p-4 sm:w-8/12 !pr-4'
  }, /*#__PURE__*/React.createElement(EnhancedHtml, {
    Content: content
  }))))))))));
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

function HeightTransition({
  beforeEnter,
  afterEnter,
  beforeLeave,
  afterLeave,
  children,
  show,
  duration,
  delay
}) {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current?.parentElement) {
      ref.current.parentElement.style.height = `${ref.current.offsetHeight}px`;
    }
  }, [ref]);
  return /*#__PURE__*/React.createElement(Transition, {
    show: show,
    style: {
      transitionProperty: 'height',
      transitionDuration: `${duration}ms`,
      transitionDelay: `${delay}ms`,
      transitionTimingFunction: 'ease-in-out'
    },
    enterFrom: "!h-0",
    leaveTo: "!h-0",
    beforeEnter: () => {
      if (ref.current?.parentElement) {
        ref.current.parentElement.style.height = `${ref.current.offsetHeight}px`;
      }
      beforeEnter?.();
    },
    afterEnter: () => {
      if (ref.current?.parentElement) {
        ref.current.parentElement.style.height = `auto`;
      }
      afterEnter?.();
    },
    beforeLeave: () => {
      if (ref.current?.parentElement) {
        ref.current.parentElement.style.height = `${ref.current.offsetHeight}px`;
      }
      beforeLeave?.();
    },
    afterLeave: () => {
      if (ref.current?.parentElement) {
        ref.current.parentElement.style.height = `auto`;
      }
      afterLeave?.();
    }
  }, /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, children));
}
function Collapsible({
  children,
  show,
  fadeDuration,
  scaleDuration,
  delay,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      transitionProperty: 'opacity',
      transitionDuration: `${fadeDuration}ms`,
      transitionDelay: show ? `${scaleDuration + delay}ms` : `${delay}ms`,
      opacity: show ? 1 : 0
    }
  }, /*#__PURE__*/React.createElement(HeightTransition, _extends({
    show: show,
    duration: scaleDuration,
    delay: !show ? fadeDuration + delay : delay
  }, rest), children));
}

function Accordion({
  item,
  justStyle = false,
  removeGaps = false,
  children
}) {
  const groupTheme = useGroupTheme({
    kinderspital: {
      default: 'text-orange-300 hover:text-orange-400',
      noFocus: 'text-orange-300'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      default: 'text-blue-900 hover:text-blue-400',
      noFocus: 'text-blue-900'
    },
    nidwalden: {
      default: 'text-brown-900 hover:text-brown-600',
      noFocus: 'text-brown-900'
    }
  });

  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  return /*#__PURE__*/React.createElement(React.Fragment, null, justStyle != false ? /*#__PURE__*/React.createElement(Disclosure, null, ({
    open
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Disclosure.Button, {
    className: clsx('focus flex w-full items-center justify-between py-5 text-left transition-all sm:px-5', theme.default)
  }, /*#__PURE__*/React.createElement("h3", {
    className: 'pr-8 font-bold tracking-wide lg:text-lg'
  }, item.title), open ? /*#__PURE__*/React.createElement(MinusIcon, {
    className: 'h-7 w-7 shrink-0'
  }) : /*#__PURE__*/React.createElement(PlusIcon, {
    className: 'h-7 w-7 shrink-0'
  })), /*#__PURE__*/React.createElement(Collapsible, {
    show: open,
    delay: 0,
    fadeDuration: 200,
    scaleDuration: 250
  }, /*#__PURE__*/React.createElement(Disclosure.Panel, {
    className: clsx('prose max-w-none sm:px-5 lg:prose-xl', removeGaps ? 'pt-0 pb-0' : 'pt-3 pb-6')
  }, item.Content ? /*#__PURE__*/React.createElement(EnhancedHtml, {
    Content: item.Content
  }) : null, children)))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: clsx('focus flex w-full items-center justify-between py-5 text-left transition-all sm:px-5', theme.noFocus)
  }, /*#__PURE__*/React.createElement("h3", {
    className: 'pr-8 font-bold tracking-wide lg:text-lg'
  }, item.title)), /*#__PURE__*/React.createElement("div", {
    className: "prose max-w-none pt-3 pb-6 sm:px-5 lg:prose-xl"
  }, item.Content ? /*#__PURE__*/React.createElement(EnhancedHtml, {
    Content: item.Content
  }) : null, children)));
}

function PreanalyticsData({
  id,
  heading,
  preanalyticsItems
}) {
  if (!preanalyticsItems?.length) {
    return null;
  }
  const itemRows = [];
  forEach(preanalyticsItems, item => {
    const {
      patientType,
      containerImageUrl,
      containerImageCaption,
      containerImageAlt,
      materialAmount,
      minimumVolume,
      sampleMaterial,
      furtherRemarks
    } = item;
    if (!patientType) {
      return;
    }
    const tableRows = [];
    if (containerImageUrl) {
      let containerImage = `<img src="${containerImageUrl}" alt="${containerImageAlt || ''}" />`;
      if (containerImageCaption) {
        containerImage += `<p className="mt-4">${containerImageCaption}</p>`;
      }
      tableRows.push({
        title: 'Gefäss',
        content: buildHtml(containerImage)
      });
    }
    if (materialAmount) {
      tableRows.push({
        title: 'Menge',
        content: buildHtml(materialAmount)
      });
    }
    if (sampleMaterial) {
      tableRows.push({
        title: 'Probenmaterial',
        content: buildHtml(sampleMaterial)
      });
    }
    if (minimumVolume) {
      tableRows.push({
        title: 'Mindestvolumen',
        content: buildHtml(minimumVolume)
      });
    }
    if (furtherRemarks) {
      tableRows.push({
        title: 'Weitere Anmerkungen',
        content: buildHtml(furtherRemarks)
      });
    }
    if (!tableRows.length) {
      return;
    }
    itemRows.push({
      rowName: patientType || '',
      tableRows
    });
  });
  const showAccordion = itemRows.length > 1;
  if (!itemRows.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'container-page mb-10 md:mb-14'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-text'
  }, /*#__PURE__*/React.createElement("div", {
    className: "prose"
  }, /*#__PURE__*/React.createElement("h2", {
    id: id,
    className: 'mt-12 mb-8 md:mb-8'
  }, heading)), itemRows.map(({
    rowName,
    tableRows
  }, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: 'border-t border-grey-200 last:border-b'
  }, /*#__PURE__*/React.createElement(Accordion, {
    item: {
      title: rowName || ''
    },
    justStyle: showAccordion
  }, /*#__PURE__*/React.createElement(Table, {
    rows: tableRows,
    noContainer: true,
    noLastBorder: !showAccordion
  }))))))));
}

const AnalysisDetailSection = ({
  heading,
  id,
  Content
}) => /*#__PURE__*/React.createElement(React.Fragment, null, Content && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
  id: id || heading
}, heading), /*#__PURE__*/React.createElement(EnhancedHtml, {
  Content: Content
})));
function AnalysisDetails({
  indication,
  preanalytics,
  storage,
  laboratory,
  analysis,
  billing,
  internal
}) {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement(React.Fragment, null, indication && indication.initialHtmlString !== '' ? /*#__PURE__*/React.createElement("div", {
    className: 'container-page my-10 lg:my-20'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-text'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'prose max-w-none lg:prose-xl'
  }, /*#__PURE__*/React.createElement(AnalysisDetailSection, {
    heading: intl.formatMessage({
      id: "OLqZuv",
      defaultMessage: [{
        "type": 0,
        "value": "Klinik/Indikation"
      }]
    }),
    Content: indication
  }))))) : null, preanalytics ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PreanalyticsData, {
    id: 'Präanalytik',
    heading: 'Präanalytik',
    preanalyticsItems: preanalytics
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: 'container-page my-10 lg:my-20'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-text'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'prose max-w-none lg:prose-xl'
  }, storage ? /*#__PURE__*/React.createElement(Table, {
    id: 'Aufbewahrung',
    heading: intl.formatMessage({
      id: "F4SKds",
      defaultMessage: [{
        "type": 0,
        "value": "Aufbewahrung und Stabilität"
      }]
    }),
    rows: storage,
    noContainer: true
  }) : null, laboratory ? /*#__PURE__*/React.createElement(Table, {
    id: 'Durchführendes-Labor',
    heading: intl.formatMessage({
      id: "JXnbHs",
      defaultMessage: [{
        "type": 0,
        "value": "Durchführendes Labor"
      }]
    }),
    rows: laboratory,
    noContainer: true
  }) : null, analysis ? /*#__PURE__*/React.createElement(Table, {
    id: 'Analyse',
    heading: intl.formatMessage({
      id: "5u7K0D",
      defaultMessage: [{
        "type": 0,
        "value": "Analyse"
      }]
    }),
    rows: analysis,
    noContainer: true
  }) : null, billing ? /*#__PURE__*/React.createElement(Table, {
    id: 'Abrechnung',
    heading: intl.formatMessage({
      id: "AcXNYd",
      defaultMessage: [{
        "type": 0,
        "value": "Abrechnung"
      }]
    }),
    rows: billing,
    noContainer: true
  }) : null, internal ? /*#__PURE__*/React.createElement(AnalysisDetailSection, {
    heading: intl.formatMessage({
      id: "qjDKcs",
      defaultMessage: [{
        "type": 0,
        "value": "Intern"
      }]
    }),
    Content: internal
  }) : null)))));
}

/**
 * List characters from a to z.
 * @param amount
 */
function createAlphabet(amount) {
  return Array.from(Array(amount)).map((e, i) => String.fromCharCode(i + 65));
}

/**
 * An item in the glossary. Has to have a "title" property.
 */

/**
 * Retrieve the index from a GlossaryItem.
 * @param item
 */
function getItemIndex(item) {
  return lowerCase(item.title.substr(0, 1));
}

/**
 * Combine the Glossary indices with items to an array of index button
 * properties.
 *
 * @param indices The list of index characters.
 * @param items The items in the glossary.
 * @param includeNumbers Whether to include the 0-9 index.
 */
function glossaryIndex(indices, items, includeNumbers = false) {
  const usedIndices = uniq(map(items, getItemIndex));
  const values = map(indices, i => ({
    value: toLower(i),
    label: i,
    enabled: usedIndices.includes(toLower(i))
  }));
  if (includeNumbers) {
    const enableNumber = usedIndices.some(r => ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'].includes(r));
    values.unshift({
      value: '0-9',
      label: '0-9',
      enabled: enableNumber
    });
  }
  return values;
}

function Glossary({
  name,
  index
}) {
  const [field,, helpers] = useField(name);
  const formik = useFormikContext();
  const buttonActiveClass = useTheme({
    luzern: 'bg-yellow-500',
    nidwalden: 'bg-brown-400'
  });
  const buttonHoverClass = useTheme({
    luzern: 'hover:text-blue-400',
    nidwalden: 'hover:text-brown-400'
  });
  const intl = useIntl();
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full border-grey-500 lg:border-b"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex lg:hidden"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "glossary",
    className: "sr-only"
  }, intl.formatMessage({
    id: "+rDB6J",
    defaultMessage: [{
      "type": 0,
      "value": "Glossar"
    }]
  })), /*#__PURE__*/React.createElement("select", {
    id: "glossary",
    role: "menu",
    name: name,
    className: clsx('field w-full'),
    onChange: async ev => {
      helpers.setValue(ev.target.value === '___' ? undefined : ev.target.value);
      await formik.submitForm();
    },
    value: field.value
  }, /*#__PURE__*/React.createElement("option", {
    value: '___'
  }, intl.formatMessage({
    id: "tSwEcG",
    defaultMessage: [{
      "type": 0,
      "value": "Alle"
    }]
  })), index.filter(item => item.enabled).map(item => /*#__PURE__*/React.createElement("option", {
    key: item.value,
    value: item.value
  }, item.label)))), /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:block"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "flex justify-between"
  }, /*#__PURE__*/React.createElement("li", {
    className: "mr-2 last:mr-0"
  }, /*#__PURE__*/React.createElement("button", {
    className: clsx('focus relative block h-16 border-white px-2 font-bold text-black transition', buttonHoverClass),
    onClick: () => {
      helpers.setValue('');
    }
  }, intl.formatMessage({
    id: "tSwEcG",
    defaultMessage: [{
      "type": 0,
      "value": "Alle"
    }]
  }), /*#__PURE__*/React.createElement("div", {
    className: clsx('absolute bottom-0 left-0 h-1 w-full', field.value === undefined ? buttonActiveClass : null)
  }))), index.map(item => /*#__PURE__*/React.createElement("li", {
    key: item.value
  }, /*#__PURE__*/React.createElement("button", {
    className: clsx('focus relative block h-16 px-2 font-bold text-grey-600 transition', {
      [buttonHoverClass]: item.enabled,
      'text-black': item.enabled,
      'text-grey-500': !item.enabled
    }),
    disabled: !item.enabled,
    onClick: () => {
      helpers.setValue(item.value);
    }
  }, item.label, /*#__PURE__*/React.createElement("div", {
    className: clsx('absolute bottom-0 left-0 h-1 w-full', item.value === field.value ? buttonActiveClass : null)
  })))))));
}

function AnalysisList({
  analysis,
  filters
}) {
  const descriptionClass = useTheme({
    luzern: 'text-blue-900 group-hover:text-blue-400',
    nidwalden: 'text-brown-900'
  });
  const {
    glossary,
    search
  } = filters;

  // Filter by search term
  const searchFiltered = analysis.filter(item => toLower(item.title).includes(toLower(search || '')) || toLower(item.externalAnalysis || '').includes(toLower(search || '')) || toLower(item.Description?.initialHtmlString || '').includes(toLower(search || '')));

  // Filter by glossary
  const filteredAnalysisName = searchFiltered.filter(item => glossary !== '0-9' ? startsWith(toLower(item.title), toLower(glossary || '')) : /^[0-9]/.test(item.title));

  // Sort by title
  filteredAnalysisName.sort((a, b) => a.title > b.title ? 1 : b.title > a.title ? -1 : 0);
  const ListTheme = useTheme({
    luzern: 'hover:bg-blue-100',
    nidwalden: 'hover:bg-brown-100'
  });
  return /*#__PURE__*/React.createElement("ul", {
    className: "mb-8"
  }, filteredAnalysisName.map(({
    id,
    ...item
  }) => /*#__PURE__*/React.createElement("li", {
    key: id,
    className: "border-b border-grey-200"
  }, /*#__PURE__*/React.createElement(item.Link, {
    className: clsx('focus group flex items-center p-2 transition md:p-8', ListTheme)
  }, /*#__PURE__*/React.createElement("div", {
    className: "mr-4 w-full"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-xl font-bold"
  }, item.title, item.externalAnalysis ? /*#__PURE__*/React.createElement("span", {
    className: "font-normal text-gray-500"
  }, "\xA0(", item.externalAnalysis, ")") : null), item.Description ? /*#__PURE__*/React.createElement("div", {
    className: clsx('mt-2 font-light', descriptionClass)
  }, /*#__PURE__*/React.createElement(item.Description, null)) : null), /*#__PURE__*/React.createElement(ArrowNarrowRightIcon, {
    className: clsx('h-8 w-8', descriptionClass)
  })))));
}
function AnalysisSearchList({
  analysis
}) {
  const [filters, setFilters] = useState({
    search: undefined,
    glossary: undefined
  });
  const intl = useIntl();
  const searchFiltered = analysis.filter(item => toLower(item.title).includes(toLower(filters.search || '')));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "container-page pt-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content"
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      search: undefined,
      glossary: undefined,
      useSearch: false
    },
    onSubmit: setFilters
  }, /*#__PURE__*/React.createElement(Form, {
    className: "form mb-10 px-0 md:px-8",
    placeholder: ""
  }, /*#__PURE__*/React.createElement("label", {
    className: clsx('label col-span-8 md:col-span-6 lg:col-span-7')
  }, intl.formatMessage({
    id: "GMUzA7",
    defaultMessage: [{
      "type": 0,
      "value": "nach Analyse"
    }]
  }), /*#__PURE__*/React.createElement(Field, {
    className: clsx('field'),
    type: 'text',
    name: 'search'
  })), /*#__PURE__*/React.createElement("div", {
    className: 'col-span-8 flex items-end justify-end md:col-span-2 lg:col-span-1 lg:justify-start'
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "button-primary md:w-full"
  }, intl.formatMessage({
    id: "dsIkSc",
    defaultMessage: [{
      "type": 0,
      "value": "Suchen"
    }]
  }))), /*#__PURE__*/React.createElement("label", {
    className: "label col-span-8 w-full"
  }, /*#__PURE__*/React.createElement("span", {
    className: "lg:hidden"
  }, intl.formatMessage({
    id: "UhWFDp",
    defaultMessage: [{
      "type": 0,
      "value": "Nach Anfangsbuchstaben filtern"
    }]
  })), /*#__PURE__*/React.createElement(Glossary, {
    name: 'glossary',
    index: glossaryIndex(createAlphabet(26), searchFiltered, true)
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: "container-page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content"
  }, /*#__PURE__*/React.createElement(AnalysisList, {
    analysis: analysis,
    filters: filters
  }))));
}
function AnalysisListing({
  analysis
}) {
  return /*#__PURE__*/React.createElement(AnalysisSearchList, {
    analysis: analysis
  });
}

function Anchor({
  anchorLink,
  isPreview
}) {
  const anchorLinkNoSpaces = anchorLink.toString().replace(/\s/g, '');
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('anchor', {
      'anchor--visible visible': isPreview,
      invisible: !isPreview
    }),
    id: anchorLinkNoSpaces
  }, isPreview ? '#' + anchorLinkNoSpaces : null);
}

function AnimatedNumbers({
  title,
  Link,
  linkText,
  linkType,
  items
}) {
  const textColor = useTheme({
    luzern: linkType ? 'text-blue-400' : 'text-black',
    nidwalden: 'text-brown-900'
  });
  return /*#__PURE__*/React.createElement("div", {
    className: 'container-page my-6 md:mt-8 md:mb-10'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'text-center'
  }, title && /*#__PURE__*/React.createElement("h2", {
    className: 'mb-16 text-center text-xl font-bold md:text-2xl lg:text-4xl'
  }, title), /*#__PURE__*/React.createElement("ul", {
    className: 'justify-center sm:-mx-2 sm:flex sm:flex-wrap'
  }, items?.map((item, index) => /*#__PURE__*/React.createElement(AnimatedSingleNumber, _extends({
    key: index
  }, item)))), Link ? /*#__PURE__*/React.createElement(Link, {
    className: clsx('mx-auto block text-center text-lg font-bold transition', textColor, {
      'button-primary': !linkType,
      textColor: linkType
    })
  }, linkText ? linkText : null, linkType && /*#__PURE__*/React.createElement(ArrowRightIconCustom, {
    className: 'ml-4 -mt-1 inline-block h-5 w-5'
  })) : null)));
}
function AnimatedSingleNumber({
  itemTitle,
  Image,
  numbers,
  connectingWords // if using multiple numbers, this will be the word between them
}) {
  const groupTheme = useGroupTheme({
    kinderspital: {
      default: 'text-orange-400'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      default: 'text-blue-900'
    },
    nidwalden: {
      default: 'text-brown-900'
    }
  });

  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  return /*#__PURE__*/React.createElement("li", {
    className: 'mb-10 flex-1 items-center justify-center pb-4 text-center sm:min-w-1/2 sm:px-6 md:min-w-1/2 lg:w-auto lg:max-w-1/4 xl:min-w-1/4'
  }, Image ? /*#__PURE__*/React.createElement("div", {
    className: "mb-6"
  }, /*#__PURE__*/React.createElement(Image, {
    className: "mx-auto"
  })) : null, numbers?.map((number, index) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    key: index,
    className: clsx('text-[3rem] font-bold md:text-[4rem]', theme.default)
  }, /*#__PURE__*/React.createElement(AnimateNumber, number)), connectingWords && index + 1 !== numbers.length ? /*#__PURE__*/React.createElement("div", {
    className: "text-[1.5rem] font-light"
  }, connectingWords) : null)), itemTitle ? /*#__PURE__*/React.createElement("div", {
    className: "text-xl font-light text-black lg:text-2xl"
  }, itemTitle) : null);
}
function AnimateNumber({
  number,
  unit,
  duration = 800,
  useThousandsSeparator = true
}) {
  const numberEnd = parseFloat(number);
  let numberStart = numberEnd < 1000 ? numberEnd - 10 : numberEnd - 1000;
  if (numberStart < 0) {
    numberStart = 0;
  }
  const steps = 100;
  const stepIncrement = (numberEnd - numberStart) / steps;
  const intervalDelay = duration / steps;
  function formatWithThousandsSeparator(num) {
    const numAsString = num.toString();

    // Bypass adding separator if not enabled
    if (!useThousandsSeparator) {
      return numAsString;
    }
    const characters = numAsString.split('').reverse();
    const parts = [];
    for (let i = 0; i < characters.length; i += 3) {
      const part = characters.slice(i, i + 3).reverse().join('');
      parts.unshift(part);
    }
    return parts.join('’');
  }
  const [count, setCount] = useState(numberStart);
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCount(prev => {
        const nextValue = prev + stepIncrement;
        // Stop updating if we've reached or exceeded the target
        if (numberEnd > numberStart && nextValue >= numberEnd || numberEnd < numberStart && nextValue <= numberEnd) {
          clearInterval(intervalId);
          return numberEnd;
        }
        return nextValue;
      });
    }, intervalDelay);
    return () => {
      clearInterval(intervalId);
    };
  }, [numberEnd, intervalDelay, stepIncrement, numberStart]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, formatWithThousandsSeparator(Math.floor(count)), unit ? /*#__PURE__*/React.createElement("span", {
    className: "text-[1.5rem] font-light"
  }, unit) : null);
}
function ArrowRightIconCustom({
  className
}) {
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2.5",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 5l7 7m0 0l-7 7m7-7H3",
    strokeLinecap: "round"
  }));
}

function HomeIcon({
  className
}) {
  return /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    className: className
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
  }));
}
const VariantContext = /*#__PURE__*/createContext('primary');
function HomeItem({
  Link
}) {
  const variant = useContext(VariantContext);
  const HomeIconTheme = useTheme({
    luzern: `focus-luks ${variant === 'primary' ? 'text-grey-600 hover:text-blue-500 hover:border-blue-500 hover:border-blue-500' : 'text-white hover:border-b-white text-white hover:text-white'}`,
    nidwalden: `${variant === 'primary' ? 'focus-nidwalden text-grey-600 hover:text-brown-500 hover:border-brown-500 hover:border-brown-500' : 'focus-secondary--nidwalden text-white hover:border-b-white text-white hover:text-white'}`
  });
  return /*#__PURE__*/React.createElement(Link, {
    className: clsx('block border-b border-transparent pb-1 transition duration-300', HomeIconTheme)
  }, /*#__PURE__*/React.createElement(HomeIcon, {
    className: "h-4 w-4 shrink-0",
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Home"));
}
function Item({
  Link,
  title
}) {
  const variant = useContext(VariantContext);
  const BreadcrumbTheme = useTheme({
    luzern: `focus-luks ${variant === 'primary' ? 'hover:text-blue-500 hover:border-blue-500 text-grey-600' : 'hover:border-b-white text-white'}`,
    nidwalden: `${variant === 'primary' ? 'focus-nidwalden hover:text-brown-500 hover:border-brown-500 text-grey-600' : 'focus-secondary--nidwalden hover:border-b-white text-white'}`
  });
  return Link ? /*#__PURE__*/React.createElement(Link, {
    className: clsx('ml-2 border-b border-transparent text-xs leading-none transition duration-300 sm:ml-4', BreadcrumbTheme)
  }, title) : /*#__PURE__*/React.createElement("div", {
    className: clsx('ml-2 border-b border-transparent text-xs leading-none sm:ml-4', {
      'text-grey-600': variant === 'primary',
      'text-white': variant === 'secondary'
    })
  }, title);
}
function Wrapper({
  className,
  variant = 'primary',
  children
}) {
  const theme = useActiveTheme();
  if (theme === 'zskr') {
    return null;
  }
  return /*#__PURE__*/React.createElement(VariantContext.Provider, {
    value: variant
  }, /*#__PURE__*/React.createElement("nav", {
    className: clsx('flex select-none overflow-x-auto overflow-y-hidden py-1 pl-0.5 no-scrollbar lg:overflow-y-visible', className),
    "aria-label": "Breadcrumb"
  }, /*#__PURE__*/React.createElement("ol", {
    className: "flex flex-1 items-center space-x-2 whitespace-nowrap sm:space-x-4"
  }, React.Children.map(children, (child, index) => /*#__PURE__*/React.createElement("li", {
    className: "flex items-baseline"
  }, index > 0 ? /*#__PURE__*/React.createElement("div", {
    className: clsx('shrink-0 border-b border-transparent text-xs leading-none', {
      'text-grey-600': variant === 'primary',
      'text-white': variant === 'secondary'
    }),
    "aria-hidden": "true"
  }, "/") : null, child)))));
}
var Breadcrumb = {
  Wrapper,
  HomeItem,
  Item
};

function share(platform) {
  return function (ev) {
    ev.preventDefault();
    pushToDatalayer({
      event: 'Social Shares',
      action: `Geteilt auf ${platform}`,
      Label: `Artikel teilen: ${window.location.href}`
    }, 'social-share');
    window.open(`https://www.addtoany.com/add_to/${platform}?linkurl=${window.location.href}`, 'blank', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
  };
}
function SocialShare() {
  return /*#__PURE__*/React.createElement("div", {
    className: 'prose relative mx-auto inline-flex items-center space-x-5'
  }, /*#__PURE__*/React.createElement("a", {
    className: clsx('inline-flex h-12 w-12 items-center justify-center rounded-full transition', useTheme({
      luzern: 'bg-blue-900 hover:bg-blue-400',
      nidwalden: 'bg-brown-400 hover:bg-brown-900'
    })),
    href: "#",
    target: "_blank",
    rel: "noreferrer",
    onClick: share('facebook')
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    viewBox: "0 0 24 24",
    fill: '#FFF'
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"
  }))), /*#__PURE__*/React.createElement("a", {
    className: clsx('inline-flex h-12 w-12 items-center justify-center rounded-full transition', useTheme({
      luzern: 'bg-blue-900 hover:bg-blue-400',
      nidwalden: 'bg-brown-400 hover:bg-brown-900'
    })),
    href: "#",
    onClick: share('twitter'),
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 27",
    width: "16.0905",
    height: "13.099",
    fill: '#FFF'
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.181 3.139a13.66 13.66 0 0 1-3.8 1.03c1.383-.824 2.421-2.122 2.919-3.653a13.21 13.21 0 0 1-4.2 1.609 6.6 6.6 0 0 0-11.263 6.018 18.73 18.73 0 0 1-13.6-6.9c-.58 1.013-.885 2.16-.885 3.328a6.58 6.58 0 0 0 2.928 5.487c-1.049-.029-2.076-.31-2.993-.821v.08A6.6 6.6 0 0 0 6.6 15.751c-.574.175-1.17.267-1.77.274-.415-.005-.83-.043-1.239-.113.87 2.681 3.345 4.516 6.163 4.57-2.322 1.827-5.188 2.824-8.142 2.832A12.76 12.76 0 0 1 0 23.22c3.016 1.947 6.531 2.981 10.121 2.977A18.65 18.65 0 0 0 28.963 7.403v-.852c1.263-.942 2.352-2.096 3.218-3.411z",
    fill: "#FFF"
  }))), /*#__PURE__*/React.createElement("a", {
    className: clsx('inline-flex h-12 w-12 items-center justify-center rounded-full transition', useTheme({
      luzern: 'bg-blue-900 hover:bg-blue-400',
      nidwalden: 'bg-brown-400 hover:bg-brown-900'
    })),
    href: "#",
    target: "_blank",
    rel: "noreferrer",
    onClick: share('facebook_messenger')
  }, /*#__PURE__*/React.createElement("svg", {
    width: "15",
    height: "15",
    xmlns: "http://www.w3.org/2000/svg",
    fill: '#FFF',
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0c-6.627 0-12 4.975-12 11.111 0 3.497 1.745 6.616 4.472 8.652v4.237l4.086-2.242c1.09.301 2.246.464 3.442.464 6.627 0 12-4.974 12-11.111 0-6.136-5.373-11.111-12-11.111zm1.193 14.963l-3.056-3.259-5.963 3.259 6.559-6.963 3.13 3.259 5.889-3.259-6.559 6.963z"
  })), ' '), /*#__PURE__*/React.createElement("a", {
    className: clsx('inline-flex h-12 w-12 items-center justify-center rounded-full transition', useTheme({
      luzern: 'bg-blue-900 hover:bg-blue-400',
      nidwalden: 'bg-brown-400 hover:bg-brown-900'
    })),
    href: "#",
    target: "_blank",
    rel: "noreferrer",
    onClick: share('linkedin')
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    viewBox: "0 0 22.496 22.496",
    fill: '#FFF'
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 7.03)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: "5.031",
    height: "15.466",
    fill: "#FFF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.03 7.03)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M171.7,160.181c-.053-.017-.1-.035-.16-.051s-.135-.028-.2-.039a4.507,4.507,0,0,0-.9-.091,6.99,6.99,0,0,0-5.406,2.957V160H160v15.466h5.031V167.03s3.8-5.295,5.406-1.406v9.842h5.029V165.029A5.016,5.016,0,0,0,171.7,160.181Z",
    transform: "translate(-160 -160)",
    fill: "#FFF"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: "2.435",
    cy: "2.435",
    r: "2.435",
    fill: "#FFF"
  }))))));
}

function Male({
  className
}) {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-2.5 -2.5 24 24",
    width: "24",
    height: "24",
    fill: "currentColor",
    style: {
      width: '1em',
      height: '1em'
    },
    className: className
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.364 14.636a5 5 0 1 0 7.071-7.071 5 5 0 0 0-7.071 7.071zm7.728-9.142 2.553-2.553h-1.517a1 1 0 0 1 0-2h4a.997.997 0 0 1 1 1v4a1 1 0 1 1-2 0V4.286l-2.622 2.622A7.002 7.002 0 0 1 2.95 16.05a7 7 0 0 1 9.142-10.556z"
  }));
}
function Female({
  className
}) {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-5 -2 24 24",
    width: "24",
    height: "24",
    style: {
      width: '1em',
      height: '1em'
    },
    fill: "currentColor",
    className: className
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 12A5 5 0 1 0 7 2a5 5 0 0 0 0 10zm1 4h1a1 1 0 0 1 0 2H8v1a1 1 0 0 1-2 0v-1H5a1 1 0 0 1 0-2h1v-2c0-.024 0-.047.002-.07A7.002 7.002 0 0 1 7 0a7 7 0 0 1 .998 13.93L8 14v2z"
  }));
}
function BabyContent({
  name,
  date,
  weight,
  Description,
  height,
  Image,
  hospital,
  breadcrumbItems,
  HomeLink,
  gender
}) {
  const intl = useIntl();
  const genderSymbolTheme = clsx('inline-block text-7xl ml-2', useTheme({
    nidwalden: 'text-brown-500',
    luzern: 'text-blue-500'
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: 'overflow-x-hidden'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, breadcrumbItems?.length ? /*#__PURE__*/React.createElement(Breadcrumb.Wrapper, {
    className: 'mt-3 md:mt-6'
  }, HomeLink ? /*#__PURE__*/React.createElement(Breadcrumb.HomeItem, {
    Link: HomeLink
  }) : null, breadcrumbItems.map((item, index) => /*#__PURE__*/React.createElement(Breadcrumb.Item, _extends({
    key: index
  }, item)))) : null, /*#__PURE__*/React.createElement("div", {
    className: clsx('relative mx-auto my-10 max-w-2xl text-center lg:mb-20', useTheme({
      luzern: 'prose',
      nidwalden: 'nidwalden prose'
    }))
  }, /*#__PURE__*/React.createElement(Teddy, {
    className: 'absolute left-[-10%] top-0 h-32 w-32 rotate-[20deg] animate-wiggle-slow text-[#B1A125] opacity-20 lg:left-[-25%]'
  }), /*#__PURE__*/React.createElement(Bottle, {
    className: 'absolute left-[-10%] top-[30%] hidden h-32 w-32 !rotate-[-20deg] animate-pulse  text-[#1CA5F7] opacity-20 md:block lg:left-[-25%]'
  }), /*#__PURE__*/React.createElement(Soother, {
    className: 'absolute left-[-10%] top-[65%] h-32 w-32 animate-spin-slow text-[#0A39F7] opacity-20 lg:left-[-25%]'
  }), /*#__PURE__*/React.createElement(Girl, {
    className: 'absolute right-0 top-0 hidden h-20 w-20 rotate-[-20deg] animate-pulse text-[#FD1789] opacity-20 md:block lg:right-[-20%] lg:h-32 lg:w-32'
  }), /*#__PURE__*/React.createElement(Boy, {
    className: 'absolute right-[-12%] top-5 hidden h-20 w-20 rotate-[20deg] animate-pulse text-[#1999E5] opacity-20 md:block lg:top-10 lg:right-[-40%] lg:h-32 lg:w-32'
  }), /*#__PURE__*/React.createElement(Rattle, {
    className: 'absolute right-[-10%] top-[35%] h-32 w-32 rotate-[20deg] animate-wiggle text-[#1FC924] opacity-20 lg:right-[-25%]'
  }), /*#__PURE__*/React.createElement(Mobile, {
    className: 'absolute right-[-10%] top-[75%] hidden h-32 w-32 animate-bounce text-[#8622E8] opacity-20 md:block lg:top-[65%] lg:right-[-25%]'
  }), /*#__PURE__*/React.createElement("p", {
    className: 'mb-3 font-bold lg:text-xl'
  }, intl.formatMessage({
    id: "PqjSAD",
    defaultMessage: [{
      "type": 0,
      "value": "Hallo, mein Name ist"
    }]
  })), /*#__PURE__*/React.createElement("h1", {
    className: 'mt-0 mb-5 lg:mb-10'
  }, name, gender === 'male' ? /*#__PURE__*/React.createElement(Male, {
    className: genderSymbolTheme
  }) : /*#__PURE__*/React.createElement(Female, {
    className: genderSymbolTheme
  })), /*#__PURE__*/React.createElement("div", {
    className: 'prose lg:prose-xl'
  }, /*#__PURE__*/React.createElement("p", {
    className: '!my-5'
  }, intl.formatMessage({
    id: "X+ECJ6",
    defaultMessage: [{
      "type": 0,
      "value": "Geboren bin ich am "
    }, {
      "type": 1,
      "value": "date"
    }, {
      "type": 0,
      "value": " um "
    }, {
      "type": 1,
      "value": "time"
    }, {
      "type": 0,
      "value": " in der "
    }, {
      "type": 1,
      "value": "hospital"
    }, {
      "type": 0,
      "value": ". Ich war "
    }, {
      "type": 1,
      "value": "height"
    }, {
      "type": 0,
      "value": " gross und wog "
    }, {
      "type": 1,
      "value": "weight"
    }, {
      "type": 0,
      "value": "."
    }]
  }, {
    date: intl.formatDate(date),
    time: intl.formatTime(date),
    hospital: /*#__PURE__*/React.createElement(hospital.Link, {
      className: clsx('inline-block transition hover:underline', useTheme({
        luzern: 'text-blue-400 hover:text-blue-900',
        nidwalden: 'text-brown-400 hover:text-brown-900'
      }))
    }, hospital.text),
    height: `${height}cm`,
    weight: `${weight}g`
  })), /*#__PURE__*/React.createElement(Description, null)), /*#__PURE__*/React.createElement(Image, {
    className: 'my-10 block h-auto w-full'
  }), /*#__PURE__*/React.createElement("div", {
    className: 'my-10'
  }, /*#__PURE__*/React.createElement("h2", {
    className: '!text-xl'
  }, intl.formatMessage({
    id: "hNhw73",
    defaultMessage: [{
      "type": 0,
      "value": "Teile die Freude meiner Geburt mit deinen Freunden"
    }]
  })), /*#__PURE__*/React.createElement(SocialShare, null)), /*#__PURE__*/React.createElement("div", {
    className: 'prose lg:prose-xl'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'opacity-50'
  }, intl.formatMessage({
    id: "kd3THA",
    defaultMessage: [{
      "type": 0,
      "value": "Zur Prävention des plötzlichen Kindstodes empfiehlt das Luzerner Kantonsspital, dass Kinder im ersten Lebensjahr ausschliesslich in Rückenlage schlafen. Die Neugeborenen sind während des Fotoshootings stets unter Aufsicht"
    }]
  })))))));
}
function Teddy({
  className
}) {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    className: className,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7,18c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S8.1,18,7,18z M7,21c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1 S7.6,21,7,21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,6c0.6,0,1-0.4,1-1s-0.4-1-1-1s-1,0.4-1,1S8.9,6,9.5,6z M9.5,4.5V5c0,0,0,0,0,0L9.5,4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,6c0.6,0,1-0.4,1-1s-0.4-1-1-1s-1,0.4-1,1S13.9,6,14.5,6z M14.5,4.5V5c0,0,0,0,0,0L14.5,4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,18c0-0.7-0.2-1.3-0.6-1.8c0.3-0.6,0.7-2,0.1-3.3c-0.5-1.2-1.6-2.1-3.3-2.7c0.4-0.7,0.6-1.5,0.7-2.4 c0.9-0.2,1.7-0.7,2.2-1.5c0.6-0.9,0.9-1.9,0.7-3c-0.3-2.2-2.4-3.7-4.6-3.3c-0.8,0.1-1.4,0.5-1.9,0.9C14.4,0.3,13.2,0,12,0 c-1.2,0-2.4,0.3-3.4,0.9c-0.7-0.6-1.7-1-2.6-1c-1,0-2,0.4-2.7,1.2C2.5,1.9,2.1,2.9,2.1,4c0,1.1,0.4,2.1,1.2,2.8 c0.5,0.5,1.1,0.9,1.8,1c0.1,0.9,0.4,1.7,0.7,2.4c-1.7,0.6-2.8,1.5-3.3,2.7c-0.6,1.3-0.2,2.7,0.1,3.3c-0.4,0.5-0.6,1.1-0.6,1.7 c-0.1,0.5,0,1.1,0.2,1.8C3,22.1,5.2,23.8,7.8,24H8c1.4,0,2.5-1,2.8-2.2c0.4,0.2,0.8,0.3,1.2,0.3c0.4,0,0.8-0.1,1.2-0.3 C13.5,23,14.7,24,16,24l0.2,0c2.6-0.2,4.8-1.9,5.5-4.3C22,19,22.1,18.4,22,18z M20.6,13.3c0.3,0.8,0.2,1.7,0,2.2 c-0.4-0.3-1-0.5-1.5-0.5l-0.2,0c-0.3,0-0.7,0.1-1,0.2c-0.2-0.9-1.1-2-1.7-2.5c0.6-0.4,1.1-1,1.5-1.5C19.2,11.6,20.2,12.3,20.6,13.3 z M9.1,12.2c0-0.1,0-0.2,0-0.2c0-0.2,0-0.3,0-0.5c0-0.9,0.2-1.7,0.8-2.4C9.9,9,10,8.8,10.2,8.7c0.3,0.7,1,1.3,1.8,1.3 c0.8,0,1.5-0.5,1.8-1.3c0.7,0.6,1.2,1.6,1.2,2.8c0,0.3,0,0.5,0,0.7c-0.9,0.5-1.9,0.8-3,0.8C10.9,13,9.9,12.7,9.1,12.2z M11,8.2 C11.3,8.1,11.7,8,12,8c0.3,0,0.7,0.1,1,0.2C12.8,8.6,12.4,9,12,9C11.6,9,11.2,8.6,11,8.2z M17.5,1c1.6-0.3,3.2,0.9,3.4,2.5 c0.1,0.8-0.1,1.6-0.5,2.2C20,6.2,19.5,6.6,19,6.8c-0.1-2.1-1.1-4-2.7-5.3C16.7,1.2,17.1,1,17.5,1z M15,1.8c0.1,0.1,0.1,0.1,0.2,0.1 C16.9,3,18,4.9,18,7c0,1.8-0.8,3.4-2,4.5c0.1-1.7-0.8-3.2-2.1-3.9c-0.1-0.1-0.1-0.1-0.2-0.1C13.2,7.2,12.6,7,12,7 c-0.6,0-1.2,0.2-1.7,0.4c0,0,0,0,0,0c-1.4,0.7-2.4,2.3-2.3,4c-1.1-1-1.8-2.3-2-3.8c0-0.1,0.1-0.1,0.1-0.2c0-0.1,0-0.2-0.1-0.3 C6,7.1,6,7,6,7c0-3.3,2.7-6,6-6C13.1,1,14.1,1.3,15,1.8z M3.1,4c0-0.8,0.3-1.6,0.9-2.2C4.5,1.3,5.2,1,6,1c0.6,0,1.2,0.2,1.7,0.5 C6.1,2.7,5.1,4.6,5,6.7C4.6,6.6,4.3,6.3,3.9,6C3.4,5.5,3.1,4.8,3.1,4z M3.4,13.3c0.4-1,1.4-1.7,3-2.2c0.4,0.6,0.9,1.1,1.5,1.5 c-0.6,0.6-1.5,1.6-1.7,2.6C5.8,15.1,5.4,15,5,15H4.8c-0.6,0-1.1,0.2-1.5,0.4C3.1,14.9,3,14.1,3.4,13.3z M9.9,21c0,1-0.7,2-1.9,2 l-0.2,0c-2.2-0.2-4-1.6-4.8-3.7c-0.2-0.5-0.2-0.9-0.2-1.3c0-0.4,0.2-0.9,0.4-1.3c0,0,0,0,0,0c0.1-0.1,0.2-0.1,0.2-0.2 C3.9,16.2,4.3,16,4.8,16L5,16c2.2,0.2,4.1,1.6,4.8,3.7c0,0,0,0,0,0C9.9,20.2,10,20.5,9.9,21z M10.9,20.7c0-0.4-0.1-0.9-0.3-1.3 c-0.6-1.8-1.9-3.1-3.6-3.8C7.1,15,7.9,14,8.7,13.2c1,0.5,2.1,0.8,3.3,0.8c1.2,0,2.3-0.3,3.3-0.8c0.8,0.8,1.6,1.8,1.6,2.3 c-1.7,0.7-3,2.1-3.6,3.9c-0.2,0.5-0.3,1-0.3,1.3C12.4,21.1,11.6,21.1,10.9,20.7z M20.8,19.3c-0.6,2-2.5,3.5-4.6,3.7H16 c-1.2,0-1.9-1-1.9-2.1c-0.1-0.4,0-0.7,0.2-1.2c0,0,0,0,0,0c0.6-2,2.5-3.5,4.6-3.7h0.2c0.5,0,0.9,0.2,1.3,0.5c0,0.1,0.1,0.1,0.2,0.2 c0.3,0.4,0.5,0.9,0.5,1.4C21.1,18.5,21,18.8,20.8,19.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,18c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S18.1,18,17,18z M17,21c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1 S17.6,21,17,21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6,15c-0.2,0-0.4,0.1-0.6,0.1c-0.6-0.3-1.2-0.2-1.7,0.3c0,0-0.1,0.1-0.1,0.1c-0.1,0.2-0.3,0.5-0.3,0.8 c0,0.9,1.5,2.4,1.8,2.5c0.1,0,0.1,0.1,0.2,0.1s0.2,0,0.2-0.1c0.3-0.2,1.8-1.7,1.8-2.5C14,15.6,13.4,15,12.6,15z M12,17.8 c-0.4-0.4-1-1.2-1-1.4c0-0.1,0.1-0.2,0.1-0.3c0.2-0.2,0.4-0.2,0.6,0c0.2,0.1,0.4,0.1,0.5,0c0.1-0.1,0.3-0.1,0.4-0.1 c0.2,0,0.4,0.2,0.4,0.4C13,16.7,12.4,17.4,12,17.8z"
  })));
}
function Bottle({
  className
}) {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    fill: 'currentColor',
    className: className
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.5,14h-3c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h3c0.3,0,0.5-0.2,0.5-0.5S13.8,14,13.5,14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,20h-3c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h3c0.3,0,0.5-0.2,0.5-0.5S13.8,20,13.5,20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,18h2c0.3,0,0.5-0.2,0.5-0.5S12.8,17,12.5,17h-2c-0.3,0-0.5,0.2-0.5,0.5S10.2,18,10.5,18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,12h2c0.3,0,0.5-0.2,0.5-0.5S12.8,11,12.5,11h-2c-0.3,0-0.5,0.2-0.5,0.5S10.2,12,10.5,12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,8.3V8c0-1-0.7-1.8-1.7-2c-0.3-0.6-0.7-1.2-1.2-1.7c-0.3-0.3-0.4-0.9-0.3-1.4C14,2.6,14,2.3,14,2 c0-1.1-0.9-2-2-2s-2,0.9-2,2c0,0.1,0,0.3,0.1,0.4c0,0.1,0,0.2,0,0.3c0,0,0,0.1,0,0.1c0.2,0.6,0.1,1.2-0.3,1.5C9.4,4.8,9,5.4,8.7,6 C7.7,6.2,7,7,7,8v0.3c-0.6,0.4-1,1-1,1.7v12c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2V10C18,9.3,17.6,8.6,17,8.3z M16,8h-1V7 C15.5,7,16,7.5,16,8z M12.5,8V7H14v1H12.5z M10,8V7h1.5v1H10z M10.6,5.1c0.6-0.6,0.8-1.5,0.5-2.4c0-0.2,0-0.3-0.1-0.5 C11,2.1,11,2,11,2c0-0.5,0.5-1,1-1s1,0.5,1,1c0,0.3,0,0.4-0.1,0.6c-0.3,0.9-0.1,1.9,0.5,2.5C13.7,5.3,14,5.6,14.2,6H9.8 C10,5.6,10.3,5.3,10.6,5.1z M9,7v1H8C8,7.5,8.5,7,9,7z M17,22c0,0.5-0.5,1-1,1H8c-0.5,0-1-0.5-1-1V10c0-0.5,0.5-1,1-1h8 c0.5,0,1,0.5,1,1V22z"
  })));
}
function Soother({
  className
}) {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    className: className,
    fill: 'currentColor',
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.5,2c-2,0-3.5,1.5-3.5,3.5C15,5.8,15.2,6,15.5,6S16,5.8,16,5.5C16,4.1,17.1,3,18.5,3C18.8,3,19,2.8,19,2.5 S18.8,2,18.5,2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3,6.3c-0.4,0.4-0.4,1,0,1.4C6.5,7.9,6.7,8,7,8s0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4 C7.3,5.9,6.7,5.9,6.3,6.3z M7,7L6.6,6.6L7,7C7,7,7,7,7,7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3,17.7c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.7c0-0.3-0.1-0.5-0.3-0.7 C17.5,16.1,17.3,16,17,16c0,0,0,0,0,0c-0.3,0-0.5,0.1-0.7,0.3C16.1,16.5,16,16.7,16,17C16,17.3,16.1,17.5,16.3,17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3,2.8c-0.7-1.3-1.9-2.2-3.4-2.5c-1-0.2-2-0.2-2.8,0C14.7,0.9,13,3.1,13,5.6c0,0.2-0.1,0.5-0.2,0.8 C10,4.2,7.3,2.9,5.5,3C4.7,3,4.1,3.2,3.6,3.6S3,4.7,3,5.5C2.9,7,3.8,9,5.3,11.2c-1.3,0.3-2.4,0.8-3.3,1.7c-2.5,2.5-2.5,6.6,0,9.2 c1.2,1.3,2.9,1.9,4.5,1.9c1.7,0,3.4-0.6,4.7-1.9c0.9-0.9,1.5-2,1.7-3.3c2.1,1.4,4.1,2.2,5.6,2.1c0.1,0,0.1,0,0.2,0 c0.5,0,1.1-0.2,1.5-0.6c0.5-0.4,0.8-1,0.8-1.6v-0.3c0-1.9-1.3-4.6-3.4-7.3c0.3-0.1,0.5-0.2,0.8-0.2c2.5,0,4.7-1.7,5.4-4.1 C24.2,5.5,24,4,23.3,2.8z M9.9,17.5c0,0.5,0,0.9-0.2,1.2c-0.6,1.8-2.6,2.7-4.5,2.1c-0.9-0.3-1.6-0.9-2-1.8 c-0.4-0.8-0.4-1.8-0.1-2.7c0.3-0.9,0.9-1.6,1.8-2c0.5-0.2,1-0.3,1.5-0.3c0.4,0,0.7,0.1,1.1,0.2l1.1,1.1l0,0l0,0l0,0 c0.2,0.2,0.4,0.4,0.7,0.6c0.1,0.1,0.3,0.3,0.4,0.4C9.8,16.8,9.9,17.1,9.9,17.5z M10.5,21.4c-2.2,2.2-5.7,2.2-7.8,0 c-2.1-2.2-2.1-5.7,0-7.8c0.8-0.8,2-1.4,3.2-1.5c0.3,0.3,0.5,0.7,0.8,1c-0.7,0-1.5,0.1-2.1,0.4C3.4,14,2.6,14.9,2.2,16 c-0.4,1.1-0.3,2.4,0.2,3.4c0.5,1.1,1.4,1.9,2.5,2.3C5.4,21.9,6,22,6.4,22c1.9,0,3.6-1.1,4.2-2.9c0.3-0.5,0.3-1.1,0.3-1.6 c0,0,0-0.1,0-0.1c0.4,0.3,0.7,0.6,1.1,0.8C11.8,19.5,11.3,20.6,10.5,21.4z M20,18.5l0,0.2c0,0.4-0.2,0.7-0.5,0.9 c-0.3,0.2-0.6,0.4-1,0.3c-1.4,0.1-3.5-0.8-5.6-2.3c0,0,0-0.1-0.1-0.1c-0.8-0.6-1.5-1.2-2.2-1.8c0,0-0.1-0.1-0.1-0.1 c-0.1-0.1-0.3-0.2-0.4-0.4c-0.2-0.2-0.5-0.4-0.7-0.7c0,0,0,0,0,0c0,0,0,0,0,0C6,11.2,3.9,7.6,4,5.5c0-0.4,0.1-0.9,0.4-1.1 C4.6,4.1,5.1,4,5.5,4c1.6-0.1,4.1,1.2,6.7,3.2c-0.4,0.5-0.9,1.1-1.5,1.5c-0.6,0.4-0.8,1.2-0.4,1.8c0.4,0.7,0.8,1.3,1.3,1.8 c0.5,0.5,1.1,0.9,1.8,1.3c0.2,0.1,0.4,0.2,0.6,0.2c0.4,0,0.9-0.2,1.2-0.6c0.2-0.3,0.8-1,1.5-1.5C18.8,14.2,20,16.8,20,18.5z M22.8,6.7c-0.5,2-2.4,3.3-4.4,3.3c-1.6,0-3.1,1.6-3.9,2.6c0,0,0,0,0,0c-0.2,0.2-0.4,0.2-0.6,0.2c-0.6-0.3-1.1-0.7-1.6-1.1 c-0.4-0.4-0.8-1-1.1-1.6c-0.1-0.2-0.1-0.4,0.2-0.6C11.8,9.2,14,7.4,14,5.6c0-2.1,1.4-3.9,3.3-4.4C17.7,1.1,18.1,1,18.5,1 s0.8,0,1.2,0.1c1.2,0.3,2.1,1,2.7,2.1C23,4.3,23.1,5.5,22.8,6.7z"
  })));
}
function Rattle({
  className
}) {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    fill: 'currentColor',
    className: className
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11,21c0,0.6,0.4,1,1,1s1-0.4,1-1s-0.4-1-1-1S11,20.4,11,21z M12,21C12,21,12,21,12,21v-0.5V21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8,8.9C11.8,9,11.9,9,12,9s0.2,0,0.2-0.1C12.5,8.8,14,7.3,14,6.4C14,5.6,13.4,5,12.6,5 c-0.2,0-0.4,0.1-0.6,0.1c-0.6-0.3-1.2-0.2-1.7,0.3c0,0-0.1,0.1-0.1,0.1C10.1,5.8,10,6.1,10,6.4C10,7.3,11.5,8.8,11.8,8.9z M11.1,6.1c0.2-0.2,0.4-0.2,0.6,0c0.2,0.1,0.4,0.1,0.5,0C12.4,6.1,12.5,6,12.6,6C12.8,6,13,6.2,13,6.4c0,0.3-0.6,1-1,1.4 c-0.4-0.4-1-1.2-1-1.4C11,6.3,11.1,6.2,11.1,6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,7c0-0.2,0-0.5,0-0.7c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.3c0-0.2-0.1-0.4-0.1-0.5c0,0,0,0,0,0 C17.9,2.2,15.2,0,12,0C8.8,0,6.1,2.2,5.3,5.1c0,0,0,0,0,0.1c0,0.2-0.1,0.4-0.1,0.5c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3 C5,6.5,5,6.8,5,7c0,3.3,2.3,6.1,5.4,6.8c0,0.2,0,0.4,0,0.6c0,0.5-0.1,1-0.1,1.6c-0.1,1.1-0.3,2.2-0.8,3.4c-0.2,0.5-0.4,1.1-0.4,1.7 c0,1.7,1.3,3,3,3s3-1.3,3-3.1c-0.1-0.6-0.2-1.2-0.5-1.7c-0.5-1.1-0.8-2.3-0.9-3.6c0,0,0,0,0,0c-0.1-0.7-0.1-1.2-0.1-1.7 C16.6,13.1,19,10.3,19,7z M6.1,6.1c0,0,0-0.1,0-0.1c0.2-1,0.6-1.9,1.3-2.7C8.7,3.8,10.2,4,12,4s3.3-0.2,4.7-0.7 C17.3,4.1,17.7,5,17.9,6c0,0,0,0.1,0,0.1C18,6.4,18,6.7,18,7c0,1.4-2.5,3-6,3S6,8.4,6,7C6,6.7,6,6.4,6.1,6.1z M15.9,2.5 C14.8,2.8,13.5,3,12,3c-1.5,0-2.8-0.2-3.9-0.5C9.1,1.6,10.5,1,12,1C13.5,1,14.9,1.6,15.9,2.5z M12.6,15.6c0.1,1.5,0.5,2.8,1.1,4 c0.3,0.4,0.3,0.9,0.4,1.3c0,1.1-0.9,2-2,2s-2-0.9-2-2c0-0.4,0.2-0.8,0.4-1.3c0.5-1.2,0.7-2.5,0.8-3.7c0-0.6,0-1.1,0.1-1.6 c0-0.2,0-0.3,0-0.5c0.2,0,0.4,0,0.6,0c0.2,0,0.3,0,0.5,0C12.5,14.5,12.5,15,12.6,15.6z M13,12.9C13,12.9,13,12.9,13,12.9 c-0.7,0.1-1.4,0.1-2,0C9,12.6,7.4,11.3,6.6,9.6C7.9,10.4,9.8,11,12,11c2.2,0,4.1-0.6,5.4-1.4C16.6,11.3,15,12.6,13,12.9z"
  })));
}
function Mobile({
  className
}) {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    fill: 'currentColor',
    className: className
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8,19.6c-0.2-0.7-1.2-0.8-2-0.8c-0.1-0.6-0.4-1.4-0.8-1.7v-6.3c0.3-0.2,0.5-0.5,0.5-0.8S18.3,9.3,18,9.2v-5 c0.6,0.2,1.2,0.5,1.8,0.8c0.1,0,0.2,0.1,0.2,0.1c0.2,0,0.3-0.1,0.4-0.3c0.1-0.2,0-0.5-0.2-0.7c-2.2-1.2-4.5-1.9-6.9-2.1 c0.1-0.2,0.1-0.4,0.1-0.6C13.5,0.7,12.8,0,12,0s-1.5,0.7-1.5,1.5c0,0.2,0,0.4,0.1,0.6C8.2,2.3,5.9,3,3.8,4.2 C3.5,4.3,3.4,4.6,3.6,4.8C3.7,5.1,4,5.2,4.2,5C4.8,4.7,5.4,4.4,6,4.2v3C5.7,7.3,5.5,7.6,5.5,8S5.7,8.7,6,8.8v5.5l-2.9,3.9 c-0.1,0.2-0.1,0.4,0,0.6l3,4C6.2,22.9,6.3,23,6.5,23s0.3-0.1,0.4-0.2l3-4c0.1-0.2,0.1-0.4,0-0.6L7,14.3V8.8C7.3,8.7,7.5,8.4,7.5,8 S7.3,7.3,7,7.2V3.8c1.5-0.5,3-0.8,4.5-0.8v2.1C11.2,5.3,11,5.6,11,6s0.2,0.7,0.5,0.8v2.2c-0.6,0.1-1.2,0.3-1.7,0.7 c-0.9,0.6-1.5,1.6-1.7,2.7c-0.2,1,0,2.1,0.6,3c0.6,0.9,1.6,1.5,2.7,1.7c0.2,0,0.5,0.1,0.7,0.1c1.3,0,2.4-0.6,3.2-1.6 c0.1-0.1,0.1-0.3,0.1-0.4c0-0.2-0.2-0.3-0.3-0.3l-0.9-0.3c-0.8-0.3-1.3-0.9-1.6-1.7c-0.3-0.7-0.2-1.5,0.1-2.3 c0.1-0.2,0.2-0.4,0.4-0.6c0.1-0.1,0.2-0.3,0.1-0.5c-0.1-0.2-0.2-0.3-0.4-0.3c-0.1,0-0.2,0-0.3,0V6.8C12.8,6.7,13,6.4,13,6 s-0.2-0.7-0.5-0.8V3c1.5,0,3,0.3,4.5,0.8v5.3c-0.3,0.2-0.5,0.5-0.5,0.8s0.2,0.7,0.5,0.8v6.3c-0.5,0.3-0.8,1.1-1,1.7 c-0.7,0-1.8,0-2,0.8c-0.2,0.7,0.5,1.6,1.1,2.1c-0.2,0.6-0.4,1.7,0.2,2.1c0.2,0.1,0.4,0.2,0.6,0.2c0.5,0,1.1-0.3,1.5-0.6 c0.7,0.4,1.6,0.8,2.1,0.4c0.5-0.4,0.4-1.3,0.2-2.1C20.2,21.3,21,20.4,20.8,19.6z M6.5,21.7l-2.4-3.2l2.4-3.2l2.4,3.2L6.5,21.7z M11.5,1.5C11.5,1.2,11.7,1,12,1s0.5,0.2,0.5,0.5C12.5,1.8,12.3,2,12,2c0,0,0,0,0,0C11.7,2,11.5,1.8,11.5,1.5z M13.8,15.5 C13.8,15.5,13.8,15.5,13.8,15.5l0.2,0.1c-0.6,0.5-1.5,0.7-2.4,0.6c-0.8-0.1-1.5-0.6-2-1.3c-0.5-0.7-0.6-1.5-0.5-2.3 c0.1-0.8,0.6-1.5,1.2-2c0.4-0.3,0.9-0.5,1.5-0.5c0,0.1,0,0.1-0.1,0.2c-0.4,0.9-0.5,2-0.1,3C12,14.2,12.8,15,13.8,15.5z M18.8,21.2 c-0.2,0.1-0.2,0.3-0.2,0.5c0.1,0.5,0.2,1,0.2,1.3c-0.3-0.1-0.8-0.3-1.2-0.6c-0.2-0.1-0.4-0.1-0.6,0c-0.4,0.3-1,0.6-1.2,0.6 c0,0,0,0,0,0c-0.1-0.2,0-0.8,0.2-1.3c0.1-0.2,0-0.4-0.1-0.6c-0.5-0.5-1-1.1-1.1-1.2c0.1-0.1,0.5-0.1,0.9-0.1c0.2,0,0.4,0,0.5,0 c0.2,0,0.5-0.1,0.5-0.4c0.2-0.6,0.4-1.2,0.6-1.4c0.2,0.2,0.3,0.8,0.4,1.4c0,0.3,0.3,0.4,0.6,0.4c0.6-0.1,1.3,0,1.4,0 C19.8,20.1,19.3,20.8,18.8,21.2z"
  }));
}
function Girl({
  className
}) {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    fill: 'currentColor',
    className: className
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.3,12c-0.7-3-2.7-5.5-5.3-6.9V0.5c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.3-0.1-0.5,0l-2.9,1.5 C13,1.2,12.5,1,12,1c-0.5,0-0.9,0.2-1.2,0.4c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0.1L7.7,0.1C7.6,0,7.4,0,7.2,0.1 C7.1,0.2,7,0.3,7,0.5v4.7C4.4,6.5,2.4,9,1.7,12C0.7,12.2,0,13,0,14s0.7,1.8,1.7,2c1.1,4.7,5.2,8,10.1,8c0.1,0,0.1,0,0.2,0 c4.9,0.1,9.2-3.3,10.3-8c0.9-0.2,1.7-1,1.7-2S23.3,12.2,22.3,12z M11.2,2.4c0-0.1,0.1-0.1,0.1-0.2c0,0,0.1-0.1,0.1-0.1 c0.1,0,0.2-0.1,0.2-0.1c0,0,0,0,0.1,0c0.1,0,0.2,0,0.3,0c0.3,0.1,0.5,0.2,0.7,0.5c0,0.1,0.1,0.1,0.1,0.1C13,2.7,13,2.9,13,3 c0,0.1,0,0.3-0.1,0.4c-0.1,0-0.1,0.1-0.2,0.2c0,0.1-0.1,0.1-0.1,0.2c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.1,0.1-0.2,0.1c0,0,0,0-0.1,0 c-0.1,0-0.2,0-0.3,0c-0.3-0.1-0.5-0.2-0.7-0.5c0-0.1-0.1-0.1-0.1-0.1C11,3.3,11,3.1,11,3c0-0.1,0-0.3,0.1-0.4 C11.2,2.6,11.2,2.5,11.2,2.4z M16,4.7l-2.1-1.1C14,3.4,14,3.2,14,3s0-0.4-0.1-0.6L16,1.3V4.7z M8,1.3l2.1,1.1C10,2.6,10,2.8,10,3 s0,0.4,0.1,0.6L8,4.7V1.3z M21.9,15c-0.2,0-0.4,0.2-0.5,0.4c-0.8,4.4-4.7,7.6-9.2,7.6c-0.1,0-0.1,0-0.2,0c-4.6,0.1-8.5-3.1-9.4-7.6 c0-0.2-0.3-0.4-0.5-0.4H2c-0.5,0-1-0.5-1-1s0.5-1,1-1h0.1c0.2,0,0.4-0.2,0.5-0.4c0.6-3,2.5-5.4,5.1-6.6c0,0,0.1,0,0.1,0l0.4-0.2 C8.7,5.5,9.4,5.3,10,5.2C9.9,5.4,9.7,5.7,9.6,6C9.4,6.7,9.5,7.4,9.8,8c0.3,0.6,0.9,1.1,1.5,1.3c0.1,0,0.1,0,0.2,0h0 c0.2,0.1,0.4,0.1,0.6,0.1c0.4,0,0.8-0.1,1.2-0.3c0.6-0.3,1-0.8,1.2-1.4c0.3-1-0.3-2-1.2-2.3c0,0-0.2,0-0.2,0 c-0.3,0-0.5,0.2-0.5,0.5c0,0.2,0.2,0.4,0.4,0.5c0.2,0.1,0.4,0.2,0.5,0.4c0.1,0.2,0.1,0.5,0.1,0.7c-0.1,0.4-0.4,0.7-0.7,0.8 c-0.3,0.2-0.7,0.2-1.1,0.1c0,0-0.1,0-0.1,0h0c-0.4-0.2-0.7-0.5-0.9-0.8c-0.2-0.4-0.2-0.8-0.1-1.2c0.2-0.6,0.5-1,1-1.3c0,0,0,0,0,0 c0.1,0,0.3,0,0.4,0c1.4,0,2.7,0.3,3.9,0.8l0.3,0.2c0,0,0,0,0.1,0c2.6,1.3,4.5,3.7,5.1,6.6c0,0.2,0.3,0.4,0.5,0.4H22 c0.5,0,1,0.5,1,1S22.5,15,21.9,15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1,18.2c0,0-0.8,0.8-3.1,0.8c-2.3,0-3.1-0.8-3.1-0.8c-0.2-0.2-0.5-0.2-0.7-0.1c-0.2,0.2-0.3,0.5-0.1,0.7 c0.1,0.1,1,1.2,3.9,1.2c2.9,0,3.8-1.1,3.9-1.2c0.2-0.2,0.1-0.5-0.1-0.7C15.6,17.9,15.3,18,15.1,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1,14.7C9.1,14.9,9.3,15,9.5,15c0.1,0,0.2,0,0.2-0.1c0.2-0.1,0.3-0.4,0.2-0.7c-0.3-0.7-1-1.1-1.9-1.3 C8,13,8,13,7.9,13c-0.9,0.1-1.5,0.6-1.9,1.3c-0.1,0.2,0,0.5,0.2,0.7c0.2,0.1,0.5,0,0.7-0.2C7.2,14.3,7.7,14.1,8,14 C8.3,14.1,8.8,14.3,9.1,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1,13c-0.1,0-0.1,0-0.2,0c-0.9,0.1-1.5,0.6-1.9,1.3c-0.1,0.2,0,0.5,0.2,0.7c0.2,0.1,0.5,0,0.7-0.2 c0.2-0.5,0.7-0.6,1.1-0.7c0.3,0.1,0.8,0.2,1.1,0.7c0.1,0.2,0.3,0.3,0.4,0.3c0.1,0,0.2,0,0.2-0.1c0.2-0.1,0.3-0.4,0.2-0.7 C17.6,13.6,16.9,13.2,16.1,13z"
  })));
}
function Boy({
  className
}) {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    fill: 'currentColor',
    className: className
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.3,12C21.2,7.2,16.9,3.9,12,4c-0.5,0-1.1,0-1.6,0.1c-0.7-0.8-0.6-1.9,0.1-2.6c0.6-0.6,1.5-0.6,2.1,0 c0.4,0.4,0.4,1.1,0,1.5c-0.2,0.2-0.2,0.5,0,0.7s0.5,0.2,0.7,0c0.8-0.8,0.8-2.1,0-2.9c-1-1-2.5-1-3.5,0c-1,1-1.1,2.4-0.5,3.5 C5.6,5.2,2.6,8.1,1.7,12C0.7,12.2,0,13,0,14s0.7,1.8,1.7,2c1.1,4.7,5.2,8,10.1,8c0.1,0,0.1,0,0.2,0c4.9,0.1,9.2-3.3,10.3-8 c0.9-0.2,1.7-1,1.7-2S23.3,12.2,22.3,12z M21.9,15c-0.2,0-0.4,0.2-0.5,0.4c-0.8,4.4-4.7,7.6-9.2,7.6c-0.1,0-0.1,0-0.2,0 c-4.6,0.1-8.5-3.1-9.4-7.6c0-0.2-0.3-0.4-0.5-0.4H2c-0.5,0-1-0.5-1-1s0.5-1,1-1h0.1c0.2,0,0.4-0.2,0.5-0.4c0.7-3.9,3.8-6.8,7.5-7.4 C10.8,5.7,11.6,6,12.5,6c0.7,0,1.5-0.2,2.1-0.7c3.4,0.9,6.2,3.7,6.9,7.3c0,0.2,0.3,0.4,0.5,0.4H22c0.5,0,1,0.5,1,1S22.5,15,21.9,15 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1,14.7C9.1,14.9,9.3,15,9.5,15c0.1,0,0.2,0,0.2-0.1c0.2-0.1,0.3-0.4,0.2-0.7c-0.3-0.7-1-1.1-1.9-1.3 C8,13,8,13,7.9,13c-0.9,0.1-1.5,0.6-1.9,1.3c-0.1,0.2,0,0.5,0.2,0.7c0.2,0.1,0.5,0,0.7-0.2C7.2,14.3,7.7,14.1,8,14 C8.3,14.1,8.8,14.3,9.1,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1,13c-0.1,0-0.1,0-0.2,0c-0.9,0.1-1.5,0.6-1.9,1.3c-0.1,0.2,0,0.5,0.2,0.7c0.2,0.1,0.5,0,0.7-0.2 c0.2-0.5,0.7-0.6,1.1-0.7c0.3,0.1,0.8,0.2,1.1,0.7c0.1,0.2,0.3,0.3,0.4,0.3c0.1,0,0.2,0,0.2-0.1c0.2-0.1,0.3-0.4,0.2-0.7 C17.6,13.6,16.9,13.2,16.1,13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1,18.2c0,0-0.8,0.8-3.1,0.8c-2.3,0-3.1-0.8-3.1-0.8c-0.2-0.2-0.5-0.2-0.7-0.1c-0.2,0.2-0.3,0.5-0.1,0.7 c0.1,0.1,1,1.2,3.9,1.2c2.9,0,3.8-1.1,3.9-1.2c0.2-0.2,0.1-0.5-0.1-0.7C15.6,17.9,15.3,18,15.1,18.2z"
  })));
}

function isBaby(input) {
  return has(input, 'name');
}

/**
 * Truncate the list of babies to a multiple of 4, so we don't display partial
 * rows.
 *
 * @param babies
 */
function truncateBabies(babies) {
  let slots = sum(babies.map(item => isBaby(item) ? 1 : 2));
  while (slots % 4 !== 0 && slots > 4) {
    const last = babies.pop();
    slots = slots - (isBaby(last) ? 1 : 2);
  }
  return babies;
}

var v = "5.7.13";
var fr = 29.9700012207031;
var ip = 0;
var op = 60.0000024438501;
var w = 500;
var h = 500;
var nm = "ambulence";
var ddd = 0;
var assets = [
];
var layers = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "light rays",
		parent: 2,
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 0,
						s: [
							100
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 5.828,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 11.655,
						s: [
							100
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 17.484,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 23.311,
						s: [
							100
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 29.139,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 34.968,
						s: [
							100
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 40.795,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 47.173,
						s: [
							100
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0
							]
						},
						t: 53,
						s: [
							0
						]
					},
					{
						t: 59.0000024031193,
						s: [
							100
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					595.141,
					270.9,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					595.141,
					270.9,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										595.141,
										280.368
									],
									[
										595.141,
										261.431
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0,
								0.7568627450980392,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 7,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 54",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										579.862,
										295.461
									],
									[
										560.925,
										295.461
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0,
								0.7568627450980392,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 7,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 53",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-9.468,
										0.1
									],
									[
										9.469,
										-0.1
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0,
								0.7568627450980392,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 7,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								619.704,
								295.387
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 52",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 3,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-6.705,
										6.688
									],
									[
										6.705,
										-6.688
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0,
								0.7568627450980392,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 7,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								612.57,
								278.208
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 51",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 4,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										6.653,
										6.736
									],
									[
										-6.653,
										-6.736
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0,
								0.7568627450980392,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 7,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								577.789,
								277.949
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 50",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 5,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 323676.013183594,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "light",
		parent: 3,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					595.139,
					274.383,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					595.139,
					293.701,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										1.239
									],
									[
										3.557,
										0
									],
									[
										0,
										0
									],
									[
										0,
										-3.557
									],
									[
										-1.238,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										1.24,
										0
									],
									[
										0,
										-3.557
									],
									[
										0,
										0
									],
									[
										-3.557,
										0
									],
									[
										0,
										1.239
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-4.637,
										4.359
									],
									[
										4.638,
										4.359
									],
									[
										6.891,
										2.108
									],
									[
										0.424,
										-4.359
									],
									[
										-0.423,
										-4.359
									],
									[
										-6.891,
										2.108
									],
									[
										-4.638,
										4.359
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.5450980392156862,
								0.5450980392156862,
								0.5450980392156862,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								595.139,
								293.701
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 49",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 323676.013183594,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "ambulence",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 0,
						s: [
							257.828,
							297.314,
							0
						],
						to: [
							0,
							0.167,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 7.375,
						s: [
							257.828,
							298.314,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 14.75,
						s: [
							257.828,
							297.314,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 22.125,
						s: [
							257.828,
							298.314,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 29.499,
						s: [
							257.828,
							297.314,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 36.875,
						s: [
							257.828,
							298.314,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 44.25,
						s: [
							257.828,
							297.314,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 51.625,
						s: [
							257.828,
							298.314,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0.167,
							0
						]
					},
					{
						t: 59.0000024031193,
						s: [
							257.828,
							297.314,
							0
						]
					}
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					581.828,
					396.314,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-96.435,
										53.282
									],
									[
										-110.172,
										53.282
									],
									[
										-110.172,
										-53.837
									],
									[
										43.572,
										-53.837
									],
									[
										86.305,
										-6.105
									],
									[
										110.172,
										3.33
									],
									[
										110.172,
										53.837
									],
									[
										87.467,
										53.673
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.5450980392156862,
								0.5450980392156862,
								0.5450980392156862,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								581.828,
								342.477
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 61",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										608.553,
										396.313
									],
									[
										546.584,
										396.313
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.5450980392156862,
								0.5450980392156862,
								0.5450980392156862,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 60",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										47.024,
										9.363
									],
									[
										3.737,
										9.363
									],
									[
										-9.311,
										-24.214
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.5450980392156862,
								0.5450980392156862,
								0.5450980392156862,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								621.109,
								327.009
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 57",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 3,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										516.766,
										347.411
									],
									[
										534.733,
										347.411
									],
									[
										534.733,
										363.766
									],
									[
										551.089,
										363.766
									],
									[
										551.089,
										381.733
									],
									[
										534.733,
										381.733
									],
									[
										534.733,
										398.089
									],
									[
										516.766,
										398.089
									],
									[
										516.766,
										381.733
									],
									[
										500.411,
										381.733
									],
									[
										500.411,
										363.766
									],
									[
										516.766,
										363.766
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 5,
							ix: 1
						},
						e: {
							a: 0,
							k: 100,
							ix: 2
						},
						o: {
							a: 0,
							k: 31,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.9019607843137255,
								0,
								0,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 6,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								35.911,
								-31.09
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "plus",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 4,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 323676.013183594,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "wheel 2",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					323.716,
					308.46,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					539.716,
					629.96,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-8.431,
										0
									],
									[
										0,
										-8.432
									],
									[
										8.432,
										0
									],
									[
										0,
										8.431
									]
								],
								o: [
									[
										8.432,
										0
									],
									[
										0,
										8.431
									],
									[
										-8.431,
										0
									],
									[
										0,
										-8.432
									]
								],
								v: [
									[
										-5.484,
										-23.784
									],
									[
										9.784,
										-8.516
									],
									[
										-5.484,
										6.75
									],
									[
										-20.75,
										-8.516
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.5450980392156862,
								0.5450980392156862,
								0.5450980392156862,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								536.716,
								629.96
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 13",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 0,
					k: 16,
					ix: 1
				},
				e: {
					a: 0,
					k: 100,
					ix: 2
				},
				o: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.833
								],
								y: [
									0.833
								]
							},
							o: {
								x: [
									0.167
								],
								y: [
									0.167
								]
							},
							t: 0,
							s: [
								0
							]
						},
						{
							t: 59.0000024031193,
							s: [
								1440
							]
						}
					],
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 0,
		op: 323676.013183594,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "wheel 1",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					199.716,
					308.46,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					539.716,
					629.96,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-8.431,
										0
									],
									[
										0,
										-8.432
									],
									[
										8.432,
										0
									],
									[
										0,
										8.431
									]
								],
								o: [
									[
										8.432,
										0
									],
									[
										0,
										8.431
									],
									[
										-8.431,
										0
									],
									[
										0,
										-8.432
									]
								],
								v: [
									[
										-5.484,
										-23.784
									],
									[
										9.784,
										-8.516
									],
									[
										-5.484,
										6.75
									],
									[
										-20.75,
										-8.516
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.5450980392156862,
								0.5450980392156862,
								0.5450980392156862,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								536.716,
								629.96
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 13",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 0,
					k: 16,
					ix: 1
				},
				e: {
					a: 0,
					k: 100,
					ix: 2
				},
				o: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.833
								],
								y: [
									0.833
								]
							},
							o: {
								x: [
									0.167
								],
								y: [
									0.167
								]
							},
							t: 0,
							s: [
								0
							]
						},
						{
							t: 59.0000024031193,
							s: [
								1440
							]
						}
					],
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 0,
		op: 323676.013183594,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 6,
		ty: 4,
		nm: "road",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					258,
					251,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										71,
										84.5
									],
									[
										-28.5,
										84.5
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 76,
							ix: 1
						},
						e: {
							a: 0,
							k: 0,
							ix: 2
						},
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 0,
									s: [
										0
									]
								},
								{
									t: 59.0000024031193,
									s: [
										1440
									]
								}
							],
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.8705882352941177,
								0.8705882352941177,
								0.8705882352941177,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 5,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								2
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 4,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 323676.013183594,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 7,
		ty: 4,
		nm: "road",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					258,
					232,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										118.5,
										84.5
									],
									[
										-118,
										84.5
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 85,
							ix: 1
						},
						e: {
							a: 0,
							k: 0,
							ix: 2
						},
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 0,
									s: [
										0
									]
								},
								{
									t: 59.0000024031193,
									s: [
										1440
									]
								}
							],
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.8705882352941177,
								0.8705882352941177,
								0.8705882352941177,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 5,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								2
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 4,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 323676.013183594,
		st: 0,
		bm: 0
	}
];
var markers = [
];
var LoaderData = {
	v: v,
	fr: fr,
	ip: ip,
	op: op,
	w: w,
	h: h,
	nm: nm,
	ddd: ddd,
	assets: assets,
	layers: layers,
	markers: markers
};

function Loader({
  className
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('my-10 mx-auto h-52 w-52 md:my-32 lg:my-40', className)
  }, /*#__PURE__*/React.createElement(Lottie, {
    autoplay: true,
    loop: true,
    animationData: LoaderData
  }));
}

function isElementInViewport(el) {
  const rect = el.getBoundingClientRect();
  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
}
function LoadMore({
  MoreLink,
  LoadingAnimation,
  resultLabel,
  isInfiniteScrollActive = true
}) {
  const intl = useIntl();
  const status = useOrganismStatus();
  const WrapLinkRef = useRef(null);
  useEffect(() => {
    const wrapLink = WrapLinkRef.current;
    if (wrapLink && isInfiniteScrollActive) {
      const handleScroll = () => {
        const inViewPort = isElementInViewport(wrapLink);
        if (inViewPort) {
          const link = wrapLink.querySelector('a');
          if (link) {
            link.click();
          }
        }
      };
      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }, [WrapLinkRef, isInfiniteScrollActive]);
  return /*#__PURE__*/React.createElement("div", {
    ref: WrapLinkRef,
    className: 'my-10 text-center'
  }, status === 404 ? /*#__PURE__*/React.createElement("p", {
    className: "italic text-grey-700"
  }, "Keine ", resultLabel || 'Ergebnisse', " gefunden.") : null, [102, 103].includes(status) ? /*#__PURE__*/React.createElement(LoadingAnimation, null) : MoreLink ? /*#__PURE__*/React.createElement(MoreLink, {
    className: 'button-primary'
  }, intl.formatMessage({
    id: "Tyzzqd",
    defaultMessage: [{
      "type": 0,
      "value": "Mehr laden"
    }]
  })) : null);
}

function flatten(a, level = 1) {
  return a.reduce(function (flattened, {
    value,
    title,
    children
  }) {
    return flattened.concat([{
      value,
      title,
      level: level
    }]).concat(children ? flatten(children, 2) : []);
  }, []);
}
function Select({
  selectItems,
  name,
  id
}) {
  const [field,, helpers] = useField(name);
  const [query, setQuery] = useState('');
  const groupTheme = useGroupTheme({
    kinderspital: {
      active: 'bg-orange-400 text-white',
      icon: 'text-orange-400 text-orange-400'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      active: 'bg-blue-100 text-blue-900',
      icon: 'text-blue-900'
    },
    nidwalden: {
      active: 'bg-brown-100 text-brown-900',
      icon: 'text-brown-900'
    }
  });

  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  const filteredSelect = query === '' ? selectItems : flatten(selectItems).filter(({
    title
  }) => {
    return lowerCase(title).includes(query.toLowerCase());
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, selectItems.length < 10 ? /*#__PURE__*/React.createElement(Listbox, {
    value: field.value,
    onChange: ev => helpers.setValue(ev)
  }, /*#__PURE__*/React.createElement("div", {
    className: 'relative'
  }, /*#__PURE__*/React.createElement(Listbox.Button, {
    id: id,
    className: 'field relative truncate pr-12 pl-4 pb-2 text-left'
  }, flatten(selectItems).filter(item => item.value === field.value)[0]?.title ||
  // Non-breaking space to preserve the height.
  ' ', /*#__PURE__*/React.createElement("span", {
    className: 'sr-only'
  }, "test"), /*#__PURE__*/React.createElement("div", {
    className: 'absolute right-0 top-1/2 flex h-full w-12 -translate-y-1/2 items-center justify-center'
  }, /*#__PURE__*/React.createElement(ArrowDownIcon, {
    className: 'h-4 w-4'
  }))), /*#__PURE__*/React.createElement(Transition, {
    as: Fragment,
    leave: "transition ease-in duration-100",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/React.createElement(Listbox.Options, {
    className: "absolute z-50 -mt-px max-h-60 w-full min-w-[200px] overflow-auto border border-grey-500 bg-white text-base shadow-lg focus:outline-none sm:text-sm"
  }, flatten(selectItems).map(({
    title,
    value,
    level
  }, index) => /*#__PURE__*/React.createElement(Listbox.Option, {
    key: index,
    className: ({
      active
    }) => clsx('relative cursor-default select-none py-2.5 pr-4', active ? theme.active : 'text-black', {
      'pl-10': level === 1,
      'pl-16': level === 2
    }),
    value: value
  }, ({
    selected
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: clsx('block', {
      'font-bold': selected,
      'font-normal': !selected && level === 1,
      'font-thin': !selected && level === 2
    })
  }, title), selected ? /*#__PURE__*/React.createElement("span", {
    className: clsx('absolute inset-y-0 left-0 flex items-center ', theme.icon, {
      'pl-3': level === 1,
      'pl-9': level === 2
    })
  }, /*#__PURE__*/React.createElement(CheckIcon, {
    className: "h-5 w-5",
    "aria-hidden": "true"
  })) : null))))))) : /*#__PURE__*/React.createElement(Combobox, {
    value: field.value,
    onChange: ev => helpers.setValue(ev)
  }, /*#__PURE__*/React.createElement("div", {
    className: 'relative'
  }, /*#__PURE__*/React.createElement(Combobox.Input, {
    className: 'field relative pl-3 pr-12 pb-2 text-left',
    onChange: event => setQuery(event.target.value),
    displayValue: value => flatten(filteredSelect).filter(item => item.value === value)[0]?.title || '',
    id: id
  }), /*#__PURE__*/React.createElement(Combobox.Button, {
    className: 'absolute right-0 top-1/2 flex h-full w-12 -translate-y-1/2 items-center justify-center pr-0.5'
  }, /*#__PURE__*/React.createElement(ArrowDownIcon, {
    className: 'h-4 w-4'
  })), /*#__PURE__*/React.createElement(Transition, {
    as: Fragment,
    leave: "transition ease-in duration-100",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/React.createElement(Combobox.Options, {
    className: "absolute z-50 -mt-px max-h-60 w-full min-w-[200px] overflow-auto border border-grey-500 bg-white text-base shadow-lg focus:outline-none sm:text-sm"
  }, filteredSelect.length === 0 && query !== '' ? /*#__PURE__*/React.createElement("div", {
    className: "relative cursor-default select-none py-2 px-4 text-grey-500"
  }, "Nothing found.") : flatten(filteredSelect).map(({
    title,
    value,
    level
  }, index) => /*#__PURE__*/React.createElement(Combobox.Option, {
    key: index,
    className: ({
      active
    }) => clsx('relative cursor-default select-none py-2.5 pr-4', active ? theme.active : 'text-black', {
      'pl-10': level === 1,
      'pl-16': level === 2
    }),
    value: value
  }, ({
    selected
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: clsx('block', {
      'font-bold': selected,
      'font-normal': !selected && level === 1,
      'font-thin': !selected && level === 2
    })
  }, title), selected ? /*#__PURE__*/React.createElement("span", {
    className: clsx('absolute inset-y-0 left-0 flex items-center pl-3', theme.icon, {
      'pl-3': level === 1,
      'pl-9': level === 2
    })
  }, /*#__PURE__*/React.createElement(CheckIcon, {
    className: "h-5 w-5",
    "aria-hidden": "true"
  })) : null))))))));
}

function BabyGallery({
  babies,
  Form,
  genders,
  locations,
  MoreLink,
  infiniteScroll
}) {
  const list = MoreLink ? truncateBabies([...babies]) : babies;
  return /*#__PURE__*/React.createElement("div", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content my-10'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'my-10',
    id: "form"
  }, /*#__PURE__*/React.createElement(BabyForm, {
    genders: genders,
    locations: locations,
    Form: Form
  })), /*#__PURE__*/React.createElement("div", {
    className: 'flex-wrap md:-mx-3 md:flex lg:-mx-5'
  }, list.map((baby, index) => !isBaby(baby) ? /*#__PURE__*/React.createElement("div", {
    key: index,
    className: 'mb-3 last:mb-0 md:mb-0 md:w-1/2 md:p-3 lg:p-5'
  }, /*#__PURE__*/React.createElement(BabyAdv, baby)) : /*#__PURE__*/React.createElement("div", {
    key: index,
    className: 'mb-3 w-full last:mb-0 md:mb-0 md:w-1/2 md:p-3 lg:w-1/4 lg:p-5'
  }, /*#__PURE__*/React.createElement(BabyTeaser, baby)))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(LoadMore, {
    MoreLink: MoreLink,
    LoadingAnimation: Loader,
    resultLabel: 'Babies',
    isInfiniteScrollActive: infiniteScroll
  }))));
}
function BabyTeaser({
  Link,
  Image,
  name
}) {
  const groupTheme = useGroupTheme({
    kinderspital: {
      arrow: 'text-orange-400',
      title: 'group-hover:text-orange-400',
      link: 'focus-kinderspital'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      arrow: 'text-blue-900 group-hover:text-blue-400',
      title: 'group-hover:text-blue-400',
      link: 'focus-luks'
    },
    nidwalden: {
      arrow: 'text-brown-400',
      title: 'group-hover:text-brown-400',
      link: 'focus-nidwalden'
    }
  });
  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  return /*#__PURE__*/React.createElement(Link, {
    className: clsx('group block p-0.5', theme.link)
  }, /*#__PURE__*/React.createElement("div", {
    className: 'aspect-w-2 aspect-h-1 relative mb-5 block overflow-hidden rounded-t-md'
  }, /*#__PURE__*/React.createElement(Image, {
    className: 'block w-full max-w-full object-cover transition duration-300 group-hover:scale-105'
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    className: clsx('text-xl font-bold transition', theme.title)
  }, name)), /*#__PURE__*/React.createElement("div", {
    className: clsx('inline-block transition-all group-hover:pl-5', theme.arrow)
  }, /*#__PURE__*/React.createElement(ArrowNarrowRightIcon, {
    className: 'mt-2.5 h-7 w-7'
  })));
}
function BabyAdv({
  Image,
  title,
  description,
  cta,
  TextOrientation = 'left'
}) {
  const TitleTheme = useTheme({
    luzern: 'text-blue-900',
    nidwalden: 'text-brown-900'
  });
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('group w-full overflow-hidden rounded-t-md lg:relative xl:h-[270px]')
  }, /*#__PURE__*/React.createElement(Image, {
    className: 'block w-full max-w-full object-cover transition duration-300 group-hover:scale-105 xl:absolute'
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: clsx('absolute hidden h-full from-white opacity-90 md:w-full xl:block', {
      'bg-gradient-to-r': TextOrientation === 'left',
      'bg-gradient-to-l': TextOrientation === 'right'
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: clsx('mt-5 xl:absolute xl:top-1/2 xl:mt-0 xl:w-2/3 xl:-translate-y-1/2', {
      'lg:pr-7 xl:left-1/3 xl:text-right': TextOrientation === 'right',
      'xl:pl-7': TextOrientation === 'left'
    })
  }, /*#__PURE__*/React.createElement("h2", {
    className: clsx('text-xl font-bold transition md:text-2xl xl:text-4xl', TitleTheme)
  }, title), description && /*#__PURE__*/React.createElement("p", {
    className: 'mt-2 text-lg font-thin xl:mt-5'
  }, description), /*#__PURE__*/React.createElement(cta.Link, {
    className: 'button-primary mt-2 mb-3 xl:mt-5 xl:mb-0'
  }, cta.text))));
}
function BabyForm({
  Form,
  genders,
  locations
}) {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement(Form, {
    className: 'form !grid-cols-12'
  }, /*#__PURE__*/React.createElement("label", {
    className: 'label col-span-12 lg:col-span-3'
  }, intl.formatMessage({
    id: "HAlOn1",
    defaultMessage: [{
      "type": 0,
      "value": "Name"
    }]
  }), /*#__PURE__*/React.createElement(Field, {
    className: clsx(useTheme({
      luzern: 'field-luks',
      nidwalden: 'field-nidwalden'
    })),
    type: 'text',
    name: 'name'
  })), /*#__PURE__*/React.createElement("div", {
    className: 'col-span-12 lg:col-span-2'
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: 'gender',
    className: 'label'
  }, intl.formatMessage({
    id: "XN4yOn",
    defaultMessage: [{
      "type": 0,
      "value": "Geschlecht"
    }]
  })), /*#__PURE__*/React.createElement(Select, {
    selectItems: [{
      value: 'All',
      title: intl.formatMessage({
        id: "9EcK6m",
        defaultMessage: [{
          "type": 0,
          "value": "- Geschlecht -"
        }]
      })
    }, ...genders],
    name: 'gender',
    id: 'gender'
  })), /*#__PURE__*/React.createElement("label", {
    className: 'label col-span-12 lg:col-span-2'
  }, intl.formatMessage({
    id: "D7S5YM",
    defaultMessage: [{
      "type": 0,
      "value": "Geburtsdatum"
    }]
  }), /*#__PURE__*/React.createElement(DateWidget$1, {
    name: "date"
  })), /*#__PURE__*/React.createElement("div", {
    className: 'col-span-12 lg:col-span-3'
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: 'location',
    className: 'label'
  }, intl.formatMessage({
    id: "qUkS0z",
    defaultMessage: [{
      "type": 0,
      "value": "Standort"
    }]
  })), /*#__PURE__*/React.createElement(Select, {
    selectItems: [{
      value: '',
      title: intl.formatMessage({
        id: "ftoYlu",
        defaultMessage: [{
          "type": 0,
          "value": "- Alle Standorte -"
        }]
      })
    }, ...locations],
    name: 'location',
    id: 'location'
  })), /*#__PURE__*/React.createElement("div", {
    className: 'col-span-12 flex items-end justify-end lg:col-span-2 lg:justify-start'
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "button-primary lg:w-full"
  }, intl.formatMessage({
    id: "JYs1ab",
    defaultMessage: [{
      "type": 0,
      "value": "Filtern"
    }]
  }))));
}
const isDateSupported$1 = () => {
  if (typeof window === 'undefined') {
    return true;
  }
  const input = document.createElement('input');
  const value = 'a';
  input.setAttribute('type', 'date');
  input.setAttribute('value', value);
  return input.value !== value;
};
function DateWidget$1({
  name
}) {
  const [field,, helpers] = useField(name);
  const FieldTheme = useTheme({
    luzern: 'field-luks',
    nidwalden: 'field-nidwalden'
  });
  return isDateSupported$1() ? /*#__PURE__*/React.createElement(Field, {
    type: "date",
    name: name,
    id: name,
    value: field.value,
    className: clsx(FieldTheme)
  }) : /*#__PURE__*/React.createElement(DatePicker, {
    className: clsx(FieldTheme),
    selected: field.value ? new Date(field.value) : new Date(Date.now() - 86400000),
    dateFormat: "dd.MM.yyyy",
    onChange: date => {
      helpers.setValue(date.toLocaleDateString('en-CA'));
    }
  });
}

function useSetMediaQuery() {
  const [mediaQuery, setMediaQuery] = useState('mobile');
  useEffect(() => {
    const SetMediaQuery = () => {
      if (window.matchMedia('(max-width: 767px)').matches) {
        return 'mobile';
      }
      if (window.matchMedia('(min-width: 768px) and (max-width: 1023px)').matches) {
        return 'tablet';
      }
      return 'desktop';
    };
    setMediaQuery(SetMediaQuery());
    const handler = debounce(() => setMediaQuery(SetMediaQuery()));
    window.addEventListener('resize', handler);
    return () => {
      window.removeEventListener('resize', handler);
    };
  }, [setMediaQuery]);
  return mediaQuery;
}

function AnimatedBackground({
  className,
  children
}) {
  const groupTheme = useGroupTheme({
    kinderspital: {
      background: 'bg-orange-400'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      background: 'bg-blue-900'
    },
    nidwalden: {
      background: 'bg-brown-600'
    }
  });
  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;

  // Used for conditional rendering for specific drupal groups
  const activeGroupTheme = useGroupTheme({
    kinderspital: 'kinderspital'
  });
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(className, 'relative text-white', theme.background)
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('absolute right-0 h-[300px] w-[300px] scale-[7] md:scale-[10] lg:scale-[17]', activeGroupTheme === 'kinderspital' && 'lg:scale-[12]')
  }, /*#__PURE__*/React.createElement("div", {
    className: 'relative -right-10 h-full w-full animate-spin-slow md:right-auto'
  }, activeGroupTheme === 'kinderspital' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'absolute top-[50%] left-[52%] h-20 w-20 -translate-y-1/2 -translate-x-1/2'
  }, /*#__PURE__*/React.createElement("svg", {
    className: "",
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 921 522.9",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("style", null, '.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}'), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.3 183.1c.8.1 1.9.3 2.7.4.4 1.7 1.5 2.7 3.2 2.8 0 .5 0 1.1-.1 1.7 2.5 5.4 6.6 9.3 11.8 12.2 1.5.3 2.1-.1 2.3-1.3.9 1.1.1 2-.3 3.1.7 5.3 2.9 9.3 8.6 10.5l-.5.9.5-.8c10.8 5.7 16.9 2.7 18.2-9.7-1.2-1.1-1.9-2.1-2.4-3.2h.1c0-2.8.1-5.6.1-8.4.7-1.5 1.5-2.9 2.4-4.2.9-4 2-8.1-2.5-10.6v.3l-.4-.4c.1.1.3.1.4.3-.8-3.2-4.5-2.3-6.2-4.2h-.2c-1.9-1.6-4-2.7-6.1-3.9-1.2.3-2.3-.1-2.9-1.2-.8-.7-1.7-1.2-2.8-1.5-.9.5-1.5.3-1.9-.7-1.2-1.2-2.7-1.7-4.4-1.7-.1 0-1.5.7-1.5.7s-.1-1.2-.1-.9c-.4-2.5-2.7-3.3-4.8-4.2v.1l-.1-.1h.1c-1.2-2-2.9-2.4-5-2-.4.3-.8.5-1.1.9-.3.3-.4.5-.7.8.3-1.3 1.5-2.7.1-4.1-2.3-1.5-4.6-1.3-7-1.1-.1-.4-.1-.9-.3-1.3-.9.1-1.7.3-2.7.4-4.6-2.1-9.4-2.8-14.2-.7-1.3.9-2.8 2-4.4 2.5 1.5-.8 2.9-1.7 4.4-2.5-1.1-.3-2.1-.4-3.3-.3-.4.9-.8 2-1.2 2.9-1.2-.1-2.1.4-2.5 1.5-.8 0-1.6-.1-2.4-.1v2.5c-1.3.9-1.5 2.1-.7 3.6-.1 2.1.9 3.3 2.9 3.9.4 2.1 1.6 3.2 3.9 2.7-1.3-.9-2.5-1.9-3.9-2.7 1.3.8 2.7 1.7 3.9 2.7 2.7.3 5.2.4 7.8.7 2.7 5.8 8.3 9.5 13.2 13.7zm6.8-24.7c-.1.3-.3.5-.3.9v-.7c.2 0 .2 0 .3-.2zm548.8 221c-1.1-.3-2.1-.4-3.2-.4-.1-.9-.4-1.9-.5-2.8-3.6 0-7.6-2.1-10.6 1.7-1.9.9-2.9 2.4-2.4 4.6-.4 2.1.5 3.5 2.7 4 .5 2 1.9 3.1 4 2.7h3.5c6.4-1.6 6.6-2 6.5-9.8zM696.5 89.3c-1.1 0-2.1 0-3.2.1-.3 1.1-.3 2-.3 3.1-.9.3-2 .4-2.9.5-.3 1.9-1.1 3.2-2.9 3.9-2 10.4-3.9 20.7 1.9 30.5 4.6 4.6 6.4 4.6 11.7 0 3.7-1.6 7.3-3.3 9.8-6.6 2.3-.3 3.7-1.6 4.4-3.7 6.2-3.5 8.2-9 7.3-15.8-.4-2.8-1.3-5.6-2-8.2-2.7-1.6-2.8-4.4-3.2-7-.8-.1-1.7-.3-2.5-.4.3-.5.4-1.2.4-1.9-.7-.4-1.2-.8-1.9-1.2-2-.1-4-.3-6.1-.5-1.3-.9-2.3-.7-2.8.8h.1l-.3.1v-.1c-1.5.4-1.9 1.3-1.5 2.7-1.7.4-3.3.7-5 1.1-.4.8-.6 1.8-1 2.6zm169.3 295.9c2 .4 2.8-.5 2.9-2.4l.4-.5c.9 0 1.9-.1 2.7-.3.1-2 .3-4.1.4-6.1-.9-.4-1.9-.8-2.8-1.2.3-1.1 0-1.9-.9-2.4.1-1.7-.4-2.8-1.7-3.3v-.7c-.1-1.3-.7-2.3-2-2.8-1.1.3-2 0-2.8-.8-1.2.3-2.4.5-3.6.8-3.3-1.2-6.8-2.1-10.2-.3-7.3.1-7.8.4-10.2 6.9-.9 3.2-.5 5.8 3.1 7 .5 1.9 1.7 2.9 3.7 2.8.7.9 1.6 1.3 2.7 1.1 1.9 2.8 4.5 3.1 7.6 2.5 3.8 1.3 7.2 1.6 10.7-.3zm-180-26.8c.7-.9.9-2 .8-3.1 1.7-.4 2.8-1.6 3.2-3.2 8.4-.7 15.7-4 22.7-8.4 0-.8-.1-1.6-.3-2.4.4-1.2.8-2.3 1.3-3.5l.1-.4c.8-.3 1.6-.5 2.4-.7.5-3.9 2.9-8-1.7-11 .1-.9-.4-1.6-1.3-1.7 0-.9-.1-1.7-.3-2.7-.9 0-1.7 0-2.7.1v1.7c0-.5-.1-1.2 0-1.7-1.2-.4-2.3-.7-3.5-1.1v-.1c-.4-.9-.8-1.7-1.2-2.7-1.1.3-1.9 0-2.4-.9-1.1.1-2.3.4-3.3.5-.7-.9-1.6-1.2-2.7-.8-9.2-2.8-12.3-9.2-11.2-18.3.1-.5 0-1.2-.1-1.7 2.4-1.3 4.8-2.7 7.2-4 6.5 1.9 12.1-1.2 17.8-3.5 2.8-1.1 1.6-3.9 2.1-5.8h.1c-5-11.3-13.8-11.2-23.8-7.6-2.3 1.2-4.5 1.5-6.9.4-2.1-.5-4.1-1.2-6.2-1.7.3-.9-.1-1.7-1.1-2.1-.9-6.1 3.2-10.9 4.6-16.3 2.5-1.9 2.9-4.5 2.8-7.4 4.5-3.9 3.3-9.3 4-14.2.9-6.4-1.6-11-7.4-13.8-1.3-2.1-2.7-4.2-4.1-6.2-5-1.7-5.6-6.1-6.2-10.5 1.9-.4 3.1-1.7 3.7-3.5 1.9 0 3.3-.7 3.7-2.7l.1-.1c2.1-.5 3.2-1.9 3.3-4 4.2-6.9 4-7.7-3.7-11.7-1.6-1.7-3.1-3.3-4.6-5-3.1-.5-6-1.1-9-1.6-.4-2-1.7-3.2-3.6-3.7.3-1.1-.1-2-1.1-2.5v-6.2c-.8-.3-1.7-.7-2.5-1.2v-5.7c.9-.4 1.9-.8 2.8-1.1-.1-5.3 1.6-10.8-.4-16.1-.9 0-1.9-.3-2.8-.4l-.3-.3c0-.9 0-2-.1-2.9-.9-.1-1.9 0-2.9.1-.4-1.1-1.2-1.5-2.3-1.2-.4-.9-.8-1.9-1.3-2.8-1.1.1-2.1.4-3.2.5-.7-1.1-1.7-1.5-2.9-1.5-1.3-5.6 1.1-12-4.1-16.6.3-2.3-.8-3.7-3.1-4.4-1.6-2.9-3.8-5.2-7.3-6-.5-1.7-1.6-2.9-3.6-2.5-1.1-.3-2.1-.7-3.3-.9l-.1-.1c-1.3-2.5-3.5-3.7-6.1-4.1.3-.9.1-1.9-.8-2.4.8-.7 1.9-2 2.4-1.7 7.4 2.5 14.1-1.1 21-2.7.1-.9.3-1.9.3-2.7l.7-.5c2 .1 2.8-.8 2.3-2.8.1-1.3.1-2.5.3-3.9.3-1.2.4-2.3.7-3.5-.9-.4-1.9-.5-2.8-.7l-.3.4c-.8-3.9-4.4-3.6-6.9-4.6.3-.8.1-1.5-.3-2.1-1.2 0-2.4.1-3.6.1-3.5-1.7-6.8-.7-10 .8-1.1-.3-2.1-.4-3.3-.3-.5 1.9-1.9 2.8-3.7 3.1-2 5.7.1 11.7-.5 17.4-5.4-1.7-10.9-.5-16.3.3-.1.9-.3 1.9-.3 2.8l-.5.4c-1.1-.1-2-.1-3.1-.1-.1.9-.3 2-.4 2.9l-.1.1c-2 0-3.6.8-3.9 3.1h-.3c-3.5 4.1-5.2 11-13 7.8-.5-.9-.8-1.9-.8-2.9-2.9-1.6-5-4.1-6.6-6.9-1.7-.5-3.6-1.2-5.3-1.7-1.1-3.3-3.5-5.3-6.6-6.5 0-1.2-.4-2.3-1.5-2.9 0-3.5.1-6.8.1-10.2 2-2.7 4-5.2 6-7.8.8-4.1 2-8.2.4-12.3-1.1-.1-2-.3-2.9-.7-.1-2.1-1.2-3.2-3.3-3.2l-.4-.3c-.3-.8-.5-1.6-.5-2.5-4.2-.3-8.5-.5-12.7-.8-.4.8-.7 1.7-.8 2.7-5.2 2.7-6.1 7.4-6 12.6 0 6.1 2.1 12.2-.5 18.2-2.1.4-4.2.8-6.4 1.2-2.9 2.9-7 1.9-10.4 3.6-3.5-.1-7-.3-10.5-.4-.3-.9-.5-1.7-.8-2.7-.9-.1-2-.1-2.9-.1l-.4-.4c0-.9 0-1.9-.1-2.8-.9-.1-1.9-.1-2.8 0-.9-1.3-1.9-2.5-2.8-3.9.7-.4 1.2-.9 1.6-1.5.8-1.2 1.3-2.5 1.9-3.9.4-.8.8-1.6 1.2-2.5.3-.1.5-.1.9-.3-.1-2.7 1.1-5.6.3-8 0-.4 0-.8-.1-1.2-.3-1.3-.8-2.5-1.5-3.7-.8-.9-1.6-1.9-2.4-2.7l-1.6-1.6c-1.6-1.2-3.3-1.9-5.2-2.4h-5.2c-2.4 1.3-5.6.9-7.6 3.2h-.1c-4.5 1.9-5.3 6-5.7 10.1 0 .3-.1.4-.1.7-.1 0-.3.1-.4.1-.3 2.1-1.5 3.2-3.6 3.3 0 .9-.3 1.7-.7 2.5-2.1-.1-4.2-.4-6.5-.5-.5-1.9-1.9-2.5-3.6-2.7-.8-1.3-1.7-2.7-2.5-4-.5-5.6-1.1-11.2-1.6-16.6V27.5c-.9-.1-1.7-.4-2.5-.8-.4-3.1-.8-6.1-1.2-9.3-.9-.3-1.7-.5-2.5-1.1.1-2.8.5-5.8-3.2-6.8 0-1.1-.1-2-.5-3.1-1.2.1-2.4.4-3.6.5-.9-.8-2-.8-3.1-.1-2.1 0-4.4.1-6.5.1-.1.9-.4 1.9-.7 2.8-2 .4-3.2 1.5-3.1 3.6-.4 1.1-.9 2.1-1.3 3.1-5.8 7.7-3.3 16.1-2 24.4.1 2.1.1 4.1.3 6.2 4.9 6.4 10.8 11.3 19.4 11.7.4-.4.8-.8 1.3-1.1l-1.3 1.1c2.7 1.9 5.2 3.6 7.8 5.4.3.9.8 1.3 1.7 1.2.8.9 1.5 2 2.3 2.9 0 1.7.5 3.2 2.3 3.9-.8 3.1-3.1 4.9-5.8 6.2-5.4-4.1-11.4-3.5-17.1-1.2-3.7 1.5-7.2 2.4-11.2 1.5-.1.3-.1.5-.3.7l-.1-.1.4-.7c-.9-1.3-1.7-2.5-2.7-3.9.5-3.3 1.2-6.6 1.7-10 2.4-6.6-1.7-10.1-6.2-13.4-6.5.3-13 .4-19.5.7-.7 1.9-2.1 2.8-4.1 2.7-.1.9-.4 1.9-.7 2.7-.9.5-2 .9-2.9 1.5h-2.7c-.1.9-.4 1.9-.7 2.8l.7.7s0 .1-.1.1c-.3-.4-.5-.8-.5-.8-1.1.1-2.1.3-3.1.4 0 .9-.3 1.9-.7 2.7l.7.9c-.1.1-.3.3-.3.4-.1-.4-.3-.9-.4-1.3-5.6 2-11 4.6-17.1 3.9l-3.6-3.6c-5.4-.7-10.9-.5-16.2.8-.9 2.4-4.6 2.7-4.5 5.8-.9.3-1.9.4-2.8.5.4 5.8-3.1 12.2 2.8 17.1-.3 2.1.9 3.1 2.9 3.3 1.6 3.5 3.2 6.9 4.6 10.4-1.7 10.2 3.1 20.6-.5 30.8-2 1.3-4.1 2.8-6.1 4.1-1.2 4.1-3.5 7.7-6.9 10.4-.4 1.7-.8 3.6-1.2 5.3-5.2 3.9-5.2 10.8-9.2 15.4-.4 3.1-.8 6.2-1.3 9.3-.9.3-1.9.5-2.8.7.1 1.1 0 2.1-.5 3.2-3.7-.3-8.2 3.1-10.6-2.7-.9-.1-2-.4-2.9-.5l-.1-.1c.3-1.1.1-2.1-.1-3.2-1.2-.1-2.3-.1-3.3.3-1.1-.1-2.1-.4-3.2-.5-3.5-1.7-6.5.4-9.7.9-.4 1.9-.8 3.9-1.2 5.7-.9.3-1.9.5-2.8.8.1 1.1 0 2.1-.4 3.2-.1.3-.1.4-.3.5-.8-.8-1.9-1.1-3.1-.8-1.2 1.2-2.4 2.3-3.6 3.5-2.1 0-4.4.1-6.5.1-2.9-3.1-7.3-1.9-10.6-3.9-1.2.3-2.4.5-3.5.8-2.3-1.1-4.6-1.1-6.9-.3-3.3-1.1-5.8-.3-6.9 3.3-.9.3-1.7.5-2.7.8-.1 2.1-.3 4.2-.4 6.4-.8.9-1.2 2-1.2 3.2.4-.3.9-.7 1.3-.9-.4.4-.8.7-1.3.9-2 .4-2.5 1.9-2.8 3.6-1.1 1.1-2.3 2.1-3.3 3.3-2 .3-3.5 1.2-4 3.3-4.9 2.5-2.3 6.6-2.1 10.2.9.1 1.9.4 2.7.5l.1.3c-.1 2.1.9 3.2 2.9 3.3.4.9.8 1.9.9 2.9 1.1 0 2.3.1 3.3.1l1.2.5c1.2 2.3 3.1 3.3 5.6 3.1l1.2.7 1.3-.1c1.7 2.3 4.4 1.7 6.6 2.3.3-.8.5-1.6 1.1-2.3 1.1-.4 2.1-.8 3.2-1.1 2.3.1 3.9 1.2 4.1 3.6.9.1 1.6.5 2.3 1.1.1 2.3 1.3 3.5 3.6 3.5 3.9 4.2 7.8 2.7 11.8.1 4.1 2.1 8.4 4.2 12.5 6.4 3.1 6.1 7.7 11.4 8 18.7 0 .8 1.6 1.5 2.4 2.1.1 12.6.3 25.4.4 38-.8.8-1.1 1.7-.7 2.9-2.4 4.9-5.4 9.8-.4 15v.1c-.7 2.3-.4 4.2.9 6.1-.1 2 .7 3.5 2.5 4.4-.3.9 0 1.9.5 2.7-1.3 3.1-4.2 2.9-6.9 3.6-.8-.7-1.6-.9-2.7-.5-4.2-4.1-9.4-2.4-14.3-2.4h-3.7c-2.3-.1-4.5-.1-6.8-.3-2.3-.9-4.5-.8-6.6.1-2.9.3-4 2.3-3.6 4.6 1.1 6 3.6 10.9 10.2 12.1l.3.1c1.7 2.5 3.9 2.4 6.2 1.2 1.5.3 2.9.7 4.4.9 4.4.5 8.8 1.1 13.1 1.5 1.2 1.7 2.5 1.7 3.7 0 2.3 0 3.3-1.3 4.1-3.3 1.2 0 2.1-.5 2.8-1.6.8.1 1.7.3 2.5.3.1-.9.4-1.9.8-2.8 12.5-2.7 12.5-2.7 20.2 4.5.5 2 1.1 4 1.7 6 .5 1.5 1.2 3.1 1.7 4.5-1.1 1.9-2 3.9-3.1 5.7-1.1-.1-2.3-.1-3.3.3-3.6-1.6-6.5-1.5-7.8 2.9-2.5 2-3.2 4.5-1.5 7.2 1.9 2.8 4.5 2.4 7.3 1.3 1.5-.5 3.2-.5 4.9-.8v5.3c-1.5 2.5-2.8 4.9-4.2 7.4-6.1 1.7-12 5.2-18.7 3.3-.4-.8-.8-1.7-1.2-2.5-1.2 0-2.1-.5-2.9-1.5-1.2-.5-2.5-.8-3.9-.8-.8-.5-1.6-.9-2.7-.9h-4.4c-.8-.1-1.5-.1-2.3.1-1.3-.1-2.7-.4-4-.5-1.1 1.2-2 2.5-3.1 3.7 0 1.1 0 2.1.1 3.2-1.5 4.1-2.1 8.1 2.8 10.6 1.9 2.3 4.5 2.5 7 3.2.9 2.4 1.7 4.9 3.7 6.8l-.1-.3c.8 1.2 1.6 2.3 2.5 3.3 1.2 1.7 2.4 3.6 3.6 5.4 4.2 4.9 8.9 5.4 14.1 1.5l-.3.3c1.6-.8 2.8-2 3.7-3.5 0 0-.1 0-.1.1l.1-.1s0 .1-.1.1c1.5-.9 2.7-2.1 3.5-3.7l-.3.3c2.5-1.5 2.3-3.7 2-6.1-.3-.3-.4-.5-.7-.8.5-.4 1.2-.7 1.9-.7 1.2-7.4 6.1-12.3 11.2-17.4h2.6c.1-.9.4-1.7.8-2.5 3.7-1.2 6.8-3.2 8.8-6.6 1.7-.5 2.7-1.7 2.5-3.6l1.3.3s1.2-.7 1.2-.8c.8.7 1.9.8 2.8.7h.3c1.3 2.3 2.7 4.4 4 6.6-.7 3.3-.1 6.2 2.5 8.6 2.4 2.1 4.6 4.5 4.8 8 .9.1 2 .5 2.8.9 2.3 4.2 5.3 8.2 4.6 13.5-1.7 2-3.5 3.9-5 5.8-1.1.5-2 1.1-3.1 1.6-.9-.1-2-.3-2.9-.1-.1.9-.3 2-.4 2.9l-.1.1c-1.9.3-3.1 1.5-3.2 3.3l-.1.3c-.9.1-1.9.3-2.8.4 0 .9 0 1.9.1 2.8-7.2 5.8-9.8 13-6.8 22 .1.5-.1 1.1-.1 1.6.8.3 1.6.5 2.3 1.1-.8 2.3.3 5.3-2.4 6.9-.1 1.7.1 3.6-.4 5-2.5 7 .4 12 5.4 16.6 5.8 5.2 12 6.2 18.9 2.8 2.1-.4 4.4-.8 6.5-1.2 4.1 1.3 6.6-2.1 10-3.5.3-2 .5-4 .9-6.1 3.3-1.7 1.7-6.9 5.8-8 1.1-3.2 3.9-4 6.4-5.2 2.1-.9 4.2-1.7 4.9-4.2 1.9-.4 2.9-1.5 3.2-3.5 4.5-2.7 9.2-5 11.2-10.5 3.5-2.1 4.2-7.6 9.3-8 1.1.8 2.1 1.6 3.2 2.3-.5.8-.4 1.5.4 2-1.2 3.3 0 6.4.9 9.6 3.6.3 7.3 1.5 10.1-2 2.1-.4 2.9-2 2.9-4 5-3.7 11-3.2 16.9-3.7 6.2 5 13.5 4.8 20.8 4.1 2.4.9 4.8 1.9 7.2 2.8l.1.1c13.4 14.7 13.9 9.2 21.6 1.2 1.2-1.2 2.1-2.5 3.2-3.9 1.1.3 2-.1 2.8-1.1 1.1-.3 2.3-.4 3.3-.7 2.8.3 5.6.4 7.6-2h1.6l1.3-.9c2-.7 4.5-.8 6.1-2.1 6-5.2 12-4.5 18.3-.9.3.8.4 1.7.5 2.5 2.7.4 5 1.2 6.6 3.6 4.1.4 8.4.9 12.5 1.3.5 2.4.7 5 3.2 6.6.5 1.1 1.1 2.1 1.6 3.1-.1 1.1 0 2 .4 2.9-1.3 1.5-2.7 2.9-4 4.2-1.3 2.1-2.5 4.4-3.9 6.5 0 3.5 0 6.9.1 10.4 4.5 3.5 9.2 6.9 13.7 10.4 1.2-.1 2.4-.1 3.7-.3l1.5.1 1.5-.1h10.5c0-4.5 0-9 .1-13.5-1.1 0-2.1-.1-3.2-.3-.1-1.1-.1-2.1-.3-3.2-.9 0-2-.1-2.9-.3-.3-1.1-.5-2.1-.5-3.2-2.8-1.5-2.9-4.4-3.6-7 0-8 0-16.1.1-24-.9-.5-1.7-.9-2.7-1.3.3-.9-.1-1.7-.9-2.1.1-2.9-.4-5.7-2.4-8.1.8-2 1.7-4 2.5-5.8 2-.3 3.3-1.2 4.1-3.1l-1.2-.5c0-.1 0-.3.1-.4.4.3.8.5 1.1.8 4.5-.7 9.3-.4 13.1-3.6 1.2-.4 2.5-.7 3.7-1.1 3.2-.7 3.5-3.1 3.3-5.7l.3-.4c2.1-1.2 2.7-3.3 2.9-5.4.4-2.1.9-4.2 3.1-5.3 1.5-2 2.9-4 4.4-6 2.3-.3 3.9-1.3 5-3.3.9.3 1.5 0 1.7-.9 1.7-.1 2.7-1.1 2.9-2.8l.7-.7c1.1-.7 2-1.6 2.8-2.7l.7-.7c1.6-.3 2.5-1.2 2.8-2.8l.5-.7c.9-.1 1.7-.1 2.7-.3 0-.9 0-1.7-.1-2.7.8-.9 1.6-2 2.4-2.9 2.7 0 4.6-.9 5.8-3.3 2.4-1.2 4.9-2.4 7.3-3.6l1.1.4 1.1-.4h.1c2.7 2.4 5.4 2.9 8.1 0 1.7.1 3.6.4 5.3.5 1.6 2.4 4.4 2.5 6.8 3.2 3.1.7 3.2-1.7 3.7-3.6-.9-.1-1.7-.4-2.7-.5-.3-2.3-.5-4.5-.8-6.8 1.3-1 1.4-2.2 1.4-3.3zm-14.8-115v-.1c.3-1.1.9-1.6 1.7-2-.1.7-.7 1.3-1.7 2.1zm-174.9-95.7.1.1h-.1c-.1 0-.1-.1 0-.1zm-94.3-15.2c-.5 0-1.1-.1-1.5-.1v-.1c.6.1 1.1.1 1.5.2zM548 368.8l-.1-.1c.1-.1.1-.1.1.1zm-65.6 20.7c-.4 0-.9 0-1.5.1.3-.4.8-.8 1.6-1.2-.1.4-.1.8-.1 1.1zm-25-41h.1-.1zm-71.7-53.6c.4.1.8.4 1.1.8-.3-.2-.7-.5-1.1-.8 0 .2 0 .2 0 0zm78.8 37c.4.4 1 .1 0 0zm93.9-70.2h.4c-.1.1-.1.3-.3.3 0 0-.1-.1-.1-.3zm-13.8-24.1v.3c-.1-.1-.3-.1-.4-.3h.4zm-130.3-23.4c0-.5-.1-1.2-.1-1.9.1.6.1 1.2.1 1.9zM403 178.9v.3l-.1-.1c0-.1 0-.2.1-.2zm-13 64.3v-.4s.1.1 0 .4zm53 99c-.3.3-.5.4-.8.7.2-.2.5-.4.8-.7zm1.3-1c.1-.2.1-.2 0 0zm187.5-42.1c0-.1-.1-.3-.1-.4h.1v.4zm-284-30.2c0 .1.1.4.1.5-.1-.1-.3-.3-.3-.5h.2zm155.3-79.7s0 .1-.1.1c0 .1 0-.1.1-.1zm-20.7 197c-.1-.2 0-.2 0 0zm96.9-3.6c-.1 0-.1 0 0 0-.1-.1-.1-.1 0-.1-.1 0 0 .1 0 .1zm-86 4.4c-.1-.3-.4-.5-.5-.9h-.1v-.1l.1.1c.4 0 .7.1 1.1.3-.2 0-.5.3-.6.6zm127.2-28.4v-.1h.1c-.1-.1-.1.1-.1.1zM478.3 104.5c-.5-.1-1.1-.3-1.5-.5.7.3 1.2.4 1.7.5-.1-.1-.1-.1-.2 0zm.7-11.9h.3l-.3.3v-.3zM385.6 89c-.1.3-.3.7-.4.9-.3-.4-.5-.7-.7-1.1.4.2.8.2 1.1.2zm93.6-.3.4.4h-.7c.2-.1.2-.2.3-.4zm-58.9 311h-.1.1zm210.6-51.4v-.3h.1c0 .1 0 .2-.1.3zm-38-228.1c-.1.1-.1.3-.3.4 0-.1-.1-.3-.1-.4h.4zM427.2 92.6v-.3c0 .1.1.1.1.3h-.1zm-24.5 365.8c.2.1.2.1 0 0 .2 0 .2.1 0 0zm55.1-34.7c-.5 0-.9-.1-1.1-.8.5.2.9.4 1.1.8zM671 228c-.7-.3-1.5-.5-2.1-.8v-1.1c1.7.6 2.2 1.3 2.1 1.9zm-430.3-7.7c-.1 0-.1 0-.3.1h-.1s0-.1-.1-.1h.5c-.1 0-.1-.1 0 0zm7.1 2.8c.8-.1 1.5-.1 2.1.1-.7.1-1.5.3-2.3.5 0-.2 0-.5.2-.6zM685.7 356c.3-.3.7-.5.9-.8-.2.3-.5.6-.9.8zm-27.2-180.7c0 .1 0 .1 0 0v.1h-.3s.2-.1.3-.1zm-20.7-44.7h-.3l.3-.3v.3zm-130.4-38h-.7l.4-.4s.1.1.3.4zM386.1 61.4c0 .1 0 .3.1.4l-.3.1h-.3c.1-.1.3-.4.5-.5zm-67.9 121.1c-.1.4-.3.8-.4 1.2-.4-.5-.9-.9-1.3-1.5.5 0 1.1 0 1.7.3zm-21.8 158.7h-.3v-.9c0 .3 0 .6.3.9zm282.7 110.3.1-.1-.1.1zm323.2-324.8c-.5-.3-1.1-.4-1.6-.7-4.6-1.6-8.1.1-10.9 3.9-.7.8-1.5 1.2-2.5.9-.4 1.1-.5 2.1-.7 3.2l-.1.1c-4 2.1-3.3 4.6-.5 7.3 3.1 4.9 7.8 5.2 12.7 4.5 3.7-.5 7.3-1.6 11-2.5.1-.9.1-1.9.1-2.8 1.3-.4 1.9-1.3 1.6-2.7l.1-.3c4.2-2.7 2.1-6.2 1.5-9.7-3.5-.9-7.1-2.1-10.7-1.2zM215 372.4c2.4.1 4.4-.5 4.8-3.2.3-2.5-1.3-4.1-3.7-4.2-2.1-.1-4.4.3-6.5.4.1 2.1.4 4.2.5 6.4 1.7.2 3.3.4 4.9.6zm513.2-234.3c-1.1 4.2-1.2 8.5-.4 12.7 1.1.3 2 .3 3.1.3l.1.1c1.2 3.2 3.7 3.5 6.6 3.1 4.1 1.2 7.8.9 10.9-2.4 4.1-1.3 3.6-4.5 2.8-7.7-.1-1.1-.3-2.3-.4-3.3.4-1.1.4-2 .3-3.1-.8-.1-1.7-.3-2.5-.4.1-.1.3-.4.4-.5-.5-.5-1.1-1.2-1.6-1.7-2.1-.5-4.2-1.1-6.4-1.7-3.5-1.1-7.2-2.9-9.8 1.6l.3-.3c.1-.1.1-.1.3-.1l-.3.1c-.1.3-.3.5-.5 1.2-.1.5 0 1.1.1 1.6l-.3.3c-.7 0-1.8.1-2.7.2zm112.3 203.1c.1-1.2.3-2.3.4-3.5v-6.4c-1.1-.3-2-.3-3.1-.3l-.1-.1c-.1-.9-.3-2-.4-2.9-5.3 0-10.5.1-15.8.1-.8 2.3-4.2 3.1-3.6 6.1v6.1c.9.1 2 .3 2.9.5.1 1.1.3 2 .4 3.1 2 .7 4.1 1.3 6.1 2.1 5.9 2.3 10.4 1 13.2-4.8zM1.7 294.3c-.7.1-1.2 1.6-1.7 2.4.1 2.5 1.6 4 4 4.1.5 0 1.5-1.6 1.5-2.5.1-2.4-1-4.3-3.8-4zM787 112.9c-.1-1.1-.4-2.1-.8-3.1h-3.5c-.5.9-.8 2-.9 3.1-4.5 6.1-4.4 7.6 1.2 10.5l1.6.5 1.3-1.1 1.5.1 1.5-.1c-.6-3.3 2.1-7.2-1.9-9.9zM64.5 174.2c2.1-.8 4.1-2 6.2-2.9 1.3-4.8-1.7-8.5-3.3-12.5-3.3-1.2-6.5-2.4-9.8-3.6-5.6-1.9-11-.8-16.6.1-.1 1.1-.3 2-.1 3.1-1.9 2.3-1.6 4.6.1 6.9-.4 2.3.9 2.9 2.8 3.2.4.9.7 1.9.7 2.8 2.1.1 4.2.4 6.5.5l1.2.8 1.3-.1c3.2 3.7 7.2 3.2 11 1.7zm645.4-8.9c-1.2-1.1-2.3-2.3-3.5-3.3-3.2 0-6.5 0-9.7-.1-.9 1.3-1.9 2.7-2.8 4 0 2.9-.1 5.8-.1 8.8 2 .9 3.9 2 5.8 2.9 2.5 1.3 5 1.9 7.3-.5.3-2.1 1.6-3.6 2.9-5 .1-2.2.1-4.5.1-6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M709.9 172c-.9 1.7-2 3.3-2.9 5 2.1-.9 3.4-2.5 2.9-5zM216.8 320.2c1.2 1.1 2.4 2.1 3.6 3.2 2 0 4.1.1 6.1.1.4-2.8.7-5.6-1.9-7.8-1.9-1.6-3.7-2.7-6.1-1.6-2.5 1.3-1.4 4-1.7 6.1zm553-41.7c-.7-2-2-3.2-4.2-2.8-.8-.9-1.7-1.3-2.9-1.3.1-.8 0-1.7-.4-2.4-1.2.1-2.4.4-3.6.5-3.2-.3-6.4-.7-9.6-.9-.4-.9-.8-1.7-1.3-2.5-.8.7-1.5.7-2.3 0-.4.8-.8 1.5-1.2 2.3-3.1-.4-5.7.3-7 3.3-2 .7-3.3 1.9-3.3 4.1-2.9 3.6-3.7 7.3-.4 11.2.5 2.7 1.5 5 4.6 5.6 1.1.7 2 1.3 3.1 2 .7 2 2.1 2.4 3.9 1.9 2.3 0 4.4.1 6.6.1 2.4 0 4.6-.1 7-.1 4.8.3 7.7-2.8 10.5-6 2.1-.4 3.3-1.6 3.5-3.7l-1.2-.9v-.3l1.2 1.2c.8-.5 1.6-.8 2.5-.8.3-2 .5-4.1.7-6.1-.9-.3-2-.7-2.9-.8-.4-2.3-1.5-3.4-3.3-3.6zm-35 9v.3c-1.4.5-1.2-.6 0-.3zm1.8-10.9c.3-.5.5-1.2.7-1.9-.1.7-.3 1.4-.7 1.9zm18.4-42.3c-1.2 0-2.3 0-3.5.1-.7-.8-1.5-1.1-2.4-.7-1.5-.9-2.9-1.9-4.4-2.8-1.1.7-2.3.7-3.3.1-.5.8-.9 1.7-1.2 2.7-.9-.4-1.6-.1-2.3.5-2.3.1-4.4.3-6.6.4-.3 1.1-.4 2-.4 3.1-.9.3-1.9.4-2.8.5-1.7 5.8-1.2 11.3 3.5 15.8 4.2.1 8.6.4 12.9.5 5.8 1.9 9-1.2 10.9-6.2 2.5-1.9 2-4.9 2.9-7.3l-.8-.8.4-1.1c-.4-1.9-1.5-2.3-3.1-1.6.5-1.1.5-2.2.2-3.2zM251.2 382.5c.1-1.1 0-2.1-.4-3.1-3.5-.1-6.8-.1-10.2-.3-2.1 1.3-4.1 2.8-6.2 4.1-.5 2-1.6 3.3-3.9 3.1-2.5 2.8-6 2-9 2.5-.3-1.1-1.1-1.7-2.1-2.3l.1.1c-2-2.8-4.2-2.7-6.5-.5l-.9.8-1.1-.5c-1.5.3-2.7 1.1-3.5 2.4 0 .1 0 .3-.1.4-5 .1-10.1.3-15.1.4-.4.9-.8 2-1.2 2.9-1.9.3-3.7.5-5.6.7-.3.9-.4 1.9-.4 2.9-.9.3-1.9.5-2.9.7 0 2 .1 4 .1 6 .9.1 1.7.4 2.5.5l.3.4c1.2.8 2.3 1.7 3.3 2.8-1.1-.9-2.1-1.9-3.3-2.8.1 2.1 1.2 3.1 3.3 2.9l1.2.9h1.6c2 2.4 4.6 2.8 7.6 2.5 1.2.3 2.3.4 3.5.7 20.8 7.2 20.8 7.2 33.9 2.3.3-1.1.4-2.1.7-3.2 2.9-.9 4.1-3.3 4.6-6.1 3.2-3.3 8.1-5 9.6-10.1l.3-.3c3.9-5.4 3.9-5.7-.2-10.8zm-52 16.8c.1 0 .1 0 0 0z"
  })))), /*#__PURE__*/React.createElement("div", {
    className: 'absolute top-[56%] left-[46%] h-20 w-20 -translate-y-1/2 -translate-x-1/2'
  }, /*#__PURE__*/React.createElement("svg", {
    className: "",
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 921 522.9",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("style", null, '.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}'), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.3 183.1c.8.1 1.9.3 2.7.4.4 1.7 1.5 2.7 3.2 2.8 0 .5 0 1.1-.1 1.7 2.5 5.4 6.6 9.3 11.8 12.2 1.5.3 2.1-.1 2.3-1.3.9 1.1.1 2-.3 3.1.7 5.3 2.9 9.3 8.6 10.5l-.5.9.5-.8c10.8 5.7 16.9 2.7 18.2-9.7-1.2-1.1-1.9-2.1-2.4-3.2h.1c0-2.8.1-5.6.1-8.4.7-1.5 1.5-2.9 2.4-4.2.9-4 2-8.1-2.5-10.6v.3l-.4-.4c.1.1.3.1.4.3-.8-3.2-4.5-2.3-6.2-4.2h-.2c-1.9-1.6-4-2.7-6.1-3.9-1.2.3-2.3-.1-2.9-1.2-.8-.7-1.7-1.2-2.8-1.5-.9.5-1.5.3-1.9-.7-1.2-1.2-2.7-1.7-4.4-1.7-.1 0-1.5.7-1.5.7s-.1-1.2-.1-.9c-.4-2.5-2.7-3.3-4.8-4.2v.1l-.1-.1h.1c-1.2-2-2.9-2.4-5-2-.4.3-.8.5-1.1.9-.3.3-.4.5-.7.8.3-1.3 1.5-2.7.1-4.1-2.3-1.5-4.6-1.3-7-1.1-.1-.4-.1-.9-.3-1.3-.9.1-1.7.3-2.7.4-4.6-2.1-9.4-2.8-14.2-.7-1.3.9-2.8 2-4.4 2.5 1.5-.8 2.9-1.7 4.4-2.5-1.1-.3-2.1-.4-3.3-.3-.4.9-.8 2-1.2 2.9-1.2-.1-2.1.4-2.5 1.5-.8 0-1.6-.1-2.4-.1v2.5c-1.3.9-1.5 2.1-.7 3.6-.1 2.1.9 3.3 2.9 3.9.4 2.1 1.6 3.2 3.9 2.7-1.3-.9-2.5-1.9-3.9-2.7 1.3.8 2.7 1.7 3.9 2.7 2.7.3 5.2.4 7.8.7 2.7 5.8 8.3 9.5 13.2 13.7zm6.8-24.7c-.1.3-.3.5-.3.9v-.7c.2 0 .2 0 .3-.2zm548.8 221c-1.1-.3-2.1-.4-3.2-.4-.1-.9-.4-1.9-.5-2.8-3.6 0-7.6-2.1-10.6 1.7-1.9.9-2.9 2.4-2.4 4.6-.4 2.1.5 3.5 2.7 4 .5 2 1.9 3.1 4 2.7h3.5c6.4-1.6 6.6-2 6.5-9.8zM696.5 89.3c-1.1 0-2.1 0-3.2.1-.3 1.1-.3 2-.3 3.1-.9.3-2 .4-2.9.5-.3 1.9-1.1 3.2-2.9 3.9-2 10.4-3.9 20.7 1.9 30.5 4.6 4.6 6.4 4.6 11.7 0 3.7-1.6 7.3-3.3 9.8-6.6 2.3-.3 3.7-1.6 4.4-3.7 6.2-3.5 8.2-9 7.3-15.8-.4-2.8-1.3-5.6-2-8.2-2.7-1.6-2.8-4.4-3.2-7-.8-.1-1.7-.3-2.5-.4.3-.5.4-1.2.4-1.9-.7-.4-1.2-.8-1.9-1.2-2-.1-4-.3-6.1-.5-1.3-.9-2.3-.7-2.8.8h.1l-.3.1v-.1c-1.5.4-1.9 1.3-1.5 2.7-1.7.4-3.3.7-5 1.1-.4.8-.6 1.8-1 2.6zm169.3 295.9c2 .4 2.8-.5 2.9-2.4l.4-.5c.9 0 1.9-.1 2.7-.3.1-2 .3-4.1.4-6.1-.9-.4-1.9-.8-2.8-1.2.3-1.1 0-1.9-.9-2.4.1-1.7-.4-2.8-1.7-3.3v-.7c-.1-1.3-.7-2.3-2-2.8-1.1.3-2 0-2.8-.8-1.2.3-2.4.5-3.6.8-3.3-1.2-6.8-2.1-10.2-.3-7.3.1-7.8.4-10.2 6.9-.9 3.2-.5 5.8 3.1 7 .5 1.9 1.7 2.9 3.7 2.8.7.9 1.6 1.3 2.7 1.1 1.9 2.8 4.5 3.1 7.6 2.5 3.8 1.3 7.2 1.6 10.7-.3zm-180-26.8c.7-.9.9-2 .8-3.1 1.7-.4 2.8-1.6 3.2-3.2 8.4-.7 15.7-4 22.7-8.4 0-.8-.1-1.6-.3-2.4.4-1.2.8-2.3 1.3-3.5l.1-.4c.8-.3 1.6-.5 2.4-.7.5-3.9 2.9-8-1.7-11 .1-.9-.4-1.6-1.3-1.7 0-.9-.1-1.7-.3-2.7-.9 0-1.7 0-2.7.1v1.7c0-.5-.1-1.2 0-1.7-1.2-.4-2.3-.7-3.5-1.1v-.1c-.4-.9-.8-1.7-1.2-2.7-1.1.3-1.9 0-2.4-.9-1.1.1-2.3.4-3.3.5-.7-.9-1.6-1.2-2.7-.8-9.2-2.8-12.3-9.2-11.2-18.3.1-.5 0-1.2-.1-1.7 2.4-1.3 4.8-2.7 7.2-4 6.5 1.9 12.1-1.2 17.8-3.5 2.8-1.1 1.6-3.9 2.1-5.8h.1c-5-11.3-13.8-11.2-23.8-7.6-2.3 1.2-4.5 1.5-6.9.4-2.1-.5-4.1-1.2-6.2-1.7.3-.9-.1-1.7-1.1-2.1-.9-6.1 3.2-10.9 4.6-16.3 2.5-1.9 2.9-4.5 2.8-7.4 4.5-3.9 3.3-9.3 4-14.2.9-6.4-1.6-11-7.4-13.8-1.3-2.1-2.7-4.2-4.1-6.2-5-1.7-5.6-6.1-6.2-10.5 1.9-.4 3.1-1.7 3.7-3.5 1.9 0 3.3-.7 3.7-2.7l.1-.1c2.1-.5 3.2-1.9 3.3-4 4.2-6.9 4-7.7-3.7-11.7-1.6-1.7-3.1-3.3-4.6-5-3.1-.5-6-1.1-9-1.6-.4-2-1.7-3.2-3.6-3.7.3-1.1-.1-2-1.1-2.5v-6.2c-.8-.3-1.7-.7-2.5-1.2v-5.7c.9-.4 1.9-.8 2.8-1.1-.1-5.3 1.6-10.8-.4-16.1-.9 0-1.9-.3-2.8-.4l-.3-.3c0-.9 0-2-.1-2.9-.9-.1-1.9 0-2.9.1-.4-1.1-1.2-1.5-2.3-1.2-.4-.9-.8-1.9-1.3-2.8-1.1.1-2.1.4-3.2.5-.7-1.1-1.7-1.5-2.9-1.5-1.3-5.6 1.1-12-4.1-16.6.3-2.3-.8-3.7-3.1-4.4-1.6-2.9-3.8-5.2-7.3-6-.5-1.7-1.6-2.9-3.6-2.5-1.1-.3-2.1-.7-3.3-.9l-.1-.1c-1.3-2.5-3.5-3.7-6.1-4.1.3-.9.1-1.9-.8-2.4.8-.7 1.9-2 2.4-1.7 7.4 2.5 14.1-1.1 21-2.7.1-.9.3-1.9.3-2.7l.7-.5c2 .1 2.8-.8 2.3-2.8.1-1.3.1-2.5.3-3.9.3-1.2.4-2.3.7-3.5-.9-.4-1.9-.5-2.8-.7l-.3.4c-.8-3.9-4.4-3.6-6.9-4.6.3-.8.1-1.5-.3-2.1-1.2 0-2.4.1-3.6.1-3.5-1.7-6.8-.7-10 .8-1.1-.3-2.1-.4-3.3-.3-.5 1.9-1.9 2.8-3.7 3.1-2 5.7.1 11.7-.5 17.4-5.4-1.7-10.9-.5-16.3.3-.1.9-.3 1.9-.3 2.8l-.5.4c-1.1-.1-2-.1-3.1-.1-.1.9-.3 2-.4 2.9l-.1.1c-2 0-3.6.8-3.9 3.1h-.3c-3.5 4.1-5.2 11-13 7.8-.5-.9-.8-1.9-.8-2.9-2.9-1.6-5-4.1-6.6-6.9-1.7-.5-3.6-1.2-5.3-1.7-1.1-3.3-3.5-5.3-6.6-6.5 0-1.2-.4-2.3-1.5-2.9 0-3.5.1-6.8.1-10.2 2-2.7 4-5.2 6-7.8.8-4.1 2-8.2.4-12.3-1.1-.1-2-.3-2.9-.7-.1-2.1-1.2-3.2-3.3-3.2l-.4-.3c-.3-.8-.5-1.6-.5-2.5-4.2-.3-8.5-.5-12.7-.8-.4.8-.7 1.7-.8 2.7-5.2 2.7-6.1 7.4-6 12.6 0 6.1 2.1 12.2-.5 18.2-2.1.4-4.2.8-6.4 1.2-2.9 2.9-7 1.9-10.4 3.6-3.5-.1-7-.3-10.5-.4-.3-.9-.5-1.7-.8-2.7-.9-.1-2-.1-2.9-.1l-.4-.4c0-.9 0-1.9-.1-2.8-.9-.1-1.9-.1-2.8 0-.9-1.3-1.9-2.5-2.8-3.9.7-.4 1.2-.9 1.6-1.5.8-1.2 1.3-2.5 1.9-3.9.4-.8.8-1.6 1.2-2.5.3-.1.5-.1.9-.3-.1-2.7 1.1-5.6.3-8 0-.4 0-.8-.1-1.2-.3-1.3-.8-2.5-1.5-3.7-.8-.9-1.6-1.9-2.4-2.7l-1.6-1.6c-1.6-1.2-3.3-1.9-5.2-2.4h-5.2c-2.4 1.3-5.6.9-7.6 3.2h-.1c-4.5 1.9-5.3 6-5.7 10.1 0 .3-.1.4-.1.7-.1 0-.3.1-.4.1-.3 2.1-1.5 3.2-3.6 3.3 0 .9-.3 1.7-.7 2.5-2.1-.1-4.2-.4-6.5-.5-.5-1.9-1.9-2.5-3.6-2.7-.8-1.3-1.7-2.7-2.5-4-.5-5.6-1.1-11.2-1.6-16.6V27.5c-.9-.1-1.7-.4-2.5-.8-.4-3.1-.8-6.1-1.2-9.3-.9-.3-1.7-.5-2.5-1.1.1-2.8.5-5.8-3.2-6.8 0-1.1-.1-2-.5-3.1-1.2.1-2.4.4-3.6.5-.9-.8-2-.8-3.1-.1-2.1 0-4.4.1-6.5.1-.1.9-.4 1.9-.7 2.8-2 .4-3.2 1.5-3.1 3.6-.4 1.1-.9 2.1-1.3 3.1-5.8 7.7-3.3 16.1-2 24.4.1 2.1.1 4.1.3 6.2 4.9 6.4 10.8 11.3 19.4 11.7.4-.4.8-.8 1.3-1.1l-1.3 1.1c2.7 1.9 5.2 3.6 7.8 5.4.3.9.8 1.3 1.7 1.2.8.9 1.5 2 2.3 2.9 0 1.7.5 3.2 2.3 3.9-.8 3.1-3.1 4.9-5.8 6.2-5.4-4.1-11.4-3.5-17.1-1.2-3.7 1.5-7.2 2.4-11.2 1.5-.1.3-.1.5-.3.7l-.1-.1.4-.7c-.9-1.3-1.7-2.5-2.7-3.9.5-3.3 1.2-6.6 1.7-10 2.4-6.6-1.7-10.1-6.2-13.4-6.5.3-13 .4-19.5.7-.7 1.9-2.1 2.8-4.1 2.7-.1.9-.4 1.9-.7 2.7-.9.5-2 .9-2.9 1.5h-2.7c-.1.9-.4 1.9-.7 2.8l.7.7s0 .1-.1.1c-.3-.4-.5-.8-.5-.8-1.1.1-2.1.3-3.1.4 0 .9-.3 1.9-.7 2.7l.7.9c-.1.1-.3.3-.3.4-.1-.4-.3-.9-.4-1.3-5.6 2-11 4.6-17.1 3.9l-3.6-3.6c-5.4-.7-10.9-.5-16.2.8-.9 2.4-4.6 2.7-4.5 5.8-.9.3-1.9.4-2.8.5.4 5.8-3.1 12.2 2.8 17.1-.3 2.1.9 3.1 2.9 3.3 1.6 3.5 3.2 6.9 4.6 10.4-1.7 10.2 3.1 20.6-.5 30.8-2 1.3-4.1 2.8-6.1 4.1-1.2 4.1-3.5 7.7-6.9 10.4-.4 1.7-.8 3.6-1.2 5.3-5.2 3.9-5.2 10.8-9.2 15.4-.4 3.1-.8 6.2-1.3 9.3-.9.3-1.9.5-2.8.7.1 1.1 0 2.1-.5 3.2-3.7-.3-8.2 3.1-10.6-2.7-.9-.1-2-.4-2.9-.5l-.1-.1c.3-1.1.1-2.1-.1-3.2-1.2-.1-2.3-.1-3.3.3-1.1-.1-2.1-.4-3.2-.5-3.5-1.7-6.5.4-9.7.9-.4 1.9-.8 3.9-1.2 5.7-.9.3-1.9.5-2.8.8.1 1.1 0 2.1-.4 3.2-.1.3-.1.4-.3.5-.8-.8-1.9-1.1-3.1-.8-1.2 1.2-2.4 2.3-3.6 3.5-2.1 0-4.4.1-6.5.1-2.9-3.1-7.3-1.9-10.6-3.9-1.2.3-2.4.5-3.5.8-2.3-1.1-4.6-1.1-6.9-.3-3.3-1.1-5.8-.3-6.9 3.3-.9.3-1.7.5-2.7.8-.1 2.1-.3 4.2-.4 6.4-.8.9-1.2 2-1.2 3.2.4-.3.9-.7 1.3-.9-.4.4-.8.7-1.3.9-2 .4-2.5 1.9-2.8 3.6-1.1 1.1-2.3 2.1-3.3 3.3-2 .3-3.5 1.2-4 3.3-4.9 2.5-2.3 6.6-2.1 10.2.9.1 1.9.4 2.7.5l.1.3c-.1 2.1.9 3.2 2.9 3.3.4.9.8 1.9.9 2.9 1.1 0 2.3.1 3.3.1l1.2.5c1.2 2.3 3.1 3.3 5.6 3.1l1.2.7 1.3-.1c1.7 2.3 4.4 1.7 6.6 2.3.3-.8.5-1.6 1.1-2.3 1.1-.4 2.1-.8 3.2-1.1 2.3.1 3.9 1.2 4.1 3.6.9.1 1.6.5 2.3 1.1.1 2.3 1.3 3.5 3.6 3.5 3.9 4.2 7.8 2.7 11.8.1 4.1 2.1 8.4 4.2 12.5 6.4 3.1 6.1 7.7 11.4 8 18.7 0 .8 1.6 1.5 2.4 2.1.1 12.6.3 25.4.4 38-.8.8-1.1 1.7-.7 2.9-2.4 4.9-5.4 9.8-.4 15v.1c-.7 2.3-.4 4.2.9 6.1-.1 2 .7 3.5 2.5 4.4-.3.9 0 1.9.5 2.7-1.3 3.1-4.2 2.9-6.9 3.6-.8-.7-1.6-.9-2.7-.5-4.2-4.1-9.4-2.4-14.3-2.4h-3.7c-2.3-.1-4.5-.1-6.8-.3-2.3-.9-4.5-.8-6.6.1-2.9.3-4 2.3-3.6 4.6 1.1 6 3.6 10.9 10.2 12.1l.3.1c1.7 2.5 3.9 2.4 6.2 1.2 1.5.3 2.9.7 4.4.9 4.4.5 8.8 1.1 13.1 1.5 1.2 1.7 2.5 1.7 3.7 0 2.3 0 3.3-1.3 4.1-3.3 1.2 0 2.1-.5 2.8-1.6.8.1 1.7.3 2.5.3.1-.9.4-1.9.8-2.8 12.5-2.7 12.5-2.7 20.2 4.5.5 2 1.1 4 1.7 6 .5 1.5 1.2 3.1 1.7 4.5-1.1 1.9-2 3.9-3.1 5.7-1.1-.1-2.3-.1-3.3.3-3.6-1.6-6.5-1.5-7.8 2.9-2.5 2-3.2 4.5-1.5 7.2 1.9 2.8 4.5 2.4 7.3 1.3 1.5-.5 3.2-.5 4.9-.8v5.3c-1.5 2.5-2.8 4.9-4.2 7.4-6.1 1.7-12 5.2-18.7 3.3-.4-.8-.8-1.7-1.2-2.5-1.2 0-2.1-.5-2.9-1.5-1.2-.5-2.5-.8-3.9-.8-.8-.5-1.6-.9-2.7-.9h-4.4c-.8-.1-1.5-.1-2.3.1-1.3-.1-2.7-.4-4-.5-1.1 1.2-2 2.5-3.1 3.7 0 1.1 0 2.1.1 3.2-1.5 4.1-2.1 8.1 2.8 10.6 1.9 2.3 4.5 2.5 7 3.2.9 2.4 1.7 4.9 3.7 6.8l-.1-.3c.8 1.2 1.6 2.3 2.5 3.3 1.2 1.7 2.4 3.6 3.6 5.4 4.2 4.9 8.9 5.4 14.1 1.5l-.3.3c1.6-.8 2.8-2 3.7-3.5 0 0-.1 0-.1.1l.1-.1s0 .1-.1.1c1.5-.9 2.7-2.1 3.5-3.7l-.3.3c2.5-1.5 2.3-3.7 2-6.1-.3-.3-.4-.5-.7-.8.5-.4 1.2-.7 1.9-.7 1.2-7.4 6.1-12.3 11.2-17.4h2.6c.1-.9.4-1.7.8-2.5 3.7-1.2 6.8-3.2 8.8-6.6 1.7-.5 2.7-1.7 2.5-3.6l1.3.3s1.2-.7 1.2-.8c.8.7 1.9.8 2.8.7h.3c1.3 2.3 2.7 4.4 4 6.6-.7 3.3-.1 6.2 2.5 8.6 2.4 2.1 4.6 4.5 4.8 8 .9.1 2 .5 2.8.9 2.3 4.2 5.3 8.2 4.6 13.5-1.7 2-3.5 3.9-5 5.8-1.1.5-2 1.1-3.1 1.6-.9-.1-2-.3-2.9-.1-.1.9-.3 2-.4 2.9l-.1.1c-1.9.3-3.1 1.5-3.2 3.3l-.1.3c-.9.1-1.9.3-2.8.4 0 .9 0 1.9.1 2.8-7.2 5.8-9.8 13-6.8 22 .1.5-.1 1.1-.1 1.6.8.3 1.6.5 2.3 1.1-.8 2.3.3 5.3-2.4 6.9-.1 1.7.1 3.6-.4 5-2.5 7 .4 12 5.4 16.6 5.8 5.2 12 6.2 18.9 2.8 2.1-.4 4.4-.8 6.5-1.2 4.1 1.3 6.6-2.1 10-3.5.3-2 .5-4 .9-6.1 3.3-1.7 1.7-6.9 5.8-8 1.1-3.2 3.9-4 6.4-5.2 2.1-.9 4.2-1.7 4.9-4.2 1.9-.4 2.9-1.5 3.2-3.5 4.5-2.7 9.2-5 11.2-10.5 3.5-2.1 4.2-7.6 9.3-8 1.1.8 2.1 1.6 3.2 2.3-.5.8-.4 1.5.4 2-1.2 3.3 0 6.4.9 9.6 3.6.3 7.3 1.5 10.1-2 2.1-.4 2.9-2 2.9-4 5-3.7 11-3.2 16.9-3.7 6.2 5 13.5 4.8 20.8 4.1 2.4.9 4.8 1.9 7.2 2.8l.1.1c13.4 14.7 13.9 9.2 21.6 1.2 1.2-1.2 2.1-2.5 3.2-3.9 1.1.3 2-.1 2.8-1.1 1.1-.3 2.3-.4 3.3-.7 2.8.3 5.6.4 7.6-2h1.6l1.3-.9c2-.7 4.5-.8 6.1-2.1 6-5.2 12-4.5 18.3-.9.3.8.4 1.7.5 2.5 2.7.4 5 1.2 6.6 3.6 4.1.4 8.4.9 12.5 1.3.5 2.4.7 5 3.2 6.6.5 1.1 1.1 2.1 1.6 3.1-.1 1.1 0 2 .4 2.9-1.3 1.5-2.7 2.9-4 4.2-1.3 2.1-2.5 4.4-3.9 6.5 0 3.5 0 6.9.1 10.4 4.5 3.5 9.2 6.9 13.7 10.4 1.2-.1 2.4-.1 3.7-.3l1.5.1 1.5-.1h10.5c0-4.5 0-9 .1-13.5-1.1 0-2.1-.1-3.2-.3-.1-1.1-.1-2.1-.3-3.2-.9 0-2-.1-2.9-.3-.3-1.1-.5-2.1-.5-3.2-2.8-1.5-2.9-4.4-3.6-7 0-8 0-16.1.1-24-.9-.5-1.7-.9-2.7-1.3.3-.9-.1-1.7-.9-2.1.1-2.9-.4-5.7-2.4-8.1.8-2 1.7-4 2.5-5.8 2-.3 3.3-1.2 4.1-3.1l-1.2-.5c0-.1 0-.3.1-.4.4.3.8.5 1.1.8 4.5-.7 9.3-.4 13.1-3.6 1.2-.4 2.5-.7 3.7-1.1 3.2-.7 3.5-3.1 3.3-5.7l.3-.4c2.1-1.2 2.7-3.3 2.9-5.4.4-2.1.9-4.2 3.1-5.3 1.5-2 2.9-4 4.4-6 2.3-.3 3.9-1.3 5-3.3.9.3 1.5 0 1.7-.9 1.7-.1 2.7-1.1 2.9-2.8l.7-.7c1.1-.7 2-1.6 2.8-2.7l.7-.7c1.6-.3 2.5-1.2 2.8-2.8l.5-.7c.9-.1 1.7-.1 2.7-.3 0-.9 0-1.7-.1-2.7.8-.9 1.6-2 2.4-2.9 2.7 0 4.6-.9 5.8-3.3 2.4-1.2 4.9-2.4 7.3-3.6l1.1.4 1.1-.4h.1c2.7 2.4 5.4 2.9 8.1 0 1.7.1 3.6.4 5.3.5 1.6 2.4 4.4 2.5 6.8 3.2 3.1.7 3.2-1.7 3.7-3.6-.9-.1-1.7-.4-2.7-.5-.3-2.3-.5-4.5-.8-6.8 1.3-1 1.4-2.2 1.4-3.3zm-14.8-115v-.1c.3-1.1.9-1.6 1.7-2-.1.7-.7 1.3-1.7 2.1zm-174.9-95.7.1.1h-.1c-.1 0-.1-.1 0-.1zm-94.3-15.2c-.5 0-1.1-.1-1.5-.1v-.1c.6.1 1.1.1 1.5.2zM548 368.8l-.1-.1c.1-.1.1-.1.1.1zm-65.6 20.7c-.4 0-.9 0-1.5.1.3-.4.8-.8 1.6-1.2-.1.4-.1.8-.1 1.1zm-25-41h.1-.1zm-71.7-53.6c.4.1.8.4 1.1.8-.3-.2-.7-.5-1.1-.8 0 .2 0 .2 0 0zm78.8 37c.4.4 1 .1 0 0zm93.9-70.2h.4c-.1.1-.1.3-.3.3 0 0-.1-.1-.1-.3zm-13.8-24.1v.3c-.1-.1-.3-.1-.4-.3h.4zm-130.3-23.4c0-.5-.1-1.2-.1-1.9.1.6.1 1.2.1 1.9zM403 178.9v.3l-.1-.1c0-.1 0-.2.1-.2zm-13 64.3v-.4s.1.1 0 .4zm53 99c-.3.3-.5.4-.8.7.2-.2.5-.4.8-.7zm1.3-1c.1-.2.1-.2 0 0zm187.5-42.1c0-.1-.1-.3-.1-.4h.1v.4zm-284-30.2c0 .1.1.4.1.5-.1-.1-.3-.3-.3-.5h.2zm155.3-79.7s0 .1-.1.1c0 .1 0-.1.1-.1zm-20.7 197c-.1-.2 0-.2 0 0zm96.9-3.6c-.1 0-.1 0 0 0-.1-.1-.1-.1 0-.1-.1 0 0 .1 0 .1zm-86 4.4c-.1-.3-.4-.5-.5-.9h-.1v-.1l.1.1c.4 0 .7.1 1.1.3-.2 0-.5.3-.6.6zm127.2-28.4v-.1h.1c-.1-.1-.1.1-.1.1zM478.3 104.5c-.5-.1-1.1-.3-1.5-.5.7.3 1.2.4 1.7.5-.1-.1-.1-.1-.2 0zm.7-11.9h.3l-.3.3v-.3zM385.6 89c-.1.3-.3.7-.4.9-.3-.4-.5-.7-.7-1.1.4.2.8.2 1.1.2zm93.6-.3.4.4h-.7c.2-.1.2-.2.3-.4zm-58.9 311h-.1.1zm210.6-51.4v-.3h.1c0 .1 0 .2-.1.3zm-38-228.1c-.1.1-.1.3-.3.4 0-.1-.1-.3-.1-.4h.4zM427.2 92.6v-.3c0 .1.1.1.1.3h-.1zm-24.5 365.8c.2.1.2.1 0 0 .2 0 .2.1 0 0zm55.1-34.7c-.5 0-.9-.1-1.1-.8.5.2.9.4 1.1.8zM671 228c-.7-.3-1.5-.5-2.1-.8v-1.1c1.7.6 2.2 1.3 2.1 1.9zm-430.3-7.7c-.1 0-.1 0-.3.1h-.1s0-.1-.1-.1h.5c-.1 0-.1-.1 0 0zm7.1 2.8c.8-.1 1.5-.1 2.1.1-.7.1-1.5.3-2.3.5 0-.2 0-.5.2-.6zM685.7 356c.3-.3.7-.5.9-.8-.2.3-.5.6-.9.8zm-27.2-180.7c0 .1 0 .1 0 0v.1h-.3s.2-.1.3-.1zm-20.7-44.7h-.3l.3-.3v.3zm-130.4-38h-.7l.4-.4s.1.1.3.4zM386.1 61.4c0 .1 0 .3.1.4l-.3.1h-.3c.1-.1.3-.4.5-.5zm-67.9 121.1c-.1.4-.3.8-.4 1.2-.4-.5-.9-.9-1.3-1.5.5 0 1.1 0 1.7.3zm-21.8 158.7h-.3v-.9c0 .3 0 .6.3.9zm282.7 110.3.1-.1-.1.1zm323.2-324.8c-.5-.3-1.1-.4-1.6-.7-4.6-1.6-8.1.1-10.9 3.9-.7.8-1.5 1.2-2.5.9-.4 1.1-.5 2.1-.7 3.2l-.1.1c-4 2.1-3.3 4.6-.5 7.3 3.1 4.9 7.8 5.2 12.7 4.5 3.7-.5 7.3-1.6 11-2.5.1-.9.1-1.9.1-2.8 1.3-.4 1.9-1.3 1.6-2.7l.1-.3c4.2-2.7 2.1-6.2 1.5-9.7-3.5-.9-7.1-2.1-10.7-1.2zM215 372.4c2.4.1 4.4-.5 4.8-3.2.3-2.5-1.3-4.1-3.7-4.2-2.1-.1-4.4.3-6.5.4.1 2.1.4 4.2.5 6.4 1.7.2 3.3.4 4.9.6zm513.2-234.3c-1.1 4.2-1.2 8.5-.4 12.7 1.1.3 2 .3 3.1.3l.1.1c1.2 3.2 3.7 3.5 6.6 3.1 4.1 1.2 7.8.9 10.9-2.4 4.1-1.3 3.6-4.5 2.8-7.7-.1-1.1-.3-2.3-.4-3.3.4-1.1.4-2 .3-3.1-.8-.1-1.7-.3-2.5-.4.1-.1.3-.4.4-.5-.5-.5-1.1-1.2-1.6-1.7-2.1-.5-4.2-1.1-6.4-1.7-3.5-1.1-7.2-2.9-9.8 1.6l.3-.3c.1-.1.1-.1.3-.1l-.3.1c-.1.3-.3.5-.5 1.2-.1.5 0 1.1.1 1.6l-.3.3c-.7 0-1.8.1-2.7.2zm112.3 203.1c.1-1.2.3-2.3.4-3.5v-6.4c-1.1-.3-2-.3-3.1-.3l-.1-.1c-.1-.9-.3-2-.4-2.9-5.3 0-10.5.1-15.8.1-.8 2.3-4.2 3.1-3.6 6.1v6.1c.9.1 2 .3 2.9.5.1 1.1.3 2 .4 3.1 2 .7 4.1 1.3 6.1 2.1 5.9 2.3 10.4 1 13.2-4.8zM1.7 294.3c-.7.1-1.2 1.6-1.7 2.4.1 2.5 1.6 4 4 4.1.5 0 1.5-1.6 1.5-2.5.1-2.4-1-4.3-3.8-4zM787 112.9c-.1-1.1-.4-2.1-.8-3.1h-3.5c-.5.9-.8 2-.9 3.1-4.5 6.1-4.4 7.6 1.2 10.5l1.6.5 1.3-1.1 1.5.1 1.5-.1c-.6-3.3 2.1-7.2-1.9-9.9zM64.5 174.2c2.1-.8 4.1-2 6.2-2.9 1.3-4.8-1.7-8.5-3.3-12.5-3.3-1.2-6.5-2.4-9.8-3.6-5.6-1.9-11-.8-16.6.1-.1 1.1-.3 2-.1 3.1-1.9 2.3-1.6 4.6.1 6.9-.4 2.3.9 2.9 2.8 3.2.4.9.7 1.9.7 2.8 2.1.1 4.2.4 6.5.5l1.2.8 1.3-.1c3.2 3.7 7.2 3.2 11 1.7zm645.4-8.9c-1.2-1.1-2.3-2.3-3.5-3.3-3.2 0-6.5 0-9.7-.1-.9 1.3-1.9 2.7-2.8 4 0 2.9-.1 5.8-.1 8.8 2 .9 3.9 2 5.8 2.9 2.5 1.3 5 1.9 7.3-.5.3-2.1 1.6-3.6 2.9-5 .1-2.2.1-4.5.1-6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M709.9 172c-.9 1.7-2 3.3-2.9 5 2.1-.9 3.4-2.5 2.9-5zM216.8 320.2c1.2 1.1 2.4 2.1 3.6 3.2 2 0 4.1.1 6.1.1.4-2.8.7-5.6-1.9-7.8-1.9-1.6-3.7-2.7-6.1-1.6-2.5 1.3-1.4 4-1.7 6.1zm553-41.7c-.7-2-2-3.2-4.2-2.8-.8-.9-1.7-1.3-2.9-1.3.1-.8 0-1.7-.4-2.4-1.2.1-2.4.4-3.6.5-3.2-.3-6.4-.7-9.6-.9-.4-.9-.8-1.7-1.3-2.5-.8.7-1.5.7-2.3 0-.4.8-.8 1.5-1.2 2.3-3.1-.4-5.7.3-7 3.3-2 .7-3.3 1.9-3.3 4.1-2.9 3.6-3.7 7.3-.4 11.2.5 2.7 1.5 5 4.6 5.6 1.1.7 2 1.3 3.1 2 .7 2 2.1 2.4 3.9 1.9 2.3 0 4.4.1 6.6.1 2.4 0 4.6-.1 7-.1 4.8.3 7.7-2.8 10.5-6 2.1-.4 3.3-1.6 3.5-3.7l-1.2-.9v-.3l1.2 1.2c.8-.5 1.6-.8 2.5-.8.3-2 .5-4.1.7-6.1-.9-.3-2-.7-2.9-.8-.4-2.3-1.5-3.4-3.3-3.6zm-35 9v.3c-1.4.5-1.2-.6 0-.3zm1.8-10.9c.3-.5.5-1.2.7-1.9-.1.7-.3 1.4-.7 1.9zm18.4-42.3c-1.2 0-2.3 0-3.5.1-.7-.8-1.5-1.1-2.4-.7-1.5-.9-2.9-1.9-4.4-2.8-1.1.7-2.3.7-3.3.1-.5.8-.9 1.7-1.2 2.7-.9-.4-1.6-.1-2.3.5-2.3.1-4.4.3-6.6.4-.3 1.1-.4 2-.4 3.1-.9.3-1.9.4-2.8.5-1.7 5.8-1.2 11.3 3.5 15.8 4.2.1 8.6.4 12.9.5 5.8 1.9 9-1.2 10.9-6.2 2.5-1.9 2-4.9 2.9-7.3l-.8-.8.4-1.1c-.4-1.9-1.5-2.3-3.1-1.6.5-1.1.5-2.2.2-3.2zM251.2 382.5c.1-1.1 0-2.1-.4-3.1-3.5-.1-6.8-.1-10.2-.3-2.1 1.3-4.1 2.8-6.2 4.1-.5 2-1.6 3.3-3.9 3.1-2.5 2.8-6 2-9 2.5-.3-1.1-1.1-1.7-2.1-2.3l.1.1c-2-2.8-4.2-2.7-6.5-.5l-.9.8-1.1-.5c-1.5.3-2.7 1.1-3.5 2.4 0 .1 0 .3-.1.4-5 .1-10.1.3-15.1.4-.4.9-.8 2-1.2 2.9-1.9.3-3.7.5-5.6.7-.3.9-.4 1.9-.4 2.9-.9.3-1.9.5-2.9.7 0 2 .1 4 .1 6 .9.1 1.7.4 2.5.5l.3.4c1.2.8 2.3 1.7 3.3 2.8-1.1-.9-2.1-1.9-3.3-2.8.1 2.1 1.2 3.1 3.3 2.9l1.2.9h1.6c2 2.4 4.6 2.8 7.6 2.5 1.2.3 2.3.4 3.5.7 20.8 7.2 20.8 7.2 33.9 2.3.3-1.1.4-2.1.7-3.2 2.9-.9 4.1-3.3 4.6-6.1 3.2-3.3 8.1-5 9.6-10.1l.3-.3c3.9-5.4 3.9-5.7-.2-10.8zm-52 16.8c.1 0 .1 0 0 0z"
  })))), /*#__PURE__*/React.createElement("div", {
    className: 'absolute top-[60%] left-[54%] h-20 w-20 -translate-y-1/2 -translate-x-1/2'
  }, /*#__PURE__*/React.createElement("svg", {
    className: "",
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 921 522.9",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("style", null, '.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}'), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.3 183.1c.8.1 1.9.3 2.7.4.4 1.7 1.5 2.7 3.2 2.8 0 .5 0 1.1-.1 1.7 2.5 5.4 6.6 9.3 11.8 12.2 1.5.3 2.1-.1 2.3-1.3.9 1.1.1 2-.3 3.1.7 5.3 2.9 9.3 8.6 10.5l-.5.9.5-.8c10.8 5.7 16.9 2.7 18.2-9.7-1.2-1.1-1.9-2.1-2.4-3.2h.1c0-2.8.1-5.6.1-8.4.7-1.5 1.5-2.9 2.4-4.2.9-4 2-8.1-2.5-10.6v.3l-.4-.4c.1.1.3.1.4.3-.8-3.2-4.5-2.3-6.2-4.2h-.2c-1.9-1.6-4-2.7-6.1-3.9-1.2.3-2.3-.1-2.9-1.2-.8-.7-1.7-1.2-2.8-1.5-.9.5-1.5.3-1.9-.7-1.2-1.2-2.7-1.7-4.4-1.7-.1 0-1.5.7-1.5.7s-.1-1.2-.1-.9c-.4-2.5-2.7-3.3-4.8-4.2v.1l-.1-.1h.1c-1.2-2-2.9-2.4-5-2-.4.3-.8.5-1.1.9-.3.3-.4.5-.7.8.3-1.3 1.5-2.7.1-4.1-2.3-1.5-4.6-1.3-7-1.1-.1-.4-.1-.9-.3-1.3-.9.1-1.7.3-2.7.4-4.6-2.1-9.4-2.8-14.2-.7-1.3.9-2.8 2-4.4 2.5 1.5-.8 2.9-1.7 4.4-2.5-1.1-.3-2.1-.4-3.3-.3-.4.9-.8 2-1.2 2.9-1.2-.1-2.1.4-2.5 1.5-.8 0-1.6-.1-2.4-.1v2.5c-1.3.9-1.5 2.1-.7 3.6-.1 2.1.9 3.3 2.9 3.9.4 2.1 1.6 3.2 3.9 2.7-1.3-.9-2.5-1.9-3.9-2.7 1.3.8 2.7 1.7 3.9 2.7 2.7.3 5.2.4 7.8.7 2.7 5.8 8.3 9.5 13.2 13.7zm6.8-24.7c-.1.3-.3.5-.3.9v-.7c.2 0 .2 0 .3-.2zm548.8 221c-1.1-.3-2.1-.4-3.2-.4-.1-.9-.4-1.9-.5-2.8-3.6 0-7.6-2.1-10.6 1.7-1.9.9-2.9 2.4-2.4 4.6-.4 2.1.5 3.5 2.7 4 .5 2 1.9 3.1 4 2.7h3.5c6.4-1.6 6.6-2 6.5-9.8zM696.5 89.3c-1.1 0-2.1 0-3.2.1-.3 1.1-.3 2-.3 3.1-.9.3-2 .4-2.9.5-.3 1.9-1.1 3.2-2.9 3.9-2 10.4-3.9 20.7 1.9 30.5 4.6 4.6 6.4 4.6 11.7 0 3.7-1.6 7.3-3.3 9.8-6.6 2.3-.3 3.7-1.6 4.4-3.7 6.2-3.5 8.2-9 7.3-15.8-.4-2.8-1.3-5.6-2-8.2-2.7-1.6-2.8-4.4-3.2-7-.8-.1-1.7-.3-2.5-.4.3-.5.4-1.2.4-1.9-.7-.4-1.2-.8-1.9-1.2-2-.1-4-.3-6.1-.5-1.3-.9-2.3-.7-2.8.8h.1l-.3.1v-.1c-1.5.4-1.9 1.3-1.5 2.7-1.7.4-3.3.7-5 1.1-.4.8-.6 1.8-1 2.6zm169.3 295.9c2 .4 2.8-.5 2.9-2.4l.4-.5c.9 0 1.9-.1 2.7-.3.1-2 .3-4.1.4-6.1-.9-.4-1.9-.8-2.8-1.2.3-1.1 0-1.9-.9-2.4.1-1.7-.4-2.8-1.7-3.3v-.7c-.1-1.3-.7-2.3-2-2.8-1.1.3-2 0-2.8-.8-1.2.3-2.4.5-3.6.8-3.3-1.2-6.8-2.1-10.2-.3-7.3.1-7.8.4-10.2 6.9-.9 3.2-.5 5.8 3.1 7 .5 1.9 1.7 2.9 3.7 2.8.7.9 1.6 1.3 2.7 1.1 1.9 2.8 4.5 3.1 7.6 2.5 3.8 1.3 7.2 1.6 10.7-.3zm-180-26.8c.7-.9.9-2 .8-3.1 1.7-.4 2.8-1.6 3.2-3.2 8.4-.7 15.7-4 22.7-8.4 0-.8-.1-1.6-.3-2.4.4-1.2.8-2.3 1.3-3.5l.1-.4c.8-.3 1.6-.5 2.4-.7.5-3.9 2.9-8-1.7-11 .1-.9-.4-1.6-1.3-1.7 0-.9-.1-1.7-.3-2.7-.9 0-1.7 0-2.7.1v1.7c0-.5-.1-1.2 0-1.7-1.2-.4-2.3-.7-3.5-1.1v-.1c-.4-.9-.8-1.7-1.2-2.7-1.1.3-1.9 0-2.4-.9-1.1.1-2.3.4-3.3.5-.7-.9-1.6-1.2-2.7-.8-9.2-2.8-12.3-9.2-11.2-18.3.1-.5 0-1.2-.1-1.7 2.4-1.3 4.8-2.7 7.2-4 6.5 1.9 12.1-1.2 17.8-3.5 2.8-1.1 1.6-3.9 2.1-5.8h.1c-5-11.3-13.8-11.2-23.8-7.6-2.3 1.2-4.5 1.5-6.9.4-2.1-.5-4.1-1.2-6.2-1.7.3-.9-.1-1.7-1.1-2.1-.9-6.1 3.2-10.9 4.6-16.3 2.5-1.9 2.9-4.5 2.8-7.4 4.5-3.9 3.3-9.3 4-14.2.9-6.4-1.6-11-7.4-13.8-1.3-2.1-2.7-4.2-4.1-6.2-5-1.7-5.6-6.1-6.2-10.5 1.9-.4 3.1-1.7 3.7-3.5 1.9 0 3.3-.7 3.7-2.7l.1-.1c2.1-.5 3.2-1.9 3.3-4 4.2-6.9 4-7.7-3.7-11.7-1.6-1.7-3.1-3.3-4.6-5-3.1-.5-6-1.1-9-1.6-.4-2-1.7-3.2-3.6-3.7.3-1.1-.1-2-1.1-2.5v-6.2c-.8-.3-1.7-.7-2.5-1.2v-5.7c.9-.4 1.9-.8 2.8-1.1-.1-5.3 1.6-10.8-.4-16.1-.9 0-1.9-.3-2.8-.4l-.3-.3c0-.9 0-2-.1-2.9-.9-.1-1.9 0-2.9.1-.4-1.1-1.2-1.5-2.3-1.2-.4-.9-.8-1.9-1.3-2.8-1.1.1-2.1.4-3.2.5-.7-1.1-1.7-1.5-2.9-1.5-1.3-5.6 1.1-12-4.1-16.6.3-2.3-.8-3.7-3.1-4.4-1.6-2.9-3.8-5.2-7.3-6-.5-1.7-1.6-2.9-3.6-2.5-1.1-.3-2.1-.7-3.3-.9l-.1-.1c-1.3-2.5-3.5-3.7-6.1-4.1.3-.9.1-1.9-.8-2.4.8-.7 1.9-2 2.4-1.7 7.4 2.5 14.1-1.1 21-2.7.1-.9.3-1.9.3-2.7l.7-.5c2 .1 2.8-.8 2.3-2.8.1-1.3.1-2.5.3-3.9.3-1.2.4-2.3.7-3.5-.9-.4-1.9-.5-2.8-.7l-.3.4c-.8-3.9-4.4-3.6-6.9-4.6.3-.8.1-1.5-.3-2.1-1.2 0-2.4.1-3.6.1-3.5-1.7-6.8-.7-10 .8-1.1-.3-2.1-.4-3.3-.3-.5 1.9-1.9 2.8-3.7 3.1-2 5.7.1 11.7-.5 17.4-5.4-1.7-10.9-.5-16.3.3-.1.9-.3 1.9-.3 2.8l-.5.4c-1.1-.1-2-.1-3.1-.1-.1.9-.3 2-.4 2.9l-.1.1c-2 0-3.6.8-3.9 3.1h-.3c-3.5 4.1-5.2 11-13 7.8-.5-.9-.8-1.9-.8-2.9-2.9-1.6-5-4.1-6.6-6.9-1.7-.5-3.6-1.2-5.3-1.7-1.1-3.3-3.5-5.3-6.6-6.5 0-1.2-.4-2.3-1.5-2.9 0-3.5.1-6.8.1-10.2 2-2.7 4-5.2 6-7.8.8-4.1 2-8.2.4-12.3-1.1-.1-2-.3-2.9-.7-.1-2.1-1.2-3.2-3.3-3.2l-.4-.3c-.3-.8-.5-1.6-.5-2.5-4.2-.3-8.5-.5-12.7-.8-.4.8-.7 1.7-.8 2.7-5.2 2.7-6.1 7.4-6 12.6 0 6.1 2.1 12.2-.5 18.2-2.1.4-4.2.8-6.4 1.2-2.9 2.9-7 1.9-10.4 3.6-3.5-.1-7-.3-10.5-.4-.3-.9-.5-1.7-.8-2.7-.9-.1-2-.1-2.9-.1l-.4-.4c0-.9 0-1.9-.1-2.8-.9-.1-1.9-.1-2.8 0-.9-1.3-1.9-2.5-2.8-3.9.7-.4 1.2-.9 1.6-1.5.8-1.2 1.3-2.5 1.9-3.9.4-.8.8-1.6 1.2-2.5.3-.1.5-.1.9-.3-.1-2.7 1.1-5.6.3-8 0-.4 0-.8-.1-1.2-.3-1.3-.8-2.5-1.5-3.7-.8-.9-1.6-1.9-2.4-2.7l-1.6-1.6c-1.6-1.2-3.3-1.9-5.2-2.4h-5.2c-2.4 1.3-5.6.9-7.6 3.2h-.1c-4.5 1.9-5.3 6-5.7 10.1 0 .3-.1.4-.1.7-.1 0-.3.1-.4.1-.3 2.1-1.5 3.2-3.6 3.3 0 .9-.3 1.7-.7 2.5-2.1-.1-4.2-.4-6.5-.5-.5-1.9-1.9-2.5-3.6-2.7-.8-1.3-1.7-2.7-2.5-4-.5-5.6-1.1-11.2-1.6-16.6V27.5c-.9-.1-1.7-.4-2.5-.8-.4-3.1-.8-6.1-1.2-9.3-.9-.3-1.7-.5-2.5-1.1.1-2.8.5-5.8-3.2-6.8 0-1.1-.1-2-.5-3.1-1.2.1-2.4.4-3.6.5-.9-.8-2-.8-3.1-.1-2.1 0-4.4.1-6.5.1-.1.9-.4 1.9-.7 2.8-2 .4-3.2 1.5-3.1 3.6-.4 1.1-.9 2.1-1.3 3.1-5.8 7.7-3.3 16.1-2 24.4.1 2.1.1 4.1.3 6.2 4.9 6.4 10.8 11.3 19.4 11.7.4-.4.8-.8 1.3-1.1l-1.3 1.1c2.7 1.9 5.2 3.6 7.8 5.4.3.9.8 1.3 1.7 1.2.8.9 1.5 2 2.3 2.9 0 1.7.5 3.2 2.3 3.9-.8 3.1-3.1 4.9-5.8 6.2-5.4-4.1-11.4-3.5-17.1-1.2-3.7 1.5-7.2 2.4-11.2 1.5-.1.3-.1.5-.3.7l-.1-.1.4-.7c-.9-1.3-1.7-2.5-2.7-3.9.5-3.3 1.2-6.6 1.7-10 2.4-6.6-1.7-10.1-6.2-13.4-6.5.3-13 .4-19.5.7-.7 1.9-2.1 2.8-4.1 2.7-.1.9-.4 1.9-.7 2.7-.9.5-2 .9-2.9 1.5h-2.7c-.1.9-.4 1.9-.7 2.8l.7.7s0 .1-.1.1c-.3-.4-.5-.8-.5-.8-1.1.1-2.1.3-3.1.4 0 .9-.3 1.9-.7 2.7l.7.9c-.1.1-.3.3-.3.4-.1-.4-.3-.9-.4-1.3-5.6 2-11 4.6-17.1 3.9l-3.6-3.6c-5.4-.7-10.9-.5-16.2.8-.9 2.4-4.6 2.7-4.5 5.8-.9.3-1.9.4-2.8.5.4 5.8-3.1 12.2 2.8 17.1-.3 2.1.9 3.1 2.9 3.3 1.6 3.5 3.2 6.9 4.6 10.4-1.7 10.2 3.1 20.6-.5 30.8-2 1.3-4.1 2.8-6.1 4.1-1.2 4.1-3.5 7.7-6.9 10.4-.4 1.7-.8 3.6-1.2 5.3-5.2 3.9-5.2 10.8-9.2 15.4-.4 3.1-.8 6.2-1.3 9.3-.9.3-1.9.5-2.8.7.1 1.1 0 2.1-.5 3.2-3.7-.3-8.2 3.1-10.6-2.7-.9-.1-2-.4-2.9-.5l-.1-.1c.3-1.1.1-2.1-.1-3.2-1.2-.1-2.3-.1-3.3.3-1.1-.1-2.1-.4-3.2-.5-3.5-1.7-6.5.4-9.7.9-.4 1.9-.8 3.9-1.2 5.7-.9.3-1.9.5-2.8.8.1 1.1 0 2.1-.4 3.2-.1.3-.1.4-.3.5-.8-.8-1.9-1.1-3.1-.8-1.2 1.2-2.4 2.3-3.6 3.5-2.1 0-4.4.1-6.5.1-2.9-3.1-7.3-1.9-10.6-3.9-1.2.3-2.4.5-3.5.8-2.3-1.1-4.6-1.1-6.9-.3-3.3-1.1-5.8-.3-6.9 3.3-.9.3-1.7.5-2.7.8-.1 2.1-.3 4.2-.4 6.4-.8.9-1.2 2-1.2 3.2.4-.3.9-.7 1.3-.9-.4.4-.8.7-1.3.9-2 .4-2.5 1.9-2.8 3.6-1.1 1.1-2.3 2.1-3.3 3.3-2 .3-3.5 1.2-4 3.3-4.9 2.5-2.3 6.6-2.1 10.2.9.1 1.9.4 2.7.5l.1.3c-.1 2.1.9 3.2 2.9 3.3.4.9.8 1.9.9 2.9 1.1 0 2.3.1 3.3.1l1.2.5c1.2 2.3 3.1 3.3 5.6 3.1l1.2.7 1.3-.1c1.7 2.3 4.4 1.7 6.6 2.3.3-.8.5-1.6 1.1-2.3 1.1-.4 2.1-.8 3.2-1.1 2.3.1 3.9 1.2 4.1 3.6.9.1 1.6.5 2.3 1.1.1 2.3 1.3 3.5 3.6 3.5 3.9 4.2 7.8 2.7 11.8.1 4.1 2.1 8.4 4.2 12.5 6.4 3.1 6.1 7.7 11.4 8 18.7 0 .8 1.6 1.5 2.4 2.1.1 12.6.3 25.4.4 38-.8.8-1.1 1.7-.7 2.9-2.4 4.9-5.4 9.8-.4 15v.1c-.7 2.3-.4 4.2.9 6.1-.1 2 .7 3.5 2.5 4.4-.3.9 0 1.9.5 2.7-1.3 3.1-4.2 2.9-6.9 3.6-.8-.7-1.6-.9-2.7-.5-4.2-4.1-9.4-2.4-14.3-2.4h-3.7c-2.3-.1-4.5-.1-6.8-.3-2.3-.9-4.5-.8-6.6.1-2.9.3-4 2.3-3.6 4.6 1.1 6 3.6 10.9 10.2 12.1l.3.1c1.7 2.5 3.9 2.4 6.2 1.2 1.5.3 2.9.7 4.4.9 4.4.5 8.8 1.1 13.1 1.5 1.2 1.7 2.5 1.7 3.7 0 2.3 0 3.3-1.3 4.1-3.3 1.2 0 2.1-.5 2.8-1.6.8.1 1.7.3 2.5.3.1-.9.4-1.9.8-2.8 12.5-2.7 12.5-2.7 20.2 4.5.5 2 1.1 4 1.7 6 .5 1.5 1.2 3.1 1.7 4.5-1.1 1.9-2 3.9-3.1 5.7-1.1-.1-2.3-.1-3.3.3-3.6-1.6-6.5-1.5-7.8 2.9-2.5 2-3.2 4.5-1.5 7.2 1.9 2.8 4.5 2.4 7.3 1.3 1.5-.5 3.2-.5 4.9-.8v5.3c-1.5 2.5-2.8 4.9-4.2 7.4-6.1 1.7-12 5.2-18.7 3.3-.4-.8-.8-1.7-1.2-2.5-1.2 0-2.1-.5-2.9-1.5-1.2-.5-2.5-.8-3.9-.8-.8-.5-1.6-.9-2.7-.9h-4.4c-.8-.1-1.5-.1-2.3.1-1.3-.1-2.7-.4-4-.5-1.1 1.2-2 2.5-3.1 3.7 0 1.1 0 2.1.1 3.2-1.5 4.1-2.1 8.1 2.8 10.6 1.9 2.3 4.5 2.5 7 3.2.9 2.4 1.7 4.9 3.7 6.8l-.1-.3c.8 1.2 1.6 2.3 2.5 3.3 1.2 1.7 2.4 3.6 3.6 5.4 4.2 4.9 8.9 5.4 14.1 1.5l-.3.3c1.6-.8 2.8-2 3.7-3.5 0 0-.1 0-.1.1l.1-.1s0 .1-.1.1c1.5-.9 2.7-2.1 3.5-3.7l-.3.3c2.5-1.5 2.3-3.7 2-6.1-.3-.3-.4-.5-.7-.8.5-.4 1.2-.7 1.9-.7 1.2-7.4 6.1-12.3 11.2-17.4h2.6c.1-.9.4-1.7.8-2.5 3.7-1.2 6.8-3.2 8.8-6.6 1.7-.5 2.7-1.7 2.5-3.6l1.3.3s1.2-.7 1.2-.8c.8.7 1.9.8 2.8.7h.3c1.3 2.3 2.7 4.4 4 6.6-.7 3.3-.1 6.2 2.5 8.6 2.4 2.1 4.6 4.5 4.8 8 .9.1 2 .5 2.8.9 2.3 4.2 5.3 8.2 4.6 13.5-1.7 2-3.5 3.9-5 5.8-1.1.5-2 1.1-3.1 1.6-.9-.1-2-.3-2.9-.1-.1.9-.3 2-.4 2.9l-.1.1c-1.9.3-3.1 1.5-3.2 3.3l-.1.3c-.9.1-1.9.3-2.8.4 0 .9 0 1.9.1 2.8-7.2 5.8-9.8 13-6.8 22 .1.5-.1 1.1-.1 1.6.8.3 1.6.5 2.3 1.1-.8 2.3.3 5.3-2.4 6.9-.1 1.7.1 3.6-.4 5-2.5 7 .4 12 5.4 16.6 5.8 5.2 12 6.2 18.9 2.8 2.1-.4 4.4-.8 6.5-1.2 4.1 1.3 6.6-2.1 10-3.5.3-2 .5-4 .9-6.1 3.3-1.7 1.7-6.9 5.8-8 1.1-3.2 3.9-4 6.4-5.2 2.1-.9 4.2-1.7 4.9-4.2 1.9-.4 2.9-1.5 3.2-3.5 4.5-2.7 9.2-5 11.2-10.5 3.5-2.1 4.2-7.6 9.3-8 1.1.8 2.1 1.6 3.2 2.3-.5.8-.4 1.5.4 2-1.2 3.3 0 6.4.9 9.6 3.6.3 7.3 1.5 10.1-2 2.1-.4 2.9-2 2.9-4 5-3.7 11-3.2 16.9-3.7 6.2 5 13.5 4.8 20.8 4.1 2.4.9 4.8 1.9 7.2 2.8l.1.1c13.4 14.7 13.9 9.2 21.6 1.2 1.2-1.2 2.1-2.5 3.2-3.9 1.1.3 2-.1 2.8-1.1 1.1-.3 2.3-.4 3.3-.7 2.8.3 5.6.4 7.6-2h1.6l1.3-.9c2-.7 4.5-.8 6.1-2.1 6-5.2 12-4.5 18.3-.9.3.8.4 1.7.5 2.5 2.7.4 5 1.2 6.6 3.6 4.1.4 8.4.9 12.5 1.3.5 2.4.7 5 3.2 6.6.5 1.1 1.1 2.1 1.6 3.1-.1 1.1 0 2 .4 2.9-1.3 1.5-2.7 2.9-4 4.2-1.3 2.1-2.5 4.4-3.9 6.5 0 3.5 0 6.9.1 10.4 4.5 3.5 9.2 6.9 13.7 10.4 1.2-.1 2.4-.1 3.7-.3l1.5.1 1.5-.1h10.5c0-4.5 0-9 .1-13.5-1.1 0-2.1-.1-3.2-.3-.1-1.1-.1-2.1-.3-3.2-.9 0-2-.1-2.9-.3-.3-1.1-.5-2.1-.5-3.2-2.8-1.5-2.9-4.4-3.6-7 0-8 0-16.1.1-24-.9-.5-1.7-.9-2.7-1.3.3-.9-.1-1.7-.9-2.1.1-2.9-.4-5.7-2.4-8.1.8-2 1.7-4 2.5-5.8 2-.3 3.3-1.2 4.1-3.1l-1.2-.5c0-.1 0-.3.1-.4.4.3.8.5 1.1.8 4.5-.7 9.3-.4 13.1-3.6 1.2-.4 2.5-.7 3.7-1.1 3.2-.7 3.5-3.1 3.3-5.7l.3-.4c2.1-1.2 2.7-3.3 2.9-5.4.4-2.1.9-4.2 3.1-5.3 1.5-2 2.9-4 4.4-6 2.3-.3 3.9-1.3 5-3.3.9.3 1.5 0 1.7-.9 1.7-.1 2.7-1.1 2.9-2.8l.7-.7c1.1-.7 2-1.6 2.8-2.7l.7-.7c1.6-.3 2.5-1.2 2.8-2.8l.5-.7c.9-.1 1.7-.1 2.7-.3 0-.9 0-1.7-.1-2.7.8-.9 1.6-2 2.4-2.9 2.7 0 4.6-.9 5.8-3.3 2.4-1.2 4.9-2.4 7.3-3.6l1.1.4 1.1-.4h.1c2.7 2.4 5.4 2.9 8.1 0 1.7.1 3.6.4 5.3.5 1.6 2.4 4.4 2.5 6.8 3.2 3.1.7 3.2-1.7 3.7-3.6-.9-.1-1.7-.4-2.7-.5-.3-2.3-.5-4.5-.8-6.8 1.3-1 1.4-2.2 1.4-3.3zm-14.8-115v-.1c.3-1.1.9-1.6 1.7-2-.1.7-.7 1.3-1.7 2.1zm-174.9-95.7.1.1h-.1c-.1 0-.1-.1 0-.1zm-94.3-15.2c-.5 0-1.1-.1-1.5-.1v-.1c.6.1 1.1.1 1.5.2zM548 368.8l-.1-.1c.1-.1.1-.1.1.1zm-65.6 20.7c-.4 0-.9 0-1.5.1.3-.4.8-.8 1.6-1.2-.1.4-.1.8-.1 1.1zm-25-41h.1-.1zm-71.7-53.6c.4.1.8.4 1.1.8-.3-.2-.7-.5-1.1-.8 0 .2 0 .2 0 0zm78.8 37c.4.4 1 .1 0 0zm93.9-70.2h.4c-.1.1-.1.3-.3.3 0 0-.1-.1-.1-.3zm-13.8-24.1v.3c-.1-.1-.3-.1-.4-.3h.4zm-130.3-23.4c0-.5-.1-1.2-.1-1.9.1.6.1 1.2.1 1.9zM403 178.9v.3l-.1-.1c0-.1 0-.2.1-.2zm-13 64.3v-.4s.1.1 0 .4zm53 99c-.3.3-.5.4-.8.7.2-.2.5-.4.8-.7zm1.3-1c.1-.2.1-.2 0 0zm187.5-42.1c0-.1-.1-.3-.1-.4h.1v.4zm-284-30.2c0 .1.1.4.1.5-.1-.1-.3-.3-.3-.5h.2zm155.3-79.7s0 .1-.1.1c0 .1 0-.1.1-.1zm-20.7 197c-.1-.2 0-.2 0 0zm96.9-3.6c-.1 0-.1 0 0 0-.1-.1-.1-.1 0-.1-.1 0 0 .1 0 .1zm-86 4.4c-.1-.3-.4-.5-.5-.9h-.1v-.1l.1.1c.4 0 .7.1 1.1.3-.2 0-.5.3-.6.6zm127.2-28.4v-.1h.1c-.1-.1-.1.1-.1.1zM478.3 104.5c-.5-.1-1.1-.3-1.5-.5.7.3 1.2.4 1.7.5-.1-.1-.1-.1-.2 0zm.7-11.9h.3l-.3.3v-.3zM385.6 89c-.1.3-.3.7-.4.9-.3-.4-.5-.7-.7-1.1.4.2.8.2 1.1.2zm93.6-.3.4.4h-.7c.2-.1.2-.2.3-.4zm-58.9 311h-.1.1zm210.6-51.4v-.3h.1c0 .1 0 .2-.1.3zm-38-228.1c-.1.1-.1.3-.3.4 0-.1-.1-.3-.1-.4h.4zM427.2 92.6v-.3c0 .1.1.1.1.3h-.1zm-24.5 365.8c.2.1.2.1 0 0 .2 0 .2.1 0 0zm55.1-34.7c-.5 0-.9-.1-1.1-.8.5.2.9.4 1.1.8zM671 228c-.7-.3-1.5-.5-2.1-.8v-1.1c1.7.6 2.2 1.3 2.1 1.9zm-430.3-7.7c-.1 0-.1 0-.3.1h-.1s0-.1-.1-.1h.5c-.1 0-.1-.1 0 0zm7.1 2.8c.8-.1 1.5-.1 2.1.1-.7.1-1.5.3-2.3.5 0-.2 0-.5.2-.6zM685.7 356c.3-.3.7-.5.9-.8-.2.3-.5.6-.9.8zm-27.2-180.7c0 .1 0 .1 0 0v.1h-.3s.2-.1.3-.1zm-20.7-44.7h-.3l.3-.3v.3zm-130.4-38h-.7l.4-.4s.1.1.3.4zM386.1 61.4c0 .1 0 .3.1.4l-.3.1h-.3c.1-.1.3-.4.5-.5zm-67.9 121.1c-.1.4-.3.8-.4 1.2-.4-.5-.9-.9-1.3-1.5.5 0 1.1 0 1.7.3zm-21.8 158.7h-.3v-.9c0 .3 0 .6.3.9zm282.7 110.3.1-.1-.1.1zm323.2-324.8c-.5-.3-1.1-.4-1.6-.7-4.6-1.6-8.1.1-10.9 3.9-.7.8-1.5 1.2-2.5.9-.4 1.1-.5 2.1-.7 3.2l-.1.1c-4 2.1-3.3 4.6-.5 7.3 3.1 4.9 7.8 5.2 12.7 4.5 3.7-.5 7.3-1.6 11-2.5.1-.9.1-1.9.1-2.8 1.3-.4 1.9-1.3 1.6-2.7l.1-.3c4.2-2.7 2.1-6.2 1.5-9.7-3.5-.9-7.1-2.1-10.7-1.2zM215 372.4c2.4.1 4.4-.5 4.8-3.2.3-2.5-1.3-4.1-3.7-4.2-2.1-.1-4.4.3-6.5.4.1 2.1.4 4.2.5 6.4 1.7.2 3.3.4 4.9.6zm513.2-234.3c-1.1 4.2-1.2 8.5-.4 12.7 1.1.3 2 .3 3.1.3l.1.1c1.2 3.2 3.7 3.5 6.6 3.1 4.1 1.2 7.8.9 10.9-2.4 4.1-1.3 3.6-4.5 2.8-7.7-.1-1.1-.3-2.3-.4-3.3.4-1.1.4-2 .3-3.1-.8-.1-1.7-.3-2.5-.4.1-.1.3-.4.4-.5-.5-.5-1.1-1.2-1.6-1.7-2.1-.5-4.2-1.1-6.4-1.7-3.5-1.1-7.2-2.9-9.8 1.6l.3-.3c.1-.1.1-.1.3-.1l-.3.1c-.1.3-.3.5-.5 1.2-.1.5 0 1.1.1 1.6l-.3.3c-.7 0-1.8.1-2.7.2zm112.3 203.1c.1-1.2.3-2.3.4-3.5v-6.4c-1.1-.3-2-.3-3.1-.3l-.1-.1c-.1-.9-.3-2-.4-2.9-5.3 0-10.5.1-15.8.1-.8 2.3-4.2 3.1-3.6 6.1v6.1c.9.1 2 .3 2.9.5.1 1.1.3 2 .4 3.1 2 .7 4.1 1.3 6.1 2.1 5.9 2.3 10.4 1 13.2-4.8zM1.7 294.3c-.7.1-1.2 1.6-1.7 2.4.1 2.5 1.6 4 4 4.1.5 0 1.5-1.6 1.5-2.5.1-2.4-1-4.3-3.8-4zM787 112.9c-.1-1.1-.4-2.1-.8-3.1h-3.5c-.5.9-.8 2-.9 3.1-4.5 6.1-4.4 7.6 1.2 10.5l1.6.5 1.3-1.1 1.5.1 1.5-.1c-.6-3.3 2.1-7.2-1.9-9.9zM64.5 174.2c2.1-.8 4.1-2 6.2-2.9 1.3-4.8-1.7-8.5-3.3-12.5-3.3-1.2-6.5-2.4-9.8-3.6-5.6-1.9-11-.8-16.6.1-.1 1.1-.3 2-.1 3.1-1.9 2.3-1.6 4.6.1 6.9-.4 2.3.9 2.9 2.8 3.2.4.9.7 1.9.7 2.8 2.1.1 4.2.4 6.5.5l1.2.8 1.3-.1c3.2 3.7 7.2 3.2 11 1.7zm645.4-8.9c-1.2-1.1-2.3-2.3-3.5-3.3-3.2 0-6.5 0-9.7-.1-.9 1.3-1.9 2.7-2.8 4 0 2.9-.1 5.8-.1 8.8 2 .9 3.9 2 5.8 2.9 2.5 1.3 5 1.9 7.3-.5.3-2.1 1.6-3.6 2.9-5 .1-2.2.1-4.5.1-6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M709.9 172c-.9 1.7-2 3.3-2.9 5 2.1-.9 3.4-2.5 2.9-5zM216.8 320.2c1.2 1.1 2.4 2.1 3.6 3.2 2 0 4.1.1 6.1.1.4-2.8.7-5.6-1.9-7.8-1.9-1.6-3.7-2.7-6.1-1.6-2.5 1.3-1.4 4-1.7 6.1zm553-41.7c-.7-2-2-3.2-4.2-2.8-.8-.9-1.7-1.3-2.9-1.3.1-.8 0-1.7-.4-2.4-1.2.1-2.4.4-3.6.5-3.2-.3-6.4-.7-9.6-.9-.4-.9-.8-1.7-1.3-2.5-.8.7-1.5.7-2.3 0-.4.8-.8 1.5-1.2 2.3-3.1-.4-5.7.3-7 3.3-2 .7-3.3 1.9-3.3 4.1-2.9 3.6-3.7 7.3-.4 11.2.5 2.7 1.5 5 4.6 5.6 1.1.7 2 1.3 3.1 2 .7 2 2.1 2.4 3.9 1.9 2.3 0 4.4.1 6.6.1 2.4 0 4.6-.1 7-.1 4.8.3 7.7-2.8 10.5-6 2.1-.4 3.3-1.6 3.5-3.7l-1.2-.9v-.3l1.2 1.2c.8-.5 1.6-.8 2.5-.8.3-2 .5-4.1.7-6.1-.9-.3-2-.7-2.9-.8-.4-2.3-1.5-3.4-3.3-3.6zm-35 9v.3c-1.4.5-1.2-.6 0-.3zm1.8-10.9c.3-.5.5-1.2.7-1.9-.1.7-.3 1.4-.7 1.9zm18.4-42.3c-1.2 0-2.3 0-3.5.1-.7-.8-1.5-1.1-2.4-.7-1.5-.9-2.9-1.9-4.4-2.8-1.1.7-2.3.7-3.3.1-.5.8-.9 1.7-1.2 2.7-.9-.4-1.6-.1-2.3.5-2.3.1-4.4.3-6.6.4-.3 1.1-.4 2-.4 3.1-.9.3-1.9.4-2.8.5-1.7 5.8-1.2 11.3 3.5 15.8 4.2.1 8.6.4 12.9.5 5.8 1.9 9-1.2 10.9-6.2 2.5-1.9 2-4.9 2.9-7.3l-.8-.8.4-1.1c-.4-1.9-1.5-2.3-3.1-1.6.5-1.1.5-2.2.2-3.2zM251.2 382.5c.1-1.1 0-2.1-.4-3.1-3.5-.1-6.8-.1-10.2-.3-2.1 1.3-4.1 2.8-6.2 4.1-.5 2-1.6 3.3-3.9 3.1-2.5 2.8-6 2-9 2.5-.3-1.1-1.1-1.7-2.1-2.3l.1.1c-2-2.8-4.2-2.7-6.5-.5l-.9.8-1.1-.5c-1.5.3-2.7 1.1-3.5 2.4 0 .1 0 .3-.1.4-5 .1-10.1.3-15.1.4-.4.9-.8 2-1.2 2.9-1.9.3-3.7.5-5.6.7-.3.9-.4 1.9-.4 2.9-.9.3-1.9.5-2.9.7 0 2 .1 4 .1 6 .9.1 1.7.4 2.5.5l.3.4c1.2.8 2.3 1.7 3.3 2.8-1.1-.9-2.1-1.9-3.3-2.8.1 2.1 1.2 3.1 3.3 2.9l1.2.9h1.6c2 2.4 4.6 2.8 7.6 2.5 1.2.3 2.3.4 3.5.7 20.8 7.2 20.8 7.2 33.9 2.3.3-1.1.4-2.1.7-3.2 2.9-.9 4.1-3.3 4.6-6.1 3.2-3.3 8.1-5 9.6-10.1l.3-.3c3.9-5.4 3.9-5.7-.2-10.8zm-52 16.8c.1 0 .1 0 0 0z"
  }))))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'absolute top-[38%] left-1/2 h-20 w-20 -translate-y-1/2 -translate-x-1/2 rounded-full bg-white opacity-10'
  }), /*#__PURE__*/React.createElement("div", {
    className: 'absolute top-1/2 left-[40%] h-20 w-20 -translate-y-1/2 -translate-x-1/2 rounded-full bg-white opacity-10'
  }), /*#__PURE__*/React.createElement("div", {
    className: 'absolute top-1/2 left-[57%] h-20 w-20 -translate-y-1/2 -translate-x-1/2 rounded-full bg-white opacity-10'
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, children));
}

gsap.registerPlugin(ScrollTrigger);
function CallToAction({
  ...props
}) {
  const Component = props.Image ? CallToActionImage : CallToActionAnimated;
  return /*#__PURE__*/React.createElement(Component, props);
}
function CallToActionAnimated({
  title,
  description,
  linkText,
  Link
}) {
  const groupTheme = useGroupTheme({
    kinderspital: {
      button: 'button-white-outline'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      button: 'button-primary'
    },
    nidwalden: {
      button: 'button-primary'
    }
  });

  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  return /*#__PURE__*/React.createElement("div", {
    className: "container-page mb-4 lg:mb-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, null, /*#__PURE__*/React.createElement("div", {
    className: "container-text"
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('mb-10 px-6 py-9 text-left lg:py-20')
  }, /*#__PURE__*/React.createElement("div", {
    className: "max-w-2xl lg:max-w-3xl"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "mb-8 text-xl font-semibold text-white lg:text-5xl"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "prose mb-8 max-w-none text-base text-white lg:text-2xl"
  }, description), Link && linkText ? /*#__PURE__*/React.createElement(Link, {
    className: theme.button
  }, linkText) : null))))));
}
function CallToActionImage({
  Image,
  title,
  description,
  linkText,
  Link,
  imgAlignment
}) {
  const BoxRef = useRef(null);
  const ImgRef = useRef(null);
  const isDesktop = useSetMediaQuery() === 'desktop';
  useEffect(() => {
    const box = BoxRef.current;
    const img = ImgRef.current;
    if (BoxRef.current || ImgRef.current) {
      gsap.fromTo(img, {
        y: isDesktop ? '60px' : '0px'
      }, {
        y: isDesktop ? '-70px' : '0px',
        duration: 1,
        ease: Power3.easeOut,
        scrollTrigger: {
          trigger: img,
          start: 'top bottom',
          scrub: isDesktop,
          toggleActions: 'play none none reverse'
        }
      });
    }
    return () => {
      gsap.set([box, img], {
        clearProps: 'all'
      });
      gsap.killTweensOf([box, img]);
    };
  }, [isDesktop, BoxRef, ImgRef]);
  const groupTheme = useGroupTheme({
    kinderspital: {
      background: 'bg-orange-400',
      button: 'button-white-outline'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      background: 'bg-blue-900',
      button: 'button-primary'
    },
    nidwalden: {
      background: 'bg-brown-600',
      button: 'button-primary'
    }
  });
  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  return /*#__PURE__*/React.createElement("div", {
    className: "container-page mb-32 lg:mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('mb-16 overflow-visible px-5 pt-10 text-left md:px-20 lg:max-w-[75%] lg:py-20', theme.background, {
      'lg:ml-[40%]': imgAlignment == 'left'
    }),
    "aria-label": title
  }, Image ? /*#__PURE__*/React.createElement("div", {
    className: clsx('relative mb-12 mt-20 hidden overflow-hidden lg:absolute lg:top-0 lg:left-0 lg:aspect-[16/10] lg:w-1/2', {
      'lg:block': imgAlignment == 'left'
    }),
    ref: imgAlignment == 'left' ? ImgRef : null
  }, /*#__PURE__*/React.createElement(Image, {
    className: "block w-full max-w-full object-cover transition duration-300 group-hover:scale-105"
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: clsx('lg:aspect-[16/9]', {
      'lg:ml-[20%] lg:max-w-[85%]': imgAlignment == 'left',
      'lg:max-w-[65%]': imgAlignment !== 'left'
    }),
    ref: BoxRef
  }, /*#__PURE__*/React.createElement("h2", {
    className: "mb-8 text-xl font-semibold text-white lg:text-5xl"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "prose mb-8 max-w-none text-base text-white lg:text-2xl"
  }, description), Link && linkText ? /*#__PURE__*/React.createElement(Link, {
    className: theme.button
  }, linkText) : null), Image ? /*#__PURE__*/React.createElement("div", {
    className: clsx('relative -bottom-24 -mt-12 block overflow-hidden lg:absolute lg:inset-y-0 lg:right-0 lg:mt-20 lg:aspect-[16/10] lg:w-1/2 lg:max-w-[60%]', {
      'lg:hidden': imgAlignment == 'left',
      'lg:block': imgAlignment == 'right' || imgAlignment == null
    }),
    ref: imgAlignment == 'right' ? ImgRef : null
  }, /*#__PURE__*/React.createElement(Image, {
    className: "block w-full max-w-full object-cover transition duration-300 group-hover:scale-105"
  })) : null)));
}

function ContactInfo({
  title,
  isPrimaryHeader,
  companyName,
  parentLocationTitle,
  city,
  postCode,
  addressFirstLine,
  addressSecondLine,
  telephone,
  email,
  firstColumnAdditional,
  secondColumn,
  thirdColumn,
  map
}) {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "container-page prose lg:prose-xl"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-text mt-14 text-center "
  }, isPrimaryHeader ? /*#__PURE__*/React.createElement("h1", null, title) : /*#__PURE__*/React.createElement("h2", null, title)), /*#__PURE__*/React.createElement("div", {
    className: 'container-nested mt-5 grid gap-2 md:mt-10 md:grid-cols-2 md:gap-8 lg:mt-6 lg:grid-cols-3'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'my-0 md:-my-6 lg:my-0'
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-text"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'mt-6'
  }, /*#__PURE__*/React.createElement("h3", {
    className: '!mt-0'
  }, intl.formatMessage({
    id: "D24UoX",
    defaultMessage: [{
      "type": 0,
      "value": "Adresse"
    }]
  })), /*#__PURE__*/React.createElement("p", {
    className: 'mt-3'
  }, companyName && /*#__PURE__*/React.createElement("span", {
    className: 'block'
  }, companyName), parentLocationTitle && /*#__PURE__*/React.createElement("span", {
    className: 'block'
  }, parentLocationTitle), /*#__PURE__*/React.createElement("span", {
    className: 'block'
  }, addressFirstLine), addressSecondLine && /*#__PURE__*/React.createElement("span", {
    className: 'block'
  }, addressSecondLine), /*#__PURE__*/React.createElement("span", {
    className: 'block'
  }, postCode, " ", city))), telephone || email ? /*#__PURE__*/React.createElement("p", {
    className: 'prose mt-3 lg:prose-xl'
  }, telephone && /*#__PURE__*/React.createElement("div", {
    className: 'block'
  }, intl.formatMessage({
    id: "/m7J79",
    defaultMessage: [{
      "type": 0,
      "value": "Telefon"
    }]
  }), " ", /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    rel: "noreferrer",
    href: `tel:${telephone}`
  }, telephone)), email && /*#__PURE__*/React.createElement("span", {
    className: 'block'
  }, /*#__PURE__*/React.createElement("a", {
    href: `mailto:${email}`
  }, email))) : null), /*#__PURE__*/React.createElement(Group, {
    definition: ParagraphsGroup,
    input: firstColumnAdditional
  })), /*#__PURE__*/React.createElement("div", {
    className: 'my-0 md:-my-6 lg:my-0'
  }, /*#__PURE__*/React.createElement(Group, {
    definition: ParagraphsGroup,
    input: secondColumn
  })), /*#__PURE__*/React.createElement("div", {
    className: 'my-0 md:-my-6 lg:my-0'
  }, /*#__PURE__*/React.createElement(Group, {
    definition: ParagraphsGroup,
    input: thirdColumn
  }))))), /*#__PURE__*/React.createElement(ContactMap, map));
}
function ContactMap({
  latitude,
  longitude,
  MapInfo
}) {
  const intl = useIntl();
  const mapOptions = {
    clickableIcons: false,
    styles: [{
      featureType: 'administrative',
      elementType: 'labels.text.fill',
      stylers: [{
        color: '#595959'
      }, {
        visibility: 'on'
      }]
    }, {
      featureType: 'administrative.country',
      elementType: 'all',
      stylers: [{
        weight: '1.38'
      }]
    }, {
      featureType: 'administrative.province',
      elementType: 'all',
      stylers: [{
        visibility: 'on'
      }, {
        weight: '1.05'
      }]
    }, {
      featureType: 'landscape',
      elementType: 'all',
      stylers: [{
        hue: '#ff0000'
      }, {
        saturation: '-100'
      }, {
        lightness: '74'
      }, {
        visibility: 'simplified'
      }]
    }, {
      featureType: 'landscape.natural',
      elementType: 'all',
      stylers: [{
        lightness: '100'
      }, {
        saturation: '-43'
      }]
    }, {
      featureType: 'poi',
      elementType: 'all',
      stylers: [{
        visibility: 'simplified'
      }]
    }, {
      featureType: 'poi',
      elementType: 'geometry',
      stylers: [{
        color: '#dff8c6'
      }]
    }, {
      featureType: 'poi',
      elementType: 'labels.text',
      stylers: [{
        visibility: 'simplified'
      }]
    }, {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [{
        visibility: 'on'
      }, {
        saturation: '-100'
      }, {
        color: '#858585'
      }]
    }, {
      featureType: 'poi.attraction',
      elementType: 'all',
      stylers: [{
        visibility: 'off'
      }]
    }, {
      featureType: 'poi.business',
      elementType: 'all',
      stylers: [{
        visibility: 'off'
      }]
    }, {
      featureType: 'poi.government',
      elementType: 'all',
      stylers: [{
        visibility: 'simplified'
      }]
    }, {
      featureType: 'poi.medical',
      elementType: 'geometry.fill',
      stylers: [{
        saturation: '-12'
      }, {
        lightness: '15'
      }]
    }, {
      featureType: 'poi.park',
      elementType: 'all',
      stylers: [{
        visibility: 'on'
      }, {
        saturation: '-31'
      }, {
        lightness: '5'
      }]
    }, {
      featureType: 'poi.place_of_worship',
      elementType: 'all',
      stylers: [{
        visibility: 'off'
      }]
    }, {
      featureType: 'road',
      elementType: 'all',
      stylers: [{
        saturation: '0'
      }]
    }, {
      featureType: 'road.highway',
      elementType: 'all',
      stylers: [{
        saturation: '-22'
      }, {
        visibility: 'simplified'
      }, {
        lightness: '35'
      }]
    }, {
      featureType: 'road.highway',
      elementType: 'geometry.fill',
      stylers: [{
        lightness: '31'
      }, {
        saturation: '3'
      }, {
        weight: '3.73'
      }, {
        visibility: 'simplified'
      }]
    }, {
      featureType: 'road.arterial',
      elementType: 'geometry.fill',
      stylers: [{
        saturation: '-13'
      }, {
        lightness: '-8'
      }]
    }, {
      featureType: 'road.local',
      elementType: 'geometry.fill',
      stylers: [{
        lightness: '0'
      }]
    }, {
      featureType: 'water',
      elementType: 'all',
      stylers: [{
        color: '#b9e4f3'
      }, {
        visibility: 'on'
      }]
    }]
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "my-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'prose mt-5 lg:prose-xl '
  }, /*#__PURE__*/React.createElement("h3", null, intl.formatMessage({
    id: "+v+FJt",
    defaultMessage: [{
      "type": 0,
      "value": "Anreise"
    }]
  })), MapInfo ? /*#__PURE__*/React.createElement("div", {
    className: 'md:hidden'
  }, /*#__PURE__*/React.createElement(MapInfo, null)) : null)))), latitude && longitude ? /*#__PURE__*/React.createElement("div", {
    className: 'mt-5'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'h-[400px] w-full md:h-[550px] lg:h-[650px]'
  }, /*#__PURE__*/React.createElement(GoogleMapReact, {
    options: mapOptions,
    bootstrapURLKeys: {
      key: 'AIzaSyAGu07yOe-dvyegu9_mom1Ldj4QuZfxyaM'
    }
    // Adjust the default centering so the PopOver has enough space.
    // @todo improve by calculating the offset (current zoom + PopOver size).
    ,
    defaultCenter: {
      lat: latitude + 0.0035,
      lng: longitude
    },
    defaultZoom: 16
  }, /*#__PURE__*/React.createElement(MapMarker
  // @ts-ignore
  , {
    lat: latitude,
    lng: longitude,
    MapInfo: MapInfo
  })))) : null);
}
function MapMarker({
  MapInfo
}) {
  const intl = useIntl();
  const IconTheme = useTheme({
    luzern: 'text-blue-900 hover:text-blue-400',
    nidwalden: 'text-brown-400 hover:text-brown-900'
  });
  const [popoverIsOpen, setPopoverIsOpen] = useState(true);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'relative'
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('absolute left-0 bottom-0 -translate-x-1/2 transition md:hidden', IconTheme)
  }, /*#__PURE__*/React.createElement(MarkerIcon, null))), /*#__PURE__*/React.createElement(Popover, {
    className: "z-10 hidden md:block"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'relative h-0 w-0'
  }, /*#__PURE__*/React.createElement(Popover.Button, {
    className: clsx('absolute left-0 bottom-0 -translate-x-1/2 transition focus:outline-none', IconTheme)
  }, /*#__PURE__*/React.createElement(MarkerIcon, null)), /*#__PURE__*/React.createElement(Popover.Panel, {
    static: popoverIsOpen,
    className: "prose absolute -top-12 left-[-160px] z-10  -translate-y-full rounded-md bg-white p-5 text-left shadow-lg md:left-[-150px] md:w-[300px] lg:prose-xl"
  }, ({
    close
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    className: 'focus absolute right-2 top-2',
    onClick: () => {
      setPopoverIsOpen(false);
      close();
    }
  }, /*#__PURE__*/React.createElement(XIcon, {
    className: 'h-5 w-5'
  })), /*#__PURE__*/React.createElement("h3", {
    className: '!mt-0'
  }, intl.formatMessage({
    id: "+v+FJt",
    defaultMessage: [{
      "type": 0,
      "value": "Anreise"
    }]
  })), MapInfo && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(MapInfo, null)))))));
}
function MarkerIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    className: "h-12 w-12",
    fill: "currentColor",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z",
    clipRule: "evenodd"
  }));
}

function ContentHeader({
  Title,
  breadcrumbItems,
  HomeLink,
  Description
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: 'my-5 md:my-8'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, breadcrumbItems?.length ? /*#__PURE__*/React.createElement(Breadcrumb.Wrapper, {
    className: 'mb-3 md:mb-6'
  }, HomeLink ? /*#__PURE__*/React.createElement(Breadcrumb.HomeItem, {
    Link: HomeLink
  }) : null, breadcrumbItems.map((item, index) => /*#__PURE__*/React.createElement(Breadcrumb.Item, _extends({
    key: index
  }, item)))) : null, /*#__PURE__*/React.createElement("div", {
    className: 'container-text'
  }, /*#__PURE__*/React.createElement("h1", {
    className: clsx('text-3xl font-bold lg:text-5xl lg:leading-[1.2]', useTheme({
      luzern: ``,
      nidwalden: `text-brown-900`
    }))
  }, /*#__PURE__*/React.createElement(Title, null)), Description ? /*#__PURE__*/React.createElement("div", {
    className: 'mt-6 text-lead-sm md:text-lead-md lg:text-lead-lg'
  }, /*#__PURE__*/React.createElement(Description, null)) : null))));
}

function LinkList$1({
  items,
  display
}) {
  return /*#__PURE__*/React.createElement("div", null, items?.map((item, index) => /*#__PURE__*/React.createElement(LinkListItem, _extends({
    key: index
  }, item, {
    display: display
  }))));
}
function LinkListItem({
  Link,
  title,
  location,
  display
}) {
  const hasLink = !!(Link && Link.href);
  const groupTheme = useGroupTheme({
    kinderspital: {
      background: hasLink ? 'hover:bg-orange-400' : '',
      title: hasLink ? 'text-orange-400 group-hover:text-white' : 'text-black',
      border: 'border-orange-400'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      background: hasLink ? 'hover:bg-blue-100' : '',
      title: hasLink ? 'text-blue-900 group-hover:text-blue-400' : 'text-black',
      border: 'border-blue-850'
    },
    nidwalden: {
      background: hasLink ? 'hover:bg-brown-100' : '',
      title: hasLink ? 'text-brown-900 group-hover:text-brown-400' : 'text-black',
      border: 'border-brown-900'
    }
  });

  // @ts-ignore
  const LinkWrapper = hasLink ? Link : ({
    className,
    children
  }) => /*#__PURE__*/React.createElement("span", {
    className: className
  }, children);

  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  return display === 'tag' ? /*#__PURE__*/React.createElement(LinkWrapper, {
    className: clsx('focus pt- group mr-4 mt-4 inline-block rounded-[0.313rem] border py-1 pl-3 pr-2 transition group-hover:no-underline', theme.background, hasLink ? theme.border : 'border-black')
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("span", {
    className: clsx('text-lead-sm font-bold', theme.title)
  }, location && location, ` ${title}`), /*#__PURE__*/React.createElement("div", {
    className: 'pl-1'
  }, /*#__PURE__*/React.createElement(ArrowRight$4, {
    className: clsx(hasLink ? 'h-4 w-6' : '', theme.title),
    hidden: !hasLink
  })))) : /*#__PURE__*/React.createElement(LinkWrapper, {
    className: clsx('focus group flex items-center justify-between border-b border-grey-200 p-5 pt-6 transition first:border-t group-hover:no-underline', theme.background, display)
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx({
      'md:w-1/3': location,
      'w-full flex-1': !location
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: clsx('block text-lg font-bold', theme.title)
  }, title), location && /*#__PURE__*/React.createElement("span", {
    className: 'md:hidden'
  }, location)), location && /*#__PURE__*/React.createElement("span", {
    className: 'hidden md:block md:w-1/3'
  }, location), /*#__PURE__*/React.createElement("div", {
    className: 'pl-8'
  }, /*#__PURE__*/React.createElement(ArrowRight$4, {
    className: clsx('h-8 w-8', theme.title),
    hidden: !hasLink
  })));
}
function ArrowRight$4({
  className,
  hidden
}) {
  if (hidden) {
    return /*#__PURE__*/React.createElement("div", {
      className: className
    });
  }
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17 8l4 4m0 0l-4 4m4-4H3"
  }));
}

function TableRow({
  label,
  children
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: 'mb-2 flex flex-col border-b border-grey-200 pb-2 last:border-b-0 md:flex-row md:items-end md:justify-between'
  }, /*#__PURE__*/React.createElement("h4", {
    className: 'mb-2 !mt-0 md:!my-0 md:w-2/3'
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "md:w-1/3 md:text-right"
  }, children));
}
function isEmail(input) {
  return input.includes('@');
}
function formatPhone(input) {
  if (!input) return input;
  const newPhone = input.replace(/ */gm, '');
  const phoneArray = newPhone.split('');
  const countryCodePattern = /^(\+\d{1,3}|00\d{1,3})/;
  const match = newPhone.match(countryCodePattern);
  let segment0 = [];
  const segments = [];
  if (match !== null) {
    segment0 = phoneArray.splice(0, phoneArray.length - 9);
  } else {
    segment0 = phoneArray.splice(0, phoneArray.length - 7);
  }

  // Split remaining numbers into segments of 2, 3, 2, 2 from right to left
  for (let i = 0; i < 4; i++) {
    const segmentLength = i === 2 ? 3 : 2;
    segments.unshift(phoneArray.splice(-segmentLength).join(''));
  }
  return `${segment0.join('')} ${segments.join(' ')}`;
}
function ContentSpecialist({
  specialization,
  memberships,
  mandates,
  awards,
  education,
  treatments,
  background,
  email,
  phone,
  locations,
  secretaries,
  offices,
  contactInfo,
  languages
}) {
  const intl = useIntl();
  const ContentTheme = useTheme({
    luzern: 'prose lg:prose-xl',
    nidwalden: 'nidwalden prose lg:prose-xl'
  });
  const TableTheme = useTheme({
    luzern: 'prose lg:prose-xl',
    nidwalden: 'nidwalden prose lg:prose-xl'
  });
  return /*#__PURE__*/React.createElement("div", {
    className: 'container-page my-10'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-text'
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('max-w-none', TableTheme)
  }, /*#__PURE__*/React.createElement("div", {
    className: 'mb-12'
  }, email ? /*#__PURE__*/React.createElement(TableRow, {
    label: intl.formatMessage({
      id: "SM3f+C",
      defaultMessage: [{
        "type": 0,
        "value": "E-mail:"
      }]
    })
  }, /*#__PURE__*/React.createElement("a", {
    href: `mailto:${email}`
  }, email)) : null, phone ? /*#__PURE__*/React.createElement(TableRow, {
    label: intl.formatMessage({
      id: "obf+qn",
      defaultMessage: [{
        "type": 0,
        "value": "Telefon:"
      }]
    })
  }, /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    rel: "noreferrer",
    href: `tel:${formatPhone(phone)}`
  }, `${formatPhone(phone)}`)) : null, secretaries?.map(({
    label,
    phone,
    email
  }, index) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: index
  }, phone ? /*#__PURE__*/React.createElement(TableRow, {
    label: intl.formatMessage({
      id: "MkBK44",
      defaultMessage: [{
        "type": 0,
        "value": "Telefon Sekretariat "
      }, {
        "type": 1,
        "value": "name"
      }, {
        "type": 0,
        "value": ":"
      }]
    }, {
      name: label
    })
  }, /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    rel: "noreferrer",
    href: `tel:${formatPhone(phone)}`
  }, `${formatPhone(phone)}`)) : null, email ? /*#__PURE__*/React.createElement(TableRow, {
    label: intl.formatMessage({
      id: "Ttcb6c",
      defaultMessage: [{
        "type": 0,
        "value": "E-Mail Sekretariat "
      }, {
        "type": 1,
        "value": "name"
      }, {
        "type": 0,
        "value": ":"
      }]
    }, {
      name: label
    })
  }, /*#__PURE__*/React.createElement("a", {
    href: `mailto:${email}`
  }, email)) : null)), offices?.map(({
    label,
    phone,
    email,
    Link,
    area
  }, index) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: index
  }, phone ? /*#__PURE__*/React.createElement(TableRow, {
    label: intl.formatMessage({
      id: "MkBK44",
      defaultMessage: [{
        "type": 0,
        "value": "Telefon Sekretariat "
      }, {
        "type": 1,
        "value": "name"
      }, {
        "type": 0,
        "value": ":"
      }]
    }, {
      name: /*#__PURE__*/React.createElement(Link, null, label, area ? `, ${area}` : null)
    })
  }, /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    rel: "noreferrer",
    href: `tel:${formatPhone(phone)}`
  }, `${formatPhone(phone)}`)) : null, email ? /*#__PURE__*/React.createElement(TableRow, {
    label: intl.formatMessage({
      id: "Ttcb6c",
      defaultMessage: [{
        "type": 0,
        "value": "E-Mail Sekretariat "
      }, {
        "type": 1,
        "value": "name"
      }, {
        "type": 0,
        "value": ":"
      }]
    }, {
      name: /*#__PURE__*/React.createElement(Link, null, label, area ? `, ${area}` : null)
    })
  }, /*#__PURE__*/React.createElement("a", {
    href: `mailto:${email}`
  }, email)) : null)), (contactInfo || []).map(({
    label,
    value
  }, index) => /*#__PURE__*/React.createElement(TableRow, {
    label: `${label}:`,
    key: index
  }, isEmail(value) ? /*#__PURE__*/React.createElement("a", {
    href: `mailto:${value}`
  }, value) : /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    rel: "noreferrer",
    href: `tel:${formatPhone(value)}`
  }, `${formatPhone(value)}`))))), locations && locations.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: 'my-10'
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx(ContentTheme)
  }, /*#__PURE__*/React.createElement("h3", {
    className: 'pb-6'
  }, intl.formatMessage({
    id: "N+aWuo",
    defaultMessage: [{
      "type": 0,
      "value": "Fachbereich"
    }]
  }))), /*#__PURE__*/React.createElement(LinkList$1, {
    items: locations
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: clsx(ContentTheme)
  }, specialization && specialization.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", {
    className: 'mb-5'
  }, intl.formatMessage({
    id: "CzeOv3",
    defaultMessage: [{
      "type": 0,
      "value": "Facharzttitel"
    }]
  })), specialization.length > 1 ? /*#__PURE__*/React.createElement("ul", null, specialization.map((item, index) => /*#__PURE__*/React.createElement("li", {
    key: index
  }, item))) : /*#__PURE__*/React.createElement("p", null, specialization[0])) : null, treatments && treatments.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", {
    className: 'mb-5'
  }, intl.formatMessage({
    id: "Qq6K9a",
    defaultMessage: [{
      "type": 0,
      "value": "Behandlungsschwerpunkte"
    }]
  })), treatments.length > 1 ? /*#__PURE__*/React.createElement("ul", null, treatments.map((item, index) => /*#__PURE__*/React.createElement("li", {
    key: index
  }, item))) : /*#__PURE__*/React.createElement("p", null, treatments[0])) : null, languages && languages.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", {
    className: 'mb-5'
  }, intl.formatMessage({
    id: "+5sQDB",
    defaultMessage: [{
      "type": 0,
      "value": "Sprachen"
    }]
  })), /*#__PURE__*/React.createElement("p", null, languages.join(', '))) : null, background && background.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", {
    className: 'mb-5'
  }, intl.formatMessage({
    id: "hsUX4B",
    defaultMessage: [{
      "type": 0,
      "value": "Beruflicher Werdegang"
    }]
  })), background.length > 1 ? /*#__PURE__*/React.createElement("ul", null, background.map((item, index) => /*#__PURE__*/React.createElement("li", {
    key: index
  }, item))) : /*#__PURE__*/React.createElement("p", null, background[0])) : null, education && education.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", {
    className: 'mb-5'
  }, intl.formatMessage({
    id: "SlJBwo",
    defaultMessage: [{
      "type": 0,
      "value": "Aus-/Weiterbildung und Diplome"
    }]
  })), education.length > 1 ? /*#__PURE__*/React.createElement("ul", null, education.map((item, index) => /*#__PURE__*/React.createElement("li", {
    key: index
  }, item))) : /*#__PURE__*/React.createElement("p", null, education[0])) : null, memberships && memberships.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", {
    className: 'mb-5'
  }, intl.formatMessage({
    id: "MgEukX",
    defaultMessage: [{
      "type": 0,
      "value": "Mitgliedschaft in Fachgesellschaften"
    }]
  })), memberships.length > 1 ? /*#__PURE__*/React.createElement("ul", null, memberships.map((item, index) => /*#__PURE__*/React.createElement("li", {
    key: index
  }, item))) : /*#__PURE__*/React.createElement("p", null, memberships[0])) : null, mandates && mandates.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", {
    className: 'mb-5'
  }, intl.formatMessage({
    id: "6F7FCJ",
    defaultMessage: [{
      "type": 0,
      "value": "Mandate und Interessenbindungen"
    }]
  })), mandates.length > 1 ? /*#__PURE__*/React.createElement("ul", null, mandates.map((item, index) => /*#__PURE__*/React.createElement("li", {
    key: index
  }, item))) : /*#__PURE__*/React.createElement("p", null, mandates[0])) : null, awards && awards.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", {
    className: 'mb-5'
  }, intl.formatMessage({
    id: "6FUkM2",
    defaultMessage: [{
      "type": 0,
      "value": "Auszeichnungen"
    }]
  })), awards.length > 1 ? /*#__PURE__*/React.createElement("ul", null, awards.map((item, index) => /*#__PURE__*/React.createElement("li", {
    key: index
  }, item))) : /*#__PURE__*/React.createElement("p", null, awards[0])) : null))));
}

function ContextualTextSection({
  inSidebar,
  ...props
}) {
  const Component = inSidebar ? ContextualTextSidebar : ContextualTextDefault;
  return /*#__PURE__*/React.createElement(Component, props);
}
function ContextualTextDefault({
  title,
  Description,
  linkText,
  Link
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('container-content grid gap-5 md:grid-cols-2 md:gap-14 lg:grid-cols-3 xl:grid-cols-4')
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('rounded-l-lg border-l-[0.563rem] px-4 md:px-5', useTheme({
      luzern: 'border-blue-850 text-grey-900',
      nidwalden: 'border-brown-400'
    }))
  }, /*#__PURE__*/React.createElement("h3", {
    className: "mb-4 text-xl font-semibold"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "prose mb-7 max-w-none lg:text-lg"
  }, /*#__PURE__*/React.createElement(Description, null)), Link && linkText ? /*#__PURE__*/React.createElement(Link, {
    className: "button-primary button-primary--icon w-max"
  }, linkText, /*#__PURE__*/React.createElement(ArrowNarrowRightIcon, {
    className: clsx('ml-2 h-7 w-7')
  })) : null));
}
function ContextualTextSidebar({
  title,
  Description,
  linkText,
  Link
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('h-max rounded-l-lg border-l-[0.563rem] px-4 md:px-5', useTheme({
      luzern: 'border-blue-850 text-grey-900',
      nidwalden: 'border-brown-400'
    }))
  }, /*#__PURE__*/React.createElement("div", {
    className: "mx-auto flex max-w-2xl flex-col justify-between lg:max-w-3xl"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    className: "mb-4 text-xl font-semibold"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "prose mb-7 max-w-none lg:text-lg"
  }, /*#__PURE__*/React.createElement(Description, null))), Link && linkText ? /*#__PURE__*/React.createElement(Link, {
    className: "button-primary button-primary--icon w-max"
  }, linkText, /*#__PURE__*/React.createElement(ArrowNarrowRightIcon, {
    className: clsx('ml-2 h-7 w-7')
  })) : null));
}

function Faq({
  id,
  heading,
  faqs,
  accordionIfGreaterThan = 0
}) {
  const showAccordion = faqs.length > accordionIfGreaterThan;
  return /*#__PURE__*/React.createElement("div", {
    className: 'container-page mb-10 md:mb-14'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-text'
  }, /*#__PURE__*/React.createElement("div", {
    className: "prose"
  }, /*#__PURE__*/React.createElement("h2", {
    id: id,
    className: 'mt-12 mb-8 md:mb-8'
  }, heading)), faqs.map(({
    title,
    Content
  }, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: 'border-t border-grey-200 last:border-b'
  }, /*#__PURE__*/React.createElement(Accordion, {
    item: {
      title,
      Content
    },
    justStyle: showAccordion
  }))))));
}

function useShowSlideshow(count, limit = 5, smallScreenOnly = false) {
  const [showSlideshow, setShowSlideShow] = useState(false);
  useEffect(() => {
    const shouldShowSlideshow = () => {
      if (!smallScreenOnly) {
        return window.matchMedia('(max-width: 767px)').matches && count > 1 || window.matchMedia('(min-width: 768px) and (max-width: 1023px)').matches && count > 3 || window.matchMedia('(min-width: 1024px)').matches && count > limit;
      }
      return window.matchMedia('(max-width: 1024px)').matches && count > 1;
    };
    setShowSlideShow(shouldShowSlideshow());
    window.onresize = debounce(() => setShowSlideShow(shouldShowSlideshow()), 1000);
  }, [count, setShowSlideShow, limit, smallScreenOnly]);
  return showSlideshow;
}

function SliderNavigation({
  prevRef,
  nextRef,
  className
}) {
  const groupTheme = useGroupTheme({
    kinderspital: {
      arrow: 'text-orange-400 hover:bg-orange-400 border-orange-400'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      arrow: 'text-blue-900 hover:bg-blue-400 border-blue-900 hover:border-blue-400'
    },
    nidwalden: {
      arrow: 'text-brown-400 hover:bg-brown-400 border-brown-400'
    }
  });

  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('pt-0.5', className)
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": 'Nach links navigieren',
    className: 'focus group cursor-pointer',
    ref: prevRef
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('flex h-9 w-9 items-center justify-center rounded-full border transition group-hover:text-white', theme.arrow)
  }, /*#__PURE__*/React.createElement(ArrowLeftIcon, {
    className: 'h-5 w-5'
  }))), /*#__PURE__*/React.createElement("button", {
    "aria-label": 'Nach rechts navigieren',
    className: 'focus group ml-2 cursor-pointer transition',
    ref: nextRef
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('flex h-9 w-9 items-center justify-center rounded-full border transition group-hover:text-white', theme.arrow)
  }, /*#__PURE__*/React.createElement(ArrowRightIcon, {
    className: 'h-5 w-5'
  }))));
}

function SliderSpecialist({
  specialists,
  title
}) {
  const intl = useIntl();
  const showSlideshow = useShowSlideshow(specialists.length);
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  if (!specialists.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "my-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content mb-2 md:relative md:mb-5 md:flex md:items-center md:justify-between'
  }, /*#__PURE__*/React.createElement("div", {
    className: "prose w-full max-w-none lg:prose-xl"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "md:text-center",
    id: "Spezialisten"
  }, title || intl.formatMessage({
    id: "oPs1NG",
    defaultMessage: [{
      "type": 0,
      "value": "Behandlungsteam"
    }]
  }))), showSlideshow ? /*#__PURE__*/React.createElement(SliderNavigation, {
    className: 'right-0 inline-flex md:absolute',
    prevRef: prevRef,
    nextRef: nextRef
  }) : null)), showSlideshow ? /*#__PURE__*/React.createElement(Swiper, {
    modules: [Navigation],
    onBeforeInit: swiper => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // eslint-disable-next-line no-param-reassign
      swiper.params.navigation.prevEl = prevRef.current;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // eslint-disable-next-line no-param-reassign
      swiper.params.navigation.nextEl = nextRef.current;
      swiper.navigation.update();
    },
    loop: specialists.length > 5,
    loopFillGroupWithBlank: specialists.length > 5,
    slidesPerView: 'auto',
    spaceBetween: 10
  }, specialists.map((specialist, index) => /*#__PURE__*/React.createElement(SwiperSlide, {
    className: 'max-w-[260px] p-1',
    key: index
  }, /*#__PURE__*/React.createElement(Specialist, specialist)))) : /*#__PURE__*/React.createElement("div", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'flex justify-center gap-5'
  }, specialists.map((specialist, index) => /*#__PURE__*/React.createElement("div", {
    className: 'p-1 md:w-1/3 lg:w-1/5',
    key: index
  }, /*#__PURE__*/React.createElement(Specialist, specialist)))))));
}
function Specialist({
  Link,
  name,
  Image,
  gender
}) {
  const groupTheme = useGroupTheme({
    kinderspital: {
      default: 'group-hover:text-orange-400',
      focus: 'focus-kinderspital'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      default: 'group-hover:text-blue-400',
      focus: 'focus-luks'
    },
    nidwalden: {
      default: 'group-hover:text-brown-400',
      focus: 'focus-nidwalden'
    }
  });

  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  return /*#__PURE__*/React.createElement(Link, {
    className: clsx('group block text-sm', theme.focus)
  }, /*#__PURE__*/React.createElement("div", {
    className: 'aspect-w-3 aspect-h-4 relative block overflow-hidden rounded-t-md'
  }, Image ? /*#__PURE__*/React.createElement(Image, {
    className: 'block w-full max-w-full object-cover'
  }) : /*#__PURE__*/React.createElement("img", {
    className: 'block w-full max-w-full object-cover',
    src: gender === 'male' ? '/dummy-male-portrait.jpg' : '/dummy-female-portrait.jpg',
    alt: `Portrait von ${name}`
  })), /*#__PURE__*/React.createElement("h4", {
    className: clsx('mt-3 text-center font-bold transition', theme.default)
  }, name));
}

const DiseaseDetailSection = ({
  heading,
  Content
}) => /*#__PURE__*/React.createElement(React.Fragment, null, Content && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
  id: heading
}, heading), /*#__PURE__*/React.createElement(EnhancedHtml, {
  Content: Content
})));
function DiseaseDetails({
  Overview,
  Course,
  Treatment,
  Prevention,
  Diagnosis,
  Causes,
  Symptoms,
  slides,
  faqs,
  sliderTitle
}) {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'container-page my-10 lg:my-20'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-text'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'prose max-w-none lg:prose-xl'
  }, /*#__PURE__*/React.createElement(DiseaseDetailSection, {
    heading: intl.formatMessage({
      id: "Ko8vYs",
      defaultMessage: [{
        "type": 0,
        "value": "Überblick"
      }]
    }),
    Content: Overview
  }))))), faqs ? /*#__PURE__*/React.createElement("div", {
    id: 'Häufige-Fragen'
  }, /*#__PURE__*/React.createElement(Faq, {
    heading: 'Häufige Fragen',
    faqs: faqs
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: 'container-page my-10 lg:my-20'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-text'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'prose max-w-none lg:prose-xl'
  }, /*#__PURE__*/React.createElement(DiseaseDetailSection, {
    heading: intl.formatMessage({
      id: "A6O61E",
      defaultMessage: [{
        "type": 0,
        "value": "Ursachen"
      }]
    }),
    Content: Causes
  }), /*#__PURE__*/React.createElement(DiseaseDetailSection, {
    heading: intl.formatMessage({
      id: "v7Rvg8",
      defaultMessage: [{
        "type": 0,
        "value": "Symptome"
      }]
    }),
    Content: Symptoms
  }), /*#__PURE__*/React.createElement(DiseaseDetailSection, {
    heading: intl.formatMessage({
      id: "wNG/VO",
      defaultMessage: [{
        "type": 0,
        "value": "Diagnose"
      }]
    }),
    Content: Diagnosis
  }), /*#__PURE__*/React.createElement(DiseaseDetailSection, {
    heading: intl.formatMessage({
      id: "grObhH",
      defaultMessage: [{
        "type": 0,
        "value": "Verlauf"
      }]
    }),
    Content: Course
  }), /*#__PURE__*/React.createElement(DiseaseDetailSection, {
    heading: intl.formatMessage({
      id: "hObH32",
      defaultMessage: [{
        "type": 0,
        "value": "Behandlung"
      }]
    }),
    Content: Treatment
  }), /*#__PURE__*/React.createElement(DiseaseDetailSection, {
    heading: intl.formatMessage({
      id: "nbOhBn",
      defaultMessage: [{
        "type": 0,
        "value": "Vorsorge"
      }]
    }),
    Content: Prevention
  }))))), slides?.length ? /*#__PURE__*/React.createElement("div", {
    className: 'md:mb-14 lg:mb-20'
  }, /*#__PURE__*/React.createElement(SliderSpecialist, {
    title: sliderTitle || 'Behandlungsteam',
    specialists: slides
  })) : null);
}

function DiseaseList({
  diseases,
  filters
}) {
  const descriptionClass = useTheme({
    luzern: 'text-blue-900 group-hover:text-blue-400',
    nidwalden: 'text-brown-900'
  });
  const {
    glossary,
    search
  } = filters;
  const searchFiltered = diseases.filter(item => toLower(item.title).includes(toLower(search || '')));
  const filteredDiseases = searchFiltered.filter(item => startsWith(toLower(item.title), toLower(glossary || '')));
  const ListTheme = useTheme({
    luzern: 'hover:bg-blue-100',
    nidwalden: 'hover:bg-brown-100'
  });
  return /*#__PURE__*/React.createElement("ul", {
    className: "mb-8"
  }, filteredDiseases.map(({
    id,
    ...item
  }) => /*#__PURE__*/React.createElement("li", {
    key: id,
    className: "border-b border-grey-200"
  }, /*#__PURE__*/React.createElement(item.Link, {
    className: clsx('focus group flex items-center p-2 transition md:p-8', ListTheme)
  }, /*#__PURE__*/React.createElement("div", {
    className: "mr-4 w-full"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-xl font-bold"
  }, item.title), item.Description ? /*#__PURE__*/React.createElement("div", {
    className: clsx('mt-2 font-light', descriptionClass)
  }, /*#__PURE__*/React.createElement(item.Description, null)) : null), /*#__PURE__*/React.createElement(ArrowNarrowRightIcon, {
    className: clsx('h-8 w-8', descriptionClass)
  })))));
}
function DiseaseSearchList({
  diseases
}) {
  const [filters, setFilters] = useState({
    search: undefined,
    glossary: undefined
  });
  const intl = useIntl();
  const searchFiltered = diseases.filter(item => toLower(item.title).includes(toLower(filters.search || '')));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "container-page pt-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content"
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      search: undefined,
      glossary: undefined,
      useSearch: false
    },
    onSubmit: setFilters
  }, /*#__PURE__*/React.createElement(Form, {
    className: "form mb-10 px-0 md:px-8",
    placeholder: ""
  }, /*#__PURE__*/React.createElement("label", {
    className: clsx('label col-span-8 md:col-span-6 lg:col-span-7')
  }, intl.formatMessage({
    id: "i+U+J+",
    defaultMessage: [{
      "type": 0,
      "value": "Krankheitsbild finden"
    }]
  }), /*#__PURE__*/React.createElement(Field, {
    className: clsx('field'),
    type: 'text',
    name: 'search'
  })), /*#__PURE__*/React.createElement("div", {
    className: 'col-span-8 flex items-end justify-end md:col-span-2 lg:col-span-1 lg:justify-start'
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "button-primary md:w-full"
  }, intl.formatMessage({
    id: "dsIkSc",
    defaultMessage: [{
      "type": 0,
      "value": "Suchen"
    }]
  }))), /*#__PURE__*/React.createElement("label", {
    className: "label col-span-8 w-full"
  }, /*#__PURE__*/React.createElement("span", {
    className: "lg:hidden"
  }, intl.formatMessage({
    id: "UhWFDp",
    defaultMessage: [{
      "type": 0,
      "value": "Nach Anfangsbuchstaben filtern"
    }]
  })), /*#__PURE__*/React.createElement(Glossary, {
    name: 'glossary',
    index: glossaryIndex(createAlphabet(26), searchFiltered)
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: "container-page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content"
  }, /*#__PURE__*/React.createElement(DiseaseList, {
    diseases: diseases,
    filters: filters
  }))));
}
function DiseaseListing({
  diseases
}) {
  return /*#__PURE__*/React.createElement(DiseaseSearchList, {
    diseases: diseases
  });
}

function Document({
  heading,
  items
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: 'container-page mb-10 md:mb-14'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-text'
  }, heading && /*#__PURE__*/React.createElement("div", {
    className: "prose"
  }, /*#__PURE__*/React.createElement("h2", {
    id: "Dokumente",
    className: 'mt-12 mb-3 md:mb-5'
  }, heading)), /*#__PURE__*/React.createElement("ul", null, items?.map((item, index) => /*#__PURE__*/React.createElement(DocumentItem, _extends({
    key: index
  }, item)))))));
}
function DocumentItem({
  Link,
  title
}) {
  return /*#__PURE__*/React.createElement("li", {
    className: "border-t border-grey-200 lg:text-xl last:border-b"
  }, /*#__PURE__*/React.createElement(Link, {
    className: clsx('flex justify-between px-4 py-5 lg:py-8', useTheme({
      luzern: 'focus-luks text-blue-900 hover:bg-blue-100 hover:text-blue-400',
      nidwalden: 'focus-nidwalden text-brown-900 hover:bg-brown-100'
    }))
  }, title, /*#__PURE__*/React.createElement(DownloadIcon, {
    className: "ml-5 h-6 w-6 shrink-0"
  })));
}

// Formats date as YYYY-MM-DD.
function formatDate(date) {
  const adjusted = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
  return adjusted.toISOString().split('T')[0];
}

function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

// Wrapper component
const DSSlide = props => {
  // Add parent class to aid typography overrides
  useEffect(() => {
    const htmlElement = document.querySelector('html');
    if (htmlElement) {
      htmlElement.classList.add('digital-signage');
      htmlElement.classList.add('single-screen');
    }
  }, []);
  switch (props.type) {
    case 'DSSimpleSlide':
      return /*#__PURE__*/React.createElement(DSSimpleSlide, props);
    case 'DSHealthTipSlide':
      return /*#__PURE__*/React.createElement(DSHealthTipSlide, props);
    case 'DSInstagramSlide':
      return /*#__PURE__*/React.createElement(DSInstagramSlide, props);
    case 'DSQuizSlide':
      return /*#__PURE__*/React.createElement(DSQuizSlide, props);
    case 'DSHistorySlide':
      return /*#__PURE__*/React.createElement(DSHistorySlide, props);
    case 'DSEventSlide':
      return /*#__PURE__*/React.createElement(DSEventSlide, props);
    case 'DSFullScreenSlide':
      return /*#__PURE__*/React.createElement(DSFullScreenSlide, props);
    case 'DSBabySlide':
      return /*#__PURE__*/React.createElement(DSBabySlide, props);
    default:
      // Fallback case, render null or handle error
      return null;
  }
};
function DSSimpleSlide({
  Image,
  Html,
  label,
  isActive = true,
  title,
  pauseDuration
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: 'relative mx-auto h-[100vh]'
  }, isActive ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'absolute right-0 bg-blue-850 py-4 px-9 text-[1.5rem] font-bold uppercase text-white'
  }, label), /*#__PURE__*/React.createElement("div", {
    className: 'digital-signage-simple digital-signage mx-auto  grid w-full max-w-[90vw] overflow-hidden py-40 px-10 lg:grid-cols-2 lg:gap-10'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'prose'
  }, /*#__PURE__*/React.createElement("h1", {
    className: 'w-full animate-slide-from-top opacity-0 transition-all duration-1000'
  }, title), /*#__PURE__*/React.createElement("div", {
    className: 'relative  w-full animate-slide-from-bottom opacity-0 transition-all duration-1000'
  }, /*#__PURE__*/React.createElement(Html, null))), /*#__PURE__*/React.createElement("div", {
    className: 'relative h-[44.625rem] w-full',
    style: {
      animationDelay: '0.5s'
    }
  }, /*#__PURE__*/React.createElement(Image, {
    className: 'relative top-0 z-50 my-0 h-full w-full animate-step-top-left-10 object-cover opacity-0 transition-all duration-500'
  }), /*#__PURE__*/React.createElement("div", {
    className: 'absolute -bottom-10 z-10 h-[30rem] w-full animate-step-right-10 bg-yellow-475 object-cover opacity-0 transition-all duration-500'
  }))), /*#__PURE__*/React.createElement(DSProgressBar, {
    pauseDuration: pauseDuration
  })) : null);
}
function DSHealthTipSlide({
  Content,
  expert,
  label,
  isActive = true,
  title,
  pauseDuration
}) {
  const ExpertImage = expert.Image;
  return /*#__PURE__*/React.createElement("div", {
    className: 'relative mx-auto h-[100vh] '
  }, isActive ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'absolute right-0 bg-blue-850 py-4 px-9 text-[1.5rem] font-bold uppercase text-white'
  }, label), /*#__PURE__*/React.createElement("div", {
    className: 'digital-signage-health digital-signage mx-auto w-full max-w-[90vw] overflow-hidden py-40 px-10'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'prose w-[60%]'
  }, /*#__PURE__*/React.createElement("h1", {
    className: 'w-full animate-slide-from-top opacity-0 transition-all duration-1000'
  }, title), /*#__PURE__*/React.createElement("div", {
    className: 'relative  w-full animate-slide-from-bottom opacity-0 transition-all duration-1000'
  }, /*#__PURE__*/React.createElement(Content, null))), /*#__PURE__*/React.createElement("div", {
    className: 'absolute left-0 top-0 -z-10 h-full w-full'
  }, /*#__PURE__*/React.createElement(ExpertImage, {
    className: 'relative z-50 my-0 h-full w-full object-cover'
  }))), /*#__PURE__*/React.createElement("div", {
    className: 'absolute right-0 bottom-12 w-2/5 bg-white py-7 pr-24 pl-11 text-[1.875rem] leading-[3.125rem] text-black'
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, expert.title)), /*#__PURE__*/React.createElement("p", null, expert.description)), /*#__PURE__*/React.createElement(DSProgressBar, {
    pauseDuration: pauseDuration
  })) : null);
}
function DSInstagramSlide({
  media,
  contentHtml: ContentHtml,
  cta,
  label,
  isActive = true,
  title,
  pauseDuration
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: 'relative mx-auto h-[100vh] '
  }, isActive ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'absolute right-0 bg-blue-850 py-4 px-9 text-[1.5rem] font-bold uppercase text-white'
  }, label), /*#__PURE__*/React.createElement("div", {
    className: 'digital-signage-instagram digital-signage mx-auto flex w-full max-w-[90vw] flex-wrap overflow-hidden py-40 px-10'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'prose w-[40%]'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'w-full animate-slide-from-top'
  }, /*#__PURE__*/React.createElement("svg", {
    className: 'mb-11 h-[4.375rem] w-[4.375rem]',
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("rect", {
    y: "0.0240479",
    width: "70",
    height: "70",
    fill: "url(#pattern0)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: "1",
    height: "1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_9_626",
    transform: "scale(0.00625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_9_626",
    width: "160",
    height: "160",
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("h1", null, title)), /*#__PURE__*/React.createElement("div", {
    className: 'relative w-full animate-slide-from-bottom'
  }, /*#__PURE__*/React.createElement(ContentHtml, null))), /*#__PURE__*/React.createElement("div", {
    className: 'w-[60%] pl-14'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'flex w-[100%]'
  }, media.map((MediaItem, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: clsx('relative h-[30rem] w-1/2 first:mt-[7%]', index === 1 ? 'ml-[0.313rem]' : 'mr-[0.313rem]')
  }, /*#__PURE__*/React.createElement(MediaItem, {
    className: clsx('relative top-0 z-20 my-0 h-full w-full object-cover', index === 1 ? 'ml-[0.313rem] animate-step-bottom-left-5 ' : 'mr-[0.313rem] animate-step-top-right-5 ')
  }), /*#__PURE__*/React.createElement("div", {
    className: clsx('absolute z-10 h-16 w-full bg-yellow-475', index === 1 ? '-top-5 animate-step-right-5' : '-bottom-5 animate-step-left-5')
  })))), /*#__PURE__*/React.createElement("div", {
    className: 'mt-16 w-full translate-x-5 bg-blue-750 px-10 pt-7 pb-5'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'block text-[1.875rem] leading-[3.125rem] text-white'
  }, cta), /*#__PURE__*/React.createElement("div", {
    className: 'flex items-center text-[3rem] leading-[3.75rem] text-white'
  }, /*#__PURE__*/React.createElement("svg", {
    className: 'mr-4 mb-2 inline-block h-[2.375rem] w-[2.375rem]',
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5505 6.9875C29.0956 6.9875 28.6509 7.11946 28.2727 7.36669C27.8944 7.61393 27.5996 7.96533 27.4255 8.37646C27.2515 8.7876 27.2059 9.24 27.2947 9.67645C27.3834 10.1129 27.6025 10.5138 27.9241 10.8285C28.2458 11.1432 28.6556 11.3574 29.1018 11.4443C29.5479 11.5311 30.0104 11.4865 30.4306 11.3162C30.8509 11.1459 31.2101 10.8575 31.4628 10.4875C31.7156 10.1175 31.8505 9.68251 31.8505 9.2375C31.8505 8.64076 31.6081 8.06847 31.1768 7.64651C30.7455 7.22455 30.1605 6.9875 29.5505 6.9875ZM38.3671 11.525C38.3299 9.96931 38.032 8.43013 37.4855 6.96875C36.9981 5.71837 36.2396 4.58615 35.2621 3.65C34.313 2.68892 33.153 1.95158 31.8696 1.49375C30.3797 0.942801 28.8046 0.644769 27.2121 0.6125C25.1805 0.5 24.5288 0.5 19.3155 0.5C14.1021 0.5 13.4505 0.5 11.4188 0.6125C9.82635 0.644769 8.25121 0.942801 6.7613 1.49375C5.48035 1.95622 4.32126 2.69293 3.3688 3.65C2.38637 4.57846 1.63264 5.71332 1.16464 6.96875C0.601445 8.42627 0.29679 9.96716 0.263804 11.525C0.148804 13.5125 0.148804 14.15 0.148804 19.25C0.148804 24.35 0.148804 24.9875 0.263804 26.975C0.29679 28.5328 0.601445 30.0737 1.16464 31.5312C1.63264 32.7867 2.38637 33.9215 3.3688 34.85C4.32126 35.8071 5.48035 36.5438 6.7613 37.0062C8.25121 37.5572 9.82635 37.8552 11.4188 37.8875C13.4505 38 14.1021 38 19.3155 38C24.5288 38 25.1805 38 27.2121 37.8875C28.8046 37.8552 30.3797 37.5572 31.8696 37.0062C33.153 36.5484 34.313 35.8111 35.2621 34.85C36.2439 33.9173 37.0031 32.7841 37.4855 31.5312C38.032 30.0699 38.3299 28.5307 38.3671 26.975C38.3671 24.9875 38.4821 24.35 38.4821 19.25C38.4821 14.15 38.4821 13.5125 38.3671 11.525ZM34.9171 26.75C34.9032 27.9402 34.6828 29.1194 34.2655 30.2375C33.9594 31.0535 33.4679 31.7908 32.828 32.3938C32.2063 33.0135 31.4542 33.4933 30.6238 33.8C29.4809 34.2083 28.2754 34.4239 27.0588 34.4375C25.1421 34.5312 24.433 34.55 19.3921 34.55C14.3513 34.55 13.6421 34.55 11.7255 34.4375C10.4622 34.4606 9.20428 34.2703 8.00714 33.875C7.21322 33.5526 6.49557 33.074 5.8988 32.4687C5.26264 31.8664 4.77725 31.1285 4.48047 30.3125C4.01253 29.1784 3.75299 27.9724 3.7138 26.75C3.7138 24.875 3.5988 24.1812 3.5988 19.25C3.5988 14.3187 3.5988 13.625 3.7138 11.75C3.72239 10.5332 3.94946 9.3274 4.38464 8.1875C4.72206 7.39608 5.23998 6.69061 5.8988 6.125C6.48111 5.48032 7.20077 4.9683 8.00714 4.625C9.17544 4.21258 10.4068 3.99702 11.6488 3.9875C13.5655 3.9875 14.2746 3.875 19.3155 3.875C24.3563 3.875 25.0655 3.875 26.9821 3.9875C28.1988 4.00115 29.4042 4.21671 30.5471 4.625C31.4181 4.94122 32.1999 5.45534 32.828 6.125C33.4561 6.70096 33.9468 7.40512 34.2655 8.1875C34.6915 9.32925 34.9119 10.5346 34.9171 11.75C35.013 13.625 35.0321 14.3187 35.0321 19.25C35.0321 24.1812 35.013 24.875 34.9171 26.75ZM19.3155 9.63125C17.3716 9.63496 15.4725 10.2022 13.8581 11.2614C12.2436 12.3206 10.9864 13.8241 10.2451 15.582C9.50384 17.34 9.31186 19.2734 9.69341 21.138C10.075 23.0026 11.0129 24.7148 12.3888 26.0581C13.7646 27.4014 15.5167 28.3157 17.4235 28.6853C19.3302 29.0549 21.3062 28.8633 23.1018 28.1348C24.8973 27.4062 26.4318 26.1733 27.5114 24.5919C28.5909 23.0106 29.1671 21.1516 29.1671 19.25C29.1697 17.9846 28.9164 16.7311 28.422 15.5618C27.9276 14.3924 27.2017 13.3303 26.2861 12.4363C25.3706 11.5424 24.2834 10.8344 23.0871 10.353C21.8908 9.87159 20.609 9.6263 19.3155 9.63125ZM19.3155 25.4937C18.0531 25.4937 16.8191 25.1276 15.7695 24.4415C14.7199 23.7554 13.9019 22.7803 13.4188 21.6394C12.9357 20.4985 12.8093 19.2431 13.0556 18.0319C13.3019 16.8207 13.9098 15.7082 14.8024 14.835C15.695 13.9618 16.8322 13.3671 18.0703 13.1262C19.3084 12.8853 20.5917 13.009 21.7579 13.4815C22.9242 13.9541 23.921 14.7544 24.6223 15.7812C25.3236 16.8079 25.698 18.0151 25.698 19.25C25.698 20.0699 25.5329 20.8819 25.2121 21.6394C24.8914 22.3969 24.4212 23.0852 23.8286 23.665C23.2359 24.2448 22.5323 24.7047 21.7579 25.0185C20.9836 25.3323 20.1536 25.4937 19.3155 25.4937Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("span", null, "luzernerkantonsspital"))))), /*#__PURE__*/React.createElement(DSProgressBar, {
    pauseDuration: pauseDuration
  })) : null);
}
function DSQuizSlide({
  question,
  answers,
  correctAnswer,
  revealAnswerAfterSeconds,
  label,
  media: Image,
  isActive = true
}) {
  const [showAnswer, setShowAnswer] = useState(false);
  useEffect(() => {
    if (isActive) {
      const timer = setTimeout(() => {
        setShowAnswer(true);
      }, revealAnswerAfterSeconds * 1000);

      // Cleanup to reset timout and showAnswer values
      return () => {
        clearTimeout(timer);
        setShowAnswer(false);
      };
    }
  }, [revealAnswerAfterSeconds, isActive]);
  return /*#__PURE__*/React.createElement("div", {
    className: 'relative mx-auto h-[100vh] '
  }, isActive ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'absolute right-0 bg-blue-850 py-4 px-9 text-[1.5rem] font-bold uppercase text-white'
  }, label), /*#__PURE__*/React.createElement("div", {
    className: 'digital-signage-quiz digital-signage mx-auto  grid w-full max-w-[90vw] overflow-hidden py-40 px-10 lg:grid-cols-2 lg:gap-10'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'prose'
  }, /*#__PURE__*/React.createElement("h1", {
    className: 'w-full animate-slide-from-top opacity-0 transition-all duration-1000'
  }, question), /*#__PURE__*/React.createElement("div", {
    className: 'relative  w-full animate-slide-from-bottom opacity-0 transition-all duration-1000'
  }, /*#__PURE__*/React.createElement("ul", {
    className: 'list-none'
  }, answers.map(answer => /*#__PURE__*/React.createElement("li", {
    key: answer,
    className: clsx(showAnswer && answer !== correctAnswer ? 'text-[#DDD]' : showAnswer && answer === correctAnswer ? 'text-blue-750' : '')
  }, answer))))), /*#__PURE__*/React.createElement("div", {
    className: 'relative h-[44.625rem] w-full',
    style: {
      animationDelay: '0.5s'
    }
  }, /*#__PURE__*/React.createElement(Image, {
    className: 'relative top-0 z-50 my-0 h-full w-full animate-step-top-left-10 object-cover '
  }), /*#__PURE__*/React.createElement("div", {
    className: 'absolute -bottom-10 z-10 h-[30rem] w-full animate-step-right-10 bg-yellow-475'
  }))), /*#__PURE__*/React.createElement(DSProgressBar, {
    pauseDuration: revealAnswerAfterSeconds
  })) : null);
}
function DSHistorySlide({
  thenImage: ThenImage,
  thenCaption,
  nowImage: NowImage,
  nowCaption,
  nowDescription: NowDescription,
  label,
  pauseDuration,
  isActive = true
}) {
  const [showAfter, setShowAfter] = useState(false);
  useEffect(() => {
    if (isActive) {
      const timer = setTimeout(() => {
        setShowAfter(true);
      }, pauseDuration * 1000);

      // Cleanup to reset timout and showAnswer values
      return () => {
        clearTimeout(timer);
        setShowAfter(false);
      };
    }
  }, [pauseDuration, isActive]);
  return /*#__PURE__*/React.createElement("div", {
    className: 'relative mx-auto h-[100vh] '
  }, isActive ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'absolute right-0 bg-blue-850 py-4 px-9 text-[1.5rem] font-bold uppercase text-white'
  }, label), /*#__PURE__*/React.createElement("div", {
    className: 'digital-signage-history digital-signage mx-auto block w-full max-w-[90vw] overflow-hidden px-10 py-40'
  }, !showAfter ? /*#__PURE__*/React.createElement("div", {
    className: 'prose grid lg:grid-cols-2 lg:gap-10'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'relative w-full animate-slide-from-left'
  }, /*#__PURE__*/React.createElement(ThenImage, {
    className: 'relative z-50 my-0 h-[35.875rem] w-full object-cover'
  }), /*#__PURE__*/React.createElement("p", {
    className: 'mt-9'
  }, thenCaption), /*#__PURE__*/React.createElement("div", {
    className: 'aspect-w-2 aspect-h-1 absolute -left-10 -top-10 z-10 w-full bg-yellow-475'
  })), /*#__PURE__*/React.createElement("div", {
    className: 'relative mt-[7%] h-[35.875rem] w-full animate-slide-from-right'
  }, /*#__PURE__*/React.createElement(NowImage, {
    className: 'relative top-0 z-50 my-0 h-full w-full object-cover'
  }), /*#__PURE__*/React.createElement("div", {
    className: 'aspect-w-2 aspect-h-1 absolute left-10 -bottom-10 z-10 w-full bg-yellow-475'
  }), /*#__PURE__*/React.createElement("p", {
    className: 'mt-20'
  }, nowCaption))) : /*#__PURE__*/React.createElement("section", {
    className: 'prose grid grid-cols-5 gap-x-10'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'relative col-span-3 h-[42.125rem] animate-slide-from-left'
  }, /*#__PURE__*/React.createElement(NowImage, {
    className: 'absolute top-0 z-50 my-0 h-full w-full object-cover'
  }), /*#__PURE__*/React.createElement("div", {
    className: 'absolute -left-10 -top-10 z-10 h-[30rem] w-full bg-yellow-475'
  })), /*#__PURE__*/React.createElement("div", {
    className: 'relative col-span-2 block animate-slide-from-right'
  }, /*#__PURE__*/React.createElement(NowDescription, null)))), /*#__PURE__*/React.createElement(DSProgressBar, {
    pauseDuration: pauseDuration
  })) : null);
}
function DSFullScreenSlide({
  media: MediaSlide,
  isActive = true
}) {
  const [playing, setPlaying] = useState(false);
  useEffect(() => {
    if (isActive && 'url' in MediaSlide) {
      setPlaying(true);
      // Cleanup to reset timout and showAnswer values
      return () => {
        setPlaying(false);
      };
    }
  }, [isActive]);
  // check media props to determine what component it should render
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      paddingTop: '56.25%'
    }
  }, 'url' in MediaSlide ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ReactPlayer, {
    url: MediaSlide.url,
    controls: false,
    muted: true,
    playing: playing,
    loop: true,
    width: "100%",
    height: "100%",
    className: 'absolute -top-3 left-0'
  }), /*#__PURE__*/React.createElement("div", {
    className: 'text-transparent'
  }, MediaSlide.url)) : 'src' in MediaSlide ?
  /*#__PURE__*/
  // media is of type Image
  React.createElement("div", {
    className: 'absolute top-0 left-0 h-full w-full'
  }, /*#__PURE__*/React.createElement(MediaSlide, {
    className: 'h-full w-full object-cover'
  })) : null);
}
function DSProgressBar({
  pauseDuration
}) {
  const [animationProgress, setAnimationProgress] = useState(0);
  useEffect(() => {
    const animationDuration = (pauseDuration ?? 1) * 1000 - 1000; // Convert pauseDuration to milliseconds
    const animationInterval = 50; // Interval in milliseconds for updating the animation progress

    let currentProgress = 0;
    const animationIntervalId = setInterval(() => {
      currentProgress += animationInterval / animationDuration;
      if (currentProgress >= 1) {
        clearInterval(animationIntervalId);
      }
      setAnimationProgress(currentProgress);
    }, animationInterval);
    return () => clearInterval(animationIntervalId);
  }, [pauseDuration]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      width: `${animationProgress * 100}%`
    },
    className: 'absolute left-0 bottom-0 z-20 h-5 bg-yellow-475 text-[1.5rem] font-bold uppercase text-white transition-all'
  }), /*#__PURE__*/React.createElement("div", {
    className: 'absolute left-0 bottom-0 z-10 h-5 w-full bg-blue-750 px-9 text-[1.5rem] font-bold uppercase text-white'
  }));
}
function DSBabySlide({
  babies,
  title,
  label,
  isActive = true,
  pauseDuration
}) {
  const [Baby1, Baby2, Baby3] = babies;
  return /*#__PURE__*/React.createElement("div", {
    className: 'relative mx-auto h-[100vh]'
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'absolute right-0 bg-blue-850 py-4 px-9 text-[1.5rem] font-bold uppercase text-white'
  }, label), /*#__PURE__*/React.createElement("div", {
    className: 'digital-signage-baby digital-signage mx-auto h-[100vh] w-full max-w-[90vw] overflow-hidden py-28 px-10'
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: 'prose flex items-center'
  }, /*#__PURE__*/React.createElement("h1", {
    className: clsx('opacity-0 transition-all duration-1000', isActive === true && 'animate-slide-from-top')
  }, title), /*#__PURE__*/React.createElement("div", {
    className: '-mt-20 ml-16 flex items-center'
  }, /*#__PURE__*/React.createElement("svg", {
    className: 'animate-wiggle-slow',
    xmlns: "http://www.w3.org/2000/svg",
    width: "161",
    height: "161",
    viewBox: "0 0 161 161",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: "0.2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.605 95.1308C135.585 68.3178 117.608 44.8866 91.6794 38.503C89.048 37.7979 85.8902 36.9518 83.1178 36.773C80.5619 31.5755 82.6394 25.9274 87.3105 23.2305C91.3144 20.9189 96.0509 22.1881 98.3626 26.1919C99.9036 28.8611 98.9165 32.5451 96.2473 34.0862C94.9127 34.8567 94.4896 36.4356 95.2602 37.7702C96.0307 39.1048 97.6096 39.5279 98.9442 38.7573C104.283 35.6752 106.116 28.8335 103.034 23.495C99.181 16.822 91.2867 14.7067 84.6137 18.5594C77.9406 22.4121 75.4401 29.6391 77.0466 36.2743C56.3048 35.7932 36.4267 46.825 26.1904 66.081C20.6455 65.7234 15.8334 68.9466 14.4232 74.2095C13.013 79.4723 15.5689 84.6697 20.5497 87.1325C19.711 113.419 36.6352 136.568 62.4232 143.478C62.9495 143.619 62.9495 143.619 63.4758 143.76C89.1228 151.196 116.548 139.366 128.965 116.182C133.983 116.399 139.322 113.317 140.732 108.054C142.142 102.791 139.586 97.5935 134.605 95.1308ZM128.27 110.355C127.217 110.073 125.883 110.844 125.074 111.755C114.659 133.784 89.6214 145.125 65.9385 138.779C65.4122 138.638 65.4122 138.638 64.886 138.497C40.5358 132.537 24.5232 110.196 26.1324 85.2439C26.4144 84.1914 25.1176 82.7157 24.065 82.4337L23.5387 82.2927C20.9073 81.5876 18.981 78.2511 19.6861 75.6196C20.3911 72.9882 23.7277 71.0619 26.3591 71.767L26.8854 71.908C27.938 72.19 29.2726 71.4195 30.0809 70.5079C39.2646 50.9699 59.669 40.0791 79.9877 42.1391C82.9666 45.7576 86.7539 48.4646 91.4905 49.7338C95.1745 50.7209 99.6668 50.7965 103.53 49.0112C120.154 58.5424 130.942 77.2269 129.549 97.1603C129.267 98.2129 130.564 99.6885 131.616 99.9706C134.248 100.676 136.174 104.012 135.469 106.644C134.764 109.275 131.427 111.201 128.27 110.355Z",
    fill: "#FD1789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3282 90.7238C61.0462 91.7763 61.9578 92.5847 63.0103 92.8667C63.5366 93.0077 64.0629 93.1487 64.2039 92.6225C65.3975 92.3782 66.3468 90.9404 66.2436 89.2205C65.6519 85.1134 62.532 82.0211 58.0774 79.6994C57.9364 80.2257 57.9364 80.2257 57.4101 80.0847C52.5325 79.3418 48.6697 81.1271 45.5774 84.2471C44.7691 85.1586 44.8723 86.8785 45.6429 88.2131C46.5544 89.0214 48.2743 88.9182 49.6089 88.1477C51.8929 85.9393 54.8063 85.5918 56.5262 85.4886C57.9641 86.4379 60.3135 88.1956 61.3282 90.7238Z",
    fill: "#FD1789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.565 91.6515C100.038 91.5104 100.038 91.5104 99.5121 91.3694C94.6345 90.6266 90.7717 92.4119 87.6794 95.5318C86.8711 96.4434 86.9743 98.1632 87.7448 99.4979C88.6564 100.306 90.3763 100.203 91.7109 99.4324C93.4685 97.083 96.241 97.2618 98.4871 97.2996C99.925 98.2489 102.415 99.4803 103.289 102.535C103.533 103.728 104.445 104.537 104.971 104.678C105.498 104.819 106.024 104.96 106.165 104.433C107.358 104.189 108.308 102.751 108.205 101.032C107.613 96.9245 104.493 93.8322 100.565 91.6515Z",
    fill: "#FD1789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9691 117.61C87.9691 117.61 82.6307 120.692 70.5261 117.449C58.4215 114.205 55.3394 108.867 55.3394 108.867C54.5688 107.532 52.99 107.109 51.7964 107.353C50.4618 108.124 49.5124 109.562 50.283 110.896C50.6683 111.564 53.8536 118.622 69.1159 122.711C84.3783 126.801 90.666 122.281 91.3333 121.896C92.6679 121.125 92.5647 119.405 91.7942 118.071C91.0236 116.736 89.3038 116.839 87.9691 117.61Z",
    fill: "#FD1789"
  }))), /*#__PURE__*/React.createElement("svg", {
    className: 'mb-8 -ml-6 animate-wiggle-slow-reverse',
    xmlns: "http://www.w3.org/2000/svg",
    width: "177",
    height: "177",
    viewBox: "0 0 177 177",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: "0.2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.39 72.2628C139.691 55.9928 124.245 44.6304 107.034 40.5616L99.9038 13.9505C99.5938 12.7935 98.8603 12.37 98.1268 11.9466C97.3933 11.5231 96.2363 11.8331 95.2343 12.7216L80.7829 25.8944C77.8488 24.2004 74.6463 23.8185 71.7538 24.5935C68.8613 25.3685 66.8573 27.1456 65.4318 28.7676C65.4318 28.7676 64.8533 28.9226 65.0083 29.5011L45.4832 26.0524C44.7496 25.6289 43.5926 25.9389 42.5906 26.8274C42.1672 27.5609 41.7437 28.2944 42.0537 29.4514L49.3391 56.641C36.3132 68.1918 28.6184 85.7545 29.2191 104.195C23.7441 106.902 20.9347 112.615 22.4848 118.4C24.0349 124.185 29.3245 127.728 35.4195 127.335C49.0684 152.819 77.9023 165.554 106.249 157.959C106.827 157.804 106.827 157.804 107.406 157.649C135.907 150.632 155.513 124.298 154.591 95.4028C159.487 92.8507 162.875 86.9827 161.325 81.1976C159.775 75.4126 154.486 71.8697 148.39 72.2628ZM69.2959 33.9326C69.1409 33.3541 69.7194 33.1991 69.5644 32.6206L69.9879 31.8871C70.5664 31.7321 70.9899 30.9986 70.9899 30.9986C70.9899 30.9986 70.9899 30.9986 71.5684 30.8435C72.1469 30.6885 72.7254 30.5335 73.3039 30.3785C75.1944 30.492 76.5064 30.7605 78.1285 32.186C78.2835 32.7645 78.862 32.6095 78.862 32.6095C80.174 32.8779 80.484 34.0349 80.639 34.6134C80.794 35.1919 81.104 36.349 80.6805 37.0825C80.102 37.2375 80.257 37.816 79.8336 38.5495C79.9886 39.128 79.4101 39.283 79.5651 39.8615L79.1416 40.595C78.5631 40.75 78.7181 41.3285 78.1396 41.4835C78.1396 41.4835 78.1396 41.4835 77.5611 41.6385C76.9826 41.7935 76.4041 41.9486 75.8256 42.1036C73.9351 41.9901 72.623 41.7216 71.001 40.2961C70.846 39.7176 70.2675 39.8726 70.2675 39.8726C69.534 39.4491 69.224 38.2921 69.069 37.7136C68.914 37.1351 68.6039 35.9781 69.0274 35.2446C69.6059 35.0896 69.4509 34.5111 69.2959 33.9326ZM100.629 39.7977L86.7756 36.6894C87.0441 35.3774 86.734 34.2204 86.424 33.0634C86.114 31.9064 85.804 30.7493 84.9155 29.7474L95.3589 20.1286L100.629 39.7977ZM49.0788 32.5294L62.9324 35.6377C62.6639 36.9497 62.9739 38.1067 63.284 39.2637C63.594 40.4207 63.904 41.5777 64.7925 42.5797L54.3491 52.1984L49.0788 32.5294ZM150.727 90.2378C149.57 90.5479 148.723 92.0149 148.454 93.3269C150.647 120.021 133.045 144.578 107.013 151.554C106.434 151.709 106.434 151.709 105.856 151.864C79.3997 159.573 51.8779 147.106 39.696 122.469C39.3859 121.312 37.3404 120.62 36.1834 120.93L35.6049 121.085C32.7124 121.86 29.0448 119.742 28.2698 116.85C27.4948 113.957 29.6122 110.29 32.5047 109.515L33.0832 109.36C34.2402 109.05 35.0872 107.583 35.3557 106.271C34.1764 87.9855 41.4478 71.1562 54.6287 60.184L55.2072 60.029L57.2112 58.2519C59.6387 55.7414 63.3782 53.4993 66.6942 51.9908C66.4257 53.3028 65.7337 55.3483 65.6202 57.2388C65.5483 61.5983 67.2118 65.4928 69.8774 68.4988C72.543 71.5048 76.789 73.4673 80.57 73.6942C81.1486 73.5392 81.1486 73.5392 81.7271 73.3842C83.0391 73.6527 84.1961 73.3427 85.3531 73.0326C87.6671 72.4126 89.8261 71.2141 91.8301 69.437C94.8361 66.7715 96.375 63.2589 96.602 59.4779C96.7874 53.2278 91.7663 48.3729 86.0947 48.0325L84.9377 48.3425C83.2022 48.8075 82.3552 50.2745 82.8203 52.01C83.1303 53.167 84.5973 54.014 85.9093 54.2825C87.2213 54.551 88.5333 54.8195 89.4219 55.8215C90.3104 56.8235 90.7754 58.559 91.0854 59.716C91.127 62.185 89.8565 64.3855 88.276 65.4291C86.8505 67.0511 84.5365 67.6711 82.0675 67.7126L81.489 67.8677C78.8649 67.3307 76.6644 66.0602 75.0424 64.6347C73.2653 62.6307 72.6453 60.3167 72.6038 57.8477C72.8307 54.0667 73.9462 51.2877 76.3737 48.7771C76.9522 48.6221 78.1092 48.3121 78.6877 48.1571C86.7867 45.9869 94.7723 45.7073 102.489 46.7397L104.535 47.4317C104.535 47.4317 104.535 47.4317 105.113 47.2767C122.17 50.767 136.881 61.7058 144.848 77.5523C145.158 78.7093 147.203 79.4013 148.36 79.0913C151.253 78.3163 154.92 80.4337 155.695 83.3262C156.47 86.2187 154.198 89.3078 150.727 90.2378Z",
    fill: "#1999E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.349 119.291C116.349 119.291 112.961 125.159 99.6557 128.724C86.3502 132.29 80.4821 128.902 80.4821 128.902C79.0151 128.055 77.2796 128.52 76.2776 129.408C75.4306 130.875 75.3171 132.766 76.7841 133.613C77.5176 134.036 84.4293 139.005 101.206 134.509C117.982 130.014 121.484 122.256 121.907 121.522C122.754 120.055 121.711 118.475 120.244 117.628C118.777 116.781 117.196 117.824 116.349 119.291Z",
    fill: "#1999E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2139 108.343C76.5239 109.5 77.8359 109.768 78.9929 109.458C79.5714 109.303 80.1499 109.148 79.9949 108.57C80.9969 107.681 81.1103 105.791 80.0668 104.21C77.2462 100.626 72.5767 99.3968 67.0602 99.6349C67.2152 100.213 67.2152 100.213 66.6367 100.368C61.5852 102.342 58.8892 106.165 57.6603 110.834C57.3918 112.146 58.4353 113.727 59.9023 114.574C61.2143 114.842 62.7948 113.799 63.6418 112.332C64.6023 108.974 67.1848 107.042 68.7653 105.998C70.6558 106.112 73.8583 106.494 76.2139 108.343Z",
    fill: "#1999E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.075 87.6601C113.497 87.8151 113.497 87.8151 112.918 87.9701C107.867 89.9437 105.171 93.7662 103.942 98.4358C103.673 99.7478 104.717 101.328 106.184 102.175C107.496 102.444 109.076 101.4 109.923 99.9332C110.305 96.7307 113.043 95.3771 115.202 94.1786C117.092 94.2921 120.14 94.0955 122.65 96.523C123.539 97.525 124.851 97.7935 125.429 97.6385C126.008 97.4835 126.586 97.3285 126.431 96.75C127.433 95.8614 127.547 93.9709 126.503 92.3904C123.683 88.8059 119.013 87.577 114.075 87.6601Z",
    fill: "#1999E5"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: 'grid lg:grid-cols-2 lg:gap-7'
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: clsx('relative mb-[1.875rem] mr-0 ml-auto', isActive === true && 'animate-grow-from-70')
  }, /*#__PURE__*/React.createElement("img", {
    className: "w-full",
    src: Baby1.Image.src,
    alt: Baby1.name
  }), /*#__PURE__*/React.createElement("span", {
    className: 'absolute left-0 top-0 bg-yellow-475 px-[1.25rem] text-[1.75rem] leading-[3.375rem]'
  }, Baby1.name)), /*#__PURE__*/React.createElement("div", {
    className: clsx('relative mr-0 ml-auto', isActive === true && 'animate-shrink-to-70')
  }, /*#__PURE__*/React.createElement("img", {
    className: "w-full",
    src: Baby2.Image.src,
    alt: Baby2.name
  }), /*#__PURE__*/React.createElement("span", {
    className: 'absolute left-0 top-0 bg-yellow-475 px-[1.25rem] text-[1.75rem] leading-[3.375rem]'
  }, Baby2.name))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: clsx('relative mt-[5.25rem]', isActive === true && 'animate-slide-from-top')
  }, /*#__PURE__*/React.createElement("img", {
    className: "w-full",
    src: Baby3.Image.src,
    alt: Baby3.name
  }), /*#__PURE__*/React.createElement("span", {
    className: 'absolute left-0 top-0 bg-yellow-475 px-[1.25rem] text-[1.75rem] leading-[3.375rem]'
  }, Baby3.name)), /*#__PURE__*/React.createElement("div", {
    className: 'mt-8 flex items-center justify-end'
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "133",
    height: "133",
    viewBox: "0 0 133 133",
    fill: "none",
    className: 'animate-wiggle-slow'
  }, /*#__PURE__*/React.createElement("g", {
    opacity: "0.5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.679 68.376C110.618 61.3425 102.297 59.113 95.2636 63.1738C94.2086 63.7829 93.9113 64.8923 94.5205 65.9474C95.1296 67.0024 96.239 67.2996 97.294 66.6905C102.217 63.848 108.319 65.483 111.162 70.4064C111.771 71.4614 112.88 71.7587 113.935 71.1496C114.991 70.5405 115.288 69.431 114.679 68.376Z",
    fill: "#E8C7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7855 34.2022C72.5667 33.6077 70.4566 34.8259 69.8621 37.0448C69.5648 38.1542 69.6192 39.0606 70.2283 40.1156C70.8375 41.1707 71.5952 41.671 72.7046 41.9682C74.9235 42.5628 77.0336 41.3445 77.6281 39.1257C78.2226 36.9068 77.0044 34.7968 74.7855 34.2022Z",
    fill: "#E8C7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9983 92.516C54.701 93.6254 54.9585 94.8835 55.3646 95.5868C55.7706 96.2902 56.7314 97.1422 57.8409 97.4394C58.9503 97.7367 59.8567 97.6823 60.9117 97.0732C61.9667 96.4641 62.4671 95.7063 62.7643 94.5969C63.0616 93.4874 63.0072 92.5811 62.3981 91.526C61.789 90.471 61.0312 89.9707 59.9218 89.6734C58.8123 89.3761 57.9059 89.4306 56.8509 90.0397C55.7959 90.6488 55.2956 91.4065 54.9983 92.516Z",
    fill: "#E8C7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.61 86.8813C124.76 81.7801 125.489 75.7326 123.498 69.8484C122.171 65.9255 120.141 62.4088 117.813 60.0015C110.83 52.7795 99.6415 51.2679 90.8496 56.3439C90.1462 56.7499 88.8882 57.0074 87.6301 57.2648C89.6818 42.9511 88.7715 30.8163 84.7652 24.6892C83.1408 21.8758 81.2192 20.1718 78.7973 19.2256C76.3754 18.2794 73.7107 19.349 70.8973 20.9733C65.4191 23.6672 60.213 30.8931 55.5217 40.6351C51.8272 36.6724 47.8353 33.8192 42.8429 32.4815C28.975 28.7656 14.5563 37.0902 10.4888 51.1612C8.35347 58.0208 9.69509 65.2175 12.9437 70.8443C16.3954 76.8228 21.9571 81.583 29.1684 83.5153C34.1609 84.853 39.2475 84.7296 44.2254 82.7934C43.5658 93.0212 44.8132 101.679 48.2104 106.751C48.4135 107.103 48.4135 107.103 48.6165 107.454C49.6317 109.213 51.5533 110.917 53.7722 111.511C56.1941 112.458 58.9132 112.294 61.0233 111.076L62.0783 110.467C68.7602 106.609 75.6159 96.5554 80.8473 83.6881C81.8081 84.5401 82.5658 85.0404 83.1749 86.0954C88.2509 94.8873 98.6963 99.1725 108.558 96.7613C113.942 95.5285 118.811 91.7795 121.61 86.8813ZM42.706 69.6037C40.9476 70.6189 39.5409 71.431 38.0798 71.3368C30.5314 72.8815 23.3055 67.6753 21.5578 59.7752C20.7855 56.001 21.4743 52.3211 23.8272 49.087C25.8284 46.056 29.3452 44.0256 33.1194 43.2533C36.8936 42.4809 40.5735 43.1697 43.8076 45.5226C45.5262 46.8749 46.893 48.4303 47.9082 50.1886C48.7204 51.5953 48.9778 52.8534 49.4383 54.4632L47.8033 60.565C47.5061 61.6745 47.2088 62.7839 47.1146 64.245C46.9659 64.7997 46.6686 65.9091 46.52 66.4638C44.9647 67.8307 44.1127 68.7915 42.706 69.6037ZM30.2089 79.6323C18.0052 76.3623 10.8988 64.0537 14.3718 52.2016C17.8448 40.3495 30.1534 33.2432 41.8025 36.3645C46.2402 37.5536 50.7867 40.5554 53.5749 44.5725C53.129 46.2367 52.1283 47.7522 51.6824 49.4163C50.2611 46.9546 48.2851 44.3442 46.0119 42.8433C41.817 39.6384 37.0276 38.6523 32.347 39.4791C27.6665 40.3058 23.2977 43.297 20.7962 47.0858C17.9429 51.0776 16.9569 55.867 17.7836 60.5476C18.0955 62.712 18.962 65.0251 19.7742 66.4318C23.632 73.1137 30.9521 76.8587 38.5005 75.314C40.868 75.3539 42.978 74.1356 44.7364 73.1204L45.0881 72.9174C44.8452 74.9332 44.3993 76.5974 44.5081 78.4101C39.5302 80.3463 34.6466 80.8214 30.2089 79.6323ZM59.6962 107.153L58.9929 107.559C57.5862 108.372 56.1251 108.277 54.8126 107.628C53.5001 106.979 52.1877 106.33 51.7272 104.721C48.533 100 47.4342 90.7878 48.4455 80.357C48.4455 80.357 48.7972 80.1539 48.5941 79.8023C49.0799 75.7706 49.7686 72.0907 50.4574 68.4107L50.6061 67.856C50.7547 67.3013 50.7003 66.3949 51.2006 65.6371C51.4979 64.5277 51.5921 63.0666 52.241 61.7541C56.943 43.0968 65.3395 28.4022 72.9277 24.49C74.3344 23.6779 76.2958 23.0144 77.6083 23.6633C79.0694 23.7575 80.4362 25.3129 81.2484 26.7196C84.8487 32.1433 85.3529 43.5747 83.5985 56.7791C81.0279 56.3876 77.9027 55.8475 75.2777 54.5496C72.6528 53.2517 69.4333 54.1726 68.1354 56.7976C66.4858 59.6256 65.188 62.2505 64.4448 65.0241C63.7016 67.7977 63.5131 70.7199 63.5277 73.9938C63.5821 74.9001 63.6365 75.8065 64.0426 76.5099C64.8548 77.9166 66.5733 79.2689 68.5891 79.5118C70.0502 79.606 73.7302 80.2948 76.9099 81.7413C72.3818 94.2025 65.6747 103.702 59.6962 107.153ZM106.879 93.0415C98.8304 95.3439 90.4008 91.3016 86.34 84.2681C83.0914 78.6413 74.419 76.6148 69.2779 75.8318C68.1685 75.5345 67.7624 74.8312 67.3563 74.1278C67.1931 71.4086 67.5846 68.8381 67.9761 66.2676C68.5707 64.0487 69.8685 61.4238 71.3695 59.1505C71.8698 58.3927 72.5731 57.9867 73.8856 58.6356C75.7528 59.4332 86.5498 63.5153 92.88 59.8606C100.265 55.5968 109.438 56.8655 115.054 62.5322C116.218 63.7358 117.382 64.9395 118.194 66.3462C119.006 67.7529 119.818 69.1596 120.279 70.7693C121.66 75.5985 121.026 80.1849 118.376 84.5284C115.725 88.8719 111.708 91.66 106.879 93.0415Z",
    fill: "#E8C7FC"
  }))), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "97",
    height: "144",
    viewBox: "0 0 97 144",
    fill: "none",
    className: 'animate-wiggle-slow-reverse'
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0343 80.3803L43.3629 84.5794C41.7957 84.9994 41.0309 86.3241 41.4508 87.8912C41.8708 89.4584 43.1955 90.2232 44.7626 89.8033L60.4341 85.6041C62.0012 85.1842 62.766 83.8595 62.3461 82.2923C61.9262 80.7252 60.6015 79.9604 59.0343 80.3803Z",
    fill: "#CFF4D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4328 111.723L51.7613 115.922C50.1942 116.342 49.4294 117.667 49.8493 119.234C50.2692 120.801 51.5939 121.566 53.161 121.146L68.8325 116.947C70.3996 116.527 71.1645 115.202 70.7446 113.635C70.3246 112.068 68.9999 111.303 67.4328 111.723Z",
    fill: "#CFF4D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9618 105.475L59.4095 102.675C60.9766 102.255 61.7414 100.931 61.3215 99.3634C60.9016 97.7963 59.5769 97.0315 58.0097 97.4514L47.5621 100.251C45.995 100.671 45.2301 101.995 45.6501 103.563C46.07 105.13 47.3947 105.895 48.9618 105.475Z",
    fill: "#CFF4D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5634 74.1319L51.011 71.3324C52.5782 70.9125 53.343 69.5878 52.9231 68.0207C52.5032 66.4535 51.1785 65.6887 49.6113 66.1086L39.1637 68.9081C37.5965 69.328 36.8317 70.6527 37.2516 72.2198C37.6715 73.787 38.9962 74.5518 40.5634 74.1319Z",
    fill: "#CFF4D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3394 45.7054L68.9195 44.1383C67.5198 38.9145 62.7434 35.7152 57.2396 36.0702C54.8326 33.3558 51.9033 30.7814 48.5915 28.8693C46.6044 27.7221 45.2422 24.7278 45.0647 21.9759C45.6896 20.1288 45.2697 18.5617 44.8498 16.9945C43.3101 11.2483 37.3489 7.80663 31.6027 9.34632C25.8565 10.886 22.4148 16.8472 23.9545 22.5934C24.0945 23.1158 24.3744 24.1605 25.0368 24.543C25.1767 25.0653 25.3167 25.5877 25.4567 26.1101L25.5966 26.6325C27.4812 29.4868 27.7987 32.7611 26.1291 34.8881C24.7394 38.0599 23.4897 41.7541 22.7624 45.3083C17.8185 47.7528 15.2816 52.9116 16.6813 58.1355L17.1012 59.7026C14.5268 62.632 13.2771 66.3261 14.2569 69.9828L31.0536 132.669C32.5933 138.415 38.5544 141.857 44.3006 140.317L86.0912 129.119C91.8374 127.579 95.2791 121.618 93.7394 115.872L76.9428 53.1862C75.963 49.5295 72.8936 46.4327 69.3394 45.7054ZM63.6957 45.538L58.4719 46.9377L57.0722 41.7139C59.6841 41.014 62.9958 42.9261 63.6957 45.538ZM45.4123 50.437L44.0126 45.2132L51.8483 43.1136L53.2481 48.3374L45.4123 50.437ZM32.3528 53.9363L30.9531 48.7125L38.7888 46.6129L40.1885 51.8367L32.3528 53.9363ZM31.4279 37.9474C33.7224 33.9733 33.5074 28.9919 30.6805 24.7104C30.4005 23.6656 30.2606 23.1432 29.4582 22.2384C29.3183 21.7161 29.1783 21.1937 29.1783 21.1937C28.4784 18.5818 30.3905 15.27 33.0024 14.5701C35.6143 13.8703 38.9261 15.7823 39.6259 18.3942C40.0459 19.9614 40.1858 20.4838 39.9434 21.6685C39.636 26.7899 42.0805 31.7337 46.0546 34.0282C47.9017 34.653 49.8887 35.8003 51.4934 37.6099L28.5086 43.7686C28.9935 41.3991 30.1407 39.4121 31.4279 37.9474ZM25.7293 50.1122L27.129 55.336L21.9051 56.7357C21.2053 54.1238 23.1173 50.8121 25.7293 50.1122ZM88.5156 117.272C89.2154 119.884 87.3034 123.195 84.6915 123.895L42.9009 135.093C40.289 135.793 36.9772 133.881 36.2774 131.269L19.4808 68.5831C18.7809 65.9712 20.693 62.6594 23.3049 61.9596L65.0954 50.7618C67.7073 50.062 71.0191 51.974 71.719 54.5859L88.5156 117.272Z",
    fill: "#CFF4D2"
  }))))))), isActive ? /*#__PURE__*/React.createElement(DSProgressBar, {
    pauseDuration: pauseDuration
  }) : null));
}
function DSEventSlide({
  events,
  title,
  label,
  isActive = true,
  pauseDuration
}) {
  const intl = useIntl();
  // check media props to determine what component it should render
  return /*#__PURE__*/React.createElement("div", {
    className: 'relative mx-auto h-[100vh]'
  }, isActive ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'absolute right-0 bg-blue-850 py-4 px-9 text-[1.5rem] font-bold uppercase text-white'
  }, label), /*#__PURE__*/React.createElement("div", {
    className: 'digital-signage-event digital-signage mx-auto h-[100vh] w-full max-w-[90vw] overflow-hidden py-28 px-10'
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "prose"
  }, /*#__PURE__*/React.createElement("h1", {
    className: 'mb-6 animate-slide-from-top opacity-0 transition-all duration-1000'
  }, title)), /*#__PURE__*/React.createElement("div", null, events.map((event, index) => {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: 'grid border-b border-black/[.2] last-of-type:border-b-0 lg:grid-cols-2 lg:gap-10'
    }, /*#__PURE__*/React.createElement("p", {
      className: 'my-8 text-[2rem] font-bold 4xl:text-[2.5rem]'
    }, event.title), /*#__PURE__*/React.createElement("p", {
      className: 'my-8 flex items-start text-[2rem] 4xl:text-[2.5rem]'
    }, /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "28",
      height: "28",
      viewBox: "0 0 28 28",
      fill: "none",
      className: 'mr-4 mt-1 inline-block'
    }, /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7 0C6.53587 0 6.09075 0.184374 5.76256 0.512563C5.43437 0.840752 5.25 1.28587 5.25 1.75V3.5H3.5C2.57174 3.5 1.6815 3.86875 1.02513 4.52513C0.368749 5.1815 0 6.07174 0 7V24.5C0 25.4283 0.368749 26.3185 1.02513 26.9749C1.6815 27.6313 2.57174 28 3.5 28H24.5C25.4283 28 26.3185 27.6313 26.9749 26.9749C27.6313 26.3185 28 25.4283 28 24.5V7C28 6.07174 27.6313 5.1815 26.9749 4.52513C26.3185 3.86875 25.4283 3.5 24.5 3.5H22.75V1.75C22.75 1.28587 22.5656 0.840752 22.2374 0.512563C21.9092 0.184374 21.4641 0 21 0C20.5359 0 20.0908 0.184374 19.7626 0.512563C19.4344 0.840752 19.25 1.28587 19.25 1.75V3.5H8.75V1.75C8.75 1.28587 8.56563 0.840752 8.23744 0.512563C7.90925 0.184374 7.46413 0 7 0ZM7 8.75C6.53587 8.75 6.09075 8.93437 5.76256 9.26256C5.43437 9.59075 5.25 10.0359 5.25 10.5C5.25 10.9641 5.43437 11.4092 5.76256 11.7374C6.09075 12.0656 6.53587 12.25 7 12.25H21C21.4641 12.25 21.9092 12.0656 22.2374 11.7374C22.5656 11.4092 22.75 10.9641 22.75 10.5C22.75 10.0359 22.5656 9.59075 22.2374 9.26256C21.9092 8.93437 21.4641 8.75 21 8.75H7Z",
      fill: "#0155A8"
    })), event.startTime && event.endTime ? intl.formatDateTimeRange(new Date(`${event.startDate}T${event.startTime}`), new Date(`${event.endDate}T${event.endTime}`), {
      dateStyle: 'full',
      timeStyle: 'short'
    }) : intl.formatDateTimeRange(new Date(event.startDate), new Date(event.endDate), {
      dateStyle: 'full'
    }), event.eventStatus && /*#__PURE__*/React.createElement("span", {
      className: 'ml-6 mt-1 inline-block bg-red-500 px-5 text-[1.375rem] leading-[2.375rem] text-white'
    }, ' ', event.eventStatus)));
  }), /*#__PURE__*/React.createElement("p", {
    className: 'my-8'
  }, /*#__PURE__*/React.createElement("a", {
    className: "text-[1.875rem] font-bold text-blue-500 4xl:text-[2rem]",
    href: 'luks.ch/veranstaltungen'
  }, "Mehr Events unter luks.ch/veranstaltungen"))))), /*#__PURE__*/React.createElement(DSProgressBar, {
    pauseDuration: pauseDuration
  })) : null);
}

function DSLoop(props) {
  const [currentLoop, setCurrentLoop] = useState(1);
  const [currentSlides, setCurrentSlides] = useState([]);
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const swiperRef = useRef(null);
  let timeoutId = null;

  // Calculate current slides to iterate in the first side effect
  useEffect(() => {
    setCurrentSlides(transformSegments(props));
  }, [props, currentLoop]);

  // Add parent class to aid typography overrides
  useEffect(() => {
    const htmlElement = document.querySelector('html');
    if (htmlElement) {
      htmlElement.classList.add('digital-signage');
      htmlElement.classList.add('single-screen');
    }
  }, []);

  // Retrieve first slide pause duration, get swiper ref and trigger autoplay after first slide duration to set swiper in motion
  // If its of type DSHistorySlide then double the pauseDuration value so that the after image is shown for the same time as the initial slide
  useEffect(() => {
    // On swiper init
    let mounted = true;
    if (currentSlides.length > 0) {
      if (mounted) {
        handleSlideChange();
      }
    }
    return () => {
      mounted = false;
    };
  }, [currentSlides]);
  const onSlideChange = () => {
    handleSlideChange();
  };
  const handleSlideChange = () => {
    const swiper = swiperRef.current;
    if (swiper && currentSlides.length > 0) {
      const currentSlide = currentSlides[swiper.activeIndex];
      const currentSlidePauseDuration = checkSlideDuration(currentSlide);

      // Clear leftover in progress timers
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        if (swiper && swiper.activeIndex < currentSlides.length - 1) {
          swiper.slideNext();
        } else {
          setCurrentLoop(currentLoop + 1);
          swiper?.slideTo(0);
        }
      }, currentSlidePauseDuration * 1000);
      setCurrentSlideIndex(swiper.activeIndex);
    }
  };
  const checkSlideDuration = currentSlide => {
    // If its of type DSHistorySlide then double the pauseDuration value so that the after image is shown for the same time as the initial slide
    return currentSlide.type === 'DSHistorySlide' ? currentSlide.pauseDuration * 2 : currentSlide.pauseDuration;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: 'ds-loop mx-auto flex items-center'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'max-h-[100vh] overflow-hidden'
  }, /*#__PURE__*/React.createElement(Swiper, {
    modules: [Autoplay],
    autoplay: false,
    slidesPerView: 1,
    spaceBetween: 0,
    className: '!overflow-visible',
    onSwiper: swiper => {
      swiperRef.current = swiper;
    },
    onSlideChangeTransitionEnd: () => {
      onSlideChange();
    },
    allowTouchMove: false,
    effect: 'fade'
  }, currentSlides.map((currentSlide, index) => /*#__PURE__*/React.createElement(SwiperSlide, {
    className: '',
    key: index
  }, /*#__PURE__*/React.createElement(DSSlide, _extends({}, currentSlide, {
    isActive: index === currentSlideIndex
  })))))));
}
function transformSegments({
  segments,
  durationBabies,
  durationEvents
}) {
  const processedBabyIds = [];
  const processedSlideIds = [];
  return segments.flatMap(segment => {
    if ('slides' in segment.playlist) {
      const slides = segment.playlist.slides
      // Filter by metadata.
      .filter(slide => {
        const shouldDisplay = (!segment.filters.departmentIds.length || slide.metadata.departmentIds.some(departmentId => segment.filters.departmentIds.includes(departmentId))) && (!segment.filters.treatmentAreaIds.length || slide.metadata.treatmentAreaIds.some(treatmentAreaId => segment.filters.treatmentAreaIds.includes(treatmentAreaId))) && (!segment.filters.projectIds.length || slide.metadata.projectIds.some(projectId => segment.filters.projectIds.includes(projectId)));
        const shouldNotDisplay = segment.filtersExclude.departmentIds.length && slide.metadata.departmentIds.some(departmentId => segment.filtersExclude.departmentIds.includes(departmentId)) || segment.filtersExclude.treatmentAreaIds.length && slide.metadata.treatmentAreaIds.some(treatmentAreaId => segment.filtersExclude.treatmentAreaIds.includes(treatmentAreaId)) || segment.filtersExclude.projectIds.length && slide.metadata.projectIds.some(projectId => segment.filtersExclude.projectIds.includes(projectId));
        return shouldDisplay && !shouldNotDisplay;
      })
      // Filter out slides already used in this loop.
      .filter(slide => !processedSlideIds.includes(slide.id));
      // Select random slides.
      const randomSlides = slides.sort(() => 0.5 - Math.random()).slice(0, segment.amount);
      // Remember which slides were used.
      processedSlideIds.push(...randomSlides.map(slide => slide.id));
      return randomSlides.map(slide => slide.slide);
    }
    if ('babies' in segment.playlist) {
      const babies = segment.playlist.babies
      // Filter out babies already used in this loop.
      .filter(baby => !processedBabyIds.includes(baby.id))
      // Filter by metadata.
      .filter(baby => !segment.filters.departmentIds.length || baby.metadata.departmentIds.find(departmentId => segment.filters.departmentIds.includes(departmentId)));
      // Shuffle.
      shuffleArray(babies);
      // Pack by 3.
      const chunks = [];
      const chunkSize = 3;
      for (let i = 0; i < babies.length; i += chunkSize) {
        const chunk = babies.slice(i, i + chunkSize);
        if (chunk.length === chunkSize) {
          // There should be exactly 3 babies.
          chunks.push(chunk);
          // Remember which babies were used.
          processedBabyIds.push(...chunk.map(baby => baby.id));
        }
        // Stop if we have enough packs already.
        if (chunks.length === segment.amount) {
          break;
        }
      }
      return chunks.map(chunk => ({
        type: 'DSBabySlide',
        title: 'Unsere jüngsten Babys',
        label: 'BABYS',
        pauseDuration: durationBabies,
        babies: chunk.map(baby => ({
          name: baby.title,
          Image: {
            src: baby.imageSrc
          }
        }))
      }));
    }
    if ('events' in segment.playlist) {
      const today = formatDate(new Date());
      const events = segment.playlist.events
      // Filter out today's and past events.
      .filter(event => event.startDate > today)
      // Filter by metadata.
      .filter(event => !segment.filters.departmentIds.length || event.metadata.departmentIds.find(departmentId => segment.filters.departmentIds.includes(departmentId)));
      // Pack by 4.
      const chunks = [];
      const chunkSize = 4;
      for (let i = 0; i < events.length; i += chunkSize) {
        chunks.push(events.slice(i, i + chunkSize));
        // Stop if we have enough packs already.
        if (chunks.length === segment.amount) {
          break;
        }
      }
      return chunks.map(chunk => ({
        type: 'DSEventSlide',
        title: 'Die nächsten Veranstaltungen',
        label: 'VERANSTALTUNGEN',
        pauseDuration: durationEvents,
        events: chunk
      }));
    }
    return [];
  });
}

function DsSlide(props) {
  return /*#__PURE__*/React.createElement(DSSlide, props);
}

function EmergencyMessage({
  Content,
  title
}) {
  const backgroundTheme = useTheme({
    luzern: 'bg-blue-100',
    nidwalden: 'bg-brown-100'
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, title ? /*#__PURE__*/React.createElement("div", {
    className: "container-page my-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('container-content border-4 border-red-500 p-5  md:p-10', backgroundTheme)
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-text"
  }, /*#__PURE__*/React.createElement("div", {
    className: "prose lg:prose-xl"
  }, /*#__PURE__*/React.createElement("h2", null, title), Content ? /*#__PURE__*/React.createElement(Content, null) : null)))) : null);
}

function EventDateTime({
  startDate,
  startTime,
  endDate,
  endTime,
  format
}) {
  const intl = useIntl();
  const hasTime = startTime && endTime;
  const formatted = hasTime ? intl.formatDateTimeRange(new Date(`${startDate}T${startTime}`), new Date(`${endDate}T${endTime}`), {
    dateStyle: format,
    timeStyle: 'short'
  }) : intl.formatDateTimeRange(new Date(startDate), new Date(endDate), {
    dateStyle: format
  });
  // The <time> tag does not support ranges. This is a probable cause of bugs
  // with Google (see LUKS-1902). To avoid any issues, we split the range into
  // two <time> tags. And also provide the `datetime` attribute.
  const match = formatted.match(/(.*?)(\s*–\s*)(.*)/);
  return match ? /*#__PURE__*/React.createElement("span", {
    className: "block"
  }, /*#__PURE__*/React.createElement("time", {
    dateTime: hasTime ? `${startDate}T${startTime}` : startDate
  }, match[1]), match[2], /*#__PURE__*/React.createElement("time", {
    dateTime: hasTime ? `${endDate}T${endTime}` : endDate
  }, match[3])) : /*#__PURE__*/React.createElement("time", {
    className: "block",
    dateTime: hasTime ? `${startDate}T${startTime}` : startDate
  }, formatted);
}

const EventDetailsListItem = ({
  heading,
  content
}) => {
  const iconTheme = useTheme({
    luzern: 'text-blue-900',
    nidwalden: 'text-brown-400'
  });
  return /*#__PURE__*/React.createElement("li", {
    className: 'border-b-2 border-grey-100 py-3 pb-5 first:pt-5 last:border-0 sm:flex md:py-5 md:pt-3 lg:text-xl'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'md mb-4 mr-4 flex shrink-0 justify-center sm:w-16 md:mb-4 md:justify-start lg:w-20'
  }, heading === 'Datum:' && /*#__PURE__*/React.createElement(CalendarIcon, {
    className: clsx('h-9 w-9 md:h-7 md:w-7', iconTheme)
  }), heading === 'Ort:' && /*#__PURE__*/React.createElement(LocationMarkerIcon, {
    className: clsx('h-10 w-10 md:h-8 md:w-8', iconTheme)
  }), heading === 'Fachbereich:' && /*#__PURE__*/React.createElement(SignpostIcon, {
    className: clsx('h-10 w-10 md:h-7 md:w-7', iconTheme)
  })), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
    className: 'block font-bold'
  }, heading), content));
};
function EventDetails({
  startDate,
  startTime,
  endDate,
  endTime,
  location,
  subjects,
  CalendarLink,
  eventStatus
}) {
  const EventStats = useTheme({
    luzern: 'bg-yellow-450 text-black',
    nidwalden: 'bg-blue-950 text-white'
  });
  return /*#__PURE__*/React.createElement("div", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-text'
  }, eventStatus ? /*#__PURE__*/React.createElement("div", {
    className: clsx('my-4 inline-block px-3 pt-1.5 pb-1 text-[20px] capitalize leading-[20px]', {
      'bg-red-500 text-white': eventStatus === 'abgesagt' || eventStatus === 'ausgebucht'
    }, eventStatus === 'beliebt' ? EventStats : null)
  }, eventStatus) : null, /*#__PURE__*/React.createElement("ul", {
    className: 'prose max-w-none'
  }, /*#__PURE__*/React.createElement(EventDetailsListItem, {
    heading: 'Datum:',
    content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EventDateTime, {
      startDate: startDate,
      startTime: startTime,
      endDate: endDate,
      endTime: endTime,
      format: "full"
    }), ' ', /*#__PURE__*/React.createElement(CalendarLink, null, "Zum Kalender hinzuf\xFCgen"))
  }), /*#__PURE__*/React.createElement(EventDetailsListItem, {
    heading: 'Ort:',
    content: location
  }), subjects.length ? /*#__PURE__*/React.createElement(EventDetailsListItem, {
    heading: 'Fachbereich:',
    content: subjects.map(({
      area,
      Link
    }, index) => /*#__PURE__*/React.createElement("div", {
      key: index
    }, /*#__PURE__*/React.createElement(Link, null, area)))
  }) : null))));
}
function SignpostIcon({
  className
}) {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.283 29.313",
    className: clsx(className)
  }, /*#__PURE__*/React.createElement("path", {
    id: "signpost_1_",
    "data-name": "signpost (1)",
    d: "M10.335,29.332a.939.939,0,0,0,.939.939H21.691a.939.939,0,1,0,0-1.878h-2.4v-.161a.939.939,0,0,0-.939-.939h-.89V21.582h8.055a.939.939,0,0,0,.661-.272l2.831-2.8a.939.939,0,0,0,0-1.329L26.2,14.349a.939.939,0,0,0-.665-.277H17.46v-2.68H27.794a1.878,1.878,0,0,0,1.878-1.878V5.759a1.878,1.878,0,0,0-1.878-1.878H17.46V1.9a.939.939,0,1,0-1.878,0V3.881H7.546a.939.939,0,0,0-.66.272l-2.831,2.8a.939.939,0,0,0,0,1.329l2.816,2.83a.939.939,0,0,0,.665.277h8.051v2.68H5.267a1.878,1.878,0,0,0-1.878,1.878V19.7a1.878,1.878,0,0,0,1.878,1.878H15.583v5.711H14.6a.939.939,0,0,0-.939.939v.161H11.274A.939.939,0,0,0,10.335,29.332Z",
    transform: "translate(-3.389 -0.958)",
    fill: "currentColor"
  }));
}

function EventSearch({
  searchTeasers,
  MoreLink,
  infiniteScroll,
  ...Form
}) {
  const intl = useIntl();
  const status = useOrganismStatus();
  return /*#__PURE__*/React.createElement("div", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'my-10'
  }, /*#__PURE__*/React.createElement(EventSearchForm, Form)), status === 404 ? intl.formatMessage({
    id: "kKLW/Q",
    defaultMessage: [{
      "type": 0,
      "value": "Leider konnten keine Veranstaltungen gefunden werden."
    }]
  }) : status === 500 ? /*#__PURE__*/React.createElement("div", {
    className: "text-red-500"
  }, intl.formatMessage({
    id: "iVzdPP",
    defaultMessage: [{
      "type": 0,
      "value": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut."
    }]
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'flex-wrap md:-mx-3 md:flex lg:-mx-5'
  }, searchTeasers.map((searchTItem, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: 'mb-3 w-full last:mb-0 md:mb-0 md:w-1/2 md:p-3 lg:w-1/4 lg:p-5'
  }, /*#__PURE__*/React.createElement(EventTeaser, searchTItem)))), /*#__PURE__*/React.createElement(LoadMore, {
    LoadingAnimation: Loader,
    MoreLink: MoreLink,
    resultLabel: 'Veranstaltungen',
    isInfiniteScrollActive: infiniteScroll
  }))));
}
function EventTeaser({
  Link,
  Image,
  title,
  location,
  startDate,
  startTime,
  endDate,
  endTime,
  eventStatus
}) {
  const groupTheme = useGroupTheme({
    kinderspital: {
      link: 'focus-luks',
      icons: 'text-orange-300 group-hover:text-orange-300',
      title: 'group-hover:text-orange-400',
      stats: 'bg-orange-400 text-white'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      link: 'focus-luks',
      icons: 'text-blue-900 group-hover:text-blue-400',
      title: 'group-hover:text-blue-400',
      stats: 'bg-yellow-450 text-black'
    },
    nidwalden: {
      link: 'focus-nidwalden',
      icons: 'text-brown-400',
      title: 'group-hover:text-brown-400',
      stats: 'bg-blue-950 text-white'
    }
  });

  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  return /*#__PURE__*/React.createElement(Link, {
    className: clsx('group block p-0.5', theme.link)
  }, /*#__PURE__*/React.createElement("div", {
    className: 'aspect-w-1 aspect-h-1 relative mb-4 block overflow-hidden rounded-t-md'
  }, /*#__PURE__*/React.createElement(Image, {
    className: 'block w-full max-w-full object-cover transition duration-300 group-hover:scale-105'
  }), eventStatus ? /*#__PURE__*/React.createElement("div", {
    className: clsx('absolute top-[calc(100%_-_37px)] left-0 z-10 my-4 block h-[21px] w-auto max-w-[100px] px-3 py-[2px] text-center text-[13px] capitalize leading-[20px]', {
      'bg-red-500 text-white': eventStatus === 'abgesagt' || eventStatus === 'ausgebucht'
    }, eventStatus === 'beliebt' ? theme.stats : null)
  }, eventStatus) : null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    className: clsx('mb-3 text-xl font-bold transition', theme.title)
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: 'mb-1 flex items-start text-sm'
  }, /*#__PURE__*/React.createElement(CalendarIcon, {
    className: clsx('mr-2 h-4 w-4 shrink-0', theme.icons)
  }), /*#__PURE__*/React.createElement(EventDateTime, {
    startDate: startDate,
    startTime: startTime,
    endDate: endDate,
    endTime: endTime,
    format: "short"
  })), location ? /*#__PURE__*/React.createElement("div", {
    className: 'flex items-start text-sm'
  }, /*#__PURE__*/React.createElement(LocationMarkerIcon, {
    className: clsx('mr-2 h-4 w-4 shrink-0', theme.icons)
  }), /*#__PURE__*/React.createElement("span", null, location)) : null);
}
function EventSearchForm({
  Form,
  types,
  locations
}) {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement(Form, {
    className: 'form !grid-cols-12'
  }, /*#__PURE__*/React.createElement("label", {
    className: 'label col-span-12 lg:col-span-3'
  }, intl.formatMessage({
    id: "LrOcWc",
    defaultMessage: [{
      "type": 0,
      "value": "Thema"
    }]
  }), /*#__PURE__*/React.createElement(Field, {
    className: 'field',
    type: 'text',
    name: 'title'
  })), /*#__PURE__*/React.createElement("div", {
    className: 'col-span-12 lg:col-span-3'
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: 'type',
    className: 'label'
  }, intl.formatMessage({
    id: "xTeBn/",
    defaultMessage: [{
      "type": 0,
      "value": "Typ"
    }]
  })), /*#__PURE__*/React.createElement(Select, {
    selectItems: [{
      title: intl.formatMessage({
        id: "b1X14e",
        defaultMessage: [{
          "type": 0,
          "value": "- Alle Typen -"
        }]
      }),
      value: ''
    }, ...types],
    name: 'type',
    id: 'type'
  })), /*#__PURE__*/React.createElement("label", {
    className: 'label col-span-12 lg:col-span-2'
  }, intl.formatMessage({
    id: "pqoMA0",
    defaultMessage: [{
      "type": 0,
      "value": "Datum"
    }]
  }), /*#__PURE__*/React.createElement(DateWidget, {
    name: "date"
  })), /*#__PURE__*/React.createElement("div", {
    className: 'col-span-12 lg:col-span-2'
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: 'location',
    className: 'label'
  }, intl.formatMessage({
    id: "qUkS0z",
    defaultMessage: [{
      "type": 0,
      "value": "Standort"
    }]
  })), /*#__PURE__*/React.createElement(Select, {
    selectItems: [{
      title: intl.formatMessage({
        id: "ftoYlu",
        defaultMessage: [{
          "type": 0,
          "value": "- Alle Standorte -"
        }]
      }),
      value: ''
    }, ...locations],
    name: 'location',
    id: 'location'
  })), /*#__PURE__*/React.createElement("div", {
    className: 'col-span-12 flex items-end justify-end lg:col-span-2 lg:justify-start'
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "button-primary lg:w-full"
  }, intl.formatMessage({
    id: "JYs1ab",
    defaultMessage: [{
      "type": 0,
      "value": "Filtern"
    }]
  }))));
}
const isDateSupported = () => {
  if (typeof window === 'undefined') {
    return true;
  }
  const input = document.createElement('input');
  const value = 'a';
  input.setAttribute('type', 'date');
  input.setAttribute('value', value);
  return input.value !== value;
};
function DateWidget({
  name
}) {
  const [field,, helpers] = useField(name);
  return isDateSupported() ? /*#__PURE__*/React.createElement(Field, {
    type: "date",
    name: name,
    id: name,
    value: field.value,
    className: 'field'
  }) : /*#__PURE__*/React.createElement(DatePicker, {
    className: 'field',
    selected: field.value ? new Date(field.value) : new Date(Date.now() - 86400000),
    dateFormat: "dd.MM.yyyy",
    onChange: date => {
      helpers.setValue(date.toLocaleDateString('en-CA'));
    }
  });
}

function EventItem({
  event
}) {
  if (!event) {
    return null;
  }
  return /*#__PURE__*/React.createElement(EventTeaser, event);
}

function EventView({
  title,
  events,
  LinkCta
}) {
  const intl = useIntl();
  if (!events.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: 'container-page my-10'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, title ? /*#__PURE__*/React.createElement("h2", {
    className: 'mb-5 text-center text-2xl font-bold md:flex-1 md:text-3xl'
  }, title) : null, /*#__PURE__*/React.createElement("div", {
    className: 'flex flex-wrap justify-center'
  }, events.map((event, index) => /*#__PURE__*/React.createElement("div", {
    className: 'mb-3 w-full last:mb-0 md:mb-0 md:w-1/2 md:p-3 lg:w-1/4 lg:p-5',
    key: index
  }, /*#__PURE__*/React.createElement(EventTeaser, event)))), LinkCta ? /*#__PURE__*/React.createElement("div", {
    className: 'mt-5 text-center'
  }, /*#__PURE__*/React.createElement(LinkCta, {
    className: 'button-primary'
  }, intl.formatMessage({
    id: "NjW9Tk",
    defaultMessage: [{
      "type": 0,
      "value": "Alle Veranstaltungen"
    }]
  }))) : null));
}

function Figure({
  Image,
  Caption
}) {
  if (!Image.src) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "container-page mb-4 lg:mb-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-text"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-2 md:my-6"
  }, /*#__PURE__*/React.createElement("figure", {
    className: clsx('image-wrapper', {
      // If there is a caption, display a smaller bottom padding for
      // visual balance.
      'pb-1 sm:pb-2': Caption
    })
  }, /*#__PURE__*/React.createElement(Image, {
    className: "block"
  }), Caption ? /*#__PURE__*/React.createElement("figcaption", {
    className: "mt-3 font-light text-grey-700"
  }, /*#__PURE__*/React.createElement(Caption, null)) : null)))));
}

function FileList({
  title,
  items
}) {
  if (!items?.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: 'container-page mb-6 md:mb-10'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-text'
  }, title ? /*#__PURE__*/React.createElement("div", {
    className: 'prose'
  }, /*#__PURE__*/React.createElement("h2", {
    id: "Dateien",
    className: 'mt-12 mb-5 lg:mb-7'
  }, title)) : null, /*#__PURE__*/React.createElement("ul", null, items.map((item, index) => /*#__PURE__*/React.createElement(FileListItem, _extends({
    key: index
  }, item)))))));
}
function FileListItem({
  Link,
  title
}) {
  const groupTheme = useGroupTheme({
    kinderspital: {
      default: 'focus-kinderspital text-orange-300 hover:text-orange-400'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      default: 'focus-luks text-blue-900 hover:text-blue-400'
    },
    nidwalden: {
      default: 'focus-nidwalden text-brown-900 hover:text-blue-400'
    }
  });

  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  return /*#__PURE__*/React.createElement("li", {
    className: "py-3 lg:text-xl"
  }, /*#__PURE__*/React.createElement(Link, {
    className: clsx('flex items-start pl-9 transition hover:underline lg:pl-12', theme.default)
  }, /*#__PURE__*/React.createElement("svg", {
    className: "mr-3 -ml-9 mt-[-3px] h-6 w-6 shrink-0 lg:mr-5 lg:-ml-12 lg:h-7 lg:w-7",
    xmlns: "http://www.w3.org/2000/svg",
    width: "25.306",
    height: "30.717",
    viewBox: "0 0 25.306 30.717"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6928.249,3643.262a.746.746,0,0,1,0-1.049.722.722,0,0,1,1.031,0l.653.661v-3.586a.732.732,0,1,1,1.464,0v3.595l.661-.67a.727.727,0,0,1,1.035,0,.752.752,0,0,1,0,1.049l-2.423,2.456Zm-15.861,1.392a4.421,4.421,0,0,1-4.387-4.448v-20.758a4.421,4.421,0,0,1,4.387-4.447h9.5a.72.72,0,0,1,.516.216l8.774,8.9a.75.75,0,0,1,.215.526v5.93a.732.732,0,1,1-1.464,0v-5.19h-5.361a3.44,3.44,0,0,1-3.411-3.458v-5.437h-8.773a2.952,2.952,0,0,0-2.926,2.966v20.758a2.952,2.952,0,0,0,2.926,2.966h12.428a.741.741,0,0,1,0,1.481Zm10.234-22.734a1.967,1.967,0,0,0,1.95,1.977h4.327l-6.277-6.365Zm-8.041,15.32a.741.741,0,0,1,0-1.482h10.234a.741.741,0,0,1,0,1.482Zm0-5.93a.743.743,0,0,1,0-1.485h10.234a.743.743,0,0,1,0,1.485Zm0-5.933a.741.741,0,0,1,0-1.481h2.925a.741.741,0,0,1,0,1.481Z",
    transform: "translate(-6908 -3615.001)",
    fill: "currentColor"
  })), title));
}

function FooterLogo({
  Logo
}) {
  const groupTheme = useGroupTheme({
    kinderspital: {
      logo: /*#__PURE__*/React.createElement("img", {
        className: "w-[90%] pt-2 lg:w-[70%]",
        src: '/kinderspital-logo.svg',
        alt: 'Luzerner Kinderspital'
      }),
      subtitle: /*#__PURE__*/React.createElement("div", null)
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      logo: /*#__PURE__*/React.createElement("img", {
        src: '/luks-logo.svg',
        alt: 'Luzerner Kantonsspital'
      }),
      subtitle: /*#__PURE__*/React.createElement("img", {
        height: 9,
        width: 'auto',
        src: '/luks-subtitle.svg',
        alt: 'Luzern, Sursee, Wollhusen'
      })
    },
    nidwalden: {
      logo: /*#__PURE__*/React.createElement("img", {
        src: '/nidwalden-logo.svg',
        alt: 'Spital Nidwalden'
      }),
      subtitle: /*#__PURE__*/React.createElement("img", {
        height: 9,
        width: 'auto',
        src: '/nidwalden-subtitle.svg',
        alt: 'Ein Unternehmen der LUKS Gruppe'
      })
    },
    zskr: {
      logo: /*#__PURE__*/React.createElement("img", {
        className: 'h-16 w-auto',
        src: '/zskr-logo.svg',
        alt: 'Zentralschweizer Krebsregister'
      }),
      subtitle: /*#__PURE__*/React.createElement("div", null)
    }
  });

  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  return /*#__PURE__*/React.createElement(Logo.Link, {
    className: clsx('focus-luks mr-8 flex max-w-[250px] flex-col', useGroupTheme({
      kinderspital: 'items-start'
    }) ?? 'items-end', useTheme({
      luzern: 'focus-luks',
      nidwalden: 'focus-nidwalden'
    }))
  }, theme.logo, /*#__PURE__*/React.createElement("div", {
    className: "pt-1"
  }, theme.subtitle), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, Logo.title));
}
function Footer({
  siteName,
  siteSlogan,
  menus,
  Logo,
  copyMenus
}) {
  const intl = useIntl();
  const groupTheme = useGroupTheme({
    kinderspital: {
      border: 'border-none',
      menulink: 'focus-luks hover:text-orange-400',
      tertiarylink: 'focus-luks hover:text-orange-400'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      border: 'border-blue-900 bg-blue-100',
      menulink: 'focus-luks hover:text-blue-500',
      tertiarylink: 'focus-luks hover:text-blue-900'
    },
    nidwalden: {
      border: 'border-brown-500 bg-brown-100',
      menulink: 'focus-nidwalden text-brown-900 hover:text-brown-500',
      tertiarylink: 'focus-nidwalden text-brown-500 hover:text-brown-900'
    }
  });

  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  const activeGroupTheme = useGroupTheme({
    kinderspital: 'kinderspital'
  });
  const activeTheme = useActiveTheme();
  return /*#__PURE__*/React.createElement("footer", null, activeTheme !== 'zskr' && /*#__PURE__*/React.createElement("div", {
    className: clsx('container-page border-t-8 bg-blue-100', theme.border, activeGroupTheme === 'kinderspital' ? 'py-8 pt-0 md:pb-12' : 'py-8 md:py-12')
  }, activeGroupTheme === 'kinderspital' && /*#__PURE__*/React.createElement("div", {
    className: "container-content mx-auto flex w-full -translate-y-[6px] items-end justify-between pb-8 md:pb-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex w-full items-center lg:w-[75%]"
  }, /*#__PURE__*/React.createElement("img", {
    src: '/orange-border-paint-stroke.svg',
    alt: 'Orange paint stroke',
    className: "hidden md:block"
  }), /*#__PURE__*/React.createElement("img", {
    src: '/orange-border-paint-stroke-small.svg',
    alt: 'Orange paint stroke',
    className: "block md:hidden"
  })), /*#__PURE__*/React.createElement("div", {
    className: "relative hidden w-[25%] lg:block"
  }, /*#__PURE__*/React.createElement("img", {
    className: "absolute -bottom-[14px] translate-x-8",
    src: '/Luksi_Grundpose.svg',
    alt: 'Luksi_Grundpose'
  }), /*#__PURE__*/React.createElement("img", {
    src: '/blue-border-paint-stroke.svg',
    alt: 'Blue paint stroke',
    className: ""
  }))), /*#__PURE__*/React.createElement("div", {
    className: "container-content"
  }, menus?.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("nav", {
    className: "gap-6 md:grid md:grid-cols-2 lg:grid-cols-4"
  }, menus.map(({
    title,
    Link,
    items
  }, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: "mb-8 last:mb-0 sm:mr-8 md:mb-4 lg:mb-0"
  }, /*#__PURE__*/React.createElement(Link, {
    "duration-300": true,
    className: clsx('block transition hover:underline', theme.menulink)
  }, /*#__PURE__*/React.createElement("h3", {
    className: "mb-5 font-bold"
  }, title)), /*#__PURE__*/React.createElement("ul", null, items.map(({
    title,
    Link
  }, index) => /*#__PURE__*/React.createElement("li", {
    key: index,
    className: 'mb-3 last:mb-0'
  }, /*#__PURE__*/React.createElement(Link, {
    className: clsx('block font-light transition duration-300 hover:underline', theme.menulink)
  }, title))))))), /*#__PURE__*/React.createElement("hr", {
    className: 'my-8 border-grey-500 opacity-50 md:my-12'
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: 'flex flex-col items-center md:flex-row md:justify-between lg:items-end'
  }, /*#__PURE__*/React.createElement(FooterLogo, {
    Logo: Logo
  }), /*#__PURE__*/React.createElement("div", {
    className: 'flex flex-1 justify-end'
  }, /*#__PURE__*/React.createElement("ul", {
    className: 'mt-10 inline-flex flex-col md:mt-0 lg:flex-row'
  }, /*#__PURE__*/React.createElement("li", {
    className: 'mb-0 text-center text-sm font-bold last:mr-0 last:mb-0 last:border-0 md:text-right md:text-base lg:mr-4 lg:border-r lg:pr-4 lg:text-left lg:leading-none'
  }, activeTheme === 'luzern' && /*#__PURE__*/React.createElement(React.Fragment, null, intl.formatMessage({
    id: "swhJS1",
    defaultMessage: [{
      "type": 0,
      "value": "Universitäres Lehr- und Forschungsspital"
    }]
  })), activeTheme !== 'luzern' && /*#__PURE__*/React.createElement(React.Fragment, null, intl.formatMessage({
    id: "skywGn",
    defaultMessage: [{
      "type": 0,
      "value": "Ein Unternehmen der LUKS Gruppe"
    }]
  }))), /*#__PURE__*/React.createElement("li", {
    className: 'mb-3 text-center text-sm font-bold last:mb-0 last:border-0 md:text-right md:text-base lg:border-r lg:text-left lg:leading-none'
  }, siteSlogan)))))), /*#__PURE__*/React.createElement("div", {
    className: 'container-page bg-white py-6 text-sm'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content flex flex-col items-center justify-end md:flex-row'
  }, /*#__PURE__*/React.createElement("div", null, "\xA9 ", new Date().getFullYear(), " ", siteName), /*#__PURE__*/React.createElement("ul", {
    className: 'mt-5 flex font-bold md:ml-6 md:mt-0'
  }, copyMenus.map(({
    title,
    Link
  }, i) => /*#__PURE__*/React.createElement("li", {
    key: i,
    className: 'mr-6 text-center last:mr-0 lg:text-left'
  }, /*#__PURE__*/React.createElement(Link, {
    "duration-300": true,
    className: clsx('transition hover:underline', theme.tertiarylink)
  }, title)))))));
}

function FormattedText({
  Content
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "container-page mb-4 lg:mb-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-text"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-2 md:my-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('prose max-w-none lg:prose-xl', useTheme({
      luzern: '',
      nidwalden: 'nidwalden'
    }))
  }, /*#__PURE__*/React.createElement(EnhancedHtml, {
    Content: Content
  }))))));
}

function Teaser({
  Image,
  Description,
  title,
  date,
  Link,
  arrowIsVisible = true,
  isFullWidth = false
}) {
  const intl = useIntl();
  const hasLink = !!(Link && Link.href);
  const groupTheme = useGroupTheme({
    kinderspital: {
      text: 'text-orange-400',
      title: Link ? 'group-hover:text-orange-350' : '',
      link: ''
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      text: 'text-blue-900 group-hover:text-blue-400',
      title: Link ? 'group-hover:text-blue-400' : '',
      link: 'focus-luks'
    },
    nidwalden: {
      text: 'text-brown-400',
      title: Link ? 'group-hover:text-brown-400' : '',
      link: 'focus-nidwalden'
    }
  });
  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;

  // @ts-ignore
  const Wrapper = hasLink ? Link : ({
    className,
    children
  }) => /*#__PURE__*/React.createElement("span", {
    className: className
  }, children);
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: clsx('focus group relative block rounded-md', isFullWidth && 'sm:flex')
  }, Image ? /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    className: clsx('relative mb-5 overflow-hidden', {
      'md:mr-7 md:mb-0 md:w-64 md:shrink-0 lg:w-80': isFullWidth,
      'aspect-w-2 aspect-h-1 block rounded-t-md': !isFullWidth
    })
  }, /*#__PURE__*/React.createElement(Image, {
    className: clsx('block object-cover transition duration-300', Link && 'group-hover:scale-105', {
      'w-full max-w-full': !isFullWidth,
      'min-h-full': isFullWidth
    })
  })) : null, /*#__PURE__*/React.createElement("div", null, !!date && /*#__PURE__*/React.createElement("div", {
    className: 'mb-2.5 flex items-center text-sm uppercase'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'mr-3'
  }, intl.formatDate(date, {
    dateStyle: 'medium'
  })), ' '), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    className: clsx('text-xl font-bold transition', theme.title)
  }, title), Description !== undefined ? /*#__PURE__*/React.createElement("div", {
    className: clsx('empty:mt-0', {
      'mt-2.5': Description
    })
  }, /*#__PURE__*/React.createElement(Description, null)) : null, arrowIsVisible && Link ? /*#__PURE__*/React.createElement("div", {
    className: clsx('inline-block transition-all group-hover:pl-5', theme.text)
  }, /*#__PURE__*/React.createElement(ArrowRight$3, {
    className: 'mb-2.5 h-7 w-7 lg:mb-0 lg:mt-2.5'
  })) : null)));
}
function ArrowRight$3({
  className
}) {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17 8l4 4m0 0l-4 4m4-4H3"
  }));
}

function GridTeaser({
  teasers,
  title,
  Link,
  linkText,
  id
}) {
  const status = useOrganismStatus();
  if (status === 404 || !teasers.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content my-10'
  }, /*#__PURE__*/React.createElement("h2", {
    className: 'section-title mb-8 text-center',
    id: id
  }, title), /*#__PURE__*/React.createElement("div", {
    className: clsx('flex flex-wrap md:-ml-5 ', {
      'lg:justify-center': teasers.length < 4,
      'md:justify-center': teasers.length < 2
    })
  }, teasers.map((teaser, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: "w-full md:w-1/2 md:p-5 lg:w-1/4"
  }, /*#__PURE__*/React.createElement(Teaser, teaser)))), Link && linkText ? /*#__PURE__*/React.createElement("div", {
    className: 'text-center'
  }, /*#__PURE__*/React.createElement(Link, {
    className: 'button-primary'
  }, linkText)) : null));
}

function SearchCombobox({
  suggestions,
  className,
  placeholderText
}) {
  const intl = useIntl();
  const [field,, helpers] = useField('query');
  const [,, category] = useField('category');
  const context = useFormikContext();
  const suggestionDict = (suggestions || []).map(category => category.results).reduce((acc, val) => [...acc, ...val], []).map(result => ({
    [result.id]: result
  })).reduce((acc, val) => ({
    ...acc,
    ...val
  }), {});
  const categoryDict = (suggestions || []).map(category => ({
    [category.categoryName]: category.categoryName
  })).reduce((acc, val) => ({
    ...acc,
    ...val
  }), {});
  const groupTheme = useGroupTheme({
    kinderspital: {
      activeOptionTheme: 'bg-orange-350 text-white',
      activeCategoryOptionTheme: 'bg-orange-400 !text-white border border-orange-400',
      categoryOptionTheme: 'text-orange-400 border border-orange-400',
      unlinkedCategoryOptionTheme: 'text-black border border-black',
      placeholder: 'placeholder:text-orange-400 lg:bg-blue-100'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      activeOptionTheme: 'bg-blue-100 text-blue-500',
      activeCategoryOptionTheme: 'bg-blue-400 !text-white border border-blue-400',
      categoryOptionTheme: 'text-blue-900 border border-blue-900',
      unlinkedCategoryOptionTheme: 'text-black border border-black',
      placeholder: 'placeholder:text-blue-900 focus:ring-yellow-500 lg:bg-blue-100'
    },
    nidwalden: {
      activeOptionTheme: 'bg-brown-100 text-brown-500',
      activeCategoryOptionTheme: 'bg-brown-500 !text-white border border-brown-500',
      categoryOptionTheme: 'text-brown-500 border border-brown-500',
      unlinkedCategoryOptionTheme: 'text-black border border-black',
      placeholder: 'placeholder:text-brown-900 focus:ring-brown-500 lg:bg-brown-100'
    }
  });

  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  const status = useOrganismStatus();
  return /*#__PURE__*/React.createElement(Combobox, {
    value: field.value,
    onChange: id => {
      if (id === field.value) {
        context.submitForm();
      }
      const [prefix, cat] = id.split(':');
      if (prefix === 'cat' && categoryDict[cat] && (suggestions || []).find(it => it.categoryName === cat)?.shouldBeLinked) {
        category.setValue(categoryDict[cat]);
        context.submitForm();
      }
      const selectedSuggestion = suggestionDict[id];
      selectedSuggestion?.Target?.navigate();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative w-full"
  }, /*#__PURE__*/React.createElement(Combobox.Input, {
    onChange: ev => {
      helpers.setValue(ev.target.value);
    },
    onKeyUp: ev => {
      if (ev.key === 'Enter') {
        context.submitForm();
      }
    },
    autoComplete: 'off',
    type: "text",
    name: "query",
    className: clsx(className, 'focus block h-10 w-full border border-r-0 border-grey-500 px-4 text-sm text-black focus:border-grey-500 focus-visible:border-grey-500 lg:border-0', theme.placeholder),
    placeholder: placeholderText || intl.formatMessage({
      id: "DX1ZtH",
      defaultMessage: [{
        "type": 0,
        "value": "Wonach suchen Sie?"
      }]
    })
  }), /*#__PURE__*/React.createElement(Combobox.Options, {
    className: "absolute right-0 z-50 mt-1 w-full cursor-pointer rounded-b-lg bg-white text-base drop-shadow-xl focus:outline-none sm:text-sm md:whitespace-nowrap lg:min-w-[600px]"
  }, suggestions && field.value ? /*#__PURE__*/React.createElement(Combobox.Option, {
    value: field.value,
    className: ({
      active
    }) => clsx('select-none border-b border-grey-100 py-2.5 px-4', active ? theme.activeOptionTheme : 'text-black')
  }, /*#__PURE__*/React.createElement(ArrowNarrowRightIcon, {
    className: 'mr-2 inline-block h-3 w-3'
  }), intl.formatMessage({
    id: "YBm10/",
    defaultMessage: [{
      "type": 0,
      "value": "Alle Ergebnisse zu \""
    }, {
      "type": 1,
      "value": "query"
    }, {
      "type": 0,
      "value": "\" zeigen."
    }]
  }, {
    query: field.value
  })) : null, status === 102 ? /*#__PURE__*/React.createElement(Combobox.Option, {
    value: '___',
    disabled: true,
    className: clsx('animate-pulse select-none border-b border-grey-100 py-2.5 px-4 text-grey-700')
  }, intl.formatMessage({
    id: "lPBNqB",
    defaultMessage: [{
      "type": 0,
      "value": "Lade Vorschläge ..."
    }]
  })) : null, suggestions?.map(group => /*#__PURE__*/React.createElement(React.Fragment, {
    key: group.id
  }, /*#__PURE__*/React.createElement(Combobox.Option, {
    value: `cat:${group.categoryName}`,
    className: clsx('border-b border-grey-100', !group.shouldBeLinked && 'cursor-default')
  }, ({
    active
  }) => /*#__PURE__*/React.createElement("span", {
    className: clsx('my-2 ml-4 inline-block select-none rounded px-2 pb-0.5 pt-1 transition', group.shouldBeLinked ? active ? theme.activeCategoryOptionTheme : theme.categoryOptionTheme : theme.unlinkedCategoryOptionTheme)
  }, group.categoryName)), group.results.map(result => /*#__PURE__*/React.createElement(Combobox.Option, {
    value: result.id,
    key: result.id,
    className: ({
      active
    }) => clsx('select-none whitespace-normal border-b border-grey-100 py-2.5 pl-8 pr-4', active ? theme.activeOptionTheme : 'text-black'),
    dangerouslySetInnerHTML: {
      __html: result.title.replace(new RegExp(`(${field.value})`, 'gi'), `<strong>$1</strong>`)
    }
  })))) || null)));
}

function MetaNavigationLink({
  item: {
    Link,
    title
  }
}) {
  return /*#__PURE__*/React.createElement(Link, {
    className: clsx('inline-block border-b border-white transition duration-300', useTheme({
      luzern: 'focus-luks hover:border-blue-900 hover:text-blue-500',
      nidwalden: 'focus-nidwalden hover:border-brown-900 hover:text-brown-500'
    }))
  }, title);
}
function MetaNavigation({
  items,
  EmergencyLink,
  EditLink,
  emergencyLinkText
}) {
  const intl = useIntl();
  const sticky = useShowStickyHeader();
  return /*#__PURE__*/React.createElement(Collapsible, {
    show: !sticky,
    delay: 0,
    fadeDuration: 200,
    scaleDuration: 200
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('flex items-center justify-end whitespace-nowrap pb-6')
  }, /*#__PURE__*/React.createElement("nav", {
    "aria-label": intl.formatMessage({
      id: "SFKE/e",
      defaultMessage: [{
        "type": 0,
        "value": "Meta-Navigation"
      }]
    })
  }, /*#__PURE__*/React.createElement("ul", {
    className: clsx('flex text-sm font-thin', useTheme({
      luzern: 'text-blue-900',
      nidwalden: 'text-brown-900'
    }))
  }, items.map((item, index) => /*#__PURE__*/React.createElement("li", {
    key: index,
    className: "mr-10"
  }, /*#__PURE__*/React.createElement(MetaNavigationLink, {
    item: item
  }))))), EmergencyLink && emergencyLinkText ? /*#__PURE__*/React.createElement(HeaderEmergency, {
    EmergencyLink: EmergencyLink,
    emergencyLinkText: emergencyLinkText
  }) : null, EditLink ? /*#__PURE__*/React.createElement(HeaderEdit, {
    EditLink: EditLink
  }) : null));
}
function MainNavigation({
  mainMenuItems,
  Logo: {
    Link
  }
}) {
  const intl = useIntl();
  const rootButtonTheme = useTheme({
    luzern: 'focus-luks hover:text-blue-500 hover:border-blue-900',
    nidwalden: 'focus-nidwalden hover:text-brown-500 hover:border-brown-900'
  });
  const rootButtonClasses = clsx(' pt-2 pb-0.5 inline-block border-white border-b-4 transition duration-300  whitespace-nowrap font-bold', rootButtonTheme);
  return /*#__PURE__*/React.createElement("nav", {
    "aria-label": intl.formatMessage({
      id: "k66zl8",
      defaultMessage: [{
        "type": 0,
        "value": "Hauptnavigation"
      }]
    })
  }, /*#__PURE__*/React.createElement("ul", {
    className: clsx('flex items-center font-bold xl:text-lg', useTheme({
      luzern: 'text-blue-900',
      nidwalden: 'text-brown-900'
    }))
  }, /*#__PURE__*/React.createElement("li", {
    className: "pr-4 xl:pr-8"
  }, /*#__PURE__*/React.createElement(Link, {
    className: clsx(' inline-block pt-2  transition duration-300', useTheme({
      luzern: 'focus-luks hover:text-blue-500',
      nidwalden: 'focus-nidwalden hover:text-brown-500'
    }))
  }, /*#__PURE__*/React.createElement(HomeIcon$1, {
    className: "h-[1.125rem]"
  }), /*#__PURE__*/React.createElement("span", {
    className: 'sr-only'
  }, intl.formatMessage({
    id: "1lDxGq",
    defaultMessage: [{
      "type": 0,
      "value": "Start page"
    }]
  })))), mainMenuItems.map(({
    title,
    Link,
    children
  }, index) => /*#__PURE__*/React.createElement("li", {
    key: index,
    className: "relative pr-4 xl:pr-8"
  }, !children || children.length === 0 ? /*#__PURE__*/React.createElement(Link, {
    className: rootButtonClasses
  }, title) : /*#__PURE__*/React.createElement(Popover, {
    className: "relative"
  }, /*#__PURE__*/React.createElement(Popover.Button, {
    className: rootButtonClasses
  }, title), /*#__PURE__*/React.createElement(Transition, {
    enter: "transition duration-100 ease-out",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "duration-75 ease-out",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/React.createElement(Popover.Panel, {
    tabIndex: -1,
    className: "absolute top-14 -left-8 z-10 w-[320px] rounded-b-md bg-white py-5 drop-shadow-xl"
  }, /*#__PURE__*/React.createElement(SlidingNavigationMenu, {
    items: children,
    fadeDuration: 300,
    scaleDuration: 300,
    parent: {
      title,
      Link
    }
  }))))))));
}
function HeaderEdit({
  EditLink
}) {
  return /*#__PURE__*/React.createElement(EditLink, {
    className: clsx('focus-luks mr-3 ml-2 flex items-center rounded-sm bg-blue-500 px-2 py-1 text-xs font-bold text-white md:text-sm lg:mr-0', useTheme({
      luzern: 'focus-luks',
      nidwalden: 'focus-nidwalden'
    }))
  }, /*#__PURE__*/React.createElement(PencilIcon, {
    className: "mr-1 h-3 md:h-4 lg:mr-2"
  }), "Bearbeiten");
}
function HeaderEmergency({
  EmergencyLink,
  emergencyLinkText
}) {
  return /*#__PURE__*/React.createElement(EmergencyLink, {
    className: clsx('focus-luks mr-3 flex items-center rounded-sm bg-red-500 px-2 py-1 text-xs font-bold text-white md:text-sm lg:mr-0', useTheme({
      luzern: 'focus-luks',
      nidwalden: 'focus-nidwalden'
    }))
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.0",
    viewBox: "0 0 66 66",
    className: "mr-1 h-3 md:h-4 lg:mr-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 23,0 0,23 -23,0 0,20 23,0 0,23 20,0 0,-23 23,0 0,-20 -23,0 0,-23 -20,0 z",
    style: {
      fill: 'white'
    }
  })), emergencyLinkText);
}
function HeaderLogo$1({
  Logo
}) {
  const groupTheme = useGroupTheme({
    kinderspital: {
      logo: /*#__PURE__*/React.createElement("img", {
        className: "w-[90%] pt-2 lg:w-[70%]",
        src: '/kinderspital-logo.svg',
        alt: 'Luzerner Kinderspital'
      }),
      subtitle: /*#__PURE__*/React.createElement("div", null)
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      logo: /*#__PURE__*/React.createElement("img", {
        src: '/luks-logo.svg',
        alt: 'Luzerner Kantonsspital'
      }),
      subtitle: /*#__PURE__*/React.createElement("img", {
        height: 9,
        width: 'auto',
        src: '/luks-subtitle.svg',
        alt: 'Luzern, Sursee, Wollhusen'
      })
    },
    nidwalden: {
      logo: /*#__PURE__*/React.createElement("img", {
        src: '/nidwalden-logo.svg',
        alt: 'Spital Nidwalden'
      }),
      subtitle: /*#__PURE__*/React.createElement("img", {
        height: 9,
        width: 'auto',
        src: '/nidwalden-subtitle.svg',
        alt: 'Ein Unternehmen der LUKS Gruppe'
      })
    },
    zskr: {
      logo: /*#__PURE__*/React.createElement("img", {
        className: 'h-16 w-auto',
        src: '/zskr-logo.svg',
        alt: 'Zentralschweizer Krebsregister'
      }),
      subtitle: /*#__PURE__*/React.createElement("div", null)
    }
  });

  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  return /*#__PURE__*/React.createElement(Logo.Link, {
    className: clsx('focus-luks md:mr-4 xl:mr-8', useTheme({
      luzern: 'focus-luks',
      nidwalden: 'focus-nidwalden'
    }))
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('flex max-w-[85%] flex-col', useGroupTheme({
      kinderspital: 'items-start'
    }) ?? 'items-end')
  }, theme.logo, /*#__PURE__*/React.createElement("div", {
    className: "max-w-[82%] pt-1"
  }, theme.subtitle), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, Logo.title)));
}
function HeaderSearchForm({
  SearchForm,
  suggestions
}) {
  const groupTheme = useGroupTheme({
    kinderspital: {
      button: 'bg-orange-400 text-white'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      button: 'focus-luks border-yellow-500 bg-yellow-500 text-blue-900 hover:bg-yellow-600'
    },
    nidwalden: {
      button: 'focus-nidwalden border-blue-950 bg-blue-950 text-blue-950 !text-white hover:bg-blue-960'
    }
  });

  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  if (!SearchForm) {
    return null;
  }
  return /*#__PURE__*/React.createElement(SearchForm, {
    className: "flex min-w-[210px]"
  }, /*#__PURE__*/React.createElement(SearchCombobox, {
    className: 'header-search-input',
    suggestions: suggestions
  }), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: clsx('h-10 w-12  border transition lg:border-0', theme.button)
  }, /*#__PURE__*/React.createElement(SearchIcon, {
    className: "mx-auto h-6"
  }), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Suchen")));
}
function useShowStickyHeader() {
  const [show, setShow] = useState(false);
  // height difference between Header wide and Header shrink
  const heightDifference = 150 - 98;
  const limit = 100;
  useEffect(() => {
    function handleUpdate() {
      if (show && window.scrollY < limit) {
        setShow(false);
      }
      if (!show && window.scrollY > limit + heightDifference) {
        setShow(true);
      }
    }
    handleUpdate();
    window.addEventListener('scroll', handleUpdate);
    return () => window.removeEventListener('scroll', handleUpdate);
  }, [show, setShow, heightDifference]);
  return show;
}
function ScrollIndicator() {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [fullHeight, setFullHeight] = useState(0);
  const [scroll, setScroll] = useState(0);
  useEffect(() => {
    function handleUpdate() {
      setWidth(window.document.body.offsetWidth);
      setHeight(window.innerHeight);
      setFullHeight(window.document.body.offsetHeight);
      setScroll(window.scrollY);
    }
    handleUpdate();
    window.addEventListener('scroll', handleUpdate);
    window.addEventListener('resize', handleUpdate);
    return () => {
      window.removeEventListener('scroll', handleUpdate);
      window.removeEventListener('resize', handleUpdate);
    };
  }, [setWidth, setHeight, setScroll]);
  const percentage = fullHeight - height > 0 ? scroll / (fullHeight - height) * width : 0;
  const groupTheme = useGroupTheme({
    kinderspital: {
      default: 'bg-orange-400',
      progress: 'bg-blue-900'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      default: 'bg-blue-900',
      progress: 'bg-yellow-500'
    },
    nidwalden: {
      default: 'bg-brown-900',
      progress: 'bg-brown-400'
    }
  });

  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('absolute bottom-0 left-0 h-1 w-full delay-500 duration-500', theme.default)
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: percentage
    },
    className: clsx('h-full', theme.progress)
  }));
}
function MenuItemTransition({
  children,
  fadeDuration,
  scaleDuration
}) {
  const {
    expanded
  } = useContext(MenuTreeContext);
  return /*#__PURE__*/React.createElement(Collapsible, {
    show: !expanded,
    delay: !expanded ? fadeDuration : 0,
    fadeDuration: fadeDuration,
    scaleDuration: scaleDuration
  }, children);
}
function SubmenuTransition({
  children,
  show,
  fadeDuration,
  scaleDuration
}) {
  const {
    setExpanded
  } = useContext(MenuTreeContext);
  return /*#__PURE__*/React.createElement(Collapsible, {
    show: show,
    delay: !show ? 0 : fadeDuration,
    fadeDuration: fadeDuration,
    scaleDuration: scaleDuration,
    beforeEnter: () => {
      setExpanded(true);
    },
    beforeLeave: () => {
      setExpanded(false);
    }
  }, children);
}
const MenuTreeContext = /*#__PURE__*/React.createContext({
  expanded: false,
  setExpanded: () => undefined
});
function MenuTreeWRapper({
  children
}) {
  const [expanded, setExpanded] = useState(false);
  return /*#__PURE__*/React.createElement(MenuTreeContext.Provider, {
    value: {
      expanded,
      setExpanded
    }
  }, children);
}
function MobileSlidingNavigationMenu({
  items,
  itemsSecondary,
  parent,
  className,
  grandParent,
  ...rest
}) {
  const menuItemClasses = 'lg:px-8';
  const intl = useIntl();
  const focusMainItems = useTheme({
    luzern: 'focus-luks text-blue-900 ',
    nidwalden: 'focus-nidwalden text-brown-900'
  });
  const focusSecondaryItems = useTheme({
    luzern: 'focus-luks',
    nidwalden: 'focus-nidwalden'
  });
  return /*#__PURE__*/React.createElement(MenuTreeWRapper, null, /*#__PURE__*/React.createElement("ul", {
    className: clsx('text-base font-normal', className)
  }, parent ? /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(MenuItemTransition, rest, /*#__PURE__*/React.createElement(Disclosure.Button, {
    className: clsx('flex w-full max-w-full items-center py-3 text-left', menuItemClasses, focusMainItems)
  }, /*#__PURE__*/React.createElement(ArrowLeftIcon, {
    className: 'mr-3 h-5 w-5'
  }), grandParent ? grandParent.title : intl.formatMessage({
    id: "jL30Hu",
    defaultMessage: [{
      "type": 0,
      "value": "Hauptmenü"
    }]
  })))) : null, parent ? /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(MenuItemTransition, rest, /*#__PURE__*/React.createElement(parent.Link, {
    className: clsx('block w-full max-w-full py-3 font-bold last:border-0', menuItemClasses, focusMainItems)
  }, parent.title))) : null, items.map((currentItem, index) => /*#__PURE__*/React.createElement("li", {
    key: index
  }, currentItem.children && currentItem.children.length > 0 ? /*#__PURE__*/React.createElement(Disclosure, null, ({
    open
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuItemTransition, rest, /*#__PURE__*/React.createElement(Disclosure.Button, {
    className: clsx('flex w-full max-w-full items-center justify-between py-3 text-left', menuItemClasses, {
      'font-bold': !parent
    }, focusMainItems)
  }, currentItem.title, /*#__PURE__*/React.createElement(ArrowRightIcon, {
    className: 'h-5 w-5'
  }))), /*#__PURE__*/React.createElement(SubmenuTransition, _extends({
    show: open
  }, rest), /*#__PURE__*/React.createElement(Disclosure.Panel, null, /*#__PURE__*/React.createElement(MobileSlidingNavigationMenu, _extends({}, rest, {
    items: currentItem.children || [],
    parent: currentItem,
    grandParent: parent
  })))))) : /*#__PURE__*/React.createElement(MenuItemTransition, rest, /*#__PURE__*/React.createElement(currentItem.Link, {
    className: clsx('block w-full max-w-full py-3', menuItemClasses, focusMainItems)
  }, currentItem.title)))), itemsSecondary ? itemsSecondary.map((currentItem, index) => /*#__PURE__*/React.createElement("li", {
    key: index,
    className: clsx('py-3 lg:px-8', {
      'pt-5': index === 0
    })
  }, /*#__PURE__*/React.createElement(MenuItemTransition, rest, index === 0 ? /*#__PURE__*/React.createElement("div", {
    className: 'mb-7 border-t border-grey-500'
  }) : null, /*#__PURE__*/React.createElement(currentItem.Link, {
    className: clsx('block w-full max-w-full text-grey-700', focusSecondaryItems)
  }, currentItem.title)))) : null));
}
function SlidingNavigationMenu({
  items,
  parent,
  grandParent,
  className,
  ...rest
}) {
  const intl = useIntl();
  const parentHasLink = !!(parent && parent.Link && parent.Link.href);
  const defaultMenuItemClasses = 'lg:px-8 hover:bg-blue-100';
  const disabledMenuItemClasses = 'lg:px-8 !text-black';
  const parentMenuItemClasses = parentHasLink ? defaultMenuItemClasses : disabledMenuItemClasses;
  const focusMainItems = useTheme({
    luzern: 'focus-luks text-blue-900 ',
    nidwalden: 'focus-nidwalden text-brown-900'
  });

  // @ts-ignore
  const ParentLinkWrapper = parentHasLink ? parent.Link : ({
    className,
    children
  }) => /*#__PURE__*/React.createElement("span", {
    className: className
  }, children);
  return /*#__PURE__*/React.createElement(MenuTreeWRapper, null, /*#__PURE__*/React.createElement("ul", {
    className: clsx('text-base font-normal', className)
  }, grandParent ? /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(MenuItemTransition, rest, /*#__PURE__*/React.createElement(Disclosure.Button, {
    className: clsx('flex w-full max-w-full items-center py-3 text-left', defaultMenuItemClasses, focusMainItems)
  }, /*#__PURE__*/React.createElement(ArrowLeftIcon, {
    className: 'mr-3 h-5 w-5'
  }), grandParent ? grandParent.title : intl.formatMessage({
    id: "jL30Hu",
    defaultMessage: [{
      "type": 0,
      "value": "Hauptmenü"
    }]
  })))) : null, parent ? /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(MenuItemTransition, rest, /*#__PURE__*/React.createElement(ParentLinkWrapper, {
    className: clsx('block w-full max-w-full py-3 font-bold last:border-0', parentMenuItemClasses, focusMainItems)
  }, parent.title))) : null, items.map((currentItem, index) => /*#__PURE__*/React.createElement("li", {
    key: index
  }, currentItem.children && currentItem.children.length > 0 ? /*#__PURE__*/React.createElement(Disclosure, null, ({
    open
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuItemTransition, rest, /*#__PURE__*/React.createElement(Disclosure.Button, {
    className: clsx('flex w-full max-w-full items-center justify-between py-3 text-left', defaultMenuItemClasses, focusMainItems)
  }, currentItem.title, /*#__PURE__*/React.createElement(ArrowRightIcon, {
    className: 'h-5 w-5'
  }))), /*#__PURE__*/React.createElement(SubmenuTransition, _extends({
    show: open
  }, rest), /*#__PURE__*/React.createElement(Disclosure.Panel, null, /*#__PURE__*/React.createElement(SlidingNavigationMenu, _extends({}, rest, {
    items: currentItem.children || [],
    parent: currentItem,
    grandParent: parent
  })))))) : /*#__PURE__*/React.createElement(MenuItemTransition, rest, currentItem.Link && currentItem.Link.href ? /*#__PURE__*/React.createElement(currentItem.Link, {
    className: clsx('block w-full max-w-full py-3', defaultMenuItemClasses, focusMainItems)
  }, currentItem.title) : /*#__PURE__*/React.createElement("span", {
    className: clsx('block w-full max-w-full py-3', disabledMenuItemClasses, focusMainItems)
  }, currentItem.title))))));
}
function MobileNavigation({
  mainMenuItems,
  metaMenuItems
}) {
  return /*#__PURE__*/React.createElement(MobileSlidingNavigationMenu, {
    scaleDuration: 100,
    fadeDuration: 200,
    className: 'mt-5',
    items: mainMenuItems,
    itemsSecondary: metaMenuItems
  });
}
function Header({
  Logo,
  metaMenuItems,
  mainMenuItems,
  SearchForm,
  EmergencyLink,
  EditLink,
  emergencyLinkText,
  suggestions
}) {
  const intl = useIntl();
  const sticky = useShowStickyHeader();
  return /*#__PURE__*/React.createElement("div", {
    className: "sticky top-0 z-40"
  }, /*#__PURE__*/React.createElement("button", {
    tabIndex: 2,
    className: clsx(useTheme({
      luzern: 'skip-link-luks',
      nidwalden: 'skip-link-nidwalden'
    })),
    onClick: () => {
      document.getElementById('header-search')?.focus();
    }
  }, intl.formatMessage({
    id: "LYhHt2",
    defaultMessage: [{
      "type": 0,
      "value": "Direkt zur Suche"
    }]
  })), /*#__PURE__*/React.createElement("div", {
    className: clsx('container-page bg-white pt-2 transition-all duration-[600ms]', {
      'pb-4': sticky,
      'pb-6': !sticky
    })
  }, /*#__PURE__*/React.createElement(Popover, null, /*#__PURE__*/React.createElement(Transition, {
    enter: "transition duration-300 ease-out",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "duration-75 ease-out",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/React.createElement(Popover.Panel, {
    tabIndex: -1,
    className: "fixed inset-0 z-10 overflow-y-auto bg-white"
  }, /*#__PURE__*/React.createElement(BodyClassName, {
    className: 'h-screen overflow-hidden'
  }), /*#__PURE__*/React.createElement("div", {
    className: clsx('container-content mb-5 flex items-end justify-between px-4 pt-2 pb-5', useTheme({
      luzern: 'bg-blue-100',
      nidwalden: 'bg-brown-100'
    }))
  }, /*#__PURE__*/React.createElement(HeaderLogo$1, {
    Logo: Logo
  }), /*#__PURE__*/React.createElement("div", {
    className: 'flex items-center'
  }, EmergencyLink && emergencyLinkText ? /*#__PURE__*/React.createElement(HeaderEmergency, {
    EmergencyLink: EmergencyLink,
    emergencyLinkText: emergencyLinkText
  }) : null, /*#__PURE__*/React.createElement("button", {
    className: 'focus mr-1 block py-0.5 pr-0.5',
    onClick: () => {
      setTimeout(() => {
        const inputSearch = document.getElementsByClassName('header-search-input');
        inputSearch[0]?.setAttribute('autofocus', 'autofocus');
        inputSearch[0]?.focus();
      }, 500);
    }
  }, /*#__PURE__*/React.createElement(SearchIcon, {
    className: "h-6 w-6"
  })), /*#__PURE__*/React.createElement(Popover.Button, {
    "aria-label": intl.formatMessage({
      id: "ElXe9Q",
      defaultMessage: [{
        "type": 0,
        "value": "Hide mobile navigation"
      }]
    })
  }, /*#__PURE__*/React.createElement(XIcon, {
    className: 'h-8 w-8'
  })))), /*#__PURE__*/React.createElement("div", {
    className: 'px-4'
  }, /*#__PURE__*/React.createElement(HeaderSearchForm, {
    SearchForm: SearchForm,
    suggestions: suggestions
  }), /*#__PURE__*/React.createElement(MobileNavigation, {
    mainMenuItems: mainMenuItems,
    metaMenuItems: metaMenuItems
  })))), /*#__PURE__*/React.createElement("div", {
    className: "container-content flex items-end justify-between lg:items-center",
    id: "header-logo"
  }, /*#__PURE__*/React.createElement(HeaderLogo$1, {
    Logo: Logo
  }), useActiveTheme() !== 'zskr' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "ml-4 hidden pt-2 md:ml-8 lg:block"
  }, /*#__PURE__*/React.createElement(MetaNavigation, {
    items: metaMenuItems,
    EmergencyLink: EmergencyLink,
    EditLink: EditLink,
    emergencyLinkText: emergencyLinkText
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement(MainNavigation, {
    mainMenuItems: mainMenuItems,
    Logo: Logo
  }), /*#__PURE__*/React.createElement(HeaderSearchForm, {
    SearchForm: SearchForm,
    suggestions: suggestions
  }))), /*#__PURE__*/React.createElement("div", {
    className: 'flex items-center lg:hidden'
  }, EmergencyLink && emergencyLinkText ? /*#__PURE__*/React.createElement(HeaderEmergency, {
    EmergencyLink: EmergencyLink,
    emergencyLinkText: emergencyLinkText
  }) : null, /*#__PURE__*/React.createElement(Popover.Button, {
    "aria-label": intl.formatMessage({
      id: "1EpV3W",
      defaultMessage: [{
        "type": 0,
        "value": "Open mobile navigation and focus Search input"
      }]
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: 'focus mr-1.5 block py-1',
    onClick: () => {
      setTimeout(() => {
        const inputSearch = document.getElementsByClassName('header-search-input');
        inputSearch[0]?.setAttribute('autofocus', 'autofocus');
        inputSearch[0]?.focus();
      }, 500);
    }
  }, /*#__PURE__*/React.createElement(SearchIcon, {
    className: "h-6 w-6"
  }))), /*#__PURE__*/React.createElement(Popover.Button, {
    "aria-label": intl.formatMessage({
      id: "5DT7Ca",
      defaultMessage: [{
        "type": 0,
        "value": "Show mobile navigation"
      }]
    })
  }, /*#__PURE__*/React.createElement(MenuAlt1Icon, {
    className: "h-8 w-8"
  }))))))), /*#__PURE__*/React.createElement(ScrollIndicator, null));
}

function HeaderSpecialist({
  name,
  Image,
  degree,
  description,
  breadcrumbItems,
  HomeLink,
  gender
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'container-page'
  }, breadcrumbItems?.length ? /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement(Breadcrumb.Wrapper, {
    className: 'my-3 md:my-5'
  }, HomeLink ? /*#__PURE__*/React.createElement(Breadcrumb.HomeItem, {
    Link: HomeLink
  }) : null, breadcrumbItems.map((item, index) => /*#__PURE__*/React.createElement(Breadcrumb.Item, _extends({
    key: index
  }, item))))) : null), /*#__PURE__*/React.createElement("div", {
    className: 'lg:container-page max-w-full overflow-x-hidden'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'relative'
  }, Image ? /*#__PURE__*/React.createElement(Image, {
    className: 'h-full max-h-[590px]  w-full object-cover object-center'
  }) : /*#__PURE__*/React.createElement("div", {
    className: "aspect-[1920/823] max-h-[590px] w-full",
    style: {
      background: `url(${gender === 'male' ? '/dummy-male-landscape.jpg' : '/dummy-female-landscape.jpg'}) no-repeat center`,
      backgroundSize: 'cover'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: 'w-full text-white md:absolute md:top-1/2 md:-translate-y-1/2 xl:left-10'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'mt-5 md:mt-0 md:max-w-md lg:max-w-lg xl:max-w-3xl'
  }, /*#__PURE__*/React.createElement("h1", {
    className: clsx(useTheme({
      luzern: 'text-black',
      nidwalden: 'text-brown-900 md:text-black'
    }))
  }, /*#__PURE__*/React.createElement("span", {
    className: 'mb-1 block text-xl font-bold md:text-2xl lg:mb-3 lg:text-3xl xl:text-4xl'
  }, degree), /*#__PURE__*/React.createElement("span", {
    className: 'block text-3xl font-bold md:text-4xl lg:text-4xl xl:text-6xl'
  }, name), /*#__PURE__*/React.createElement("span", {
    className: 'mt-1 block text-lg font-thin md:mt-2 md:text-xl lg:mt-5 lg:text-2xl xl:text-3xl'
  }, description)))))))));
}

function HeaderLogo({
  Logo
}) {
  return /*#__PURE__*/React.createElement(Logo.Link, {
    className: clsx('focus-luks mr-8 flex flex-col items-end', useTheme({
      luzern: 'focus-luks',
      nidwalden: 'focus-nidwalden'
    }))
  }, useTheme({
    luzern: /*#__PURE__*/React.createElement("img", {
      src: '/luks-logo.svg',
      alt: 'Luzerner Kantonsspital'
    }),
    nidwalden: /*#__PURE__*/React.createElement("img", {
      src: '/nidwalden-logo.svg',
      alt: 'Spital Nidwalden'
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: "pt-1"
  }, useTheme({
    luzern: /*#__PURE__*/React.createElement("img", {
      height: 9,
      width: 'auto',
      src: '/luks-subtitle.svg',
      alt: 'Luzern, Sursee, Wollhusen'
    }),
    nidwalden: /*#__PURE__*/React.createElement("img", {
      height: 9,
      width: 'auto',
      src: '/nidwalden-subtitle.svg',
      alt: 'Ein Unternehmen der LUKS Gruppe'
    })
  })), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, Logo.title));
}
function ScrollIndicatorDup() {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [fullHeight, setFullHeight] = useState(0);
  const [scroll, setScroll] = useState(0);
  useEffect(() => {
    function handleUpdate() {
      setWidth(window.document.body.offsetWidth);
      setHeight(window.innerHeight);
      setFullHeight(window.document.body.offsetHeight);
      setScroll(window.scrollY);
    }
    handleUpdate();
    window.addEventListener('scroll', handleUpdate);
    window.addEventListener('resize', handleUpdate);
    return () => {
      window.removeEventListener('scroll', handleUpdate);
      window.removeEventListener('resize', handleUpdate);
    };
  }, [setWidth, setHeight, setScroll]);
  const percentage = fullHeight - height > 0 ? scroll / (fullHeight - height) * width : 0;
  const groupTheme = useGroupTheme({
    kinderspital: {
      default: 'bg-orange-400',
      progress: 'bg-blue-900'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      default: 'bg-blue-900',
      progress: 'bg-yellow-500'
    },
    nidwalden: {
      default: 'bg-brown-900',
      progress: 'bg-brown-400'
    }
  });

  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('absolute bottom-0 left-0 h-1 w-full delay-500 duration-500', theme.default)
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: percentage
    },
    className: clsx('h-full', theme.progress)
  }));
}
function HeaderWithLogo({
  Logo
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "sticky top-0 z-40"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-page bg-white pt-2 pb-4"
  }, /*#__PURE__*/React.createElement(Popover, null, /*#__PURE__*/React.createElement(Transition, {
    enter: "transition duration-100 ease-out",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "duration-75 ease-out",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/React.createElement(Popover.Panel, {
    className: "fixed inset-0 z-10 overflow-y-auto bg-white"
  }, /*#__PURE__*/React.createElement(BodyClassName, {
    className: 'h-screen overflow-hidden'
  }), /*#__PURE__*/React.createElement("div", {
    className: clsx('container-content mb-5 flex items-end justify-between px-4 pt-2 pb-5', useTheme({
      luzern: 'bg-blue-100',
      nidwalden: 'bg-brown-100'
    }))
  }, /*#__PURE__*/React.createElement(HeaderLogo, {
    Logo: Logo
  })))), /*#__PURE__*/React.createElement("div", {
    className: "container-content flex items-end justify-between lg:items-center"
  }, /*#__PURE__*/React.createElement(HeaderLogo, {
    Logo: Logo
  })))), /*#__PURE__*/React.createElement(ScrollIndicatorDup, null));
}

function YesButton() {
  const groupTheme = useGroupTheme({
    kinderspital: {
      default: 'bg-orange-400 hover:bg-orange-300'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      default: 'ring-yellow-900 bg-blue-900 hover:bg-blue-400'
    },
    nidwalden: {
      default: 'bg-brown-900 ring-brown-900 hover:bg-brown-400 focus:outline'
    }
  });

  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  const formik = useFormikContext();
  return /*#__PURE__*/React.createElement("button", {
    type: "submit",
    "aria-label": 'War diese Seite hilfreich? Ja',
    disabled: formik.isSubmitting,
    onClick: () => {
      formik.setFieldValue('wasHelpful', true);
    },
    className: clsx('block h-20 w-20 rounded-full text-xl font-bold leading-6 text-white ring-offset-2 ring-offset-white duration-300 ease-in-out focus:outline-none focus-visible:ring-2 md:ml-6', theme.default)
  }, "Ja");
}
function NoButton() {
  const groupTheme = useGroupTheme({
    kinderspital: {
      default: 'bg-orange-400 hover:bg-orange-300'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      default: 'ring-yellow-900 bg-blue-900 hover:bg-blue-400'
    },
    nidwalden: {
      default: 'bg-brown-900 ring-brown-900 hover:bg-brown-400 focus:outline'
    }
  });

  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  const formik = useFormikContext();
  return /*#__PURE__*/React.createElement("button", {
    type: "submit",
    "aria-label": 'War diese Seite hilfreich? Nein',
    onClick: () => {
      formik.setFieldValue('wasHelpful', false);
    },
    className: clsx('block h-20 w-20 rounded-full text-xl font-bold leading-6 text-white ring-offset-2 ring-offset-white duration-300 ease-in-out focus:outline-none focus-visible:ring-2', theme.default)
  }, "Nein");
}
var HelpfulnessState;
(function (HelpfulnessState) {
  HelpfulnessState[HelpfulnessState["feedback"] = 0] = "feedback";
  HelpfulnessState[HelpfulnessState["comment"] = 1] = "comment";
  HelpfulnessState[HelpfulnessState["loading"] = 2] = "loading";
  HelpfulnessState[HelpfulnessState["done"] = 3] = "done";
})(HelpfulnessState || (HelpfulnessState = {}));
function Feedback({
  FeedbackForm
}) {
  const groupTheme = useGroupTheme({
    kinderspital: {
      default: 'text-orange-400'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      default: 'text-blue-900'
    },
    nidwalden: {
      default: 'text-2xl font-bold text-brown-900'
    }
  });

  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  return /*#__PURE__*/React.createElement(FeedbackForm, null, /*#__PURE__*/React.createElement("div", {
    className: "helpfulness my-20 md:flex md:items-center md:justify-center"
  }, /*#__PURE__*/React.createElement("h3", {
    className: clsx('mb-4 text-center text-2xl font-bold md:mb-0 md:text-left', theme.default)
  }, "War diese Seite hilfreich?"), /*#__PURE__*/React.createElement("div", {
    className: 'flex items-center justify-center gap-6'
  }, /*#__PURE__*/React.createElement(YesButton, null), /*#__PURE__*/React.createElement(NoButton, null))));
}
function Comment() {
  const {
    errors
  } = useFormikContext();
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('container-page block py-10 md:py-20', useTheme({
      luzern: 'bg-blue-100',
      nidwalden: 'bg-brown-100'
    }))
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid gap-14 md:grid-cols-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'form-item'
  }, /*#__PURE__*/React.createElement("p", {
    className: 'mb-6'
  }, "1. Weshalb ist die Website nicht hilfreich? Das Kontaktformular ist nicht f\xFCr medizinische Auskunft gedacht. Wenn Sie medizinische Fragen haben, nehmen Sie bitte direkt mit der entsprechenden Abteilung Kontakt auf."), /*#__PURE__*/React.createElement(Field, {
    component: "textarea",
    rows: 10,
    title: "comment",
    name: "comment",
    placeholder: "Geben Sie uns Ihr Feedback hier",
    className: 'field w-full border border-solid'
  })), /*#__PURE__*/React.createElement("div", {
    className: 'form-item'
  }, /*#__PURE__*/React.createElement("p", {
    className: 'mb-8'
  }, "2. Bitte geben Sie Ihre E-mail-Adresse an, damit wir Sie bei R\xFCckfragen kontaktieren k\xF6nnen."), /*#__PURE__*/React.createElement("label", {
    className: "label block",
    htmlFor: 'email'
  }, "E-Mail-Adresse"), /*#__PURE__*/React.createElement(Field, {
    name: "email",
    type: "text",
    title: "email",
    className: 'field mb-3 block w-full'
  }), errors.email ? /*#__PURE__*/React.createElement("div", {
    className: "text-xs text-red-500"
  }, "Ung\xFCltige E-Mail Adresse.") : null, /*#__PURE__*/React.createElement("div", {
    className: 'form-actions'
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: 'button-primary mt-6'
  }, "Senden"))))));
}
function ThankYou() {
  const groupTheme = useGroupTheme({
    kinderspital: {
      default: 'text-orange-400'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      default: 'text-blue-900'
    },
    nidwalden: {
      default: 'text-2xl font-bold text-brown-900'
    }
  });

  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  return /*#__PURE__*/React.createElement("h2", {
    className: clsx('my-20 flex h-20 items-center justify-center text-center text-2xl font-bold md:text-left', theme.default)
  }, "Vielen Dank f\xFCr Ihr Feedback!");
}
function Step({
  children,
  state
}) {
  const currentStatus = useOrganismStatus();
  return currentStatus === state ? /*#__PURE__*/React.createElement(React.Fragment, null, children) : null;
}
function Helpfulness({
  FeedbackForm,
  CommentForm
}) {
  const theme = useActiveTheme();
  if (theme === 'zskr') {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Step, {
    state: HelpfulnessState.feedback
  }, /*#__PURE__*/React.createElement(Feedback, {
    FeedbackForm: FeedbackForm
  })), /*#__PURE__*/React.createElement(Step, {
    state: HelpfulnessState.comment
  }, /*#__PURE__*/React.createElement(CommentForm, null, /*#__PURE__*/React.createElement(Comment, null))), /*#__PURE__*/React.createElement(Step, {
    state: HelpfulnessState.loading
  }, /*#__PURE__*/React.createElement(Loader, null)), /*#__PURE__*/React.createElement(Step, {
    state: HelpfulnessState.done
  }, /*#__PURE__*/React.createElement(ThankYou, null)));
}

function HeroSection({
  isHomepage,
  isTaller = false,
  Title,
  Description,
  CallToAction,
  videoUrl,
  isRemoteVideo,
  Image
}) {
  const overlayTheme = useTheme({
    luzern: 'from-[#093667]',
    nidwalden: 'from-brown-900'
  });
  let videoURLID = '';

  // Only allowing Vimeo. If YouTube is requested, update this.
  if (videoUrl && isRemoteVideo) {
    const regex =
    // From https://stackoverflow.com/a/13286930/580371
    /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
    videoURLID = regex.exec(videoUrl)?.[3] || '';
  }
  return /*#__PURE__*/React.createElement("div", {
    className: clsx({
      relative: isHomepage,
      'lg:mb-10': !isHomepage
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: 'relative h-full'
  }, Image && !videoUrl ? /*#__PURE__*/React.createElement(Image, {
    className: clsx('h-full min-h-[220px]  w-full object-cover object-center', {
      'max-h-[810px]': isTaller,
      'max-h-[590px]': !isTaller
    })
  }) : null, videoUrl && !isRemoteVideo ? /*#__PURE__*/React.createElement("video", {
    className: clsx(' h-full min-h-[220px] w-full object-cover object-center transition duration-1000 ease-out', {
      'max-h-[810px]': isTaller,
      'max-h-[600px]': !isTaller
    }),
    width: "100%",
    height: "100%",
    autoPlay: true,
    loop: true,
    muted: true,
    playsInline: true
  }, /*#__PURE__*/React.createElement("source", {
    src: videoUrl,
    type: 'video/mp4'
  })) : null, videoUrl && isRemoteVideo && videoURLID ? /*#__PURE__*/React.createElement("div", {
    className: clsx('overflow-hidden', {
      'max-h-[810px]': isTaller,
      'max-h-[600px]': !isTaller
    })
  }, /*#__PURE__*/React.createElement("iframe", {
    src: 'https://player.vimeo.com/video/' + videoURLID + '?muted=1&autoplay=1&dnt=1&background=1&loop=1',
    className: "relative h-full min-h-[calc(100vw_/_16_*_9)] w-full transition duration-1000 ease-out lg:-top-2 xl:top-2/4 xl:translate-y-[-10vw]",
    width: "100%",
    height: "100%",
    frameBorder: "0",
    allow: "autoplay; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; background",
    scrolling: "no"
  })) : null, isHomepage ? /*#__PURE__*/React.createElement("div", {
    className: clsx('absolute top-0 left-0 h-full w-full bg-gradient-to-r to-transparent opacity-0 md:opacity-50', overlayTheme)
  }) : null), /*#__PURE__*/React.createElement("div", {
    className: clsx('container-page', {
      'mt-8 w-full text-white md:absolute md:top-1/2 md:left-1/2 md:mt-0 md:-translate-y-1/2 md:-translate-x-1/2': isHomepage
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('container-content', {
      'relative z-10 -mt-14 -mt-14 bg-white p-5 text-center md:-mt-20 md:p-10 lg:px-20': !isHomepage
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx({
      'md:mt-0 md:max-w-md lg:max-w-lg xl:max-w-3xl': isHomepage
    }, {
      'mx-auto': !isHomepage
    })
  }, /*#__PURE__*/React.createElement("h1", {
    className: clsx('text-3xl', {
      'font-thin': isHomepage,
      'font-bold': !isHomepage
    }, useTheme({
      luzern: `${isHomepage && 'md:text-white'}`,
      nidwalden: `text-brown-900 ${isHomepage && 'md:text-white'}`
    }), {
      'md:text-4xl lg:text-4xl xl:text-6xl': isHomepage,
      'lg:text-5xl': !isHomepage
    })
  }, /*#__PURE__*/React.createElement(Title, {
    classNames: {
      strong: 'font-bold'
    }
  })), Description ? /*#__PURE__*/React.createElement("div", {
    className: clsx('container-text mt-6 text-lg lg:text-2xl', {
      'text-black md:text-white': isHomepage
    }, {
      '!leading-[1.75]': !isHomepage
    })
  }, /*#__PURE__*/React.createElement(Description, null)) : null, CallToAction ? /*#__PURE__*/React.createElement(CallToAction.Link, {
    className: clsx('button-primary mt-6')
  }, CallToAction.title) : null))));
}

function HighlightTeaser({
  Image,
  title,
  date,
  Link
}) {
  const intl = useIntl();
  const LinkTheme = useTheme({
    luzern: ' focus-luks',
    nidwalden: 'focus-nidwalden'
  });
  const Wrapper = Link || (({
    className,
    children
  }) => /*#__PURE__*/React.createElement("span", {
    className: className
  }, children));
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: clsx('group relative block rounded-md', LinkTheme)
  }, Image ? /*#__PURE__*/React.createElement("div", {
    className: 'aspect-w-3 aspect-h-4 relative block overflow-hidden rounded-t-md md:aspect-w-2 md:aspect-h-1'
  }, /*#__PURE__*/React.createElement(Image, {
    className: clsx('block w-full max-w-full object-cover transition duration-300', Link && 'group-hover:scale-105')
  }), /*#__PURE__*/React.createElement("div", {
    className: "absolute h-full w-full bg-gradient-to-b from-transparent via-transparent to-grey-900"
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('absolute h-full w-full bg-transparent opacity-50 transition-all')
  }))) : null, /*#__PURE__*/React.createElement("div", {
    className: 'absolute bottom-0 p-7 text-white'
  }, date ? /*#__PURE__*/React.createElement("div", {
    className: 'mb-2.5 flex items-center text-sm uppercase'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'mr-3'
  }, intl.formatDate(date, {
    dateStyle: 'medium'
  })), ' ') : null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    className: clsx('text-xl font-bold transition')
  }, title))));
}

function HomeGridTeaser({
  title,
  teasers,
  Link
}) {
  const intl = useIntl();
  if (!teasers.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement("section", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content my-20'
  }, /*#__PURE__*/React.createElement("h2", {
    className: 'section-title mb-2 text-center md:mb-3'
  }, title || intl.formatMessage({
    id: "VebT7x",
    defaultMessage: [{
      "type": 0,
      "value": "News & Stories"
    }]
  })), /*#__PURE__*/React.createElement("div", {
    className: 'flex-wrap md:-mx-3 md:flex lg:-mx-5'
  }, teasers.map((teaser, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: clsx('mb-5 last:mb-0 md:mb-0 md:p-3 lg:p-5', {
      'md:w-full lg:w-2/3': index === 0,
      'md:w-1/2 lg:w-1/3': index !== 0
    })
  }, index === 0 ? /*#__PURE__*/React.createElement(HighlightTeaser, teaser) : /*#__PURE__*/React.createElement(Teaser, teaser)))), /*#__PURE__*/React.createElement("div", {
    className: 'mt-10 text-center'
  }, Link && /*#__PURE__*/React.createElement(Link, {
    className: 'button-primary'
  }, intl.formatMessage({
    id: "S7Sa+3",
    defaultMessage: [{
      "type": 0,
      "value": "Zur Newsübersicht"
    }]
  })))));
}

function ImageCarousel({
  display,
  images,
  lightboxImages,
  title
}) {
  const [descriptionSwiperRef, setDescriptionSwiperRef] = useState();
  const [loopIndex, setLoopIndex] = useState(0);
  const [lightboxController, setLightboxController] = useState({
    toggler: false,
    slide: 1
  });
  const theme = useTheme({
    luzern: 'text-black',
    nidwalden: 'text-brown-900'
  });
  if (!images.length) {
    return null;
  }
  const loopLength = images.length;
  const hasDescription = images[loopIndex].description ? true : false;
  function openLightboxOnSlide(number) {
    setLightboxController({
      toggler: !lightboxController.toggler,
      slide: number
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('my-10', display)
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-text"
  }, display === 'grid' ? images.length > 2 && images.length < 5 ? /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-2 gap-1 md:gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid-auto-rows grid grid-cols-1 gap-1 md:gap-4"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: () => openLightboxOnSlide(1)
  }, /*#__PURE__*/React.createElement("img", {
    src: images[0].Image.src,
    alt: "Image 1",
    className: "h-full w-full object-cover"
  }))), /*#__PURE__*/React.createElement("div", {
    className: 'grid grid-cols-1 gap-4'
  }, images.map((image, index) => index === 0 ? null : /*#__PURE__*/React.createElement("button", {
    onClick: () => openLightboxOnSlide(index + 1),
    key: index
  }, /*#__PURE__*/React.createElement("img", {
    src: image.Image.src,
    alt: `Image ${index + 1}`,
    className: `h-full w-full object-cover ${images.length === 3 ? 'max-h-[200px]' : 'max-h-[250px]'}`,
    style: {
      maxHeight: `${images.length === 3 ? 250 : 200}px`
    }
  }))))) : images.length >= 5 ? /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-2 gap-1 md:gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 grid-rows-2 gap-1 md:gap-4"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: () => openLightboxOnSlide(1)
  }, /*#__PURE__*/React.createElement("img", {
    src: images[0].Image.src,
    alt: "Image 1",
    className: "h-full w-full object-cover"
  })), /*#__PURE__*/React.createElement("button", {
    onClick: () => openLightboxOnSlide(2)
  }, /*#__PURE__*/React.createElement("img", {
    src: images[1].Image.src,
    alt: "Image 2",
    className: "h-full w-full object-cover"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 grid-rows-3 gap-1 md:gap-4"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: () => openLightboxOnSlide(3),
    className: "max-h-[280px] overflow-hidden"
  }, /*#__PURE__*/React.createElement("img", {
    src: images[2].Image.src,
    alt: "Image 3",
    className: "min-h-full min-w-full object-cover"
  })), /*#__PURE__*/React.createElement("button", {
    onClick: () => openLightboxOnSlide(4),
    className: "max-h-[280px] overflow-hidden"
  }, /*#__PURE__*/React.createElement("img", {
    src: images[3].Image.src,
    alt: "Image 4",
    className: "min-h-full min-w-full object-cover"
  })), /*#__PURE__*/React.createElement("button", {
    className: "relative max-h-[280px] overflow-hidden",
    onClick: () => openLightboxOnSlide(5)
  }, /*#__PURE__*/React.createElement("img", {
    src: images[4].Image.src,
    alt: "Image 5 with remaining overlay",
    className: "min-h-full min-w-full object-cover"
  }), images.length > 5 && /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 flex items-center justify-center bg-black/30"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[2rem] font-bold text-white md:text-[5rem]"
  }, "+", images.length - 5))))) : /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-2 gap-1 md:gap-4"
  }, images.map((image, index) => /*#__PURE__*/React.createElement("button", {
    onClick: () => openLightboxOnSlide(index + 1),
    key: index
  }, /*#__PURE__*/React.createElement("img", {
    src: image.Image.src,
    alt: `Image ${index + 1}`,
    className: "h-full w-full object-cover"
  })))) : /*#__PURE__*/React.createElement("div", {
    className: "mx-0 block max-w-4xl overflow-hidden"
  }, /*#__PURE__*/React.createElement("h2", {
    className: clsx('section-title mx-4 mb-3 md:mb-4 md:flex-1', theme)
  }, title, "\xA0"), /*#__PURE__*/React.createElement("div", {
    className: "relative mb-2 grid md:mb-5"
  }, /*#__PURE__*/React.createElement(Swiper, {
    className: "relative w-full",
    modules: [Navigation, Pagination, A11y, Controller],
    pagination: {
      el: '.dynamic-pagination',
      dynamicBullets: true,
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    controller: {
      control: descriptionSwiperRef
    },
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    onActiveIndexChange: swiper => {
      setLoopIndex(swiper.realIndex);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute top-[13px] right-[9px] z-10 rounded-[1.25rem] bg-[#8B8B8B] px-[9px] pt-[4px] pb-[2px] text-[0.813rem] font-medium leading-4 text-white"
  }, loopIndex + 1, " / ", loopLength), /*#__PURE__*/React.createElement("button", {
    className: "swiper-button-prev absolute top-[50%] left-4 z-10 hidden h-[42px] w-[42px] -translate-y-[50%] items-center justify-center rounded-full bg-white/80 shadow-[0_2px_20px_#00000086] hover:bg-white/90 md:flex"
  }, /*#__PURE__*/React.createElement(ChevronLeftIcon, {
    className: "h-6 w-6"
  })), /*#__PURE__*/React.createElement("button", {
    className: "swiper-button-next absolute top-[50%] right-4 z-10 hidden h-[42px] w-[42px] -translate-y-[50%] items-center justify-center rounded-full bg-white/80 shadow-[0_2px_20px_#00000086] hover:bg-white/90 md:flex"
  }, /*#__PURE__*/React.createElement(ChevronRightIcon, {
    className: "h-6 w-6"
  })), images.map((CarouselImage, index) => /*#__PURE__*/React.createElement(SwiperSlide, {
    key: index
  }, /*#__PURE__*/React.createElement("button", {
    className: "h-full",
    onClick: () => openLightboxOnSlide(loopIndex + 1)
  }, /*#__PURE__*/React.createElement(CarouselImage.Image, {
    className: "h-full object-cover"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: clsx('flex w-full justify-center pb-6 pt-4 md:pb-8', hasDescription && 'bg-blue-100')
  }, /*#__PURE__*/React.createElement("div", {
    className: "dynamic-pagination transform-none"
  })), /*#__PURE__*/React.createElement(Swiper, {
    className: clsx('relative w-full', hasDescription && 'bg-blue-100'),
    modules: [A11y, Navigation],
    onBeforeInit: swiper => {
      setDescriptionSwiperRef(swiper);
    },
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 0
  }, images.map((carouselImage, index) => /*#__PURE__*/React.createElement(SwiperSlide, {
    key: index,
    className: 'px-5 pb-12 md:px-10 md:pb-16'
  }, carouselImage.description && carouselImage.description))))), /*#__PURE__*/React.createElement(FsLightbox, {
    type: 'image',
    toggler: lightboxController.toggler,
    sources: lightboxImages.map(image => image.Image.src || ''),
    slide: lightboxController.slide,
    captions: images.map((carouselImage, index) => /*#__PURE__*/React.createElement("span", {
      key: index
    }, carouselImage.description ? carouselImage.description : '')),
    svg: {
      slideButtons: {
        next: {
          viewBox: '0 0 24 24',
          d: 'M15.293 12l-6.147 6.146a1 1 0 0 0 1.414 1.414l7-7a1 1 0 0 0 0-1.414l-7-7a1 1 0 0 0-1.414 1.414L15.293 12z'
        },
        previous: {
          viewBox: '0 0 24 24',
          d: 'M8.707 12l6.147 6.146a1 1 0 0 1-1.414 1.414l-7-7a1 1 0 0 1 0-1.414l7-7a1 1 0 0 1 1.414 1.414L8.707 12z'
        }
      }
    }
  })));
}

function markHighLight(input) {
  return input.map((object, index) => {
    return {
      ...object,
      highlighted: index % 16 === 0 || index % 16 === 9
    };
  });
}

function InfiniteGridTeaser({
  teasers,
  MoreLink,
  infiniteScroll
}) {
  const status = useOrganismStatus();
  return /*#__PURE__*/React.createElement("div", {
    className: "container-page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'flex-wrap md:-mx-3 md:flex lg:-mx-5'
  }, status === 101 ? /*#__PURE__*/React.createElement(Loader, null) : markHighLight(teasers).map((teaser, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: clsx('mb-5 last:mb-0 md:mb-0 md:p-3 lg:p-5', {
      'md:w-full lg:w-2/3': teaser.highlighted,
      'md:w-1/2 lg:w-1/3': !teaser.highlighted
    })
  }, teaser.highlighted ? /*#__PURE__*/React.createElement(HighlightTeaser, teaser) : /*#__PURE__*/React.createElement(Teaser, teaser)))), /*#__PURE__*/React.createElement(LoadMore, {
    LoadingAnimation: Loader,
    MoreLink: MoreLink,
    isInfiniteScrollActive: infiniteScroll
  })));
}

function SubTitle({
  children
}) {
  return /*#__PURE__*/React.createElement("h2", {
    className: "mb-4 text-xl font-semibold"
  }, children);
}

function SearchForm$1({
  Form,
  areas,
  locations,
  workloads
}) {
  const intl = useIntl();
  const hasLocationsFilter = locations.length > 0;
  const FormInner = () => {
    const {
      values,
      resetForm
    } = useFormikContext();
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
      className: "label col-span-8"
    }, intl.formatMessage({
      id: "eN4MPj",
      defaultMessage: [{
        "type": 0,
        "value": "Stichwortsuche"
      }]
    }), /*#__PURE__*/React.createElement(Field, {
      name: "keyword",
      type: "text",
      className: "field",
      placeholder: intl.formatMessage({
        id: "7fo55O",
        defaultMessage: [{
          "type": 0,
          "value": "Beruf, Stichwort eingeben"
        }]
      })
    })), /*#__PURE__*/React.createElement("div", {
      className: clsx('col-span-8 grid grid-cols-1 gap-5', hasLocationsFilter ? 'md:grid-cols-3' : 'md:grid-cols-2')
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-full"
    }, /*#__PURE__*/React.createElement(Multiselect, {
      name: "areas",
      title: intl.formatMessage({
        id: "4zmkql",
        defaultMessage: [{
          "type": 0,
          "value": "Berufsfeld"
        }]
      }),
      items: areas
    })), /*#__PURE__*/React.createElement("div", {
      className: "w-full"
    }, /*#__PURE__*/React.createElement(Multiselect, {
      name: "workloads",
      title: intl.formatMessage({
        id: "uQF8On",
        defaultMessage: [{
          "type": 0,
          "value": "Pensum"
        }]
      }),
      items: workloads
    })), hasLocationsFilter ? /*#__PURE__*/React.createElement("div", {
      className: "w-full"
    }, /*#__PURE__*/React.createElement(Multiselect, {
      name: "locations",
      title: intl.formatMessage({
        id: "qUkS0z",
        defaultMessage: [{
          "type": 0,
          "value": "Standort"
        }]
      }),
      items: locations
    })) : null), /*#__PURE__*/React.createElement("div", {
      className: 'col-span-8 flex items-end justify-end'
    }, /*#__PURE__*/React.createElement("button", {
      type: "submit",
      className: "button-primary mr-5"
    }, intl.formatMessage({
      id: "oj1ywf",
      defaultMessage: [{
        "type": 0,
        "value": "Anwenden"
      }]
    })), /*#__PURE__*/React.createElement("button", {
      type: "reset",
      className: "button-primary",
      onClick: () => {
        resetForm({
          values: {
            keyword: ''
          }
        });
      },
      disabled: isEmpty(values) || !(values.areas?.length || values.locations?.length || values.workloads?.length || values.keyword?.length)
    }, intl.formatMessage({
      id: "126CEs",
      defaultMessage: [{
        "type": 0,
        "value": "Zurücksetzen"
      }]
    }))));
  };
  return /*#__PURE__*/React.createElement(Form, {
    className: "form my-10"
  }, /*#__PURE__*/React.createElement(FormInner, null));
}
function ArrowDisclosure({
  defaultOpen,
  title,
  children
}) {
  const groupTheme = useGroupTheme({
    kinderspital: {
      color: 'text-orange-400 group-hover:text-orange-350'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      color: 'text-blue-900 group-hover:text-blue-400'
    },
    nidwalden: {
      color: 'text-brown-400'
    }
  });
  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  return /*#__PURE__*/React.createElement("div", {
    className: "group w-full"
  }, /*#__PURE__*/React.createElement(Disclosure, {
    defaultOpen: defaultOpen
  }, ({
    open
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Disclosure.Button, {
    className: clsx('focus mb-2.5 w-full text-left', theme.color),
    type: 'button'
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pt-0.5 underline-offset-4 group-hover:underline"
  }, title), /*#__PURE__*/React.createElement(ArrowUpIcon, {
    className: clsx('block h-4 w-4 transition', {
      'rotate-180': !open
    })
  }))), /*#__PURE__*/React.createElement(Collapsible, {
    show: open,
    delay: 0,
    fadeDuration: 100,
    scaleDuration: 200
  }, /*#__PURE__*/React.createElement(Disclosure.Panel, null, /*#__PURE__*/React.createElement("div", {
    className: "py-2"
  }, children))))));
}
function Multiselect({
  name,
  title,
  items
}) {
  const [field] = useField(name);
  const LabelTheme = useTheme({
    luzern: 'hover:bg-blue-100 hover:text-blue-900',
    nidwalden: 'hover:bg-brown-100 hover:text-brown-900'
  });
  return /*#__PURE__*/React.createElement(Popover, {
    className: "relative w-full"
  }, ({
    open
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Popover.Button, {
    className: clsx('focus mb-2.5 w-full border border-grey-500 p-3 pb-2 text-left text-black'),
    type: 'button'
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-nowrap items-center justify-between"
  }, field.value?.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "flex w-full justify-between gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "overflow-hidden text-ellipsis whitespace-nowrap"
  }, items.filter(item => field.value.includes(item.id)).map(item => item.label).join(', ')), ' ', /*#__PURE__*/React.createElement("div", {
    className: "shrink-0"
  }, "(", field.value?.length, ")")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, title), /*#__PURE__*/React.createElement(ArrowUpIcon, {
    className: clsx('block h-4 w-4 shrink-0 transition', {
      'rotate-180': !open
    })
  })))), /*#__PURE__*/React.createElement(Transition, {
    enter: "transition duration-100 ease-out",
    enterFrom: "transform scale-95 opacity-0",
    enterTo: "transform scale-100 opacity-100",
    leave: "transition duration-75 ease-out",
    leaveFrom: "transform scale-100 opacity-100",
    leaveTo: "transform scale-95 opacity-0"
  }, /*#__PURE__*/React.createElement(Popover.Panel, {
    tabIndex: -1,
    className: "absolute z-10 w-full border border-grey-500 bg-white py-2 drop-shadow"
  }, ({
    close
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, items.map(({
    id,
    label
  }) => /*#__PURE__*/React.createElement("label", {
    key: id,
    className: clsx('relative block px-3 pb-1 pt-2 last:mb-0', LabelTheme)
  }, /*#__PURE__*/React.createElement(Field, {
    type: "checkbox",
    name: name,
    value: id,
    className: "focus checkbox absolute"
  }), /*#__PURE__*/React.createElement("span", {
    className: "block pl-6"
  }, label))), /*#__PURE__*/React.createElement("button", {
    className: 'absolute -top-14 h-12 w-full opacity-0',
    type: 'button',
    onClick: async () => {
      close();
    }
  }))))));
}
function SignupForm({
  Form,
  isSubmitted
}) {
  const intl = useIntl();
  const FormInner = () => {
    const {
      dirty,
      touched,
      errors,
      isSubmitting,
      status
    } = useFormikContext();
    const Error = ({
      canBeDisplayed,
      text,
      className
    }) => canBeDisplayed && text ? /*#__PURE__*/React.createElement("div", {
      className: clsx('h-0 text-xs normal-case text-red-500', className)
    }, text) : null;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
      className: "label col-span-8 lg:col-span-4"
    }, intl.formatMessage({
      id: "jK2FMY",
      defaultMessage: [{
        "type": 0,
        "value": "Betreff des Job Abos"
      }]
    }), /*#__PURE__*/React.createElement(Field, {
      name: "subject",
      type: "text",
      maxlength: "50",
      className: clsx('field', {
        error: touched.subject && errors.subject
      })
    }), /*#__PURE__*/React.createElement(Error, {
      canBeDisplayed: touched.subject,
      text: errors.subject
    })), /*#__PURE__*/React.createElement("label", {
      className: "label col-span-8 lg:col-span-3"
    }, intl.formatMessage({
      id: "AMzjyJ",
      defaultMessage: [{
        "type": 0,
        "value": "E-mail-Adresse"
      }]
    }), /*#__PURE__*/React.createElement(Field, {
      name: "email",
      type: "email",
      className: clsx('field', {
        error: touched.email && errors.email
      })
    }), /*#__PURE__*/React.createElement(Error, {
      canBeDisplayed: touched.email,
      text: errors.email
    })), /*#__PURE__*/React.createElement("div", {
      className: 'col-span-8 flex items-end justify-end lg:col-span-1 lg:justify-start'
    }, /*#__PURE__*/React.createElement("button", {
      type: "submit",
      className: "button-primary lg:w-full",
      disabled: !dirty || isSubmitting || !!errors.subject || !!errors.email
    }, intl.formatMessage({
      id: "DxjMUl",
      defaultMessage: [{
        "type": 0,
        "value": "Abonnieren"
      }]
    }))), /*#__PURE__*/React.createElement(Error, {
      canBeDisplayed: status === 500,
      text: intl.formatMessage({
        id: "8CjSm9",
        defaultMessage: [{
          "type": 0,
          "value": "Bei der Anmeldung für das Job Abo ist ein Fehler aufgetreten, bitte versuchen Sie es später erneut"
        }]
      }),
      className: "col-span-8"
    }));
  };
  return /*#__PURE__*/React.createElement(ArrowDisclosure, {
    defaultOpen: false,
    title: intl.formatMessage({
      id: "xLr3NG",
      defaultMessage: [{
        "type": 0,
        "value": "Job Abo mit diesen Kriterien bestellen"
      }]
    })
  }, isSubmitted ? /*#__PURE__*/React.createElement("p", null, intl.formatMessage({
    id: "FjDRgL",
    defaultMessage: [{
      "type": 0,
      "value": "Die Anmeldung fürs Job-Abo war erfolgreich."
    }]
  })) : /*#__PURE__*/React.createElement(Form, {
    className: "form"
  }, /*#__PURE__*/React.createElement(FormInner, null)));
}
function ArrowRight$2({
  className
}) {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17 8l4 4m0 0l-4 4m4-4H3"
  }));
}
function List(props) {
  const intl = useIntl();
  const groupTheme = useGroupTheme({
    kinderspital: {
      headline: 'text-orange-400 group-hover:text-orange-350',
      list: ''
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      headline: 'text-blue-900 group-hover:text-blue-400',
      list: 'hover:bg-blue-100'
    },
    nidwalden: {
      headline: 'text-brown-500',
      list: 'hover:bg-brown-100'
    }
  });
  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  const status = useOrganismStatus();
  return /*#__PURE__*/React.createElement("div", {
    className: "pt-20"
  }, status === 200 ? /*#__PURE__*/React.createElement("div", {
    className: "mb-10 text-lg text-grey-600"
  }, intl.formatMessage({
    id: "4TspJa",
    defaultMessage: [{
      "type": 1,
      "value": "total"
    }, {
      "type": 0,
      "value": " Stellen gefunden"
    }]
  }, {
    total: props.totalItems
  })) : null, /*#__PURE__*/React.createElement("ul", null, props.items.map(item => {
    return /*#__PURE__*/React.createElement("li", {
      key: item.id,
      className: "border-t border-grey-200 last:border-b"
    }, /*#__PURE__*/React.createElement(item.Link, {
      className: clsx('group flex items-center justify-between px-2 py-4 transition md:p-8', theme.list)
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
      className: clsx(theme.headline, 'font-bold md:text-lg')
    }, item.title), /*#__PURE__*/React.createElement("dl", {
      className: "mt-5 text-sm md:flex md:text-base"
    }, /*#__PURE__*/React.createElement("dt", {
      className: "sr-only"
    }, intl.formatMessage({
      id: "uQF8On",
      defaultMessage: [{
        "type": 0,
        "value": "Pensum"
      }]
    })), /*#__PURE__*/React.createElement("dd", {
      className: "mr-4 font-bold"
    }, item.workload), /*#__PURE__*/React.createElement("span", {
      className: "hidden md:inline"
    }, '|'), /*#__PURE__*/React.createElement("dt", {
      className: "sr-only"
    }, intl.formatMessage({
      id: "YVb5VQ",
      defaultMessage: [{
        "type": 0,
        "value": "Arbeitsbereich"
      }]
    })), /*#__PURE__*/React.createElement("dd", {
      className: "ml-0 text-grey-600 md:mx-4"
    }, item.area), /*#__PURE__*/React.createElement("span", {
      className: "hidden md:inline"
    }, '|'), /*#__PURE__*/React.createElement("dt", {
      className: "sr-only"
    }, intl.formatMessage({
      id: "qUkS0z",
      defaultMessage: [{
        "type": 0,
        "value": "Standort"
      }]
    })), /*#__PURE__*/React.createElement("dd", {
      className: "ml-0 text-grey-600 md:ml-4"
    }, item.location))), /*#__PURE__*/React.createElement(ArrowRight$2, {
      className: clsx('h-8 w-8 flex-none', theme.headline)
    })));
  })));
}
function JobListing(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "container-page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content"
  }, props.title ? /*#__PURE__*/React.createElement(SubTitle, null, props.title) : null, props.displaySearchForm ? /*#__PURE__*/React.createElement(SearchForm$1, {
    Form: props.SearchForm,
    areas: props.areas,
    locations: props.locations,
    workloads: props.workloads
  }) : null, /*#__PURE__*/React.createElement(SignupForm, {
    Form: props.SignupForm,
    isSubmitted: props.isSignupFormSubmitted
  }), /*#__PURE__*/React.createElement(List, props), /*#__PURE__*/React.createElement(LoadMore, {
    LoadingAnimation: Loader,
    MoreLink: props.MoreLink,
    isInfiniteScrollActive: props.infiniteScroll
  })));
}

function LinkList(props) {
  if (!props.items?.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "container-page my-8",
    id: props.htmlId
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-text"
  }, props.title ? /*#__PURE__*/React.createElement("div", {
    className: clsx('max-w-none', props.display === 'tag' ? 'mt-10 mb-1 text-lead-md font-bold' : 'prose mt-12 mb-3 md:mb-5 lg:prose-xl')
  }, /*#__PURE__*/React.createElement("h3", {
    id: "Links"
  }, props.title)) : null, /*#__PURE__*/React.createElement(LinkList$1, props))));
}

let videoURLID = '';
function LocalVideo({
  url,
  title
}) {
  if (url) {
    const regex =
    // From https://stackoverflow.com/a/13286930/580371
    /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
    videoURLID = regex.exec(url)?.[3] || '';
  }
  return /*#__PURE__*/React.createElement("div", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-text',
    "data-chromatic": "ignore"
  }, videoURLID ? /*#__PURE__*/React.createElement(CookieGate, {
    enable: !!videoURLID
  }, /*#__PURE__*/React.createElement("iframe", {
    src: 'https://player.vimeo.com/video/' + videoURLID + '?dnt=1',
    className: "h-full w-full",
    width: "100%",
    height: "100%",
    frameBorder: "0",
    allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture;",
    scrolling: "no"
  })) : /*#__PURE__*/React.createElement("figure", {
    className: "my-5 w-full sm:my-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "aspect-w-16 aspect-h-9"
  }, /*#__PURE__*/React.createElement("video", {
    controls: true
  }, /*#__PURE__*/React.createElement("source", {
    src: url,
    type: "video/mp4"
  }))), title && /*#__PURE__*/React.createElement("figcaption", {
    className: "mt-2 text-sm sm:mt-4"
  }, title)))));
}

function LocationHeader({
  title,
  titleDetail,
  isPrimaryHeading,
  AssignersLink,
  subNavigation,
  breadcrumbItems,
  HomeLink,
  introText,
  isInPageNav = false,
  buttonText
}) {
  const groupTheme = useGroupTheme({
    kinderspital: {
      default: 'focus-secondary--nidwalden hover:border-black hover:text-black',
      active: 'text-black border-black'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      default: 'focus-luks hover:text-yellow-500',
      active: 'text-yellow-500 border-yellow-500'
    },
    nidwalden: {
      default: 'focus-secondary--nidwalden hover:text-black',
      active: 'text-black border-black'
    }
  });

  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  // Determine the title tag based on the heading level
  const TitleTag = isPrimaryHeading ? 'h1' : 'h2';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AnimatedBackground, {
    className: 'mb-10 pt-6 lg:mb-16'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-page relative'
  }, breadcrumbItems?.length ? /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement(Breadcrumb.Wrapper, {
    className: 'mb-4',
    variant: 'secondary'
  }, HomeLink ? /*#__PURE__*/React.createElement(Breadcrumb.HomeItem, {
    Link: HomeLink
  }) : null, breadcrumbItems.map((item, index) => /*#__PURE__*/React.createElement(Breadcrumb.Item, _extends({
    key: index
  }, item))))) : null, /*#__PURE__*/React.createElement("div", {
    className: "container-content md:flex md:items-center md:justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'my-2'
  }, /*#__PURE__*/React.createElement(TitleTag, {
    className: 'text-3xl font-bold text-white lg:text-5xl'
  }, title, titleDetail && /*#__PURE__*/React.createElement("span", {
    className: 'text-lg lg:text-2xl font-normal'
  }, " / ", titleDetail)), introText ? /*#__PURE__*/React.createElement("p", {
    className: 'prose -mb-3 mt-4 text-white md:mb-0 lg:mt-6 lg:prose-xl'
  }, introText) : null), AssignersLink ? AssignersLink.href.startsWith('#') ? /*#__PURE__*/React.createElement("a", {
    href: AssignersLink.href,
    className: clsx('button-secondary mt-5 md:mt-0')
  }, buttonText) : /*#__PURE__*/React.createElement(AssignersLink, {
    className: clsx('button-secondary mt-5 md:mt-0')
  }, buttonText) : null), /*#__PURE__*/React.createElement(Swiper, {
    slidesPerView: 'auto'
    // Without this option, the slider can't set active a slide which
    // index is greater than 4 🤷
    ,
    normalizeSlideIndex: false,
    initialSlide: subNavigation.findIndex(it => it.active),
    className: clsx('container-content mt-3 flex', {
      'lg:mt-5': introText
    })
  }, !isInPageNav ? subNavigation.map(({
    Link,
    title,
    active
  }, index) => {
    return /*#__PURE__*/React.createElement(SwiperSlide, {
      className: '!w-auto pt-2 last:mr-[150px]',
      key: index
    }, Link && /*#__PURE__*/React.createElement(Link, {
      className: clsx('inline-block border-b-4 border-transparent px-2.5 pb-5 pt-3 text-sm font-bold transition lg:px-5', theme.default, active && theme.active)
    }, title));
  }) : subNavigation.map(({
    title,
    anchor
  }, index) => {
    return /*#__PURE__*/React.createElement(SwiperSlide, {
      className: '!w-auto pt-2 last:mr-[150px]',
      key: index
    }, /*#__PURE__*/React.createElement("a", {
      href: `#${anchor || title.replace(/\s/g, '-')}`,
      className: clsx('inline-block border-b-4 border-transparent px-2.5 pb-5 pt-3 text-sm font-bold transition lg:px-5', theme.default)
    }, title));
  })))));
}

function LogoCloudImage({
  Image,
  Link
}) {
  const hasLink = !!(Link && Link.href);
  const groupTheme = useGroupTheme({
    kinderspital: {
      background: 'bg-orange-400 text-white'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      background: 'bg-blue-900 text-white'
    },
    nidwalden: {
      background: 'bg-brown-400 text-white'
    }
  });
  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;

  // @ts-ignore
  const Wrapper = hasLink ? Link : ({
    className,
    children
  }) => /*#__PURE__*/React.createElement("span", {
    className: className
  }, children);
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: clsx('focus group relative block px-12 py-3 border border-grey-200 h-full')
  }, /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    className: clsx('relative flex justify-center items-center h-full')
  }, Image?.src ? /*#__PURE__*/React.createElement("img", {
    src: Image.src,
    className: clsx('block object-contain transition duration-300 max-h-full', Link && 'group-hover:scale-105'),
    alt: ''
  }) : /*#__PURE__*/React.createElement("div", {
    className: clsx('block object-contain w-full p-3 text-center transition duration-300', theme.background, Link && 'group-hover:scale-105')
  }, "No Logo")));
}

function LogoCloud({
  logos
}) {
  const logosCount = logos?.length || 0;
  const showSlideshow = useShowSlideshow(logosCount, 20, true);
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  if (!logos || logos.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "my-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-page mb-10 md:mb-14'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content mb-2 md:relative md:mb-5 md:flex md:items-center md:justify-between'
  }, showSlideshow ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "prose w-full max-w-none lg:prose-xl"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "md:text-center",
    id: "logoCloudSlider"
  }, "\xA0")), /*#__PURE__*/React.createElement(SliderNavigation, {
    className: 'right-0 inline-flex md:absolute',
    prevRef: prevRef,
    nextRef: nextRef
  })) : null), /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, showSlideshow ? /*#__PURE__*/React.createElement(Swiper, {
    modules: [Navigation],
    onBeforeInit: swiper => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // eslint-disable-next-line no-param-reassign
      swiper.params.navigation.prevEl = prevRef.current;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // eslint-disable-next-line no-param-reassign
      swiper.params.navigation.nextEl = nextRef.current;
      swiper.navigation.update();
    },
    loop: logos.length > 1,
    loopFillGroupWithBlank: logos.length > 1,
    slidesPerView: 'auto',
    spaceBetween: 10
  }, logos.map((logo, index) => /*#__PURE__*/React.createElement(SwiperSlide, {
    className: 'max-w-[260px] !h-[150px] p-1',
    key: index
  }, /*#__PURE__*/React.createElement(LogoCloudImage, logo)))) : /*#__PURE__*/React.createElement("div", {
    className: 'flex gap-5 flex-wrap content-center justify-center'
  }, logos.map((logo, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: 'h-[150px] lg:flex-1/4 w-full'
  }, /*#__PURE__*/React.createElement(LogoCloudImage, logo)))))));
}

function MedicinesList({
  title,
  medicines,
  MoreLink,
  infiniteScroll,
  ...Form
}) {
  if (!medicines.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: 'container-page my-10 lg:my-20'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, title ? /*#__PURE__*/React.createElement(SubTitle, null, title) : null, /*#__PURE__*/React.createElement("div", {
    className: 'my-10'
  }, /*#__PURE__*/React.createElement(MedicinesForm, Form)), medicines.map((item, index) => /*#__PURE__*/React.createElement(MedicineItem, _extends({}, item, {
    key: index
  }))), /*#__PURE__*/React.createElement(LoadMore, {
    LoadingAnimation: Loader,
    MoreLink: MoreLink,
    isInfiniteScrollActive: infiniteScroll
  })));
}
function MedicineItem({
  date,
  left,
  right,
  Description
}) {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement("div", {
    className: 'my-5 border-b border-grey-200 pb-3 first:border-t'
  }, /*#__PURE__*/React.createElement("time", {
    className: 'mb-5 block text-lg font-bold'
  }, intl.formatDate(date, {
    dateStyle: 'medium'
  })), /*#__PURE__*/React.createElement("div", {
    className: 'md:flex'
  }, [left, right].map(({
    name,
    change,
    composition,
    articleNumber,
    comment
  }, index) => /*#__PURE__*/React.createElement("div", {
    className: 'last:pr-0 md:w-1/2 md:pr-10 lg:pr-20',
    key: index
  }, name ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    className: clsx('text-xl font-bold')
  }, name)) : null, change ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
    className: clsx('text-lg font-bold')
  }, change)) : null, composition ? /*#__PURE__*/React.createElement("p", null, composition) : null, articleNumber ? /*#__PURE__*/React.createElement("p", null, intl.formatMessage({
    id: "Y/tr3U",
    defaultMessage: [{
      "type": 0,
      "value": "Artikelnr."
    }]
  }), ":", ' ', articleNumber) : null, comment ? /*#__PURE__*/React.createElement("p", null, comment) : null))), Description ? /*#__PURE__*/React.createElement("div", {
    className: 'my-3'
  }, /*#__PURE__*/React.createElement(Description, null)) : null);
}
function MedicinesForm({
  Form,
  changes
}) {
  const intl = useIntl();
  changes.unshift({
    value: '',
    title: intl.formatMessage({
      id: "1frayP",
      defaultMessage: [{
        "type": 0,
        "value": "Alle Änderungen"
      }]
    })
  });
  const FormInner = () => {
    const {
      values,
      initialValues
    } = useFormikContext();
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
      className: clsx('label col-span-8 lg:col-span-3')
    }, intl.formatMessage({
      id: "/ZVb1D",
      defaultMessage: [{
        "type": 0,
        "value": "Freitextsuche"
      }]
    }), /*#__PURE__*/React.createElement(Field, {
      className: clsx('field'),
      type: 'text',
      name: 'text'
    })), /*#__PURE__*/React.createElement("div", {
      className: 'col-span-8 lg:col-span-3'
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: 'change',
      className: 'label'
    }, intl.formatMessage({
      id: "nrc8hU",
      defaultMessage: [{
        "type": 0,
        "value": "Änderung"
      }]
    })), /*#__PURE__*/React.createElement(Select, {
      selectItems: changes,
      name: 'change',
      id: 'change'
    })), /*#__PURE__*/React.createElement("div", {
      className: 'col-span-8 flex items-end justify-end lg:col-span-2 lg:justify-start'
    }, /*#__PURE__*/React.createElement("button", {
      className: clsx('button-primary mr-5'),
      type: 'submit'
    }, intl.formatMessage({
      id: "oj1ywf",
      defaultMessage: [{
        "type": 0,
        "value": "Anwenden"
      }]
    })), /*#__PURE__*/React.createElement("button", {
      className: clsx('button-primary lg:w-full'),
      type: 'reset',
      disabled: values == initialValues
    }, intl.formatMessage({
      id: "126CEs",
      defaultMessage: [{
        "type": 0,
        "value": "Zurücksetzen"
      }]
    }))));
  };
  return /*#__PURE__*/React.createElement(Form, {
    className: 'form mb-10'
  }, /*#__PURE__*/React.createElement(FormInner, null));
}

function MegaHighlightTeaser({
  Image,
  title,
  Link,
  lead
}) {
  const LinkTheme = useTheme({
    luzern: 'focus-luks',
    nidwalden: 'focus-nidwalden'
  });
  return /*#__PURE__*/React.createElement(Link, {
    className: clsx('group relative block rounded-md', LinkTheme)
  }, Image ? /*#__PURE__*/React.createElement("div", {
    className: 'aspect-w-2 aspect-h-2 relative block overflow-hidden'
  }, /*#__PURE__*/React.createElement(Image, {
    className: 'block w-full max-w-full object-cover object-center transition duration-300 group-hover:scale-105'
  }), /*#__PURE__*/React.createElement("div", {
    className: "teaser-gradient absolute h-full w-full md:bg-gradient-to-b md:from-transparent md:via-transparent md:to-grey-900"
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: 'absolute bottom-0 p-7 text-white'
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    className: clsx('text-xl font-bold transition')
  }, title), lead ? /*#__PURE__*/React.createElement("p", {
    className: "mt-1 text-sm"
  }, lead) : null)));
}

function MegaTeasers({
  title,
  teasers
}) {
  const intl = useIntl();
  if (!teasers.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement("section", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content my-20'
  }, /*#__PURE__*/React.createElement("h2", {
    className: 'section-title mb-2 text-center md:mb-3'
  }, title ? title : intl.formatMessage({
    id: "wPGWvC",
    defaultMessage: [{
      "type": 0,
      "value": "Zur Stories-Übersicht"
    }]
  })), /*#__PURE__*/React.createElement("div", {
    className: 'flex-wrap md:-mx-3 md:flex lg:-mx-5'
  }, teasers.map((teaser, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: "mb-5 last:mb-0 md:mb-0 md:w-full md:p-3 lg:w-1/2 lg:p-5"
  }, /*#__PURE__*/React.createElement(MegaHighlightTeaser, teaser))))));
}

function NewsContent({
  date,
  jsonLd,
  // type,
  readTime,
  caption,
  TeaserImage
}) {
  const intl = useIntl();
  let minutePlural = ' Minute';
  readTime && parseFloat(readTime) > 1 ? minutePlural = ' Minuten' : ' Minute'; // TODO: Look into intl.formatMessage plurals?

  const readingTime = readTime ? 'Lesezeit: ' + readTime.toString() + minutePlural : '';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    key: "bob",
    type: "application/ld+json"
  }, jsonLd)), /*#__PURE__*/React.createElement("div", {
    className: 'container-page my-10'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-text'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'my-5 flex justify-between font-thin'
  }, /*#__PURE__*/React.createElement("div", null, intl.formatDate(date, {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  })), /*#__PURE__*/React.createElement("div", null, readingTime)), TeaserImage && /*#__PURE__*/React.createElement(TeaserImage, {
    className: 'mt-5 mb-2 block h-auto w-full'
  }), caption && /*#__PURE__*/React.createElement("figcaption", {
    className: "prose mt-3 !max-w-full font-light text-grey-700"
  }, caption)))));
}

function NewsroomList({
  items,
  MoreLink,
  infiniteScroll
}) {
  const status = useOrganismStatus();
  if (!items.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-text'
  }, status === 101 ? /*#__PURE__*/React.createElement(Loader, null) : items.map((item, index) => /*#__PURE__*/React.createElement(NewsroomListItem, _extends({
    key: index
  }, item))), /*#__PURE__*/React.createElement(LoadMore, {
    LoadingAnimation: Loader,
    MoreLink: MoreLink,
    isInfiniteScrollActive: infiniteScroll
  }))));
}
function NewsroomListItem({
  Link,
  title,
  description,
  date
}) {
  const intl = useIntl();
  const LinkTheme = useTheme({
    luzern: 'hover:bg-blue-100',
    nidwalden: 'hover:bg-brown-100'
  });
  const TitleTheme = useTheme({
    luzern: 'text-blue-900 group-hover:text-blue-400',
    nidwalden: 'text-brown-900 group-hover:text-brown-400'
  });
  return /*#__PURE__*/React.createElement(Link, {
    className: clsx('focus group flex border-b border-grey-200 px-3 py-5 transition first:border-t md:py-10', LinkTheme)
  }, /*#__PURE__*/React.createElement("time", {
    className: 'mr-5 text-center transition group-hover:text-black md:mr-10'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'block text-3xl font-bold'
  }, intl.formatDate(date, {
    day: 'numeric'
  })), /*#__PURE__*/React.createElement("span", {
    className: 'block text-lg'
  }, intl.formatDate(date, {
    month: 'short'
  })), /*#__PURE__*/React.createElement("span", {
    className: 'block font-bold'
  }, intl.formatDate(date, {
    year: 'numeric'
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    className: clsx('text-xl font-bold transition', TitleTheme)
  }, title), /*#__PURE__*/React.createElement("div", {
    className: 'mt-3'
  }, description)));
}

function QuoteMark({
  className
}) {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    fill: 'currentColor',
    className: className
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M225.1,408.2c118.3,0,214.2,95.9,214.2,214.2c0,118.3-95.9,214.2-214.2,214.2S11,740.7,11,622.4l-1-30.6c0-236.6,191.8-428.3,428.3-428.3v122.4c-81.7,0-158.6,31.8-216.3,89.6c-11.1,11.1-21.3,23-30.4,35.4C202.5,409.1,213.7,408.2,225.1,408.2L225.1,408.2z M775.8,408.2c118.3,0,214.2,95.9,214.2,214.2c0,118.3-95.9,214.2-214.2,214.2c-118.3,0-214.2-95.9-214.2-214.2l-1-30.6c0-236.6,191.8-428.3,428.3-428.3v122.4c-81.7,0-158.6,31.8-216.3,89.6c-11.1,11.1-21.3,23-30.4,35.4C753.2,409.1,764.4,408.2,775.8,408.2L775.8,408.2z"
  })));
}

function Quote(props) {
  const groupTheme = useGroupTheme({
    kinderspital: {
      border: 'border-orange-300',
      quoteMark: 'text-orange-400'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      border: 'border-yellow-500',
      quoteMark: 'text-yellow-500'
    },
    nidwalden: {
      border: 'border-brown-500',
      quoteMark: 'text-brown-500'
    }
  });

  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  return /*#__PURE__*/React.createElement("div", {
    className: "container-page mb-5 lg:mb-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-text"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative max-w-full"
  }, /*#__PURE__*/React.createElement("blockquote", {
    className: clsx('relative inline-block border-l-[9px] pl-6 font-serif text-lg italic md:text-2xl', theme.border)
  }, props.quote, /*#__PURE__*/React.createElement(QuoteMark, {
    className: clsx('absolute right-0 -bottom-8 ml-2 -mt-1 h-9 w-9 rotate-180', theme.quoteMark)
  })), props.author ? /*#__PURE__*/React.createElement("p", {
    className: "mt-8 text-sm font-bold text-grey-650"
  }, props.author) : null))));
}

function RemoteVideo(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-text'
  }, /*#__PURE__*/React.createElement(Video, props))));
}

function Screen({
  textLeft,
  textRight,
  FallbackSingleScreenImage,
  FallbackDualScreenImage,
  StandardImage,
  screenInfo,
  forceDualScreen = false
}) {
  const [enableDualScreen, setEnableDualScreen] = useState(false);

  /** Calculate if the window is in dual screen mode */
  const calculateDualScreenState = () => {
    // If the forceDualScreen prop is set, we always return true
    if (forceDualScreen) {
      return true;
    }
    if (typeof window === 'undefined') {
      return false;
    }
    if (!window.screen) {
      return false;
    }
    // @ts-ignore
    if (!window.screen.isExtended) {
      return false;
    }
    // @ts-ignore
    const canBeExtended = window.screen.isExtended;
    const widthLargerThanSingleScreen = window.innerWidth > window.screen.availWidth;
    return canBeExtended && widthLargerThanSingleScreen;
  };
  const screenSizeClass = enableDualScreen ? 'dual-screens' : 'single-screen';

  // Add parent class to aid typography overrides
  useEffect(() => {
    const htmlElement = document.querySelector('html');
    if (htmlElement) {
      htmlElement.classList.add('digital-signage');
      htmlElement.classList.remove('dual-screens');
      htmlElement.classList.remove('single-screen');
      htmlElement.classList.add(enableDualScreen ? 'dual-screens' : 'single-screen');
    }
  }, [enableDualScreen, screenSizeClass]);

  // adjust content based on screen size
  useEffect(() => {
    setEnableDualScreen(calculateDualScreenState());
    function reCalculateDualScreenState() {
      setEnableDualScreen(calculateDualScreenState());
    }
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', reCalculateDualScreenState);
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: 'relative mx-auto flex h-[100vh] flex-col'
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('digital-signage mx-auto grid w-full grow overflow-hidden ', {
      'lg:grid-cols-4': !enableDualScreen,
      'lg:grid-cols-6': enableDualScreen
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: 'col-span-1 p-12 pt-0'
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-[5.25rem] flex items-end"
  }, /*#__PURE__*/React.createElement("svg", {
    className: "xxl:max-w-[30%] xl:max-w-[40%] lg:max-w-[50%] p-8 pl-0",
    viewBox: "0 0 76 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.75 59.5117L6.25 33.0117L32.75 6.51172",
    stroke: "black",
    strokeWidth: "8",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 33H72",
    stroke: "black",
    strokeWidth: "8",
    strokeLinecap: "round"
  }))), textLeft && /*#__PURE__*/React.createElement("div", {
    className: "prose"
  }, /*#__PURE__*/React.createElement("ul", null, textLeft.map((textItem, index) => /*#__PURE__*/React.createElement("li", {
    key: index,
    className: "mb-10 hyphens-auto break-words !text-[2rem] !leading-[3.375rem]"
  }, textItem))))), enableDualScreen ? /*#__PURE__*/React.createElement(DualScreenContent, {
    screenInfo: screenInfo,
    FallbackImage: FallbackDualScreenImage,
    StandardImage: StandardImage
  }) : /*#__PURE__*/React.createElement(SingleScreenContent, {
    screenInfo: screenInfo,
    FallbackImage: FallbackSingleScreenImage
  }), /*#__PURE__*/React.createElement("div", {
    className: 'col-span-1 p-12 pt-0'
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-[5.25rem] flex items-end justify-end"
  }, /*#__PURE__*/React.createElement("svg", {
    className: "xxl:max-w-[30%] xl:max-w-[40%] lg:max-w-[50%] p-8 pr-0",
    viewBox: "0 0 76 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.25 59.5117L69.75 33.0117L43.25 6.51172",
    stroke: "black",
    strokeWidth: "8",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 33H4",
    stroke: "black",
    strokeWidth: "8",
    strokeLinecap: "round"
  }))), textRight && /*#__PURE__*/React.createElement("div", {
    className: "prose"
  }, /*#__PURE__*/React.createElement("ul", null, textRight.map((textItem, index) => /*#__PURE__*/React.createElement("li", {
    key: index,
    className: "mb-10 hyphens-auto break-words text-right !text-[2rem] !leading-[3.375rem]"
  }, textItem)))))), /*#__PURE__*/React.createElement(DSProgressBarStatic, {
    dualScreen: enableDualScreen
  }));
}
function ScreenInfo({
  title,
  image: Image,
  datetimeFrom,
  datetimeTo,
  room
}) {
  const intl = useIntl();
  const date = formatFancyDatetimeRange(intl, datetimeFrom, datetimeTo);
  return /*#__PURE__*/React.createElement("div", {
    className: "mb-12 grid grid-cols-4 gap-[1.875rem]"
  }, Image?.src && /*#__PURE__*/React.createElement(Image, {
    className: 'relative my-0 h-[8.75rem] w-full object-cover'
  }), /*#__PURE__*/React.createElement("div", {
    className: clsx('break-words', Image ? 'col-span-3' : 'col-span-4')
  }, /*#__PURE__*/React.createElement("span", {
    className: "block text-[1.875rem] font-bold leading-[2.5rem]"
  }, title), /*#__PURE__*/React.createElement("span", {
    className: "font-regular block text-[1.625rem] leading-[3rem]"
  }, date, room ? `, ${room}` : '')));
}
function SingleScreenContent({
  screenInfo,
  FallbackImage,
  enableTitle = true
}) {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('relative col-span-2 h-full w-full')
  }, screenInfo && screenInfo?.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "h-full bg-[#E9F2FA]"
  }, enableTitle ? /*#__PURE__*/React.createElement("h2", {
    className: "font-regular bg-[#2A71B8] p-8 text-center text-[2rem] leading-[3.375rem] text-white"
  }, intl.formatMessage({
    id: "e4eFua",
    defaultMessage: [{
      "type": 0,
      "value": "Herzlich willkommen am Luzerner Kantonsspital"
    }]
  })) : null, /*#__PURE__*/React.createElement("h3", {
    className: clsx("mx-12 border-b border-[#2A71B8] pb-9 !text-[2rem] font-bold !leading-[3.375rem]", {
      'mt-[5.25rem]': enableTitle,
      'pt-[5.25rem]': !enableTitle
    })
  }, intl.formatMessage({
    id: "yhG18j",
    defaultMessage: [{
      "type": 0,
      "value": "Aktuelles"
    }]
  })), /*#__PURE__*/React.createElement("ul", {
    className: "mx-12 mt-11"
  }, screenInfo.map((screenInfoItem, index) => /*#__PURE__*/React.createElement("li", {
    key: index
  }, /*#__PURE__*/React.createElement(ScreenInfo, screenInfoItem))))) : /*#__PURE__*/React.createElement(FallbackImage, {
    className: 'relative my-0 h-screen w-full object-cover'
  }));
}
function DualScreenContent({
  screenInfo,
  FallbackImage,
  StandardImage
}) {
  const intl = useIntl();
  const hasScreenInfo = screenInfo && screenInfo?.length > 0;
  return /*#__PURE__*/React.createElement(React.Fragment, null, hasScreenInfo ? /*#__PURE__*/React.createElement(SingleScreenContent, {
    FallbackImage: FallbackImage,
    screenInfo: screenInfo,
    enableTitle: false
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: clsx('relative h-full w-full', {
      'col-span-2': hasScreenInfo,
      'col-span-4': !hasScreenInfo
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-full bg-[#E9F2FA]"
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('bg-[#2A71B8CC] lg:absolute lg:bottom-32 lg:right-[4rem]  z-10', {
      'w-[45%]': hasScreenInfo,
      'w-[22.5%]': !hasScreenInfo
    })
  }, /*#__PURE__*/React.createElement("h2", {
    className: "font-regular p-8 text-center text-[2rem] leading-[3.375rem] text-white"
  }, intl.formatMessage({
    id: "e4eFua",
    defaultMessage: [{
      "type": 0,
      "value": "Herzlich willkommen am Luzerner Kantonsspital"
    }]
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-0 h-0 absolute right-10 -bottom-[3rem] border-l-[2.5rem] border-l-transparent border-t-[3rem] border-[#2A71B8CC] border-r-transparent"
  })), hasScreenInfo ? /*#__PURE__*/React.createElement(StandardImage, {
    className: 'relative my-0 h-screen w-full object-cover'
  }) : /*#__PURE__*/React.createElement(FallbackImage, {
    className: 'relative my-0 h-screen w-full object-cover'
  }))));
}
function DSProgressBarStatic({
  dualScreen = false
}) {
  if (dualScreen) {
    return /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-6"
    }, /*#__PURE__*/React.createElement("div", {
      className: 'z-20 col-span-5 h-5 bg-yellow-475'
    }), /*#__PURE__*/React.createElement("div", {
      className: 'z-20 col-span-1 h-5 bg-blue-750'
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'z-20 col-span-3 h-5 bg-yellow-475'
  }), /*#__PURE__*/React.createElement("div", {
    className: 'z-20 col-span-1 h-5 bg-blue-750'
  }));
}

/**
 * Formats a datetime range in a fancy way.
 *
 * The weekday is replaced by German "Today" or "Tomorrow" if the given date is
 * today or tomorrow.
 */
function formatFancyDatetimeRange(intl, datetimeFrom, datetimeTo) {
  if (!datetimeFrom) {
    return null;
  }
  const from = new Date(datetimeFrom);
  const to = new Date(datetimeTo || datetimeFrom);
  const formatted = intl.formatDateTimeRange(from, to, {
    dateStyle: 'full',
    timeStyle: 'short'
  });
  const makeItFancy = (date, formatted) => {
    // Today.
    const today = new Date();
    if (date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear()) {
      return formatted.replace(intl.formatDate(date, {
        weekday: 'long'
      }), intl.formatMessage({
        id: "2sWIxu",
        defaultMessage: [{
          "type": 0,
          "value": "Heute"
        }]
      }));
    }
    // Tomorrow.
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    if (date.getDate() === tomorrow.getDate() && date.getMonth() === tomorrow.getMonth() && date.getFullYear() === tomorrow.getFullYear()) {
      return formatted.replace(intl.formatDate(date, {
        weekday: 'long'
      }), intl.formatMessage({
        id: "JsVm7H",
        defaultMessage: [{
          "type": 0,
          "value": "Morgen"
        }]
      }));
    }
    // Other.
    return formatted;
  };
  const match = formatted.match(/(.*?)(\s*–\s*)(.*)/);
  if (match) {
    const [, fromFormatted, separator, toFormatted] = match;
    return makeItFancy(from, fromFormatted) + separator + makeItFancy(to, toFormatted);
  } else {
    return makeItFancy(from, formatted);
  }
}

function SearchForm({
  Form,
  suggestions,
  isTitleVisible = true,
  placeholderText
}) {
  const intl = useIntl();
  const groupTheme = useGroupTheme({
    kinderspital: {
      default: 'focus-kinderspital bg-transparent !border-2 !border-l-0 border-white text-white hover:bg-orange-300'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      default: 'focus-luks bg-yellow-500 text-blue-900 hover:bg-yellow-600'
    },
    nidwalden: {
      default: 'focus-nidwalden bg-blue-950 text-blue-950 !text-white hover:bg-blue-960'
    }
  });

  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  return /*#__PURE__*/React.createElement(AnimatedBackground, null, /*#__PURE__*/React.createElement("div", {
    className: "container-page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-text"
  }, /*#__PURE__*/React.createElement(Form, {
    className: "py-8 lg:py-12"
  }, isTitleVisible ? /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("span", {
    className: "mb-4 block text-center text-3xl font-bold md:text-4xl lg:mb-8 lg:text-6xl "
  }, intl.formatMessage({
    id: "qi41lO",
    defaultMessage: [{
      "type": 0,
      "value": "Suche"
    }]
  }))) : null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement(SearchCombobox, {
    suggestions: suggestions,
    placeholderText: placeholderText
  })), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: clsx('h-10 w-12 border-0 border-grey-500 transition', theme.default)
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, intl.formatMessage({
    id: "gYrVno",
    defaultMessage: [{
      "type": 0,
      "value": "Suche starten"
    }]
  })), /*#__PURE__*/React.createElement(SearchIcon, {
    className: "mx-auto h-6"
  })))))));
}

function Chip(item) {
  const groupTheme = useGroupTheme({
    kinderspital: {
      default: 'border-orange-400 text-orange-400 hover:border-orange-400 hover:bg-orange-400',
      active: 'border-orange-400 bg-orange-400 text-white'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      default: 'border-blue-900 text-blue-900 hover:border-blue-400 hover:bg-blue-400',
      active: 'border-blue-400 bg-blue-400 text-white'
    },
    nidwalden: {
      default: 'border-brown-500 text-brown-500 hover:border-brown-400 hover:bg-brown-400',
      active: 'border-brown-400 bg-brown-400 text-white'
    }
  });

  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  return /*#__PURE__*/React.createElement(item.Link, {
    className: clsx('focus block rounded border px-2 pt-1 pb-0.5 transition hover:text-white', item.active ? theme.active : theme.default)
  }, item.label, typeof item.count !== 'undefined' && item.count >= 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, " (", item.count, ")") : null);
}

function FacetMultipleChips({
  items
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap gap-2 py-4"
  }, items.map(({
    ...item
  }) => /*#__PURE__*/React.createElement(Chip, _extends({
    key: item.id
  }, item))));
}

function ArrowRight$1({
  className
}) {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17 8l4 4m0 0l-4 4m4-4H3"
  }));
}
function SearchResults(props) {
  const intl = useIntl();
  const groupTheme = useGroupTheme({
    kinderspital: {
      background: 'group-hover:bg-orange-400 group-hover:text-white',
      text: 'text-orange-400 group-hover:text-white'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      background: 'group-hover:bg-blue-100',
      text: 'text-blue-900 group-hover:text-blue-400'
    },
    nidwalden: {
      background: 'group-hover:bg-brown-100',
      text: 'text-brown-500'
    }
  });

  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  const status = useOrganismStatus();
  return /*#__PURE__*/React.createElement("div", {
    className: "container-page relative py-10"
  }, status === 500 ? /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center"
  }, /*#__PURE__*/React.createElement(Loader, null), /*#__PURE__*/React.createElement("div", {
    className: "mb-10 font-bold text-red-500"
  }, intl.formatMessage({
    id: "iVzdPP",
    defaultMessage: [{
      "type": 0,
      "value": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut."
    }]
  }))) : null, /*#__PURE__*/React.createElement("div", {
    className: clsx('container-content transition', {
      'opacity-70 blur-sm grayscale': status === 102
    })
  }, props.suggestion ? /*#__PURE__*/React.createElement("p", {
    className: "prose"
  }, intl.formatMessage({
    id: "oYY89U",
    defaultMessage: [{
      "type": 0,
      "value": "Meinten Sie "
    }, {
      "type": 1,
      "value": "query"
    }, {
      "type": 0,
      "value": "?"
    }]
  }, {
    query: /*#__PURE__*/React.createElement(props.suggestion.Link, null, props.suggestion.query)
  })) : null, !props.query ? /*#__PURE__*/React.createElement("p", {
    className: "italic text-grey-700"
  }, intl.formatMessage({
    id: "kH7nOL",
    defaultMessage: [{
      "type": 0,
      "value": "Bitte geben Sie einen Suchbegriff ein."
    }]
  })) : null, props.facets && props.facets.length > 0 ? /*#__PURE__*/React.createElement(FacetMultipleChips, {
    items: props.facets
  }) : null, props.items && props.items.length > 0 ? /*#__PURE__*/React.createElement("p", {
    className: "my-4 md:my-10"
  }, intl.formatMessage({
    id: "1culoC",
    defaultMessage: [{
      "type": 1,
      "value": "number"
    }, {
      "type": 0,
      "value": " von "
    }, {
      "type": 1,
      "value": "total"
    }, {
      "type": 0,
      "value": " Suchtreffern für "
    }, {
      "type": 1,
      "value": "query"
    }]
  }, {
    number: props.items.length,
    total: props.totalItems,
    query: /*#__PURE__*/React.createElement("span", {
      className: "font-bold"
    }, "\xAB", props.query, "\xBB")
  })) : null, props.items && props.items.length > 0 ? /*#__PURE__*/React.createElement("ul", {
    className: "my-4 md:my-10"
  }, props.items.map(item => {
    return /*#__PURE__*/React.createElement("li", {
      key: item.id,
      className: "border-t border-grey-200 last:border-b"
    }, /*#__PURE__*/React.createElement(item.Link, {
      className: 'group block'
    }, /*#__PURE__*/React.createElement("div", {
      className: clsx('flex items-center px-2 py-4 transition md:p-8', theme.background)
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-full flex-auto"
    }, /*#__PURE__*/React.createElement("h3", {
      className: clsx('text-lg font-bold md:text-xl', theme.text)
    }, /*#__PURE__*/React.createElement(item.Link, null, /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: item.title.replace(new RegExp(`(${props.query})`, 'gi'), `<strong>$1</strong>`)
      }
    }))), props.HomeLink ? /*#__PURE__*/React.createElement(Breadcrumb.Wrapper, null, /*#__PURE__*/React.createElement(Breadcrumb.HomeItem, {
      Link: props.HomeLink
    }), item.breadcrumbs?.map(({
      title,
      Link
    }, index) => /*#__PURE__*/React.createElement(Breadcrumb.Item, {
      key: index,
      title: title,
      Link: Link
    }))) : null, /*#__PURE__*/React.createElement("div", {
      className: "mt-2 text-sm md:mt-4 md:text-base"
    }, /*#__PURE__*/React.createElement(item.Snippet, null))), /*#__PURE__*/React.createElement(item.Link, null, /*#__PURE__*/React.createElement(ArrowRight$1, {
      className: clsx('h-8 w-8 shrink-0', theme.text)
    })))));
  })) : null, /*#__PURE__*/React.createElement(LoadMore, {
    LoadingAnimation: Loader,
    MoreLink: props.MoreLink,
    isInfiniteScrollActive: props.infiniteScroll
  })));
}

const SidebarContext = /*#__PURE__*/createContext(false);
function Sidebar(props) {
  if (!props.content.items.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: 'container-page my-10 md:my-24'
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('grid grid-flow-row auto-rows-auto gap-5 md:grid-cols-2 md:gap-14', props.content.items.length === 1 && props.content.items[0]?.key === 'ContextualTextSection' ? 'container-text' : 'container-content lg:grid-cols-3 xl:grid-cols-4')
  }, /*#__PURE__*/React.createElement(SidebarContext.Provider, {
    value: true
  }, /*#__PURE__*/React.createElement(Group, {
    definition: SidebarGroup,
    input: props.content
  }))));
}

function SimpleHeader({
  Title,
  AssignersLink,
  breadcrumbItems,
  HomeLink
}) {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement(AnimatedBackground, {
    className: "mb-20 py-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-page relative'
  }, breadcrumbItems?.length ? /*#__PURE__*/React.createElement(Breadcrumb.Wrapper, {
    className: 'mt-3 md:mt-6'
  }, HomeLink ? /*#__PURE__*/React.createElement(Breadcrumb.HomeItem, {
    Link: HomeLink
  }) : null, breadcrumbItems.map((item, index) => /*#__PURE__*/React.createElement(Breadcrumb.Item, _extends({
    key: index
  }, item)))) : null, AssignersLink ? /*#__PURE__*/React.createElement("div", {
    className: "container-content min-h-[9rem] md:flex md:items-center md:justify-between"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "mt-4 self-start text-3xl font-bold text-white lg:text-5xl"
  }, /*#__PURE__*/React.createElement(Title, null)), /*#__PURE__*/React.createElement(AssignersLink, {
    className: clsx('button-secondary mt-10 md:mt-0')
  }, intl.formatMessage({
    id: "AwTTG9",
    defaultMessage: [{
      "type": 0,
      "value": "For Assigners"
    }]
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "container-content md:flex md:items-center md:justify-between"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "my-4 self-start text-3xl font-bold text-white lg:text-5xl"
  }, /*#__PURE__*/React.createElement(Title, null)))));
}

function Menu({
  items
}) {
  return /*#__PURE__*/React.createElement("ul", null, items.map(item => /*#__PURE__*/React.createElement("li", {
    key: item.id
  }, item.Link ? /*#__PURE__*/React.createElement(item.Link, null, item.title) : /*#__PURE__*/React.createElement("span", null, item.title), item.children ? /*#__PURE__*/React.createElement(Menu, {
    items: item.children
  }) : null)));
}
function Sitemap({
  menus
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "container-page my-10 md:my-20"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-text"
  }, /*#__PURE__*/React.createElement("div", {
    className: "prose"
  }, /*#__PURE__*/React.createElement("h1", null, "Sitemap"), menus.map(menu => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", null, menu.label), /*#__PURE__*/React.createElement(Menu, {
    items: menu.items
  })))))));
}

function SliderTeaser({
  teasers,
  title
}) {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const showSlideshow = useShowSlideshow(teasers.length);
  if (teasers.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: 'container-page mx-auto my-10 overflow-hidden'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content mb-2 md:flex md:items-center md:justify-between'
  }, /*#__PURE__*/React.createElement("div", {
    className: "prose max-w-none lg:prose-xl"
  }, /*#__PURE__*/React.createElement("h3", null, title)), showSlideshow ? /*#__PURE__*/React.createElement(SliderNavigation, {
    className: 'inline-flex',
    prevRef: prevRef,
    nextRef: nextRef
  }) : null), /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, showSlideshow ? /*#__PURE__*/React.createElement(Swiper, {
    modules: [Navigation],
    onBeforeInit: swiper => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // eslint-disable-next-line no-param-reassign
      swiper.params.navigation.prevEl = prevRef.current;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // eslint-disable-next-line no-param-reassign
      swiper.params.navigation.nextEl = nextRef.current;
      swiper.navigation.update();
    },
    slidesPerView: 'auto',
    spaceBetween: 30,
    className: '!overflow-visible'
  }, teasers.map((teaser, index) => /*#__PURE__*/React.createElement(SwiperSlide, {
    className: 'max-w-[300px] p-1 lg:max-w-sm',
    key: index
  }, /*#__PURE__*/React.createElement(Teaser, teaser)))) : /*#__PURE__*/React.createElement("div", {
    className: 'flex justify-center gap-5 lg:gap-20'
  }, teasers.map((teaser, index) => /*#__PURE__*/React.createElement("div", {
    className: 'p-1 md:w-1/2 lg:w-1/4',
    key: index
  }, /*#__PURE__*/React.createElement(Teaser, teaser))))));
}

function SliderTestimonial({
  specialists,
  title
}) {
  const intl = useIntl();
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const showSlideshow = useShowSlideshow(specialists.length, 3);
  if (!specialists.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "my-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'mb-2 md:relative md:mb-5 md:flex md:items-center md:justify-between'
  }, /*#__PURE__*/React.createElement("div", {
    className: "prose w-full max-w-none lg:prose-xl"
  }, /*#__PURE__*/React.createElement("h2", {
    className: 'md:text-center'
  }, title || intl.formatMessage({
    id: "X7+QFF",
    defaultMessage: [{
      "type": 0,
      "value": "Testimonials"
    }]
  }))), showSlideshow ? /*#__PURE__*/React.createElement(SliderNavigation, {
    className: 'right-0 inline-flex md:absolute',
    prevRef: prevRef,
    nextRef: nextRef
  }) : null), showSlideshow ? /*#__PURE__*/React.createElement(Swiper, {
    modules: [Navigation],
    onBeforeInit: swiper => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // eslint-disable-next-line no-param-reassign
      swiper.params.navigation.prevEl = prevRef.current;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // eslint-disable-next-line no-param-reassign
      swiper.params.navigation.nextEl = nextRef.current;
      swiper.navigation.update();
    },
    slidesPerView: 1,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 30
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 50
      }
    }
  }, specialists.map((specialist, index) => /*#__PURE__*/React.createElement(SwiperSlide, {
    className: 'h-auto p-1',
    key: index
  }, /*#__PURE__*/React.createElement(Testimonial, specialist)))) : /*#__PURE__*/React.createElement("div", {
    className: 'grid grid-cols-3 justify-center gap-4 lg:gap-12'
  }, specialists.map((specialist, index) => /*#__PURE__*/React.createElement("div", {
    className: 'p-1',
    key: index
  }, /*#__PURE__*/React.createElement(Testimonial, specialist)))))));
}
function Testimonial({
  link,
  Blockquote,
  BlockquoteShort,
  Image,
  testimonialDescription
}) {
  const ArrowTheme = useTheme({
    luzern: 'text-blue-900 group-hover:text-blue-400',
    nidwalden: 'text-brown-400'
  });
  const QuoteTheme = useTheme({
    luzern: 'text-blue-900',
    nidwalden: 'text-brown-900'
  });
  const [open, setOpen] = useState(false);
  const hasText = Blockquote.initialHtmlString.length > BlockquoteShort.initialHtmlString.length;
  const hasLink = !!link;
  const Wrapper = !hasText && hasLink ? ({
    children
  }) => /*#__PURE__*/React.createElement("button", {
    onClick: () => link.Link.navigate(),
    className: clsx('focus group flex h-full w-full max-w-full cursor-pointer flex-col justify-between text-left')
  }, children) : hasText ? ({
    children
  }) => /*#__PURE__*/React.createElement("button", {
    onClick: () => setOpen(true),
    className: clsx('focus group flex h-full w-full max-w-full cursor-pointer flex-col justify-between text-left')
  }, children) : ({
    children
  }) => /*#__PURE__*/React.createElement("div", {
    className: "group flex h-full max-w-full flex-col justify-between text-left"
  }, children);
  return /*#__PURE__*/React.createElement("div", {
    className: "h-full"
  }, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement("div", {
    className: 'w-full max-w-full'
  }, Image ? /*#__PURE__*/React.createElement("div", {
    className: 'aspect-w-3 aspect-h-2 relative block overflow-hidden rounded-tl-md'
  }, /*#__PURE__*/React.createElement(Image, {
    className: 'block w-full max-w-full object-cover transition duration-300 group-hover:scale-105'
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: "w-full rounded-b-md bg-blue-100 p-4 pt-5"
  }, /*#__PURE__*/React.createElement("blockquote", {
    className: clsx('relative mt-3 overflow-hidden pl-14 text-lg font-light transition', useTheme({
      luzern: hasText || hasLink ? 'group-hover:text-blue-400' : '',
      nidwalden: hasText || hasLink ? 'group-hover:text-brown-400' : ''
    }))
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('absolute left-0 top-0 text-grey-500 transition', useTheme({
      luzern: hasText || hasLink ? 'group-hover:text-blue-400' : '',
      nidwalden: hasText || hasLink ? 'group-hover:text-brown-400' : ''
    }))
  }, /*#__PURE__*/React.createElement(QuoteMark, {
    className: 'h-9 w-9'
  })), /*#__PURE__*/React.createElement(BlockquoteShort, null)), testimonialDescription && testimonialDescription !== '' ? /*#__PURE__*/React.createElement("p", {
    className: 'mt-5 border-t border-grey-200 pt-5 text-sm font-bold text-grey-600'
  }, testimonialDescription) : null, hasText ? /*#__PURE__*/React.createElement("div", {
    className: clsx('mt-2.5 flex items-center font-bold', ArrowTheme)
  }, 'Weiterlesen', /*#__PURE__*/React.createElement(ArrowNarrowRightIcon, {
    className: 'ml-2 h-7 w-7 transition-all group-hover:ml-5'
  })) : hasLink ? /*#__PURE__*/React.createElement(link.Link, {
    className: clsx('mt-2.5 flex items-center font-bold', ArrowTheme)
  }, link.text || 'Mehr erfahren', /*#__PURE__*/React.createElement(ArrowNarrowRightIcon, {
    className: 'ml-2 h-7 w-7 transition-all group-hover:ml-5'
  })) : null))), /*#__PURE__*/React.createElement(Transition.Root, {
    show: open,
    as: Fragment
  }, /*#__PURE__*/React.createElement(Dialog, {
    as: "div",
    className: "fixed inset-0 z-50 overflow-y-auto",
    onClose: setOpen
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex min-h-screen items-end justify-center bg-black-transparent px-4 pt-4 pb-20 text-center sm:block sm:p-0"
  }, /*#__PURE__*/React.createElement(Transition.Child, {
    as: Fragment,
    enter: "ease-out duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/React.createElement(Dialog.Overlay, {
    className: "fixed inset-0 transition-opacity"
  })), /*#__PURE__*/React.createElement("span", {
    className: "hidden sm:inline-block sm:h-screen sm:align-middle",
    "aria-hidden": "true"
  }, "\u200B"), /*#__PURE__*/React.createElement(Transition.Child, {
    as: Fragment,
    enter: "ease-out duration-300",
    enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
    enterTo: "opacity-100 translate-y-0 sm:scale-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
    leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative inline-block w-full max-w-3xl overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left align-bottom shadow-xl transition-all sm:my-8 sm:p-6 sm:align-middle"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: 'mb-6'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'flex items-center justify-between'
  }, Image ? /*#__PURE__*/React.createElement("div", {
    className: 'w-64'
  }, /*#__PURE__*/React.createElement(Image, {
    className: 'block w-full max-w-full object-cover transition duration-300 group-hover:scale-105'
  })) : null, /*#__PURE__*/React.createElement(Dialog.Title, {
    as: "h3",
    className: "ml-10 hidden max-w-sm text-lg font-bold leading-6 md:block"
  }, testimonialDescription), /*#__PURE__*/React.createElement("button", {
    className: 'focus self-start',
    onClick: () => setOpen(false)
  }, /*#__PURE__*/React.createElement(XIcon, {
    className: 'h-10 w-10'
  }))), /*#__PURE__*/React.createElement(QuoteMark, {
    className: clsx('mt-4 h-12 w-12', QuoteTheme)
  }), /*#__PURE__*/React.createElement(Dialog.Title, {
    as: "h3",
    className: "mt-2 max-w-sm text-lg font-bold leading-6 md:hidden"
  }, testimonialDescription)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "prose max-w-full"
  }, /*#__PURE__*/React.createElement(Blockquote, null))), hasLink ? /*#__PURE__*/React.createElement(link.Link, {
    className: clsx('mt-2.5 flex items-center font-bold', ArrowTheme)
  }, link.text || 'Mehr erfahren', /*#__PURE__*/React.createElement(ArrowNarrowRightIcon, {
    className: 'ml-2 h-7 w-7 transition-all group-hover:ml-5'
  })) : null)))))));
}

function SocialShareSection({
  title
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-text'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'mt-10 mb-16 lg:mb-24'
  }, /*#__PURE__*/React.createElement("p", {
    className: 'mb-5 !text-xl font-bold'
  }, title), /*#__PURE__*/React.createElement(SocialShare, null)))));
}

function Spacer({
  desktopOnly,
  withoutBorder
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "container-page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-text"
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('spacer', {
      'desktop-only': desktopOnly,
      'no-border': withoutBorder
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "hr"
  })))));
}

function FacetChipsInputMode({
  items,
  name,
  allText
}) {
  const [field,, helpers] = useField(name);
  const formik = useFormikContext();
  const groupTheme = useGroupTheme({
    kinderspital: {
      default: 'border-orange-400 text-orange-400 hover:border-orange-400 hover:bg-orange-400',
      active: 'border-orange-400 bg-orange-400 text-white'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      default: 'border-blue-900 text-blue-900 hover:border-blue-400 hover:bg-blue-400',
      active: 'border-blue-400 bg-blue-400 text-white'
    },
    nidwalden: {
      default: 'border-brown-500 text-brown-500 hover:border-brown-400 hover:bg-brown-400',
      active: 'border-brown-400 bg-brown-400 text-white'
    }
  });

  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  const intl = useIntl();
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: name,
    className: "sr-only"
  }, name), /*#__PURE__*/React.createElement("select", {
    id: name,
    role: "menu",
    name: name,
    className: clsx('field w-full'),
    onChange: async ev => {
      helpers.setValue(ev.target.value === '___' ? undefined : ev.target.value);
      await formik.submitForm();
    },
    value: field.value
  }, /*#__PURE__*/React.createElement("option", {
    value: '___'
  }, allText ? allText : intl.formatMessage({
    id: "XjX4MJ",
    defaultMessage: [{
      "type": 0,
      "value": "Alle Resultate"
    }]
  })), items.map(item => /*#__PURE__*/React.createElement("option", {
    key: item.id,
    value: item.label
  }, item.label)))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap gap-2 py-4"
  }, /*#__PURE__*/React.createElement("button", {
    key: '___',
    onClick: () => {
      helpers.setValue('___');
    },
    className: clsx('focus block rounded border px-2 pt-1 pb-0.5 transition hover:text-white', field.value === '___' || field.value === '' || field.value === undefined ? theme.active : theme.default)
  }, allText ? allText : intl.formatMessage({
    id: "XjX4MJ",
    defaultMessage: [{
      "type": 0,
      "value": "Alle Resultate"
    }]
  })), items.map(item => /*#__PURE__*/React.createElement("button", {
    key: item.id,
    onClick: () => {
      helpers.setValue(item.label);
    },
    className: clsx('focus block rounded border px-2 pt-1 pb-0.5 transition hover:text-white', item.label !== field.value && theme.default, item.label === field.value && theme.active)
  }, item.label, typeof item.count !== 'undefined' && item.count >= 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, " (", item.count, ")") : null))));
}

function SpecialistGallery({
  specialists,
  MoreLink,
  infiniteScroll,
  ...Form
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: 'container-page my-10 lg:my-20'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'my-10'
  }, /*#__PURE__*/React.createElement(SpecialistForm, Form)), /*#__PURE__*/React.createElement("div", {
    className: 'flex-wrap md:-mx-3 md:flex lg:-mx-5'
  }, specialists.map((specialist, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: 'mb-3 w-full last:mb-0 md:mb-0 md:w-1/2 md:p-3 lg:w-1/4 lg:p-5'
  }, /*#__PURE__*/React.createElement(SpecialistTeaser, specialist)))), /*#__PURE__*/React.createElement(LoadMore, {
    LoadingAnimation: Loader,
    MoreLink: MoreLink,
    isInfiniteScrollActive: infiniteScroll
  })));
}
function SpecialistTeaser({
  Image,
  Link,
  title,
  Description,
  gender
}) {
  const groupTheme = useGroupTheme({
    kinderspital: {
      arrow: 'text-orange-400',
      title: 'group-hover:text-orange-400',
      link: 'focus-kinderspital'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      arrow: 'text-blue-900 group-hover:text-blue-400',
      title: 'group-hover:text-blue-400',
      link: 'focus-luks'
    },
    nidwalden: {
      arrow: 'text-brown-400',
      title: 'group-hover:text-brown-400',
      link: 'focus-nidwalden'
    }
  });
  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  return /*#__PURE__*/React.createElement(Link, {
    className: clsx('group block p-0.5', theme.link)
  }, /*#__PURE__*/React.createElement("div", {
    className: 'aspect-w-2 aspect-h-2 relative mb-5 block overflow-hidden rounded-t-md',
    style: {
      background: `url(${gender === 'male' ? '/dummy-male-portrait.jpg' : '/dummy-female-portrait.jpg'}) no-repeat top`,
      backgroundSize: 'cover'
    }
  }, Image ? /*#__PURE__*/React.createElement(Image, {
    className: 'block w-full max-w-full object-cover object-top transition duration-300 group-hover:scale-105'
  }) : null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    className: clsx('text-xl font-bold transition', theme.title)
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: 'my-3'
  }, /*#__PURE__*/React.createElement(Description, null)), /*#__PURE__*/React.createElement("div", {
    className: clsx('inline-block transition-all group-hover:pl-5', theme.arrow)
  }, /*#__PURE__*/React.createElement(ArrowRight, {
    className: 'mt-2.5 h-7 w-7'
  })));
}
function ArrowRight({
  className
}) {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17 8l4 4m0 0l-4 4m4-4H3"
  }));
}
function SpecialistForm({
  Form,
  departments,
  locations,
  spokenLanguages,
  glossary,
  jobFunctions
}) {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement(Form, {
    className: 'form mb-10'
  }, /*#__PURE__*/React.createElement("label", {
    className: clsx('label', {
      'col-span-8 lg:col-span-2': locations && departments && spokenLanguages,
      /* all enabled */
      'col-span-8 lg:col-span-3': locations && departments && !spokenLanguages,
      'col-span-8 lg:col-span-4': spokenLanguages && departments && !locations || spokenLanguages && locations && !departments,
      'col-span-8 lg:col-span-5': departments && !locations && !spokenLanguages || locations && !departments && !spokenLanguages,
      'col-span-8 lg:col-span-6': spokenLanguages && !departments && !locations,
      'col-span-8 lg:col-span-7': !locations && !departments && !spokenLanguages /* none enabled */
    })
  }, intl.formatMessage({
    id: "xX5LGs",
    defaultMessage: [{
      "type": 0,
      "value": "Wen oder was suchen Sie?"
    }]
  }), /*#__PURE__*/React.createElement(Field, {
    className: clsx('field'),
    type: 'text',
    name: 'text'
  })), locations ? /*#__PURE__*/React.createElement("div", {
    className: 'col-span-8 lg:col-span-2'
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: 'location',
    className: 'label'
  }, intl.formatMessage({
    id: "qUkS0z",
    defaultMessage: [{
      "type": 0,
      "value": "Standort"
    }]
  })), /*#__PURE__*/React.createElement(Select, {
    selectItems: [{
      title: intl.formatMessage({
        id: "ftoYlu",
        defaultMessage: [{
          "type": 0,
          "value": "- Alle Standorte -"
        }]
      }),
      value: ''
    }, ...(locations || [])],
    name: 'location',
    id: 'location'
  })) : null, departments ? /*#__PURE__*/React.createElement("div", {
    className: 'col-span-8 lg:col-span-2'
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: 'department',
    className: 'label'
  }, intl.formatMessage({
    id: "fv4YEl",
    defaultMessage: [{
      "type": 0,
      "value": "Abteilung"
    }]
  })), /*#__PURE__*/React.createElement(Select, {
    selectItems: [{
      title: intl.formatMessage({
        id: "AbqVPM",
        defaultMessage: [{
          "type": 0,
          "value": "- Alle Abteilungen -"
        }]
      }),
      value: ''
    }, ...(departments || [])],
    name: 'department',
    id: 'department'
  })) : null, spokenLanguages ? /*#__PURE__*/React.createElement("div", {
    className: 'col-span-8 lg:col-span-1'
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: 'spokenLanguage',
    className: 'label'
  }, intl.formatMessage({
    id: "+5sQDB",
    defaultMessage: [{
      "type": 0,
      "value": "Sprachen"
    }]
  })), /*#__PURE__*/React.createElement(Select, {
    selectItems: [{
      title: intl.formatMessage({
        id: "Eco6dJ",
        defaultMessage: [{
          "type": 0,
          "value": "- Alle Sprachen -"
        }]
      }),
      value: ''
    }, ...(spokenLanguages || [])],
    name: 'spokenLanguage',
    id: 'spokenLanguage'
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: 'col-span-8 flex items-end justify-end lg:col-span-1 lg:justify-start'
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "button-primary lg:w-full"
  }, intl.formatMessage({
    id: "JYs1ab",
    defaultMessage: [{
      "type": 0,
      "value": "Filtern"
    }]
  }))), /*#__PURE__*/React.createElement("label", {
    className: "label col-span-8"
  }, /*#__PURE__*/React.createElement("span", {
    className: "lg:hidden"
  }, intl.formatMessage({
    id: "UhWFDp",
    defaultMessage: [{
      "type": 0,
      "value": "Nach Anfangsbuchstaben filtern"
    }]
  })), /*#__PURE__*/React.createElement(Glossary, {
    name: 'glossary',
    index: createAlphabet(26).map(char => ({
      value: char,
      label: toUpper(char),
      enabled: glossary.includes(char)
    }))
  })), jobFunctions && jobFunctions.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "col-span-8"
  }, /*#__PURE__*/React.createElement(FacetChipsInputMode, {
    items: jobFunctions,
    name: "jobFunction",
    allText: "Alle Spezialisten"
  })) : null);
}

function SubpageHeader({
  headline,
  Description,
  anchorLink
}) {
  const LinkTheme = useTheme({
    luzern: `text-blue-400`,
    nidwalden: `text-brown-400`
  });
  return /*#__PURE__*/React.createElement("div", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('container-text my-10 md:flex md:items-start md:justify-between', useTheme({
      luzern: 'prose',
      nidwalden: 'nidwalden prose'
    }))
  }, /*#__PURE__*/React.createElement("div", {
    className: 'md:pr-14'
  }, /*#__PURE__*/React.createElement("h1", {
    className: 'mb-3 md:mb-2'
  }, headline), Description ? /*#__PURE__*/React.createElement("div", {
    className: 'mt-6 text-lead-sm md:text-lead-md lg:text-lead-lg'
  }, /*#__PURE__*/React.createElement(Description, {
    classNames: {
      h3: 'font-light'
    }
  })) : null), anchorLink ? /*#__PURE__*/React.createElement(anchorLink.Link, {
    className: clsx('flex items-center md:mt-3 lg:mt-6', LinkTheme)
  }, /*#__PURE__*/React.createElement(MailIcon, {
    className: 'mr-2 h-4 w-4'
  }), anchorLink.title) : null)));
}

function SubscribeFormCM({
  title,
  Image
}) {
  const groupTheme = useGroupTheme({
    kinderspital: {
      background: 'bg-orange-400'
    }
  });
  // Default theme values
  const defaultTheme = useTheme({
    luzern: {
      background: 'bg-blue-900'
    },
    nidwalden: {
      background: 'bg-brown-900'
    }
  });

  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  const intl = useIntl();
  const formDivRef = useRef(null);
  useEffect(() => {
    if (formDivRef.current) {
      const script = document.createElement('script');
      script.src = 'https://js.createsend1.com/javascript/copypastesubscribeformlogic.js';
      script.type = 'text/javascript';
      formDivRef.current.append(script);
    }
  }, [formDivRef]);
  return /*#__PURE__*/React.createElement("div", {
    className: 'relative overflow-hidden md:min-h-[1020px] xl:min-h-[980px]',
    id: "subscribe-form"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'top-0 h-full w-full overflow-hidden object-cover object-center md:absolute md:max-h-[1040px] md:min-h-[1020px] xl:max-h-[1000px] xl:min-h-[980px]'
  }, /*#__PURE__*/React.createElement(Image, {
    className: 'top-0 h-full w-full object-cover object-center md:!absolute md:max-h-[1040px] md:min-h-[1020px]'
  })), /*#__PURE__*/React.createElement("div", {
    className: 'container-content relative'
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('p-8 text-white md:absolute md:top-[510px] md:left-4 md:w-3/4 md:-translate-y-2/4 lg:left-6 lg:min-h-[600px] lg:w-1/2 lg:p-12 lg:pr-14 xl:top-[50px] xl:transform-none 2xl:left-0', theme.background, useTheme({
      luzern: '',
      nidwalden: 'nidwalden'
    }))
  }, /*#__PURE__*/React.createElement(React.Fragment, null, title ? /*#__PURE__*/React.createElement("h2", {
    className: 'section-title mb-8'
  }, title) : null, /*#__PURE__*/React.createElement("h2", {
    className: 'section-title mb-8'
  }, intl.formatMessage({
    id: "cEXFeC",
    defaultMessage: [{
      "type": 0,
      "value": "Für LUKS-Newsletter anmelden"
    }]
  })), /*#__PURE__*/React.createElement("div", {
    ref: formDivRef,
    dangerouslySetInnerHTML: {
      __html: formData
    }
  })))));
}
const formData = `
<form action="https://www.createsend.com/t/subscribeerror?description=" class="js-cm-form" data-id="A61C50BEC994754B1D79C5819EC1255CFBBF87B9BFCBFF7EB68B44DE81B18348ACAD861984FA1192110961E6810E44D436DE928F2078A70C241059DD59948F54" id="subForm" method="post">
<p><label>Anrede</label></p>

<div class="form-options">
<div><input id="fieldjkklttr-0" name="cm-fo-jkklttr" type="radio" value="3678467" /> <label for="fieldjkklttr-0">Frau</label></div>

<div><input id="fieldjkklttr-1" name="cm-fo-jkklttr" type="radio" value="3678468" /> <label for="fieldjkklttr-1">Herr</label></div>
</div>

<p><input id="fieldjkhkjyt" name="cm-f-jkhkjyt" placeholder="Vorname" type="text" /></p>

<p><input id="fieldjkhkjyh" name="cm-f-jkhkjyh" placeholder="Nachname" type="text" /></p>

<p><input class="js-cm-email-input" id="fieldEmail" name="cm-yhidkyy-yhidkyy" placeholder="E-Mail-Adresse" required="" type="email" /></p>

<p class="subscriptions">Wählen Sie Ihre Abonnements</p>

<div class="form-options">
<div><input id="fieldjkhkjtr-0" name="cm-fo-jkhkjtr" type="checkbox" value="3676905" /> <label for="fieldjkhkjtr-0">Allgemeine News</label></div>

<div><input id="fieldjkhkjtr-1" name="cm-fo-jkhkjtr" type="checkbox" value="3676906" /> <label for="fieldjkhkjtr-1">Personelles</label></div>

<div><input id="fieldjkhkjtr-2" name="cm-fo-jkhkjtr" type="checkbox" value="3989131" /> <label for="fieldjkhkjtr-2">Forschung</label></div>

<div><input id="fieldjkhkjtr-3" name="cm-fo-jkhkjtr" type="checkbox" value="3676907" /> <label for="fieldjkhkjtr-3">LUKS in den Medien</label></div>
</div>

<div class="form-options small">
<p><input id="fieldjkhkjjl-0" name="cm-fo-jkhkjjl" required="" type="checkbox" value="3676903" /> <label for="fieldjkhkjjl-0">Durch Angabe meiner E-Mail-Adresse und Anklicken des Buttons „Absenden“ erkläre ich mich damit einverstanden, dass das Luzerner Kantonsspital mir regelmässig Informationen zuschickt. Meine Einwilligung kann ich jederzeit widerrufen.</label></p>
</div>

<p><button class="js-cm-submit-button" type="submit">Absenden</button></p>
</form>
`;

function TeaserBox({
  inSidebar,
  ...props
}) {
  const Component = inSidebar ? TeaserBoxSidebar : TeaserBoxDefault;
  return /*#__PURE__*/React.createElement(Component, props);
}
function TeaserBoxDefault({
  teaser
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('mb-10 mt-14 p-5 first:mt-0 md:mb-16 md:p-8', useTheme({
      luzern: 'bg-blue-100 text-grey-900',
      nidwalden: 'bg-brown-300'
    }))
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-text sm:flex'
  }, /*#__PURE__*/React.createElement(Teaser, teaser)));
}
function TeaserBoxSidebar({
  teaser
}) {
  const props = {
    ...teaser,
    isFullWidth: false
  };
  return /*#__PURE__*/React.createElement(Teaser, props);
}

function ThankYouMessage({
  Image,
  NewsLink
}) {
  const bgThemeCol = useTheme({
    luzern: 'bg-blue-900',
    nidwalden: 'bg-brown-900'
  });
  const intl = useIntl();
  return /*#__PURE__*/React.createElement("div", {
    className: 'relative overflow-hidden md:min-h-[1020px] xl:min-h-[980px]',
    id: "subscribe-form"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'top-0 h-full w-full overflow-hidden object-cover object-center md:absolute md:max-h-[1040px] md:min-h-[1020px] xl:max-h-[1000px] xl:min-h-[980px]'
  }, /*#__PURE__*/React.createElement(Image, {
    className: 'top-0 h-full w-full object-cover object-center md:!absolute md:max-h-[1040px] md:min-h-[1020px]'
  })), /*#__PURE__*/React.createElement("div", {
    className: 'container-content relative'
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('p-8 text-white md:absolute md:top-[510px] md:left-4 md:w-1/2 md:-translate-y-2/4 lg:left-6 lg:min-h-[600px] lg:p-12 lg:pr-14 xl:top-[50px] xl:transform-none 2xl:left-0', bgThemeCol, useTheme({
      luzern: '',
      nidwalden: 'nidwalden'
    }))
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
    className: 'section-title mb-8'
  }, intl.formatMessage({
    id: "MJmMZ+",
    defaultMessage: [{
      "type": 0,
      "value": "Vielen Dank für Ihre Newsletter-Anmeldung!"
    }]
  })), /*#__PURE__*/React.createElement("p", {
    className: 'text-lg'
  }, intl.formatMessage({
    id: "cm9hgp",
    defaultMessage: [{
      "type": 0,
      "value": "Ihre Anmeldung war erfolgreich und Sie werden regelmässige Updates erhalten."
    }]
  })), /*#__PURE__*/React.createElement(NewsLink, {
    className: 'button-secondary mt-8'
  }, intl.formatMessage({
    id: "7Cumao",
    defaultMessage: [{
      "type": 0,
      "value": "Zum Newsroom"
    }]
  }))))));
}

function Tile({
  items
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: 'container-page mb-6 md:mb-10'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-text'
  }, /*#__PURE__*/React.createElement("ul", {
    className: 'sm:-mx-2 sm:flex sm:flex-wrap'
  }, items?.map((item, index) => /*#__PURE__*/React.createElement(TileItem, _extends({
    key: index
  }, item)))))));
}
function TileItem({
  Link,
  title
}) {
  // check if the Link has a href.
  const hasLink = Link && Link.href;

  // Group theme
  const activeGroupTheme = useGroupTheme({
    kinderspital: 'kinderspital'
  });
  const groupTheme = useGroupTheme({
    kinderspital: 'group relative text-white ' + (hasLink ? 'hover:text-black' : '')
  });

  // Default theme values
  const defaultTheme = useTheme({
    luzern: 'focus-luks bg-blue-100 ' + (hasLink ? 'text-blue-900 hover:bg-blue-150 hover:text-blue-400' : 'text-black'),
    nidwalden: 'focus-nidwalden bg-brown-300 ' + (hasLink ? 'text-brown-900 hover:bg-brown-200' : 'text-black')
  });

  // @ts-ignore
  const LinkWrapper = hasLink ? Link : ({
    className,
    children
  }) => /*#__PURE__*/React.createElement("span", {
    className: className
  }, children);

  // Apply group theme if available, otherwise use the default theme
  const theme = groupTheme || defaultTheme;
  return /*#__PURE__*/React.createElement("li", {
    className: 'pb-4 sm:w-1/2 sm:basis-2/4 sm:px-2 lg:max-w-1/3 lg:basis-2/6'
  }, /*#__PURE__*/React.createElement(LinkWrapper, {
    className: clsx('flex h-full min-h-[6rem] items-center justify-center px-5 py-7 text-center transition sm:min-h-[7rem] md:px-6 lg:text-lg', theme)
  }, title, activeGroupTheme === 'kinderspital' && /*#__PURE__*/React.createElement("svg", {
    width: "289",
    height: "112",
    viewBox: "0 0 289 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "absolute top-0 left-0 -z-10 w-full text-orange-400 group-hover:text-orange-200"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.578 51.444C285.821 52.7225 285.583 53.5666 284.992 54.5135C283.983 56.1274 282.925 56.7142 281.636 56.6685C280.716 56.6342 279.793 56.739 278.867 56.8724C280.178 58.0461 281.615 56.5751 282.86 58.29C282.579 58.6958 282.09 59.0674 282.064 60.1992C282.3 60.7917 282.858 60.5879 282.961 61.7635C283.008 62.3141 283.49 62.8305 283.817 63.2154C284.552 64.0842 284.651 64.2938 284.22 65.6504C283.892 66.685 284.141 67.0166 284.559 67.2357C284.883 67.4053 285.253 67.5406 285.562 67.3939C286.437 66.9747 287.254 68.2417 288.122 67.874C288.234 67.8264 288.41 68.1808 288.537 68.3961C288.661 68.6057 288.825 68.8515 288.733 69.2268C288.66 69.5298 288.516 69.7641 288.331 69.6536C287.661 69.2535 287.085 69.4174 286.641 70.5015C285.985 69.5755 285.336 70.9035 284.646 70.3624C284.428 70.1928 283.759 70.2729 284.094 71.6162C284.127 71.7457 284.084 71.942 284.086 72.1058C284.098 72.8413 283.141 72.8089 283.731 73.9636C284.017 74.5238 284.454 74.3065 284.796 74.6286C284.826 74.6552 284.834 74.7715 284.854 74.8553C284.768 75.3564 284.515 75.1964 284.337 75.3412C283.248 76.2234 283.2 76.471 283.602 78.8108C283.626 78.948 283.616 79.2377 283.618 79.2377C284.772 79.2719 283.883 80.5619 283.988 81.2364C284.061 81.7032 283.977 81.8004 283.813 81.9223C283.161 82.4025 282.902 83.2898 283.036 84.5841C283.492 85.0109 284.03 84.1649 284.449 84.9728C284.534 85.171 284.531 85.3577 284.429 85.4187C283.452 85.9941 283.33 86.0741 283.687 87.8614C283.949 89.1761 283.902 90.567 284.225 91.8093C284.304 92.1065 284.449 92.5467 284.398 92.7277C283.859 94.6521 284.588 96.003 285.009 97.493C285.294 98.501 285.817 99.4156 285.311 100.683C285.224 100.904 285.36 101.304 285.47 101.588C285.645 102.047 286.278 101.984 285.971 102.952C285.763 103.604 286.329 103.939 286.002 104.6C285.629 104.69 285.391 103.51 284.953 103.739C284.667 104.419 285.336 104.914 285.089 105.513C284.735 106.38 284.185 106.917 283.668 106.839C283.078 106.751 282.701 107.323 282.258 107.731C280.742 109.118 279.091 109.609 277.439 109.68C276.521 109.72 275.603 109.836 274.688 109.908C270.447 110.246 266.198 109.598 261.954 109.4C261.201 109.364 260.459 108.921 259.693 109.024C259.271 109.08 258.855 108.92 258.551 109.666C258.371 110.107 258.099 110.181 257.872 109.859C257.539 109.383 257.277 109.352 256.984 109.901C256.819 110.206 256.573 110.169 256.399 109.882C255.884 109.034 255.493 108.527 255.061 110.116C254.885 110.764 254.255 110.238 253.885 109.895C252.794 108.885 252.802 108.841 252.107 110.088C251.865 109.706 251.968 109.404 252.066 109.091C251.891 109.158 251.715 109.217 251.538 109.297C250.576 109.731 249.539 109.853 248.515 109.301C247.853 108.944 247.177 108.847 246.495 108.754C246.359 109.188 246.4 109.825 246.275 110.545C246.058 109.798 245.976 109.209 246.029 108.699C245.465 108.634 244.904 108.605 244.346 108.613C244.442 108.727 244.545 108.847 244.66 108.982C244.311 108.929 244.037 109.032 243.817 108.632C241.903 108.718 240 109.085 238.087 109.158C237.296 109.186 236.505 110.15 235.716 108.897C235.531 108.603 235.456 109.042 235.327 109.181C234.768 109.775 234.202 110.583 233.536 109.482C233.452 109.343 233.44 109.303 233.345 109.369C230.728 111.21 227.947 110.518 225.222 110.764C223.991 110.874 222.755 110.89 221.523 111.368C220.418 111.795 219.197 111.368 218.034 111.137C217.518 111.036 217.018 111.042 216.535 111.221C214.962 111.797 213.403 112.21 211.76 111.886C210.198 111.579 208.612 111.6 207.055 111.791C205.983 111.921 204.941 111.473 203.89 111.459C201.659 111.433 199.422 111.353 197.196 111.193C195.8 111.094 194.394 111.073 192.996 110.972C190.231 110.775 187.467 110.404 184.702 110.259C182.397 110.137 180.1 110.259 177.804 110.27C173.413 110.295 169.016 110.11 164.632 110.524C162.837 110.693 161.035 111.075 159.253 111.002C156.861 110.907 154.497 111.32 152.114 111.277C148.57 111.208 145.03 111.364 141.491 111.499C138.7 111.606 135.875 111.282 133.085 111.393C130.791 111.482 128.487 111.292 126.194 111.345C123.661 111.404 121.117 111.616 118.563 111.296C116.685 111.059 114.785 110.806 112.91 111.275C112.47 111.385 112.008 111.115 111.564 111.029C108.949 110.514 106.358 111.092 103.75 110.907C100.101 110.652 96.4544 110.785 92.8039 110.562C91.5888 110.488 90.3737 110.638 89.1586 110.627C88.3311 110.621 87.5036 110.318 86.6674 110.478C84.3908 110.909 82.0898 110.269 79.7976 110.465C77.0043 110.701 74.1848 110.362 71.3758 110.27C69.1935 110.198 66.9921 109.823 64.836 110.168C63.565 110.371 62.3272 109.888 61.0755 110.023C57.645 110.389 54.1918 109.987 50.7525 110.25C48.7169 110.404 46.6621 110.65 44.5933 109.844C43.2211 109.31 41.8209 109.743 40.433 109.769C39.0835 109.796 37.7462 109.994 36.388 109.865C34.5618 109.691 32.734 109.859 30.9079 109.87C29.5199 109.878 28.132 109.897 26.7441 109.867C22.1963 109.758 17.6519 109.788 13.1006 109.344C11.2081 109.16 9.30867 108.655 7.42494 108.72C6.13478 108.761 5.07682 108.173 4.06425 106.555C3.47067 105.606 3.2315 104.762 3.47067 103.484C3.6697 102.424 3.25245 99.8024 2.76013 99.7566C2.10894 99.6976 1.67423 98.3505 0.975909 98.783C0.726258 98.9373 0.382333 98.5258 0.302026 97.8436C0.214735 97.0929 0.515015 96.8833 0.776886 96.6128C1.31809 96.0526 1.88722 96.0926 2.49302 96.2164C3.18785 96.3574 3.30657 96.0907 3.20007 94.6959C3.11627 93.6004 3.20706 92.5619 3.30133 91.5254C2.87884 91.0586 2.63268 91.756 2.31495 91.7674C2.05482 91.775 1.79295 91.8912 1.66376 91.3025C1.54155 90.7461 1.71264 90.3822 1.91516 90.0411C2.08974 89.7496 2.4162 89.8258 2.45461 89.1856C2.06355 88.2977 1.73359 89.8163 1.30238 89.1284C1.37395 88.17 1.65678 87.5317 2.12815 87.2879C2.69204 86.9963 3.13373 86.7124 3.01502 85.1729C2.80028 82.3968 2.72347 82.0862 1.73708 81.4917C1.18191 81.1564 0.59183 81.0249 0 80.3542C0.635476 78.7022 1.59567 78.1859 2.33241 77.0846C2.51048 76.8197 2.71823 76.9645 2.919 77.2103C3.17214 77.5209 3.4375 77.8296 3.71683 78.0106C4.53562 78.5384 4.76956 78.3116 4.84114 76.6444C4.89526 75.3678 5.37186 74.6305 5.60755 73.5977C5.72277 73.0966 6.04051 73.1919 6.28842 73.2586C6.80518 73.3958 7.29575 73.1843 7.78458 72.9728C8.22801 72.7803 8.54924 72.2773 8.55797 71.3037C8.56321 70.5892 8.46893 69.8499 7.97836 70.13C7.27131 70.532 7.28178 69.6936 7.33241 68.7752C7.35511 68.3885 7.5646 68.0379 7.41272 67.6168C7.24687 67.1595 6.85406 66.8832 7.00594 66.1877C7.15608 65.498 7.4616 64.873 7.82124 64.7778C8.86349 64.5034 8.61209 62.0779 9.34009 61.3176C9.38199 61.2738 9.34359 60.847 9.30169 60.6279C8.96475 58.8673 8.32054 56.3027 6.80168 54.9098C6.3565 54.5021 5.97766 53.9267 5.38932 54.0143C4.87256 54.0905 4.32263 53.5532 3.96474 52.6844C3.71683 52.0842 4.38373 51.5926 4.09568 50.9105C3.65748 50.6818 3.42179 51.8612 3.04819 51.7698C2.71998 51.1086 3.28387 50.7752 3.07437 50.1216C2.76537 49.1537 3.3991 49.2166 3.57193 48.7574C3.68017 48.4735 3.81635 48.0734 3.72731 47.8542C3.21753 46.5853 3.73953 45.6707 4.02235 44.6646C4.4396 43.1766 5.1676 41.8256 4.62466 39.9012C4.57403 39.7183 4.71718 39.2801 4.794 38.9828C5.11523 37.7405 5.0646 36.3496 5.32298 35.0349C5.67564 33.2496 5.55343 33.1695 4.57403 32.5922C4.47277 32.5312 4.46928 32.3445 4.55308 32.1463C4.97033 31.3385 5.50978 32.1883 5.96369 31.7634C6.09521 30.469 5.8345 29.5804 5.18157 29.0977C5.01572 28.9758 4.93367 28.8786 5.00524 28.4118C5.10999 27.7354 4.21788 26.4436 5.37186 26.415C5.37186 26.415 5.36139 26.1254 5.38583 25.9882C5.78388 23.6484 5.73674 23.4007 4.64386 22.5147C4.46404 22.3718 4.21264 22.528 4.12535 22.0269C4.14456 21.945 4.15503 21.8268 4.18297 21.8002C4.52514 21.4782 4.9616 21.6973 5.24617 21.139C5.8345 19.9862 4.87605 20.0148 4.88827 19.2794C4.89002 19.1136 4.84637 18.9192 4.87954 18.7878C5.21125 17.4464 4.5426 17.3645 4.32438 17.534C3.63478 18.0713 2.98359 16.7433 2.32891 17.6674C1.88373 16.5813 1.30761 16.4175 0.638967 16.8157C0.453911 16.9243 0.309009 16.69 0.235685 16.387C0.143157 16.0097 0.307263 15.7678 0.42947 15.5563C0.555168 15.3409 0.733241 14.9885 0.843227 15.0342C1.71264 15.4038 2.52444 14.1387 3.40084 14.5597C3.70985 14.7065 4.08171 14.5731 4.40468 14.4054C4.82193 14.1863 5.06984 13.8567 4.73988 12.8201C4.30517 11.4635 4.40643 11.2539 5.13792 10.3889C5.46439 10.004 5.94449 9.48764 5.98988 8.93698C6.08939 7.76137 6.64805 7.96715 6.88374 7.37458C6.8558 6.24279 6.36349 5.86933 6.08241 5.46349C7.33067 3.74294 8.78144 5.25199 10.096 4.04017C9.89003 3.2342 9.34708 3.86488 9.26153 2.99031C10.309 2.35963 12.0199 2.27199 12.8701 2.97888C13.3258 3.35805 13.75 3.40568 14.2092 3.09511C14.6107 2.82454 14.9983 2.64163 15.4382 2.65116C16.1348 2.66259 16.9955 1.80708 17.5018 2.33677C18.3415 3.21896 18.9124 1.98428 19.5985 1.86995C19.9808 1.80517 20.3021 1.98809 20.6285 2.23388C20.9044 2.03 21.2064 1.98999 21.5014 1.89091C21.5259 1.88329 21.5503 1.87948 21.5765 1.87186C21.7842 0.98586 22.1194 0.494273 22.7846 1.2831C22.8597 1.37075 23.0657 0.949657 23.2228 0.877253C23.9508 0.540002 24.7102 -0.1345 25.4033 0.0236458C26.2605 0.221805 27.116 0.294209 27.9731 0.381856C30.8852 0.675284 33.8478 -0.38601 36.7179 1.05636C36.9431 1.16878 37.2172 0.945847 37.4686 0.869632C38.8653 0.448544 40.1903 1.65465 41.5852 1.26785C42.0217 2.61686 42.5123 1.82422 43.0098 1.32311C43.153 1.18021 43.3642 1.06207 43.4934 1.16306C44.5671 1.99571 45.6547 2.28914 46.8122 1.58605C47.1107 1.40504 47.5158 1.69085 47.3307 2.453C47.2766 2.67593 47.2469 2.83979 47.2399 2.96364C47.2766 2.96554 47.3133 2.96745 47.3499 2.97126C47.851 3.00175 48.3503 3.06843 48.8478 3.14274C49.0102 2.92362 49.1725 2.68545 49.3471 2.51206C49.3559 2.75214 49.3401 2.9865 49.3122 3.21134C49.9948 3.31804 50.6792 3.42855 51.3653 3.49143C53.366 3.67053 55.3353 4.51271 57.3709 4.00778C57.9034 3.87631 58.4533 3.86678 59.005 4.00778C60.3073 4.33932 61.6376 4.85758 62.9348 4.60226C65.1729 4.16402 67.3412 5.06336 69.5706 4.92046C72.0217 4.76231 74.4921 4.91283 76.9519 5.0062C80.3335 5.13576 83.7239 4.73373 87.1108 4.46126C89.3664 4.28025 91.6237 4.22118 93.8793 4.10496C94.0085 4.09733 94.1359 4.09162 94.2634 4.084C94.3384 3.77914 94.534 3.48762 94.6056 3.71626C94.6614 3.89918 94.7173 4.00397 94.7714 4.05732C94.843 4.05351 94.9128 4.0497 94.9844 4.04589C95.145 3.9087 95.3091 3.57717 95.5012 3.71626C95.4313 3.80391 95.3737 3.91061 95.3213 4.02874C97.4477 3.91442 99.5741 3.79819 101.701 3.70483C101.68 3.63814 101.666 3.56192 101.657 3.46856C101.634 3.19228 101.723 3.05319 101.695 3.06272C102.039 2.98269 102.154 3.15417 102.191 3.49524C102.2 3.56955 102.198 3.63433 102.191 3.68577C102.601 3.67053 103.013 3.66291 103.422 3.661C103.422 3.661 103.418 3.65719 103.417 3.65529C103.595 3.35233 103.769 3.0932 103.988 3.3409C104.024 3.38282 104.056 3.55621 104.064 3.66863C105.068 3.68006 106.072 3.71626 107.076 3.75246C108.951 3.82106 110.835 3.62099 112.711 3.85916C113.708 3.98492 114.691 4.18689 115.678 4.37552C116.631 4.55844 117.659 3.65148 118.52 5.09575C118.567 5.17768 118.684 5.10337 118.768 5.09956C120.306 5.02525 121.845 4.78708 123.384 4.90521C124.258 4.97381 125.166 4.72039 126.018 4.84043C127.94 5.11099 129.869 4.93951 131.793 5.12243C135.014 5.42919 138.263 5.08241 141.493 5.37584C142.395 5.45777 143.333 5.47111 144.225 5.32058C145.913 5.03668 147.593 5.06908 149.27 5.01001C154.314 4.83281 159.358 4.82709 164.4 4.73373C168.054 4.66514 171.711 4.38314 175.362 4.53176C179.354 4.69372 183.354 4.39457 187.345 4.64037C188.542 4.71277 189.744 4.71277 190.945 4.6861C190.987 4.45936 191.119 4.35837 191.247 4.35456C191.344 4.35265 191.407 4.4765 191.439 4.67466C192.514 4.64418 193.588 4.60226 194.663 4.57558C195.047 4.17546 195.43 4.28597 195.798 4.30693C195.906 4.31264 195.988 4.4041 196.037 4.55081C196.128 4.55081 196.221 4.54891 196.313 4.54891C199.037 4.5451 201.76 4.59273 204.482 4.68419C206.036 4.73563 214.272 7.31932 216.517 7.67372C218.694 8.01669 220.875 7.73469 223.048 7.89665C225.604 8.08719 228.179 7.72136 230.744 7.71755C233.722 7.71373 236.697 7.84902 239.674 7.90618C241.47 7.94047 243.267 7.95953 245.065 7.95191C246.956 7.94047 248.848 7.86426 250.737 7.85854C253.616 7.85092 256.495 7.97668 259.377 7.84711C260.718 7.78614 262.057 7.78995 263.394 7.72517C265.622 7.62037 267.853 7.44317 270.077 7.0621C272.368 6.66959 274.709 7.30027 276.936 5.38156C277.041 5.2901 277.228 5.22151 277.286 5.33011C277.766 6.22945 278.375 5.92649 278.951 6.02748C279.833 6.18181 279.983 6.81249 279.649 8.57496C279.608 8.79408 279.571 9.22088 279.613 9.26471C280.343 10.0269 280.096 12.4524 281.139 12.7287C281.498 12.8239 281.805 13.4508 281.957 14.1425C282.109 14.8379 281.718 15.1142 281.554 15.5715C281.402 15.9926 281.613 16.3413 281.638 16.73C281.692 17.6484 281.704 18.4867 280.995 18.0809C280.505 17.8008 280.411 18.5401 280.419 19.2546C280.428 20.2282 280.753 20.7312 281.196 20.9256C281.685 21.139 282.177 21.3524 282.694 21.2152C282.942 21.1504 283.26 21.0533 283.377 21.5563C283.614 22.5909 284.093 23.3283 284.15 24.6049C284.225 26.2702 284.459 26.5007 285.278 25.9729C285.556 25.7938 285.819 25.4852 286.072 25.1746C286.273 24.9307 286.481 24.7859 286.659 25.0507C287.399 26.152 288.361 26.6722 289 28.3242C288.41 28.9929 287.82 29.1225 287.265 29.456C286.28 30.0485 286.203 30.3572 285.995 33.1333C285.88 34.671 286.324 34.9568 286.888 35.2502C287.359 35.496 287.643 36.1362 287.717 37.0927C287.287 37.7805 286.954 36.26 286.565 37.146C286.605 37.7862 286.931 37.71 287.106 38.0035C287.308 38.3445 287.479 38.7104 287.359 39.2667C287.231 39.8555 286.968 39.7412 286.709 39.7297C286.392 39.7183 286.142 39.019 285.721 39.4858C285.817 40.5224 285.912 41.5627 285.83 42.6564C285.727 44.0511 285.845 44.3179 286.54 44.1788C287.144 44.0568 287.713 44.0187 288.256 44.5789C288.518 44.8514 288.82 45.061 288.735 45.8117C288.656 46.4938 288.312 46.9035 288.062 46.7491C287.364 46.3166 286.931 47.6618 286.28 47.719C285.788 47.7628 285.376 50.3827 285.578 51.444Z",
    fill: "currentColor"
  }))));
}

function Timeline({
  groups
}) {
  const mainTimelineTheme = useTheme({
    luzern: `border-blue-750`,
    nidwalden: `border-brown-900`
  });
  const beforesTheme = useTheme({
    luzern: `before:bg-blue-750`,
    nidwalden: `before:bg-brown-900`
  });
  const aftersTheme = useTheme({
    luzern: `after:border-blue-750`,
    nidwalden: `after:border-brown-900`
  });
  const amountOfGroups = groups.length;
  return /*#__PURE__*/React.createElement("div", {
    className: "container-page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative my-10 mx-auto max-w-[940px]"
  }, /*#__PURE__*/React.createElement("ul", {
    className: clsx('relative ml-2 lg:ml-0', groups[0].groupTitle ? beforesTheme : null, {
      'before:absolute before:left-[-17px] before:block before:h-[2px] before:w-[34px]': groups[0].groupTitle
    })
  }, groups.map((item, index) => {
    const anchorGroupLinkNoSpaces = item.groupTitle ? item.groupTitle.toString().replace(/\s/g, '-').replace('.', '').replace(',', '') : null;
    return /*#__PURE__*/React.createElement("li", {
      key: index,
      className: clsx('group/element relative z-0 border-l-2 pb-4 lg:mt-[136px] lg:odd:pl-0 first:lg:odd:mt-0 lg:even:ml-[130px]', mainTimelineTheme, {
        'mb-[-40px] last:mb-0 lg:mb-0': !item.groupTitle
      })
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CurvedLeft, {
      grouped: true
    }), /*#__PURE__*/React.createElement("div", {
      className: "max-w-none last:mb-0"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pl-6 lg:pl-20"
    }, /*#__PURE__*/React.createElement("div", {
      className: clsx('anchor snap-start scroll-mt-32', {
        'anchor--visible visible': item.isPreview,
        invisible: !item.isPreview
      }),
      id: anchorGroupLinkNoSpaces ? anchorGroupLinkNoSpaces : undefined
    }, item.isPreview ? '#' + anchorGroupLinkNoSpaces : null), /*#__PURE__*/React.createElement("h2", {
      className: "mb-[30px] snap-start scroll-mt-32 text-[24px] font-bold leading-[32px] tracking-[-0.44px] lg:mb-[50px] lg:text-[44px] lg:leading-[48px]"
    }, item.groupTitle)), item?.elements?.map((item, index) => {
      return /*#__PURE__*/React.createElement(TimelineElement, _extends({}, item, {
        key: index
      }));
    })), /*#__PURE__*/React.createElement(CurvedRight, {
      grouped: true
    })));
  })), /*#__PURE__*/React.createElement("div", {
    className: clsx('group relative block leading-none after:absolute after:left-[-8px] after:top-[-11px] after:z-0 after:block after:h-[34px] after:w-[34px] after:rounded-full after:border-2 after:bg-white', aftersTheme, {
      'even:after:lg:left-[114px]': amountOfGroups % 2 !== 1,
      'after:lg:left-[-16px]': amountOfGroups % 2 == 1
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('relative left-[3px] z-10 h-[12px] w-[12px] rounded-full border-2', mainTimelineTheme, {
      'group-even:lg:left-[125px]': amountOfGroups % 2 !== 1,
      'lg:left-[-5px]': amountOfGroups % 2 == 1
    })
  }, "\xA0"))));
}
const CurvedLeft = ({
  grouped,
  itemIndex
}) => {
  const curveTheme = useTheme({
    luzern: `text-blue-750`,
    nidwalden: `text-brown-900`
  });
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('group-even/element:hidden absolute top-[-151px] left-[-2px] hidden h-[165px] w-[132px] lg:block', curveTheme, {
      'group-first/element:hidden': grouped,
      '!hidden': itemIndex === 0
    })
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 40 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 50C0 10 40 40 40 0",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: ".54"
  })));
};
const CurvedRight = ({
  grouped
}) => {
  const curveTheme = useTheme({
    luzern: `text-blue-750`,
    nidwalden: `text-brown-900`
  });
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('group-even/element:hidden absolute bottom-[-151px] left-[-2px] hidden h-[165px] w-[132px] lg:block', curveTheme, {
      'group-last/element:hidden': grouped
    })
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "20 20 40 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 20c0 40 40 10 40 50",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "0.54"
  })));
};

function WallsIo({
  title
}) {
  const divRef = useRef(null);
  useEffect(() => {
    if (divRef.current) {
      const script = document.createElement('script');
      script.src = 'https://walls.io/js/wallsio-widget-1.2.js';
      script.setAttribute('data-wallurl', 'https://walls.io/luks?nobackground=1&amp;show_header=0');
      script.setAttribute('data-width', '100%');
      script.setAttribute('data-autoheight', '1');
      script.setAttribute('data-injectloadmorebutton', '1');
      script.setAttribute('data-loadmoretext', 'Mehr');
      script.setAttribute('data-loadmorecount', '');
      script.setAttribute('data-height', '800');
      script.setAttribute('data-lazyload', '1');
      divRef.current.append(script);
    }
  }, [divRef]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, title ? /*#__PURE__*/React.createElement("div", {
    className: "container-page prose lg:prose-xl"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-text"
  }, /*#__PURE__*/React.createElement("h2", null, title)))) : null, /*#__PURE__*/React.createElement("div", {
    className: "walls-io-embed",
    ref: divRef
  }));
}

function Messages({
  messages
}) {
  const MessageTheme = useTheme({
    luzern: 'bg-blue-100',
    nidwalden: 'bg-brown-100'
  });
  if (!messages.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('mb-10 p-5 md:p-10', MessageTheme)
  }, messages.map((Html, i) => /*#__PURE__*/React.createElement(Message, {
    key: i,
    Text: Html
  })));
}
function Message({
  Text
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "prose my-2 max-w-full lg:prose-xl"
  }, /*#__PURE__*/React.createElement(Text, null));
}

function Webform({
  Element
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-text'
  }, /*#__PURE__*/React.createElement(Element, {
    buildMessages: messages => /*#__PURE__*/React.createElement(Messages, {
      messages: messages
    })
  })));
}

const allParagraphs = {
  Figure: Figure,
  FormattedText: FormattedText,
  RemoteVideo: RemoteVideo,
  LocalVideo: LocalVideo,
  SliderTeaser: SliderTeaser,
  GridTeaser: GridTeaser,
  DiseaseListing: DiseaseListing,
  AnalysisListing: AnalysisListing,
  Tile: Tile,
  Faq: Faq,
  FileList: FileList,
  Document: Document,
  ImageCarousel: ImageCarousel,
  LinkList: LinkList,
  SpecialistGallery: SpecialistGallery,
  SliderTestimonial: SliderTestimonial,
  HomeGridTeaser: HomeGridTeaser,
  JobListing: JobListing,
  InfiniteGridTeaser: InfiniteGridTeaser,
  EventSearch: EventSearch,
  BabyGallery: BabyGallery,
  SliderSpecialist: SliderSpecialist,
  NewsroomList: NewsroomList,
  MedicinesList: MedicinesList,
  SubscribeFormCM: SubscribeFormCM,
  Teaser: TeaserBox,
  Quote: Quote,
  EventView: EventView,
  ContextualTextSection: ContextualTextSection,
  Anchor: Anchor,
  Spacer: Spacer,
  MegaTeasers: MegaTeasers,
  AnimatedNumbers: AnimatedNumbers,
  Webform: Webform,
  SearchForm: SearchForm,
  EventItem: EventItem,
  CallToAction: CallToAction,
  WallsIo: WallsIo,
  SubpageHeader,
  Timeline: Timeline,
  TimelineElement: TimelineElement,
  LogoCloud: LogoCloud
};
const standardBody = {
  ...allParagraphs,
  Sidebar: Sidebar,
  Helpfulness: Helpfulness,
  SocialShare: SocialShareSection
};
const WithStandardFrame = route(StandardFrame, {
  header: Header,
  emergencyMessage: EmergencyMessage,
  footer: Footer
});
const WithSimpleFrame = route(StandardFrame, {
  header: HeaderWithLogo,
  emergencyMessage: EmergencyMessage,
  footer: Footer
});
const WithDocumentationFrame = route(StandardFrame, {
  header: Header,
  footer: Footer
});
const locationHeader = {
  LocationHeader: LocationHeader,
  SubPageHeader: SubpageHeader
};
const basicPageHeader = {
  ContentHeader: ContentHeader,
  // or
  ...locationHeader
};
const BasicPage = route(Content, {
  header: basicPageHeader,
  body: standardBody
});
const TeamPage = route(Content, {
  header: basicPageHeader,
  body: {
    ...standardBody
  }
});
const EventPage = route(Content, {
  header: ContentHeader,
  body: {
    ...standardBody,
    EventDetails: EventDetails
  }
});
const DiseasePage = route(Content, {
  header: LocationHeader,
  body: {
    ...standardBody,
    DiseaseDetails: DiseaseDetails
  }
});
const AnalysisPage = route(Content, {
  header: LocationHeader,
  body: {
    ...standardBody,
    AnalysisDetails: AnalysisDetails
  }
});
const SearchPage = route(Content, {
  header: SearchForm,
  body: SearchResults
});
const OverviewPage = route(Content, {
  header: HeroSection,
  body: standardBody
});
const SpecialistPage = route(Content, {
  header: HeaderSpecialist,
  body: {
    ContentSpecialist: ContentSpecialist,
    FileList: FileList,
    SliderTeaser: SliderTeaser,
    Helpfulness: Helpfulness
  }
});
const BabyPage = route(Plain, {
  body: {
    BabyContent: BabyContent
  }
});
const ScreenRoute = route(Plain, {
  body: {
    Screen
  }
});
const DsSlideRoute = route(Plain, {
  body: {
    DsSlide
  }
});
const DsLoopRoute = route(Plain, {
  body: {
    DSLoop
  }
});
const locationContactPageBody = {
  ...standardBody,
  ContactInfo: ContactInfo
};
const LocationContactRoute = route(Content, {
  header: LocationHeader,
  body: {
    ContactInfo,
    Helpfulness
  }
});
const LocationPage = route(Content, {
  header: locationHeader,
  body: {
    ...standardBody,
    ...locationContactPageBody
  }
});
const NewsroomPage = route(Content, {
  header: LocationHeader,
  body: {
    SubpageHeader,
    NewsroomList,
    InfiniteGridTeaser,
    SubscribeFormCM,
    WallsIo,
    Helpfulness
  }
});
const SitemapRoute = route(Plain, {
  body: Sitemap
});
const KitchenSinkRoute = route(Content, {
  header: {
    HeaderSpecialist: HeaderSpecialist,
    LocationHeader: LocationHeader,
    ContentHeader: ContentHeader,
    HeroSection: HeroSection
  },
  body: standardBody
});
const NewsContentRoute = route(Content, {
  header: ContentHeader,
  body: {
    ...standardBody,
    NewsContent: NewsContent
  }
});
const patientInformationPageBody = {
  ContactInfo: ContactInfo,
  ...standardBody
};
const PatientInformationPageRoute = route(Content, {
  header: SimpleHeader,
  body: patientInformationPageBody
});
const DocumentationPageRoute = route(Content, {
  header: SimpleHeader,
  body: allParagraphs
});
const DocumentationSearchRoute = route(Content, {
  body: {
    SearchForm,
    SearchResults
  }
});
const CampaignMonitorRoute = route(Content, {
  header: {
    ContentHeader
  },
  body: {
    SubscribeFormCM,
    ThankYouMessage
  }
});
const SidebarGroup = group({
  items: allParagraphs
});
const ParagraphsGroup = group({
  items: allParagraphs
});
const TimelineElementsGroup = group({
  items: allParagraphs
});

export { AnalysisPage, BabyPage, BasicPage, CampaignMonitorRoute, DiseasePage, DocumentationPageRoute, DocumentationSearchRoute, DsLoopRoute, DsSlideRoute, EventPage, KitchenSinkRoute, LocationContactRoute, LocationPage, NewsContentRoute, NewsroomPage, OverviewPage, ParagraphsGroup, PatientInformationPageRoute, ScreenRoute, SearchPage, SidebarGroup, SitemapRoute, SpecialistPage, TeamPage, ThemeProvider, TimelineElementsGroup, WithDocumentationFrame, WithSimpleFrame, WithStandardFrame };
